'use strict';

// ─────────────────────────────────────────────────────────────────────────────
// RESTOCK REDIRECT INTERCEPTOR — Runs immediately before anything else.
// Shopify redirects customer forms to /search?customer_posted=true which
// loses the product context. We catch that and bounce back to the product page.
// ─────────────────────────────────────────────────────────────────────────────
(function restockRedirectInterceptor() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      const returnUrl = sessionStorage.getItem('ma_restock_return_url');
      sessionStorage.removeItem('ma_restock_return_url');
      if (returnUrl) {
        window.location.replace(returnUrl);
        return; // Stop all further JS execution
      }
    }
  } catch (_) {}
})();


// ─────────────────────────────────────────────────────────────────────────────
// TOUCH GUARD UTILITY — Ensures touch buttons only trigger on clean taps,
// ignoring drag/swipe scroll gestures on mobile.
// ─────────────────────────────────────────────────────────────────────────────
function addTapListener(element, callback) {
  if (!element) return;

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let touchHandled = false;

  element.addEventListener('touchstart', function(e) {
    if (e.touches && e.touches.length === 1) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = false;
      touchHandled = false;
    }
  }, { passive: true });

  element.addEventListener('touchmove', function(e) {
    if (e.touches && e.touches.length === 1) {
      const moveX = e.touches[0].clientX;
      const moveY = e.touches[0].clientY;
      if (Math.abs(moveX - startX) > 6 || Math.abs(moveY - startY) > 6) {
        isDragging = true;
      }
    }
  }, { passive: true });

  element.addEventListener('touchend', function(e) {
    if (!isDragging && !touchHandled) {
      touchHandled = true;
      if (e.cancelable) e.preventDefault();
      e.stopPropagation();
      callback(e);
      setTimeout(function() { touchHandled = false; }, 400);
    }
  }, { passive: false });

  element.addEventListener('click', function(e) {
    if (touchHandled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    callback(e);
  });
}
window.addTapListener = addTapListener;


// ─────────────────────────────────────────────────────────────────────────────
// I18N — Translations dictionary (EN / ES)
// ─────────────────────────────────────────────────────────────────────────────
const I18N = {
  en: {
    'announcement': 'FREE SHIPPING IN PERU ON ORDERS OVER $80  —  FREE RETURNS',
    'nav.t01': 'T-01 ESSENTIAL PIMA',
    'nav.j01': 'J-01 DOWN JACKET',
    'nav.c01': 'C-01 TRAVEL DUFFEL',
    'nav.shop': 'SHOP',
    'nav.outerwear': 'OUTERWEAR',
    'nav.tshirts': 'T-SHIRTS',
    'nav.all': 'SHOP ALL',
    'nav.about': 'ABOUT US',
    'nav.purpose': 'OUR STORY',
    'nav.account': 'ACCOUNT',
    'nav.contact': 'CONTACT',
    '404.title': '404 — PAGE NOT FOUND',
    '404.subtitle': 'THE PAGE YOU ARE LOOKING FOR DOES NOT EXIST OR HAS BEEN MOVED.',
    '404.return_home': 'RETURN TO HOME',

    'hero.eyebrow': 'Own the Altitude',
    'hero.title': "MARK ESSENTIALS",
    'hero.cta': 'VIEW COLLECTION',
    'gallery.curated_title': 'MARK ESSENTIALS',
    
    'materials.title': 'ELEVATED MATERIALS',

    'benefits.shipping': '24–48h shipping in Lima',
    'benefits.returns': 'Free exchanges & returns',
    'benefits.payment': 'Secure payments · Visa · Mastercard',
    'benefits.packaging': 'Sustainable packaging',

    'collection.title': 'THE FOUNDATION LINE',
    'collection.eyebrow': 'COLLECTION',
    'collection.sub': 'A focused system of essential pieces for everyday movement.',
    'badge.bestseller': 'Bestseller',
    'badge.new': 'NEW IN',
    'color.black': 'Black',
    'color.white': 'White',
    'color.gray': 'Gray',

    'size.guide': 'Sizing',
    'size.add': 'ADD',
    'size.added': 'ADDED',
    'size.select': 'Select a size',
    'campaign.cta': 'DISCOVER',

    'lookbook.eyebrow': 'EDITORIAL',
    'lookbook.title': 'URBAN ALTITUDE',
    'lookbook.body': 'Built for those who move between mountain cold and city rhythm.',

    'feat.down.t': 'NATURAL DOWN',
    'feat.down.b': '90/10 duck down filling that retains warmth without bulk.',
    'feat.cotton.t': 'PIMA COTTON',
    'feat.cotton.b': 'T-shirts in extra-long-staple Peruvian cotton, soft and long-lasting.',
    'feat.timeless.t': 'TIMELESS DESIGN',
    'feat.timeless.b': 'Clean cuts and a neutral palette that pair with everything, season after season.',
    'feat.water.t': 'WATER REPELLENT',
    'feat.water.b': 'Technical exterior finish with DWR treatment to protect you from light rain.',

    'faq.title': 'FREQUENTLY ASKED QUESTIONS',
    'faq.q1': 'How do I choose my size?',
    'faq.a1': 'Check our <a href="#" data-open="size-guide">size guide</a>. If you\'re between two sizes, we recommend going up for a relaxed fit. Measurements are in cm taken on the laid-flat garment.',
    'faq.q2': 'How do I care for my garment?',
    'faq.a2': 'Jackets: professional dry-clean only. T-shirts: machine wash cold, inside out, no bleach. Air dry and iron on low. Skip the dryer to keep your garment looking new for longer.',
    'faq.q3': 'What is the returns policy?',
    'faq.a3': 'You have 30 days from delivery to exchange or return, as long as the garment is unworn, with tags and in original packaging. Returns within Peru are free.',
    'faq.q4': 'How long does shipping take?',
    'faq.a4': 'Peru: 2–4 business days via Shalom. International: 3–7 business days via DHL. You\'ll receive a tracking number when your order ships.',
    'faq.q5': 'What payment methods do you accept?',
    'faq.a5': 'We accept Visa, Mastercard, American Express, Yape, Plin and bank transfer (BCP, Interbank, BBVA). All payments are secured with SSL encryption.',
    'faq.q6': 'Is the down ethically sourced?',
    'faq.a6': 'Yes. All our down is sourced from RDS-certified suppliers (Responsible Down Standard), guaranteeing animal welfare and traceability across the supply chain.',

    'spotlight.title': 'ELEVATED MATERIALS',

    'news.title': 'GET 10% OFF YOUR FIRST ORDER',
    'news.sub': 'Exclusive access to subscriber-only deals and new releases.',
    'news.placeholder': 'Enter your email address',
    'news.cta': 'SUBSCRIBE',
    'news.disclaimer': 'By subscribing you agree to our <a href="/search?view=minfo&p=privacy" style="color:inherit;text-decoration:underline">Privacy Policy</a>.',
    'news.success': 'Thank you! Check your inbox for your 10% discount.',
    'news.error': 'Please enter a valid email address.',

    'footer.products_title': 'PRODUCTS',
    'footer.view_all': 'VIEW ALL',
    'footer.brand_title': 'ABOUT MARK ALTITUDE',
    'footer.our_story': 'OUR STORY',
    'footer.philosophy': 'PHILOSOPHY',
    'footer.privacy_policy': 'PRIVACY POLICY',
    'footer.terms_conditions': 'TERMS & CONDITIONS',
    'footer.claims_book': 'BOOK OF COMPLAINTS',
    'footer.help_title': 'CUSTOMER SERVICE',
    'footer.faq': 'FAQ',
    'footer.size_guide': 'SIZE GUIDE',
    'footer.shipping_deliveries': 'SHIPPING & DELIVERIES',
    'footer.returns_exchanges': 'RETURNS & EXCHANGES',
    'footer.contact': 'CONTACT',
    'footer.region_label': 'REGION',
    'footer.tagline': 'Designed for the cold<br>built for the city.',
    'footer.shop': 'SHOP',
    'footer.help': 'HELP',
    'footer.company': 'COMPANY',
    'footer.faqs': 'FAQs',
    'footer.returns': 'Returns & Exchanges',
    'footer.journal': 'Journal',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms & Conditions',
    'footer.refund': 'Refund Policy',
    'footer.copy': '© 2026 MARK ALTITUDE. ALL RIGHTS RESERVED.',
    'footer.admin': 'ADMIN',

    'cart.title': 'YOUR CART',
    'cart.empty': 'Your cart is empty.',
    'cart.subtotal': 'TOTAL',
    'cart.checkout': 'CHECKOUT',
    'cart.note': 'By continuing, I declare that I have read and accept the Shipping Terms and understand the Privacy Policy of MARK ALTITUDE.',
    'cart.free_shipping': 'FREE SHIPPING ON ORDERS OVER $100 USD',
    'cart.remove': 'Remove',
    'cart.size': 'Size',
    'cart.color': 'Color',

    'size.guide.title': 'SIZING',
    'size.guide.intro': 'Body measurements in centimeters. If you are between two sizes, we recommend choosing the larger one.',
    'size.guide.col_tag': 'Tag Size',
    'size.guide.col_eu': 'EU',
    'size.guide.col_chest': 'Chest',
    'size.guide.col_waist': 'Waist',
    'size.guide.col_height': 'Height',
    'size.recommender.title': 'HOW TO FIND MY SIZE?',
    'size.recommender.intro': 'Enter your height and weight to calculate your ideal recommended size and see it highlighted in the table.',
    'size.recommender.height': 'Height',
    'size.recommender.weight': 'Weight',
    'size.recommender.btn': 'Calculate my size',

    'toast.select_size': 'Please select a size first.',
    'toast.added': 'Added to cart.',
    'toast.checkout': 'Checkout coming soon — this is a demo.',

    'breadcrumb.home': 'Home',
    'breadcrumb.shop': 'Shop',
    'product.qty': 'Quantity',
    'product.add': 'ADD TO CART',
    'product.find_your_size': 'FIND YOUR SIZE',
    'product.sold_out': 'SOLD OUT',
    'product.unavailable': 'UNAVAILABLE',
    'product.recommended': 'RECOMMENDED',
    'product.section.description': 'DESCRIPTION',
    'product.section.fabric': 'FABRIC',
    'product.section.materials': 'MATERIALS',
    'product.section.care': 'CARE',
    'product.section.shipping': 'DELIVERY',
    'product.shipping.body': 'International shipping via DHL. Free shipping on orders over $100 USD. Orders processed within 24 business hours.',
    'product.related': 'COMPLETE THE LOOK',

    'product.bundle.label':           'COMPLETE THE LOOK',
    'product.bundle.tee.label':       'T-01 ESSENTIAL PACK',
    'product.bundle.cta':             'SHOP THE LOOK',
    'product.bundle.tee.cta':         'SHOP THE PACK',
    'product.bundle.added':           'ADDED',
    'product.bundle.tee.added':       'PACK ADDED',
    'product.bundle.view':            'VIEW CART',
    'product.bundle.discount.label': 'Bundle discount',
    'product.bundle.alreadyInSize':  'This look is already in size {size}',
    'product.bundle.savings':        'Save {amount}',
    'reviews.title':                  'REVIEWS',
    'reviews.write':                  'WRITE A REVIEW',
    'reviews.empty':                  'NO REVIEWS YET',
    'reviews.empty_sub':              'Reviews are collected from customers who purchased the product.',
    'reviews.eligibility_title':      'REVIEW AVAILABLE AFTER PURCHASE',
    'reviews.eligibility_desc':       'Only customers who purchased this product can publish a review.',
    'reviews.based_on':               'Based on {n} review(s)',
    'reviews.show_all':               'Show all ({n})',
    'reviews.show_less':              'Show less',
    'review.form.photos_label':       'PHOTOS',
    'review.form.photos_add':         'ADD PHOTOS',
    'toast.review_added':             'Review published. Thanks!',
    'cart.subtotalPartial':           'Subtotal',
    'cart.total':                     'Total',
    'footer.brand_desc':              'ARCHIVAL PIECES & INDEPENDENT DESIGN.',

    'campaign.jacket.subtitle': 'LIGHTWEIGHT 90/10 <br class="mobile-only-br">DOWN JACKET',
    'campaign.tee.subtitle': 'ESSENTIAL TEE MADE IN <br class="mobile-only-br">100% PIMA COTTON',
    'campaign.duffel.subtitle': 'TRAVEL DUFFEL MADE IN <br class="mobile-only-br">100% FULL-GRAIN COW LEATHER',

    'product.dj01.desc': 'Down jacket built with an urban silhouette. RDS-certified 90/10 duck down, technical outer shell with DWR water repellency and a clean matte finish. Designed for the city\'s unpredictable weather.',
    'product.dj01.materials': 'Outer: 100% Nylon ripstop with DWR finish · Lining: 100% Polyester taffeta · Fill: 90% duck down / 10% feather · YKK® zippers',
    'product.jacket.care': 'Professional dry-clean only. Do not bleach. Do not wring. Cool iron if needed.',

    'product.tee.desc': 'Essential t-shirt in extra-long-staple Peruvian Pima cotton. Regular fit, reinforced collar and double-stitched seams. Pre-shrunk to hold its shape wash after wash.',
    'product.tee.materials': '100% Peruvian Pima cotton · 180 g/m² · Eco-friendly dyes',
    'product.tee.care': 'Machine wash cold. Do not bleach. Air dry. Iron on low temperature, inside out.',
    'product.duffel.desc': 'Full-grain leather travel bag designed for short trips, weekend escapes, and urban travel.',
    'product.duffel.materials': '100% Premium full-grain leather · High-resistance metal zippers and hardware · Durable water-resistant lining',
    'product.duffel.care': 'Leather specialist clean only. Store in a cool, dry place. Avoid prolonged exposure to direct sunlight and moisture.',

    'checkout.title': 'CHECKOUT',
    'checkout.secure': 'Secure checkout',
    'checkout.contact': 'CONTACT',
    'checkout.email': 'Email',
    'checkout.shipping': 'SHIPPING ADDRESS',
    'checkout.firstname': 'First name',
    'checkout.lastname': 'Last name',
    'checkout.address': 'Address',
    'checkout.city': 'City',
    'checkout.postal': 'Postal code',
    'checkout.country': 'Country / Region',
    'checkout.phone': 'Phone',
    'checkout.payment': 'PAYMENT',
    'checkout.card.number': 'Card number',
    'checkout.card.exp': 'MM / YY',
    'checkout.card.cvv': 'CVV',
    'checkout.card.name': 'Name on card',
    'checkout.summary': 'ORDER SUMMARY',
    'checkout.shipping.line': 'Shipping',
    'checkout.shipping.free': 'FREE',
    'checkout.total': 'TOTAL',
    'checkout.place_order': 'PLACE ORDER',
    'checkout.empty': 'Your cart is empty. Add a product before checking out.',
    'checkout.back': '← Back to shop',
    'checkout.success.title': 'THANK YOU FOR YOUR ORDER',
    'checkout.success.body': 'Your order has been received. We sent a confirmation email to {email}. You\'ll receive tracking info shortly.',
    'checkout.success.order': 'Order',
    'checkout.success.continue': 'CONTINUE SHOPPING',
    'checkout.discount': 'Discount code',
    'checkout.apply': 'Apply',
    'campaign.tee.eyebrow': 'MADE FOR EVERYDAY',
    'campaign.eyebrow': 'MADE FOR EVERYWHERE',
    'campaign.duffel.eyebrow': 'MADE FOR MOVEMENT',
    'pf.down.t': '90/10 FEATHER DOWN FILL',
    'pf.down.d': 'RDS-certified 90/10 duck down filling that retains warmth without bulk. Lightness and warmth in a single layer.',
    'pf.water.t': 'WATER REPELLENT',
    'pf.water.d': 'Technical outer shell with DWR treatment that repels drizzle and wind. Ideal for unpredictable weather.',
    'pf.pack.t': 'THERMOREGULATOR',
    'pf.pack.d': 'Ultra-compressible structure that allows the garment to be packed into its own pocket. Maximum portability for travel.',
    'pf.wind.t': 'WINDPROOF',
    'pf.wind.d': 'Dense outer structure that blocks gusts of air, keeping internal temperature efficiently.',
    'pf.tee.cotton.t': '100% PIMA COTTON',
    'pf.tee.cotton.d': 'Extra-long-staple fiber of maximum purity. Offers superior softness to the touch and a luxury finish that does not lose quality.',
    'pf.tee.breath.t': 'ULTRASOFT',
    'pf.tee.breath.d': 'Lightweight and thermoregulating knit fabric that allows airflow, keeping you cool all day long.',
    'pf.tee.build.t': 'CLASSIC FIT',
    'pf.tee.build.d': 'Deformation-resistant collar and structured pattern. Retains its clean silhouette wash after wash.',
    'pf.tee.seams.t': 'REINFORCED SEAMS',
    'pf.tee.seams.d': 'High stitch density for greater resistance at structural tension points.',
    'pf.duffel.leather.t': '100% GENUINE LEATHER',
    'pf.duffel.leather.d': 'Highest quality premium full-grain leather, selected for its durability and capacity to age with character with constant use.',
    'pf.duffel.garment.t': 'GARMENT BAG OPENING',
    'pf.duffel.garment.d': 'Full lay-flat opening system that allows the bag to unfold completely for efficient organization, reducing wrinkles on clothing.',
    'pf.duffel.shoes.t': 'SHOE COMPARTMENT',
    'pf.duffel.shoes.d': 'Dedicated independent internal space for footwear or isolated personal items, keeping the main compartment clean and organized.',
    'pf.duffel.hardware.t': 'METAL HARDWARE',
    'pf.duffel.hardware.d': 'Reinforced custom metal zippers and details designed for high durability to withstand daily use and frequent travel.',
    'pdp.feat.cotton': '100% PIMA COTTON',
    'pdp.feat.stitching': 'REINFORCED STITCHING',
    'pdp.feat.comfort': 'ULTRA-SOFT',
    'pdp.feat.fit': 'CLASSIC FIT',
    'pdp.feat.down': '90/10 DOWN FILL',
    'pdp.feat.water': 'WATER REPELLENT',
    'pdp.feat.warmth': 'THERMOREGULATING',
    'pdp.feat.breathable': 'WINDPROOF',
    'pdp.feat.leather': '100% GENUINE LEATHER',
    'pdp.feat.hardware': 'METAL HARDWARE',
    'pdp.feat.shoes': 'SHOE COMPARTMENT',
    'pdp.feat.access': 'GARMENT BAG OPENING',
    'diff.heading': 'THE MARK ALTITUDE DIFFERENCE',
    'diff.peru': 'DESIGNED IN PERU',
    'diff.peru.sub': 'Conceived in Lima. Architectural lines inspired by urban concrete and Peruvian landscapes.',
    'diff.care': 'MANUFACTURED WITH CARE',
    'diff.care.sub': 'Crafted in local workshops. Ethical production and premium finishing in every detail.',
    'diff.last': 'MADE TO LAST',
    'diff.last.sub': 'Timeless materials. Long-staple Peruvian Pima cotton and certified down made to endure.',
    'cart.item_added': 'Item added to cart',
    'cart.view': 'VIEW CART',
    'cart.continue': 'CONTINUE SHOPPING',
    'cart.unit_price': 'Unit price',
    'cart.total_price': 'Total'
  },

  es: {
    'announcement': 'ENVÍO GRATIS EN PERÚ POR COMPRAS MAYORES A S/300  —  DEVOLUCIONES GRATIS',
    'nav.t01': 'T-01 ESSENTIAL PIMA',
    'nav.j01': 'J-01 DOWN JACKET',
    'nav.c01': 'C-01 TRAVEL DUFFEL',
    'nav.shop': 'TIENDA',
    'nav.outerwear': 'CASACAS',
    'nav.tshirts': 'POLOS',
    'nav.all': 'VER TODO',
    'nav.about': 'NOSOTROS',
    'nav.purpose': 'OUR STORY',
    'nav.account': 'MI CUENTA',
    'nav.contact': 'CONTACTO',
    '404.title': '404 — PÁGINA NO ENCONTRADA',
    '404.subtitle': 'LA PÁGINA QUE BUSCAS NO EXISTE O HA SIDO MOVIDA.',
    '404.return_home': 'VOLVER AL INICIO',

    'hero.eyebrow': 'Own the Altitude',
    'hero.title': "MARK ESSENTIALS",
    'hero.cta': 'VER COLECCIÓN',
    'gallery.curated_title': 'MARK ESSENTIALS',
    
    'materials.title': 'MATERIALES DE ALTA CALIDAD',

    'benefits.shipping': 'Envío 24–48h en Lima',
    'benefits.returns': 'Cambios y devoluciones gratis',
    'benefits.payment': 'Pago seguro · Yape · Plin · Tarjetas',
    'benefits.packaging': 'Empaque sostenible',

    'collection.title': 'THE FOUNDATION LINE',
    'collection.eyebrow': 'COLECCIÓN',
    'collection.sub': 'Un sistema preciso de piezas esenciales para el movimiento cotidiano.',
    'badge.bestseller': 'Más vendido',
    'badge.new': 'NUEVO',
    'color.black': 'Black',
    'color.white': 'White',
    'color.gray': 'Gray',

    'size.guide': 'Tallaje',
    'size.add': 'AÑADIR',
    'size.added': 'AÑADIDO',
    'size.select': 'Elige una talla',
    'campaign.cta': 'DESCUBRIR',

    'lookbook.eyebrow': 'EDITORIAL',
    'lookbook.title': 'ALTITUD URBANA',
    'lookbook.body': 'Pensado para los que se mueven entre el frío de la sierra y el ritmo de la ciudad.',

    'spotlight.title': 'MATERIALES DE ALTA CALIDAD',

    'feat.down.t': 'PLUMA NATURAL',
    'feat.down.b': 'Relleno de pluma 90/10 que retiene el calor de forma eficiente.',
    'feat.cotton.t': 'ALGODÓN PIMA',
    'feat.cotton.b': 'Polos en algodón peruano de fibra extra-larga, suave y de larga duración.',
    'feat.timeless.t': 'DISEÑO ATEMPORAL',
    'feat.timeless.b': 'Cortes limpios y paleta neutra que combinan con todo, temporada tras temporada.',
    'feat.water.t': 'REPELENCIA AL AGUA',
    'feat.water.b': 'Acabado exterior técnico con tratamiento DWR que te protege de la llovizna.',

    'faq.title': 'PREGUNTAS FRECUENTES',
    'faq.q1': '¿Cómo elijo mi talla?',
    'faq.a1': 'Revisa nuestra <a href="#" data-open="size-guide">guía de tallas</a>. Si estás entre dos, recomendamos elegir la mayor para un calce más relajado. Las medidas están en cm sobre la prenda extendida.',
    'faq.q2': '¿Cómo cuido mi prenda?',
    'faq.a2': 'Casacas: lavado en seco profesional. Polos: lavar a máquina con agua fría, del revés, sin lejía. Secar al aire libre y planchar a temperatura baja. Evita la secadora para prolongar la vida de la prenda.',
    'faq.q3': '¿Cuál es la política de devoluciones?',
    'faq.a3': 'Tienes 14 días calendario desde la entrega para cambios o devoluciones, siempre que la prenda esté sin uso, con etiquetas y en su empaque original. Las devoluciones dentro de Perú son gratuitas.',
    'faq.q4': '¿Cuánto demora el envío?',
    'faq.a4': 'Lima: 24–48h. Provincias del Perú: 3–5 días hábiles. Internacional: 7–14 días hábiles. Recibirás un número de seguimiento por correo cuando tu pedido sea despachado.',
    'faq.q5': '¿Qué métodos de pago aceptan?',
    'faq.a5': 'Aceptamos Visa, Mastercard, American Express, Yape, Plin y transferencia bancaria (BCP, Interbank, BBVA). Todos los pagos están protegidos con encriptación SSL.',
    'faq.q6': '¿La pluma es ética?',
    'faq.a6': 'Sí. Toda nuestra pluma proviene de proveedores certificados RDS (Responsible Down Standard), garantizando bienestar animal y trazabilidad en toda la cadena de suministro.',

    'news.title': 'OBTÉN 10% DE DESCUENTO EN TU PRIMER PEDIDO',
    'news.sub': 'Acceso exclusivo a ofertas y lanzamientos solo para suscriptores.',
    'news.placeholder': 'Ingresa tu correo electrónico',
    'news.cta': 'SUSCRIBIRSE',
    'news.disclaimer': 'Al suscribirte aceptas nuestra <a href="/search?view=minfo&p=privacy" style="color:inherit;text-decoration:underline">Política de Privacidad</a>.',
    'news.success': '¡Gracias! Revisa tu bandeja para obtener tu 10% de descuento.',
    'news.error': 'Por favor ingresa un correo válido.',

    'footer.tagline': 'Diseñado para el frío<br>hecho para la ciudad.',
    'footer.shop': 'TIENDA',
    'footer.help': 'AYUDA',
    'footer.company': 'EMPRESA',
    'footer.faqs': 'Preguntas frecuentes',
    'footer.returns': 'Devoluciones y cambios',
    'footer.journal': 'Blog',
    'footer.privacy': 'Política de privacidad',
    'footer.terms': 'Términos y condiciones',
    'footer.refund': 'Política de reembolso',
    'footer.copy': '© 2026 MARK ALTITUDE. TODOS LOS DERECHOS RESERVADOS.',
    'footer.admin': 'ADMIN',
    'footer.products_title': 'PRODUCTOS',
    'footer.view_all': 'VER TODO',
    'footer.brand_title': 'ACERCA DE MARK ALTITUDE',
    'footer.our_story': 'NUESTRA HISTORIA',
    'footer.philosophy': 'FILOSOFÍA',
    'footer.privacy_policy': 'POLÍTICA DE PRIVACIDAD',
    'footer.terms_conditions': 'TÉRMINOS Y CONDICIONES',
    'footer.claims_book': 'LIBRO DE RECLAMACIONES',
    'footer.help_title': 'SERVICIO AL CLIENTE',
    'footer.faq': 'PREGUNTAS FRECUENTES',
    'footer.size_guide': 'GUÍA DE TALLAS',
    'footer.shipping_deliveries': 'ENVÍOS Y ENTREGAS',
    'footer.returns_exchanges': 'CAMBIOS Y DEVOLUCIONES',
    'footer.contact': 'CONTACTO',
    'footer.region_label': 'REGIÓN',

    'cart.title': 'TU CARRITO',
    'cart.empty': 'Tu carrito está vacío.',
    'cart.subtotal': 'TOTAL',
    'cart.checkout': 'IR A PAGAR',
    'cart.note': 'Al continuar, declaro que he leído y acepto las Condiciones de Envío y entiendo la Política de Privacidad de MARK ALTITUDE.',
    'cart.free_shipping': 'ENVÍO GRATIS POR PEDIDOS SUPERIORES A S/349.00 PEN',
    'cart.remove': 'Eliminar',
    'cart.size': 'Talla',
    'cart.color': 'Color',

    'size.guide.title': 'TALLAJE',
    'size.guide.intro': 'Medidas en centímetros sobre el cuerpo. Si estás entre dos tallas, te recomendamos elegir la mayor.',
    'size.guide.col_tag': 'Tamaño de la etiqueta',
    'size.guide.col_eu': 'EU',
    'size.guide.col_chest': 'Pecho',
    'size.guide.col_waist': 'Cintura',
    'size.guide.col_height': 'Estatura',
    'size.recommender.title': '¿CÓMO SABER MI TALLA?',
    'size.recommender.intro': 'Introduce tu estatura y peso para calcular tu talla ideal recomendada y verla destacada en la tabla.',
    'size.recommender.height': 'Estatura',
    'size.recommender.weight': 'Peso',
    'size.recommender.btn': 'Calcular mi talla',

    'toast.select_size': 'Por favor elige una talla primero.',
    'toast.added': 'AÑADIDO AL CARRITO',
    'toast.checkout': 'Pago en línea próximamente — esta es una demo.',

    'breadcrumb.home': 'Inicio',
    'breadcrumb.shop': 'Tienda',
    'product.qty': 'Cantidad',
    'product.add': 'AÑADIR AL CARRITO',
    'product.find_your_size': 'ENCUENTRA TU TALLA',
    'product.sold_out': 'AGOTADO',
    'product.unavailable': 'NO DISPONIBLE',
    'product.recommended': 'RECOMENDADA',
    'product.section.description': 'DESCRIPCIÓN',
    'product.section.fabric': 'TEJIDO',
    'product.section.materials': 'MATERIALES',
    'product.section.care': 'CUIDADO',
    'product.section.shipping': 'ENVÍOS Y DEVOLUCIONES',
    'product.shipping.body': 'Envíos a todo el Perú a través de la empresa Shalom Empresarial S.A.C. El costo del envío se cobra en el checkout.',
    'product.related': 'COMPLETA EL LOOK',

    'product.bundle.label':           'COMPLETA EL LOOK',
    'product.bundle.tee.label':       'PAQUETE T-01 ESSENTIAL',
    'product.bundle.cta':             'COMPRAR LOOK',
    'product.bundle.tee.cta':         'COMPRAR PAQUETE',
    'product.bundle.added':           'AÑADIDO',
    'product.bundle.tee.added':       'PAQUETE AÑADIDO',
    'product.bundle.view':            'VER CARRITO',
    'product.bundle.discount.label': 'Descuento bundle',
    'product.bundle.alreadyInSize':  'Este look ya está en talla {size}',
    'product.bundle.savings':        'Ahorra {amount}',
    'reviews.title':                  'RESEÑAS',
    'reviews.write':                  'ESCRIBIR RESEÑA',
    'reviews.empty':                  'AÚN NO HAY RESEÑAS',
    'reviews.empty_sub':              'Las reseñas son recopiladas de clientes que compraron el producto.',
    'reviews.eligibility_title':      'RESEÑA DISPONIBLE DESPUÉS DE LA COMPRA',
    'reviews.eligibility_desc':       'Solo los clientes que hayan comprado este producto pueden publicar una reseña.',
    'reviews.based_on':               'Basado en {n} reseña(s)',
    'reviews.show_all':               'Mostrar todas ({n})',
    'reviews.show_less':              'Mostrar menos',
    'cart.subtotalPartial':           'Subtotal',
    'cart.total':                     'Total',
    'cart.item_added':                'Producto añadido al carrito',
    'cart.view':                      'VER CARRITO',
    'cart.continue':                  'SEGUIR COMPRANDO',
    'cart.unit_price':                'Precio unitario',
    'cart.total_price':               'Total',
    'footer.brand_desc':              'PIEZAS DE ARCHIVO Y DISEÑO INDEPENDIENTE.',

    'campaign.jacket.subtitle': 'CASACA LIGERA CON RELLENO <br class="mobile-only-br">DE PLUMA 90/10',
    'campaign.tee.subtitle': 'POLO ESENCIAL HECHO EN <br class="mobile-only-br">100% ALGODÓN PIMA',
    'campaign.duffel.subtitle': 'BOLSO DE VIAJE HECHO EN 100% <br class="mobile-only-br">CUERO FULL-GRAIN',

    'product.dj01.desc': 'CASACA LIGERA CON RELLENO DE PLUMA 90/10, ACABADO REPELENTE AL AGUA Y DISEÑO TERMORREGULADOR.',
    'product.dj01.materials': 'Exterior: 100% Nylon mate repelente al agua · Forro: 100% Poliéster · Relleno: 90/10 pluma y plumón',
    'product.jacket.care': 'Lavado en seco profesional. No usar lejía. No retorcer. Plancha tibia si es necesario.',

    'product.tee.desc': 'POLO ESENCIAL ELABORADO EN 100% ALGODÓN PIMA PERUANO, ACABADO ULTRASUAVE Y AJUSTE CLÁSICO.',
    'product.tee.materials': '100% Algodón Pima peruano · 180 g/m² · Tinte ecológico',
    'product.tee.care': 'Lavar a máquina con agua fría. No usar lejía. Secar al aire libre. Planchar a temperatura baja por el revés.',
    'product.duffel.desc': 'Bolso de viaje de cuero full-grain diseñado para viajes cortos, escapadas de fin de semana y desplazamientos urbanos.',
    'product.duffel.materials': '100% Cuero premium de grano entero · Cierres y herrajes metálicos de alta resistencia · Forro interior duradero resistente al agua',
    'product.duffel.care': 'Limpieza especializada para cuero únicamente. Almacenar en un lugar fresco y seco. Evitar la exposición prolongada a la luz solar directa y la humedad.',

    'checkout.title': 'PAGO',
    'checkout.secure': 'Pago seguro',
    'checkout.contact': 'CONTACTO',
    'checkout.email': 'Correo electrónico',
    'checkout.shipping': 'DIRECCIÓN DE ENVÍO',
    'checkout.firstname': 'Nombre',
    'checkout.lastname': 'Apellido',
    'checkout.address': 'Dirección',
    'checkout.city': 'Ciudad',
    'checkout.postal': 'Código postal',
    'checkout.country': 'País / Región',
    'checkout.phone': 'Teléfono',
    'checkout.payment': 'PAGO',
    'checkout.card.number': 'Número de tarjeta',
    'checkout.card.exp': 'MM / AA',
    'checkout.card.cvv': 'CVV',
    'checkout.card.name': 'Nombre en la tarjeta',
    'checkout.summary': 'RESUMEN DEL PEDIDO',
    'checkout.shipping.line': 'Envío',
    'checkout.shipping.free': 'GRATIS',
    'checkout.total': 'TOTAL',
    'checkout.place_order': 'REALIZAR PEDIDO',
    'checkout.empty': 'Tu carrito está vacío. Agrega un producto antes de pagar.',
    'checkout.back': '← Volver a la tienda',
    'checkout.success.title': 'GRACIAS POR TU PEDIDO',
    'checkout.success.body': 'Hemos recibido tu pedido. Enviamos una confirmación a {email}. Recibirás tu número de seguimiento en breve.',
    'checkout.success.order': 'Pedido',
    'checkout.success.continue': 'SEGUIR COMPRANDO',
    'checkout.discount': 'Código de descuento',
    'checkout.apply': 'Aplicar',
    'campaign.tee.eyebrow': 'MADE FOR EVERYDAY',
    'campaign.eyebrow': 'MADE FOR EVERYWHERE',
    'campaign.duffel.eyebrow': 'MADE FOR MOVEMENT',
    'pf.down.t': 'RELLENO DE PLUMA 90/10',
    'pf.down.d': 'Relleno térmico 90/10 que atrapa el calor corporal manteniendo la prenda ligera para el movimiento diario.',
    'pf.water.t': 'REPELENTE AL AGUA',
    'pf.water.d': 'Shell exterior con tratamiento DWR que repele la llovizna y el viento. Ideal para climas impredecibles.',
    'pf.pack.t': 'TERMOREGULADOR',
    'pf.pack.d': 'Estructura ultra-compresible que permite guardar la prenda en su propio bolsillo. Máxima portabilidad para viajar.',
    'pf.wind.t': 'CORTAVIENTOS',
    'pf.wind.d': 'Estructura exterior densa que bloquea ráfagas de aire, manteniendo la temperatura interna de manera eficiente.',
    'pf.tee.cotton.t': '100% ALGODÓN PIMA',
    'pf.tee.cotton.d': 'Fibra extra-larga de máxima pureza. Ofrece una suavidad superior al tacto y un acabado de lujo que no pierde calidad.',
    'pf.tee.breath.t': 'ULTRASUAVE',
    'pf.tee.breath.d': 'Tejido ligero y termorregulador que permite el flujo de aire, manteniéndote fresco durante todo el día.',
    'pf.tee.build.t': 'AJUSTE CLÁSICO',
    'pf.tee.build.d': 'Cuello indeformable y patronaje estructurado. Mantiene su silueta limpia lavado tras lavado.',
    'pf.tee.seams.t': 'COSTURAS REFORZADAS',
    'pf.tee.seams.d': 'Alta densidad de puntadas para mayor resistencia en puntos de tensión estructural.',
    'pf.duffel.leather.t': '100% CUERO GENUINO',
    'pf.duffel.leather.d': 'Cuero de grano entero premium de la más alta calidad, seleccionado por su durabilidad y capacidad para envejecer con carácter con el uso constante.',
    'pf.duffel.garment.t': 'APERTURA GARMENT BAG',
    'pf.duffel.garment.d': 'Sistema de apertura total que permite desplegar el bolso por completo para una organización eficiente, reduciendo las arrugas en la ropa.',
    'pf.duffel.shoes.t': 'COMPARTIMENTO DE CALZADO',
    'pf.duffel.shoes.d': 'Espacio interno independiente para calzado u objetos personales aislados, manteniendo el compartimento principal limpio y organizado.',
    'pf.duffel.hardware.t': 'HERRAJES METÁLICOS',
    'pf.duffel.hardware.d': 'Cierres y detalles metálicos reforzados de alta durabilidad diseñados para resistir el uso diario y viajes frecuentes.',
    'pdp.feat.cotton': '100% ALGODÓN PIMA',
    'pdp.feat.stitching': 'COSTURAS REFORZADAS',
    'pdp.feat.comfort': 'ULTRASUAVE',
    'pdp.feat.fit': 'AJUSTE CLÁSICO',
    'pdp.feat.down': 'RELLENO DE PLUMA 90/10',
    'pdp.feat.water': 'REPELENTE AL AGUA',
    'pdp.feat.warmth': 'TERMOREGULADOR',
    'pdp.feat.breathable': 'CORTAVIENTOS',
    'pdp.feat.leather': '100% CUERO GENUINO',
    'pdp.feat.hardware': 'HERRAJES METÁLICOS',
    'pdp.feat.shoes': 'COMPARTIMENTO DE CALZADO',
    'pdp.feat.access': 'APERTURA GARMENT BAG',
    'diff.heading': 'THE MARK ALTITUDE DIFFERENCE',
    'diff.peru': 'DESIGNED IN PERU',
    'diff.peru.sub': 'Concebido en Lima. Líneas arquitectónicas inspiradas en el concreto urbano y paisajes peruanos.',
    'diff.care': 'MANUFACTURED WITH CARE',
    'diff.care.sub': 'Elaborado en talleres locales. Producción ética y acabados premium en cada costura.',
    'diff.last': 'MADE TO LAST',
    'diff.last.sub': 'Materiales atemporales. Pima peruano de fibra larga y pluma certificada para perdurar.'
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// INFO PAGES CONTENT (rendered by info.html?p=<slug>)
// All content lives here in a single bilingual dictionary so renderInfoPage()
// can build the page from a slug. Keep prose tight, in MARK ALTITUDE voice.
// ─────────────────────────────────────────────────────────────────────────────
const INFO_CONTENT = {
  es: {
    'about': {
      eyebrow: 'MANIFIESTO',
      title: 'NUESTRA HISTORIA',
      intro: 'CON ORIGEN EN PERÚ. CON VISIÓN INTERNACIONAL.',
      heroText: `
        <p class="history-hero__paragraph">MARK ALTITUDE nace de una convicción: desde Perú puede construirse una marca capaz de competir bajo un estándar internacional.</p>
        <p class="history-hero__paragraph">No desde la imitación, sino desde una visión propia.</p>
        <p class="history-hero__paragraph">Nada se plantea de forma aislada. Producto, identidad, calidad y experiencia forman parte de una misma dirección.</p>
        <p class="history-hero__paragraph">No buscamos ser reconocidos únicamente como una buena marca peruana. Buscamos construir una gran marca. Y hacerlo orgullosamente desde Perú.</p>
      `,
      bannerTitle: 'UN ESTÁNDAR MÁS ALTO.',
      bannerSubtitle: '<span class="history-feature-item">Diseño contemporáneo.</span> <span class="history-feature-item">Calidad elevada.</span> <span class="history-feature-item">Funcionalidad con propósito.</span>',
      bannerImg: 'mark-altitude-editorial-estandar-alto-casaca-plumas.jpg',
      closingLead: 'Este es el punto de partida.',
      closingTitle: 'MARK ALTITUDE CONTINÚA.',
      ctaText: 'DESCUBRIR EL SISTEMA'
    },
    'philosophy': {
      eyebrow: 'ADN',
      title: 'FILOSOFÍA',
      intro: 'MENOS RUIDO. MÁS INTENCIÓN.',
      heroBgImg: 'mark-altitude-editorial-filosofia-polo-negro.jpg',
      heroText: `
        <p class="history-hero__paragraph">MARK ALTITUDE parte de una convicción: la presencia no depende del exceso.</p>
        <p class="history-hero__paragraph">Se construye mediante decisiones precisas, materiales de alta calidad y piezas que cumplen una función real. Diseñamos para el hombre contemporáneo que encuentra seguridad en la claridad, no en la ostentación.</p>
      `,
      bannerSubtitle: '<span class="history-feature-item">DISEÑO CONTEMPORÁNEO.</span> <span class="history-feature-item">CALIDAD ELEVADA.</span> <span class="history-feature-item">FUNCIONALIDAD CON PROPÓSITO.</span>',
      ctaText: 'DESCUBRIR EL SISTEMA',
      pillars: [
        {
          title: 'LO ESENCIAL, ELEVADO.',
          body: `
            <p>Creemos en un guardarropa construido con menos piezas y mayor propósito.</p>
            <p>No diseñamos para llenar una colección ni para responder a una tendencia pasajera. Cada producto debe integrarse con naturalidad, acompañar distintos momentos y permanecer relevante más allá de una temporada.</p>
            <p>Eliminamos lo innecesario hasta conservar únicamente aquello que mejora la forma, el tacto y la experiencia de uso.</p>
          `
        },
        {
          title: 'FORMA Y FUNCIÓN.',
          body: `
            <p>La estética y la funcionalidad no deberían competir.</p>
            <p>Una silueta limpia, un ajuste preciso y un detalle funcional deben responder a una misma intención. Cada elemento tiene una razón de estar presente; nada se incorpora únicamente para llamar la atención.</p>
            <p>El diseño debe sentirse natural: piezas que se adaptan a la vida real sin perder carácter.</p>
          `
        },
        {
          title: 'LA CALIDAD SE PERCIBE.',
          body: `
            <p>La calidad comienza en la elección del material y continúa en la construcción, el ajuste y la manera en que una pieza responde con el tiempo.</p>
            <p>No buscamos demostrarla mediante el exceso. Buscamos que pueda sentirse desde el primer contacto y confirmarse con el uso.</p>
            <p>Un producto debe verse bien, sentirse bien y cumplir correctamente su propósito.</p>
          `
        },
        {
          title: 'PRESENCIA SIN ESFUERZO.',
          body: `
            <p>MARK ALTITUDE propone una visión contemporánea de la masculinidad: segura, sobria e intencional.</p>
            <p>La ropa no debe dominar a quien la lleva. Debe aportar estructura, libertad y confianza sin exigir atención.</p>
            <p>La verdadera presencia no necesita anunciarse.</p>
          `
        },
        {
          title: 'UN SISTEMA, NO RUIDO.',
          body: `
            <p>Cada pieza tiene una razón de existir y un lugar dentro del sistema.</p>
            <div class="philosophy-system-list">
              <span class="philosophy-system-item">Menos elementos.</span>
              <span class="philosophy-system-item">Más claridad.</span>
              <span class="philosophy-system-item">Más intención.</span>
            </div>
          `
        }
      ]
    },
    'filosofia': null, // set dynamically as alias to philosophy below
    'contact': {
      eyebrow: 'ESCRÍBENOS',
      title: 'ESTAMOS PARA AYUDARTE',
      intro: 'Si tienes preguntas sobre la talla, cuidados, envíos o devoluciones, estamos aquí para ayudarte personalmente al número de whatsapp +51 916 643 733.',
      body: `<!-- Contact uses a custom layout, body unused -->`,
      contact: {
        emailLabel: 'Email',
        emailValue: 'markaltitude.co@gmail.com',
        whatsappLabel: 'WhatsApp',
        whatsappValue: '+51 916 643 733',
        hoursLabel: 'Horario',
        hoursValue: 'Lun – Vie · 9:00 – 18:00 (GMT-5)',
        addressLabel: 'Empresa / Domicilio',
        addressValue: 'MARK ALTITUDE (RUC N.º 10737617985) · Calle Zepita N° 208 · Perú',
        instagramLabel: 'Instagram',
        instagramValue: '@mark.altitude',
        formTitle: 'Envíanos un mensaje',
        nameLabel: 'Nombre',
        emailFormLabel: 'Correo electrónico',
        subjectLabel: 'Asunto',
        subjectOptions: ['Consulta general', 'Pedido / envío', 'Devolución / cambio', 'Reclamo / sugerencia', 'Otro'],
        messageLabel: 'Tu mensaje',
        submit: 'ENVIAR MENSAJE',
        submitSuccess: 'Mensaje enviado. Te respondemos pronto.'
      }
    },
    'faq': {
      eyebrow: 'AYUDA',
      title: 'PREGUNTAS FRECUENTES',
      intro: 'Resolvemos las dudas más habituales sobre nuestros productos, envíos, pagos, tallas y cuidados. Si no encuentras la respuesta que buscas, estamos aquí para ayudarte personalmente al número de whatsapp +51 916 643 733.',
      body: `
        <h2>1. PRODUCTOS Y MATERIALES</h2>
        <p><strong>¿De qué materiales están hechas las casacas?</strong><br>
        Nuestras casacas cuentan con un relleno térmico de pluma 90/10 y un exterior de nylon mate repelente al agua.</p>

        <p><strong>¿De qué material están hechos los polos?</strong><br>
        Nuestros polos están confeccionados en 100% Algodón Pima peruano de fibra extra larga, ofreciendo máxima suavidad al tacto, transpirabilidad y una caída estructurada que se conserva tras cada lavado.</p>

        <p><strong>¿De qué material están hechos los bolsos de viaje?</strong><br>
        Nuestros bolsos de viaje están elaborados en 100% Cuero premium de grano entero, acompañados de cierres y herrajes metálicos de alta resistencia, junto con un forro interior duradero resistente al agua.</p>

        <h2>2. TALLAS Y RECOMENDACIÓN</h2>
        <p><strong>¿Cómo elijo mi talla correcta?</strong><br>
        Puedes revisar nuestra <a href="/search?view=minfo&p=tallas">Guía de Tallas</a> o usar nuestro recomendador introduciendo tu altura y peso en la página de cada producto.</p>

        <p><strong>¿Las medidas de la guía son de la prenda o del cuerpo?</strong><br>
        Las medidas son una referencia corporal. La recomendación puede variar ligeramente según las proporciones de cada persona.</p>

        <p><strong>¿Qué hago si dudo entre dos tallas?</strong><br>
        Si dudan entre tallas, suban una. Estamos aquí para ayudarte personalmente al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>

        <h2>3. ENVÍOS Y TIEMPOS DE ENTREGA</h2>
        <p><strong>¿Por medio de qué empresa realizan los envíos?</strong><br>
        En Perú los envíos se efectúan mediante la empresa Shalom. Para envíos internacionales (modo INTERNATIONAL USD / INTERNACIONAL USD), enviamos a través de DHL Express.</p>

        <p><strong>¿Cuánto cuesta el envío?</strong><br>
        En envíos internacionales (USD), los pedidos superiores a 100 USD cuentan con envío gratuito. En Perú, los pedidos superiores a S/ 349.00 cuentan con envío gratuito. Para compras menores a S/ 349.00, el costo de envío es cobrado durante el proceso de pago (checkout).</p>

        <p><strong>¿Cuál es el tiempo de procesamiento y envío?</strong><br>
        Los pedidos son preparados y enviados dentro de las 24 horas hábiles posteriores a la confirmación del pago. El tiempo de entrega para envíos internacionales vía DHL es de 3 a 7 días hábiles. Para Perú (Shalom), el tiempo de entrega es de 2 a 4 días hábiles.</p>

        <h2>4. CAMBIOS Y DEVOLUCIONES</h2>
        <p><strong>¿Cuál es el plazo para solicitar un cambio o devolución?</strong><br>
        Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.</p>

        <p><strong>¿Qué condiciones debe cumplir el producto?</strong><br>
        Los productos deben encontrarse sin uso, con sus etiquetas y en su empaque original.</p>

        <p><strong>¿MARK ALTITUDE cobras cargos por cambios?</strong><br>
        MARK ALTITUDE no aplica cargos adicionales por cambios de talla o devoluciones. El cliente únicamente deberá asumir el costo de envío del producto hacia MARK ALTITUDE.</p>

        <h2>5. MEDIOS DE PAGO</h2>
        <p><strong>¿Qué métodos de pago aceptan?</strong><br>
        Aceptamos Visa, Mastercard, American Express, Yape, Plin y transferencia bancaria directa. Todos los pagos son procesados de forma segura con encriptación SSL.</p>

        <p class="info-page__note">¿Tienes más preguntas? Escríbenos al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a> y te atenderemos de inmediato.</p>
      `
    },
    'tallas': {
      eyebrow: 'GUÍA',
      title: 'GUÍA DE TALLAS',
      intro: 'Las medidas son una referencia corporal. La recomendación puede variar ligeramente según las proporciones de cada persona.',
      body: `
        <p>Esta tabla de medidas aplica tanto para el polo como para la casaca (T-01 Essential Pima y J-01 Down Jacket).</p>

        <h2>TABLA DE MEDIDAS (EN CENTÍMETROS)</h2>

        <table style="width: 100%; border-collapse: collapse; margin: 1.5rem 0; font-size: 0.9rem;">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.2); text-align: left;">
              <th style="padding: 0.75rem 0;">TALLA</th>
              <th style="padding: 0.75rem 0;">PECHO</th>
              <th style="padding: 0.75rem 0;">CINTURA</th>
              <th style="padding: 0.75rem 0;">ESTATURA</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>S</strong></td>
              <td style="padding: 0.75rem 0;">92–96</td>
              <td style="padding: 0.75rem 0;">78–82</td>
              <td style="padding: 0.75rem 0;">165–170</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>M</strong></td>
              <td style="padding: 0.75rem 0;">96–100</td>
              <td style="padding: 0.75rem 0;">82–86</td>
              <td style="padding: 0.75rem 0;">170–175</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>L</strong></td>
              <td style="padding: 0.75rem 0;">100–105</td>
              <td style="padding: 0.75rem 0;">86–91</td>
              <td style="padding: 0.75rem 0;">175–180</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>XL</strong></td>
              <td style="padding: 0.75rem 0;">105–110</td>
              <td style="padding: 0.75rem 0;">91–96</td>
              <td style="padding: 0.75rem 0;">180–185</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>XXL</strong></td>
              <td style="padding: 0.75rem 0;">110–115</td>
              <td style="padding: 0.75rem 0;">96–102</td>
              <td style="padding: 0.75rem 0;">180–185</td>
            </tr>
          </tbody>
        </table>

        <h2>MÓDULO ENCUENTRA TU TALLA</h2>
        <p>Una vez que rellenes tus datos, te indicaremos tu talla recomendada en MARK ALTITUDE.</p>
        <p>Usaremos tu altura y peso únicamente para calcular la talla que mejor se adapta a ti. Estos datos no se vinculan con tu identidad.</p>

        <p class="info-page__note">Si dudan entre tallas, suban una. Estamos aquí para ayudarte personalmente al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>
      `
    },
    'envios': {
      eyebrow: 'LOGÍSTICA',
      title: 'ENVÍOS Y ENTREGAS',
      intro: 'Envíos en Perú mediante Shalom (envío gratis en compras > S/ 349.00). Envíos internacionales (modo INTERNATIONAL USD / INTERNACIONAL USD) a través de DHL Express con envío gratis por pedidos superiores a 100 USD.',
      body: `
        <h2>EMPRESA DE TRANSPORTE</h2>
        <p>En Perú los envíos se efectúan mediante la empresa Shalom. Para compras internacionales en dólares (USD), los envíos se efectúan a través de DHL Express.</p>

        <h2>COSTOS DE ENVÍO</h2>
        <p><strong>Envío Gratuito Internacional (USD):</strong> Los pedidos superiores a 100 USD cuentan con envío gratuito.</p>
        <p><strong>Envío Gratuito Perú (PEN):</strong> Los pedidos superiores a S/ 349.00 cuentan con envío gratuito.</p>
        <p><strong>Compras menores a la meta:</strong> Para compras menores a S/ 349.00, el costo de envío es cobrado durante el proceso de pago (checkout).</p>

        <h2>TIEMPO DE PROCESAMIENTO</h2>
        <p>Los pedidos son preparados y enviados dentro de las 24 horas hábiles posteriores a la confirmación del pago.</p>

        <h2>TIEMPO DE ENTREGA ESTIMADO</h2>
        <ul>
          <li><strong>Envíos Internacionales (DHL):</strong> 3 a 7 días hábiles tras el despacho.</li>
          <li><strong>Lima Metropolitana y Provincias (Shalom):</strong> 2 a 4 días hábiles tras el despacho.</li>
        </ul>

        <h2>INFORMACIÓN Y SEGUIMIENTO</h2>
        <p>Una vez que el paquete haya sido entregado al operador logístico (DHL / Shalom), enviaremos a tu correo/WhatsApp la guía de seguimiento para monitorear el estado del traslado.</p>

        <p class="info-page__note">Para consultas sobre tu envío, escríbenos al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>
      `
    },
    'devoluciones': {
      eyebrow: 'POLÍTICA',
      title: 'CAMBIOS Y DEVOLUCIONES',
      intro: 'Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.',
      body: `
        <h2>PLAZO PARA CAMBIOS Y DEVOLUCIONES</h2>
        <p>Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.</p>

        <h2>ESTADO DEL PRODUCTO</h2>
        <p>Los productos deben encontrarse sin uso, con sus etiquetas y en su empaque original.</p>

        <h2>COSTOS POR CAMBIOS Y DEVOLUCIONES</h2>
        <p>MARK ALTITUDE no aplica cargos adicionales por cambios de talla o devoluciones.</p>
        <p>El cliente deberá asumir el costo de envío del producto hacia MARK ALTITUDE.</p>

        <h2>PROCESO DE SOLICITUD</h2>
        <ol>
          <li>Envía un mensaje al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</li>
          <li>Indica tu Nombre Completo, Número de Pedido y la prenda que deseas cambiar o devolver.</li>
          <li>Te responderemos de inmediato para indicarte los datos de envío hacia MARK ALTITUDE.</li>
        </ol>

        <p class="info-page__note">Si tienes preguntas sobre la talla, cuidados, envíos o devoluciones, estamos aquí para ayudarte personalmente al número de whatsapp <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>
      `
    },
    'returns': {
      eyebrow: 'POLÍTICA',
      title: 'CAMBIOS Y DEVOLUCIONES',
      intro: 'Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.',
      body: `
        <p class="info-page__updated">Última actualización: 31 de julio de 2026</p>

        <h2>PLAZO PARA CAMBIOS Y DEVOLUCIONES</h2>
        <p>Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.</p>

        <h2>ESTADO DEL PRODUCTO</h2>
        <p>Los productos deben encontrarse sin uso, con sus etiquetas y en su empaque original.</p>

        <h2>COSTOS POR CAMBIOS Y DEVOLUCIONES</h2>
        <p>MARK ALTITUDE no aplica cargos adicionales por cambios de talla o devoluciones.</p>
        <p>El cliente deberá asumir el costo de envío del producto hacia MARK ALTITUDE.</p>

        <h2>PROCESO DE SOLICITUD</h2>
        <ol>
          <li>Envía un correo a <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a>.</li>
          <li>Indica tu Nombre Completo, Número de Pedido y motivo del cambio o devolución.</li>
          <li>Te enviaremos los datos de recepción en menos de 24 horas hábiles.</li>
        </ol>
      `
    },
    'privacy': {
      eyebrow: 'LEGAL',
      title: 'POLÍTICA DE PRIVACIDAD',
      intro: 'En MARK ALTITUDE respetamos la privacidad de nuestros clientes y usuarios. Conoce cómo recopilamos, utilizamos y protegemos tus datos personales conforme a la legislación peruana.',
      body: `
        <p class="info-page__updated">Última actualización: 31 de julio de 2026</p>

        <p>En MARK ALTITUDE respetamos la privacidad de nuestros clientes y usuarios. La presente Política de Privacidad describe la forma en que recopilamos, utilizamos, almacenamos, compartimos y protegemos los datos personales obtenidos mediante nuestro sitio web, canales de atención, procesos de compra y demás servicios relacionados con la marca.</p>

        <p>El tratamiento de los datos personales se realiza de conformidad con la Ley N.º 29733, Ley de Protección de Datos Personales, su Reglamento aprobado mediante el Decreto Supremo N.º 016-2024-JUS y demás normas aplicables en la República del Perú.</p>

        <h2>1. IDENTIDAD DEL RESPONSABLE</h2>
        <p>MARK ALTITUDE es una marca comercial operada bajo el RUC N.º 10737617985 y actúa como responsable del tratamiento de los datos personales recopilados mediante sus canales comerciales.</p>
        <p>Para consultas relacionadas con esta Política de Privacidad o con el tratamiento de datos personales, los usuarios podrán comunicarse mediante:</p>
        <p><strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
        <strong>Domicilio:</strong> Calle Zepita N° 208<br>
        <strong>País:</strong> Perú</p>

        <h2>2. DATOS PERSONALES QUE RECOPILAMOS</h2>
        <p>MARK ALTITUDE podrá recopilar las siguientes categorías de datos personales:</p>

        <h3>DATOS DE IDENTIFICACIÓN Y CONTACTO</h3>
        <ul>
          <li>Nombres y apellidos.</li>
          <li>Número de documento de identidad, cuando sea necesario para emitir comprobantes de pago o cumplir obligaciones legales.</li>
          <li>Número de teléfono.</li>
          <li>Dirección de correo electrónico.</li>
          <li>Dirección de entrega, ciudad, provincia y departamento.</li>
          <li>Información proporcionada mediante formularios o canales de atención.</li>
        </ul>

        <h3>DATOS RELACIONADOS CON LAS COMPRAS</h3>
        <ul>
          <li>Productos adquiridos.</li>
          <li>Talla, color y demás variantes seleccionadas.</li>
          <li>Número y estado del pedido.</li>
          <li>Importe de la compra.</li>
          <li>Método y estado del pago.</li>
          <li>Información necesaria para emitir comprobantes.</li>
          <li>Datos relacionados con cambios, devoluciones, garantías y solicitudes de atención.</li>
          <li>Información necesaria para coordinar el envío o recojo del pedido.</li>
        </ul>
        <p>MARK ALTITUDE no almacena directamente la información completa de tarjetas bancarias. Dichos datos son tratados por las plataformas y proveedores de pago habilitados en el sitio web, conforme a sus propias políticas de privacidad y medidas de seguridad.</p>

        <h3>DATOS DE NAVEGACIÓN Y USO</h3>
        <p>Al utilizar nuestro sitio web, podremos recopilar automáticamente determinada información técnica, entre ella:</p>
        <ul>
          <li>Dirección IP.</li>
          <li>Tipo de dispositivo.</li>
          <li>Tipo y versión del navegador.</li>
          <li>Sistema operativo.</li>
          <li>Páginas visitadas.</li>
          <li>Productos consultados.</li>
          <li>Tiempo de navegación.</li>
          <li>Interacciones realizadas dentro del sitio.</li>
          <li>Dirección web de procedencia.</li>
          <li>Identificadores asociados con cookies y tecnologías similares.</li>
        </ul>

        <h3>DATOS PARA COMUNICACIONES COMERCIALES</h3>
        <p>Cuando el usuario otorgue su consentimiento, podremos recopilar su correo electrónico, número de teléfono, preferencias de productos e historial de interacción para enviar novedades, lanzamientos, promociones, reposiciones de stock y comunicaciones relacionadas con MARK ALTITUDE.</p>

        <h2>3. FORMAS DE RECOPILACIÓN</h2>
        <p>Los datos personales podrán ser recopilados cuando el usuario:</p>
        <ul>
          <li>Realice una compra.</li>
          <li>Cree o utilice una cuenta de cliente.</li>
          <li>Complete formularios del sitio web.</li>
          <li>Utilice el sistema de recomendación de talla.</li>
          <li>Solicite ser notificado sobre la reposición de un producto.</li>
          <li>Se suscriba voluntariamente a comunicaciones comerciales.</li>
          <li>Se comunique mediante correo electrónico, redes sociales, mensajería u otros canales de atención.</li>
          <li>Solicite un cambio, devolución o atención posventa.</li>
          <li>Navegue o interactúe con el sitio web.</li>
        </ul>

        <h2>4. FINALIDADES DEL TRATAMIENTO</h2>
        <p>Los datos personales serán tratados para las siguientes finalidades:</p>
        <ul>
          <li>Procesar, confirmar y gestionar pedidos.</li>
          <li>Verificar y registrar pagos.</li>
          <li>Emitir comprobantes de pago.</li>
          <li>Coordinar la preparación, despacho, entrega o recojo de productos.</li>
          <li>Compartir los datos necesarios con Shalom u otros operadores logísticos que intervengan en la entrega.</li>
          <li>Atender consultas, reclamos, cambios, devoluciones y solicitudes de garantía.</li>
          <li>Proporcionar recomendaciones de talla y mejorar su precisión.</li>
          <li>Informar al usuario cuando una talla o producto solicitado vuelva a estar disponible.</li>
          <li>Gestionar la relación comercial con los clientes.</li>
          <li>Prevenir operaciones fraudulentas o usos indebidos del sitio.</li>
          <li>Cumplir obligaciones tributarias, contables, administrativas y legales.</li>
          <li>Mantener la seguridad y el correcto funcionamiento del sitio web.</li>
          <li>Analizar el uso de la tienda y mejorar la experiencia de navegación, los productos y los servicios.</li>
          <li>Elaborar estadísticas y análisis comerciales.</li>
          <li>Enviar comunicaciones promocionales únicamente cuando exista consentimiento o una base legal que lo permita.</li>
          <li>Atender requerimientos de autoridades administrativas, judiciales o tributarias.</li>
        </ul>
        <p>La negativa a proporcionar datos indispensables para procesar una compra podría impedir que MARK ALTITUDE complete el pedido o coordine la entrega.</p>

        <h2>5. BASES QUE LEGITIMAN EL TRATAMIENTO</h2>
        <p>MARK ALTITUDE tratará los datos personales cuando resulte aplicable alguna de las siguientes bases:</p>
        <ul>
          <li>El consentimiento libre, previo, expreso, informado e inequívoco del titular.</li>
          <li>La necesidad de ejecutar una relación contractual o adoptar medidas solicitadas antes de una compra.</li>
          <li>El cumplimiento de obligaciones legales.</li>
          <li>Las demás circunstancias autorizadas por la normativa peruana de protección de datos personales.</li>
        </ul>
        <p>El consentimiento para recibir comunicaciones comerciales será independiente de la aceptación necesaria para procesar una compra.</p>
        <p>El usuario podrá retirar su consentimiento para comunicaciones promocionales en cualquier momento, sin que ello afecte la licitud del tratamiento efectuado previamente.</p>

        <h2>6. COMUNICACIONES COMERCIALES Y REPOSICIONES</h2>
        <p>Cuando el usuario se suscriba a novedades, promociones o comunicaciones comerciales, MARK ALTITUDE podrá utilizar sus datos de contacto para enviarle información relacionada con productos, lanzamientos, campañas y ofertas.</p>
        <p>Cuando el usuario solicite una alerta de reposición, su correo electrónico será utilizado para informarle cuando el producto, color o talla seleccionada vuelva a encontrarse disponible.</p>
        <p>Solicitar una alerta de reposición no implica automáticamente la suscripción al boletín general de MARK ALTITUDE. Cualquier autorización para recibir comunicaciones promocionales adicionales deberá solicitarse de manera separada.</p>
        <p>El usuario podrá cancelar su suscripción mediante el enlace habilitado en los correos electrónicos recibidos o solicitándolo a través del correo de contacto indicado en esta política.</p>

        <h2>7. PROVEEDORES Y DESTINATARIOS DE LOS DATOS</h2>
        <p>Para desarrollar sus operaciones, MARK ALTITUDE podrá compartir únicamente los datos necesarios con proveedores que presten servicios vinculados con la tienda, entre ellos:</p>
        <ul>
          <li>Shopify y proveedores de alojamiento o infraestructura tecnológica.</li>
          <li>Plataformas de procesamiento de pagos.</li>
          <li>Shalom y demás operadores logísticos o de transporte.</li>
          <li>Proveedores de correo electrónico, mensajería y atención al cliente.</li>
          <li>Proveedores de analítica, medición y seguridad digital.</li>
          <li>Proveedores de servicios contables, tributarios o administrativos.</li>
          <li>Autoridades públicas cuando exista una obligación legal o requerimiento válido.</li>
        </ul>
        <p>Estos terceros podrán tratar los datos personales por cuenta de MARK ALTITUDE o como responsables independientes, según la naturaleza del servicio prestado y sus respectivas obligaciones legales.</p>
        <p>MARK ALTITUDE no vende ni comercializa los datos personales de sus clientes.</p>

        <h2>8. FLUJO TRANSFRONTERIZO DE DATOS</h2>
        <p>Algunos proveedores tecnológicos utilizados por MARK ALTITUDE, incluyendo plataformas de comercio electrónico, alojamiento, analítica, comunicaciones o procesamiento de pagos, podrían almacenar o procesar información en servidores ubicados fuera del Perú.</p>
        <p>En estos casos, MARK ALTITUDE adoptará las medidas razonables para que el tratamiento y la transferencia de los datos personales se realicen conforme a la legislación peruana y con niveles adecuados de protección y seguridad.</p>

        <h2>9. COOKIES Y TECNOLOGÍAS SIMILARES</h2>
        <p>El sitio web podrá utilizar cookies, píxeles, etiquetas y tecnologías similares para:</p>
        <ul>
          <li>Permitir el funcionamiento de la tienda.</li>
          <li>Mantener activo el carrito de compras.</li>
          <li>Recordar preferencias del usuario.</li>
          <li>Procesar pedidos de forma segura.</li>
          <li>Analizar el tráfico y rendimiento del sitio.</li>
          <li>Comprender la interacción con productos y contenidos.</li>
          <li>Medir campañas publicitarias, cuando corresponda.</li>
          <li>Personalizar determinadas funciones o comunicaciones.</li>
        </ul>
        <p>Algunas cookies son necesarias para el funcionamiento del sitio y no pueden desactivarse desde nuestros sistemas. Las cookies analíticas o publicitarias que requieran consentimiento serán utilizadas de acuerdo con las preferencias seleccionadas por el usuario.</p>
        <p>El usuario puede configurar su navegador para bloquear o eliminar cookies. Sin embargo, algunas funciones de la tienda podrían dejar de operar correctamente.</p>

        <h2>10. CONSERVACIÓN DE LOS DATOS</h2>
        <p>Los datos personales serán conservados durante el tiempo necesario para cumplir las finalidades señaladas en esta política, gestionar la relación contractual y atender las obligaciones legales, tributarias, contables o administrativas aplicables.</p>
        <p>Cuando los datos ya no sean necesarios y no exista una obligación legal que justifique su conservación, serán eliminados, anonimizados o sometidos a medidas que impidan su utilización.</p>
        <p>Los datos utilizados exclusivamente para comunicaciones comerciales serán tratados hasta que el usuario retire su consentimiento o solicite su eliminación, sin perjuicio de la información mínima que deba conservarse para acreditar dicha solicitud.</p>

        <h2>11. SEGURIDAD DE LA INFORMACIÓN</h2>
        <p>MARK ALTITUDE adopta medidas técnicas, organizativas y legales razonables para proteger los datos personales frente a pérdida, acceso no autorizado, alteración, divulgación, destrucción o tratamiento indebido.</p>
        <p>No obstante, ninguna transmisión o sistema de almacenamiento electrónico puede garantizar una seguridad absoluta. En caso de producirse un incidente que pudiera afectar significativamente los derechos de los titulares, MARK ALTITUDE actuará de conformidad con las obligaciones establecidas por la normativa aplicable.</p>

        <h2>12. DERECHOS DEL TITULAR</h2>
        <p>El titular de los datos personales puede ejercer los derechos reconocidos por la legislación peruana, incluyendo:</p>
        <ul>
          <li><strong>Acceso:</strong> conocer qué datos personales son tratados y cómo están siendo utilizados.</li>
          <li><strong>Rectificación:</strong> solicitar la corrección o actualización de datos inexactos, incompletos o desactualizados.</li>
          <li><strong>Cancelación:</strong> solicitar la eliminación de los datos cuando corresponda.</li>
          <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos personales en los casos permitidos por ley.</li>
          <li><strong>Revocación:</strong> retirar el consentimiento otorgado para finalidades que dependan de este.</li>
          <li><strong>Información:</strong> recibir información clara sobre las condiciones y finalidades del tratamiento.</li>
        </ul>
        <p>Para ejercer estos derechos, el titular deberá enviar una solicitud al correo:</p>
        <p><strong><a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a></strong></p>
        <p>La solicitud deberá contener, como mínimo:</p>
        <ul>
          <li>Nombres y apellidos del titular.</li>
          <li>Medio para recibir la respuesta.</li>
          <li>Derecho que desea ejercer.</li>
          <li>Descripción clara de su solicitud.</li>
          <li>Documentación que permita acreditar su identidad, cuando resulte necesario.</li>
          <li>Información adicional que facilite la ubicación de sus datos.</li>
        </ul>
        <p>MARK ALTITUDE atenderá la solicitud dentro de los plazos establecidos por la normativa peruana.</p>
        <p>Si el titular considera que su solicitud no ha sido atendida adecuadamente, podrá acudir ante la Autoridad Nacional de Protección de Datos Personales del Ministerio de Justicia y Derechos Humanos.</p>

        <h2>13. DATOS DE MENORES DE EDAD</h2>
        <p>El sitio web y los productos de MARK ALTITUDE no se encuentran dirigidos específicamente a menores de edad.</p>
        <p>Cuando una compra sea realizada por un menor, deberá contar con la autorización y supervisión de sus padres, tutores o representantes legales. Si MARK ALTITUDE identifica que se han recopilado datos de un menor sin la autorización correspondiente, podrá adoptar medidas para eliminarlos.</p>

        <h2>14. ENLACES Y SERVICIOS DE TERCEROS</h2>
        <p>El sitio web puede contener enlaces o integraciones con plataformas externas, redes sociales, proveedores de pago u otros servicios de terceros.</p>
        <p>MARK ALTITUDE no controla las prácticas de privacidad de dichos terceros. Se recomienda al usuario revisar sus respectivas políticas antes de proporcionarles información personal.</p>

        <h2>15. ACTUALIZACIONES DE LA POLÍTICA</h2>
        <p>MARK ALTITUDE podrá modificar esta Política de Privacidad para reflejar cambios normativos, operativos, tecnológicos o comerciales.</p>
        <p>La versión vigente será publicada en el sitio web indicando su fecha de última actualización. Cuando los cambios sean sustanciales y resulte necesario, se informará a los usuarios mediante los canales disponibles.</p>

        <h2>16. CONTACTO</h2>
        <p>Para consultas, solicitudes o comentarios relacionados con la privacidad y el tratamiento de datos personales, el usuario puede comunicarse con MARK ALTITUDE mediante:</p>
        <p><strong>MARK ALTITUDE</strong><br>
        <strong>RUC N.º 10737617985</strong><br>
        <strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
        <strong>Domicilio:</strong> Calle Zepita N° 208<br>
        <strong>País:</strong> Perú</p>
      `
    },
    'privacidad': null, // set dynamically below
    'terms': {
      eyebrow: 'LEGAL',
      title: 'TÉRMINOS Y CONDICIONES',
      intro: 'Los presentes Términos y Condiciones regulan el acceso, navegación y uso del sitio web de MARK ALTITUDE, así como las compras de productos realizadas mediante la tienda en línea y los demás canales comerciales habilitados por la marca.',
      body: `
        <p class="info-page__updated">Última actualización: 31 de julio de 2026</p>

        <p>Los presentes Términos y Condiciones regulan el acceso, navegación y uso del sitio web de MARK ALTITUDE, así como las compras de productos realizadas mediante la tienda en línea y los demás canales comerciales habilitados por la marca.</p>
        <p>Al acceder al sitio web, crear una cuenta, completar un pedido o adquirir un producto, el usuario declara haber leído y aceptado estos Términos y Condiciones, la Política de Privacidad y las demás políticas publicadas por MARK ALTITUDE.</p>

        <h2>1. IDENTIFICACIÓN DEL PROVEEDOR</h2>
        <p>MARK ALTITUDE es una marca comercial operada bajo los siguientes datos:</p>
        <p><strong>MARK ALTITUDE</strong><br>
        <strong>RUC N.º 10737617985</strong><br>
        <strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
        <strong>Domicilio:</strong> Calle Zepita N° 208<br>
        <strong>País:</strong> Perú</p>
        <p>Para consultas relacionadas con compras, productos, pedidos, cambios o devoluciones, el cliente puede comunicarse mediante el correo electrónico indicado.</p>

        <h2>2. ÁMBITO DE APLICACIÓN</h2>
        <p>Los presentes Términos y Condiciones se aplican a todas las personas que accedan al sitio web o adquieran productos ofrecidos por MARK ALTITUDE.</p>
        <p>Las compras realizadas mediante la tienda en línea se encuentran sujetas a la legislación vigente en la República del Perú, incluyendo el Código de Protección y Defensa del Consumidor y demás normas aplicables.</p>
        <p>Ninguna disposición de estos Términos y Condiciones limita o excluye los derechos que la legislación peruana reconoce a los consumidores.</p>

        <h2>3. CAPACIDAD PARA REALIZAR COMPRAS</h2>
        <p>El usuario declara contar con capacidad legal suficiente para celebrar contratos y realizar compras.</p>
        <p>Las personas menores de edad deberán efectuar cualquier compra bajo la autorización y supervisión de sus padres, tutores o representantes legales.</p>
        <p>Cuando una compra sea realizada por una persona en representación de otra, se entenderá que cuenta con autorización suficiente para proporcionar sus datos y completar la operación.</p>

        <h2>4. INFORMACIÓN DE LOS PRODUCTOS</h2>
        <p>MARK ALTITUDE procura presentar de forma clara, suficiente y actualizada las características esenciales de cada producto, incluyendo, según corresponda:</p>
        <ul>
          <li>Nombre y código del producto.</li>
          <li>Composición y materiales.</li>
          <li>Color.</li>
          <li>Tallas disponibles.</li>
          <li>Tipo de ajuste.</li>
          <li>Medidas o dimensiones.</li>
          <li>Precio.</li>
          <li>Cuidados recomendados.</li>
          <li>Disponibilidad de stock.</li>
          <li>Imágenes referenciales del producto.</li>
        </ul>
        <p>Las imágenes buscan representar los productos con la mayor fidelidad posible. Sin embargo, pueden existir variaciones mínimas en la percepción del color debido a la iluminación utilizada en las fotografías, la configuración de la pantalla o el dispositivo del usuario.</p>
        <p>Estas variaciones visuales mínimas no modifican las características esenciales, materiales, estructura ni calidad ofrecida del producto.</p>
        <p>El cliente es responsable de revisar la descripción, composición, medidas, guía de tallas y demás información disponible antes de realizar la compra.</p>

        <h2>5. SISTEMA DE RECOMENDACIÓN DE TALLA</h2>
        <p>MARK ALTITUDE podrá poner a disposición del usuario un sistema orientativo de recomendación de talla basado en información como la altura y el peso.</p>
        <p>La recomendación constituye una referencia destinada a facilitar la elección del producto. El ajuste final puede variar según la composición corporal, las proporciones personales y la preferencia de uso de cada cliente.</p>
        <p>La recomendación de talla no sustituye la revisión de la guía de medidas ni impide que el cliente solicite un cambio dentro de las condiciones establecidas en estos Términos y Condiciones.</p>

        <h2>6. DISPONIBILIDAD Y STOCK</h2>
        <p>Todos los pedidos se encuentran sujetos a disponibilidad de stock.</p>
        <p>La incorporación de un producto al carrito de compras no constituye una reserva. El producto se considerará adquirido únicamente después de que el pedido y el pago hayan sido confirmados.</p>
        <p>En caso de agotamiento, error de inventario o imposibilidad de atender un pedido ya pagado, MARK ALTITUDE se comunicará con el cliente para ofrecer, según corresponda:</p>
        <ul>
          <li>El cambio por otro producto disponible.</li>
          <li>La espera por una reposición, previa aceptación del cliente.</li>
          <li>La devolución íntegra del importe pagado por el producto no disponible.</li>
        </ul>
        <p>MARK ALTITUDE podrá habilitar alertas de reposición. La solicitud de una alerta no constituye una reserva, preventa ni garantía de disponibilidad futura.</p>

        <h2>7. PRECIOS</h2>
        <p>Los precios se muestran en soles peruanos e incluyen los tributos que resulten aplicables.</p>
        <p>El precio vigente será el que aparezca en el sitio web al momento de completar la compra, salvo que exista un error manifiesto y verificable.</p>
        <p>Antes de confirmar el pedido, el cliente podrá revisar el precio de los productos, los descuentos aplicables y cualquier otro importe relacionado con la compra.</p>
        <p>El costo del envío no se encuentra incluido en el precio del producto, excepto cuando el pedido cumpla las condiciones para acceder al envío gratuito o cuando se indique expresamente lo contrario.</p>

        <h2>8. PROMOCIONES Y DESCUENTOS</h2>
        <p>Las promociones, descuentos, códigos promocionales y beneficios comerciales estarán sujetos a:</p>
        <ul>
          <li>El periodo de vigencia indicado.</li>
          <li>La disponibilidad de stock.</li>
          <li>Los productos participantes.</li>
          <li>El importe mínimo de compra, cuando corresponda.</li>
          <li>Las condiciones específicas comunicadas en cada promoción.</li>
        </ul>
        <p>Salvo que se indique expresamente lo contrario, las promociones no son acumulables entre sí.</p>
        <p>Los descuentos no podrán ser canjeados por dinero en efectivo ni aplicados retroactivamente a pedidos confirmados con anterioridad.</p>
        <p>Cuando una promoción tenga stock limitado, MARK ALTITUDE informará las condiciones o unidades disponibles mediante el sitio web, la publicidad correspondiente o el canal en el que se comunique la promoción.</p>

        <h2>9. PROCESO DE COMPRA</h2>
        <p>Para realizar una compra, el cliente deberá:</p>
        <ol>
          <li>Seleccionar el producto, color, talla y cantidad.</li>
          <li>Añadir el producto al carrito.</li>
          <li>Proporcionar los datos solicitados para la compra y coordinación del pedido.</li>
          <li>Revisar el resumen del pedido.</li>
          <li>Seleccionar el método de pago disponible.</li>
          <li>Confirmar la compra.</li>
          <li>Completar correctamente el pago.</li>
        </ol>
        <p>El cliente es responsable de verificar que la información proporcionada sea correcta antes de confirmar el pedido.</p>
        <p>Después de completar la compra, MARK ALTITUDE podrá enviar una confirmación al correo electrónico o medio de contacto registrado por el cliente.</p>
        <p>La recepción de una solicitud de pedido no implica necesariamente su aceptación definitiva. La compra quedará confirmada cuando el pago sea aprobado y MARK ALTITUDE confirme que puede atender el pedido.</p>

        <h2>10. MEDIOS DE PAGO</h2>
        <p>Los pedidos podrán pagarse mediante los métodos habilitados y mostrados durante el proceso de compra.</p>
        <p>Los pagos pueden ser procesados por proveedores externos que aplican sus propias medidas de seguridad, condiciones de uso y políticas de privacidad.</p>
        <p>MARK ALTITUDE no almacena directamente la información completa de las tarjetas bancarias utilizadas por el cliente.</p>
        <p>Cuando una operación sea rechazada, observada o no pueda ser validada por el proveedor de pagos, el pedido podrá permanecer pendiente o no ser confirmado.</p>
        <p>El cliente declara que se encuentra autorizado para utilizar el medio de pago seleccionado.</p>

        <h2>11. VALIDACIÓN Y CANCELACIÓN DE PEDIDOS</h2>
        <p>MARK ALTITUDE podrá solicitar información razonablemente necesaria para validar una compra, prevenir operaciones fraudulentas o confirmar la identidad del comprador.</p>
        <p>Un pedido podrá ser cancelado antes de su despacho cuando:</p>
        <ul>
          <li>El pago no haya sido aprobado.</li>
          <li>Los datos proporcionados sean incompletos o no puedan ser verificados.</li>
          <li>Se detecte un posible uso fraudulento del medio de pago.</li>
          <li>El producto no se encuentre disponible debido a un error de inventario.</li>
          <li>Exista un error manifiesto en el precio o información esencial de la oferta.</li>
          <li>Se presente una causa que impida razonablemente atender el pedido.</li>
        </ul>
        <p>Cuando un pedido pagado sea cancelado por una causa atribuible a MARK ALTITUDE, se informará al cliente y se realizará la devolución íntegra del importe cobrado por dicho pedido.</p>
        <p>El cliente podrá solicitar la cancelación escribiendo a <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a>. La cancelación podrá efectuarse siempre que el pedido todavía no haya sido entregado al operador logístico.</p>
        <p>Si el pedido ya fue despachado, se aplicarán las condiciones correspondientes a cambios y devoluciones.</p>

        <h2>12. TIEMPO DE PROCESAMIENTO</h2>
        <p>Los pedidos son preparados y enviados dentro de las 24 horas hábiles posteriores a la confirmación de la compra.</p>
        <p>El plazo de procesamiento no incluye sábados, domingos, feriados ni días declarados no laborables cuando estos afecten las operaciones de MARK ALTITUDE o del operador logístico.</p>
        <p>Durante campañas, lanzamientos, promociones, periodos de alta demanda o circunstancias excepcionales, el procesamiento podría requerir un tiempo adicional. En ese caso, MARK ALTITUDE procurará informar al cliente mediante los canales disponibles.</p>

        <h2>13. ENVÍOS</h2>
        <p>MARK ALTITUDE realiza envíos a nivel nacional en Perú mediante la empresa Shalom, y envíos internacionales a través de DHL Express.</p>
        <p>Para envíos en Perú, los pedidos superiores a S/ 349.00 cuentan con envío gratuito. Para compras menores a S/ 349.00, el costo de envío es cobrado durante el proceso de pago (checkout).</p>
        <p>Para envíos internacionales (modo INTERNATIONAL USD / INTERNACIONAL USD), los pedidos superiores a 100 USD cuentan con envío gratuito. Para compras menores a 100 USD, el costo de envío es calculado durante el proceso de pago (checkout) y gestionado a través de DHL.</p>

        <h2>14. INFORMACIÓN PARA LA ENTREGA</h2>
        <p>El cliente deberá proporcionar datos completos y correctos para coordinar el envío, incluyendo:</p>
        <ul>
          <li>Nombres y apellidos.</li>
          <li>Número de documento, cuando sea requerido por el operador logístico.</li>
          <li>Número de teléfono.</li>
          <li>Correo electrónico.</li>
          <li>Ciudad y departamento.</li>
          <li>Agencia o dirección de destino, según corresponda.</li>
          <li>Cualquier referencia razonablemente necesaria.</li>
        </ul>
        <p>MARK ALTITUDE no será responsable por retrasos o imposibilidad de entrega derivados de información incorrecta, incompleta o desactualizada proporcionada por el cliente.</p>
        <p>Cuando un pedido deba ser enviado nuevamente debido a datos incorrectos, falta de recojo, rechazo injustificado o una circunstancia atribuible al cliente, este deberá asumir el nuevo costo de envío.</p>
        <p>Si el cliente detecta un error en los datos proporcionados, deberá comunicarlo inmediatamente antes de que el pedido sea entregado a Shalom.</p>

        <h2>15. RECEPCIÓN DEL PEDIDO</h2>
        <p>Al recibir o recoger el pedido, el cliente deberá verificar, dentro de un plazo razonable:</p>
        <ul>
          <li>El estado exterior del paquete.</li>
          <li>Que el producto corresponda al pedido realizado.</li>
          <li>La talla y color seleccionados.</li>
          <li>La cantidad de productos.</li>
          <li>La existencia de posibles daños, defectos o faltantes.</li>
        </ul>
        <p>Si el paquete presenta daños evidentes, señales de apertura o irregularidades, se recomienda dejar constancia ante Shalom y comunicarse inmediatamente con MARK ALTITUDE.</p>
        <p>Para facilitar la evaluación de una incidencia, MARK ALTITUDE podrá solicitar fotografías o videos del paquete, la etiqueta de envío y el producto recibido.</p>
        <p>Esta solicitud no limita los derechos que correspondan al consumidor conforme a ley.</p>

        <h2>16. CAMBIOS Y DEVOLUCIONES</h2>
        <p>Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega del pedido.</p>
        <p>Para acceder a un cambio o devolución voluntaria, el producto deberá:</p>
        <ul>
          <li>Encontrarse sin uso.</li>
          <li>Conservar sus etiquetas originales.</li>
          <li>Mantenerse limpio y sin alteraciones.</li>
          <li>No presentar manchas, olores, daños o señales de lavado.</li>
          <li>Incluir sus accesorios y componentes, cuando corresponda.</li>
          <li>Encontrarse en su empaque original.</li>
        </ul>
        <p>El cliente deberá enviar su solicitud a <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a>, indicando:</p>
        <ul>
          <li>Nombre completo.</li>
          <li>Número de pedido.</li>
          <li>Producto que desea cambiar o devolver.</li>
          <li>Motivo de la solicitud.</li>
          <li>Fotografías del producto cuando sean requeridas para una evaluación inicial.</li>
        </ul>
        <p>El envío de una solicitud no implica su aprobación automática. MARK ALTITUDE verificará el cumplimiento de las condiciones cuando reciba el producto.</p>

        <h2>17. COSTOS POR CAMBIOS Y DEVOLUCIONES</h2>
        <p>Los cambios de talla o devoluciones no tienen un costo adicional por parte de MARK ALTITUDE.</p>
        <p>Sin embargo, en cambios o devoluciones voluntarias, el cliente deberá asumir el costo de envío del producto hacia MARK ALTITUDE.</p>
        <p>En caso de cambio, el cliente deberá cancelar el costo de envío del nuevo producto directamente con Shalom.</p>
        <p>Estas condiciones no se aplicarán cuando el producto presente un defecto de fabricación, no corresponda al pedido realizado o exista otra causa atribuible a MARK ALTITUDE. En dichos casos, los costos necesarios para solucionar la incidencia serán asumidos conforme a la legislación aplicable.</p>

        <h2>18. CAMBIOS DE TALLA O PRODUCTO</h2>
        <p>Los cambios se encuentran sujetos a disponibilidad de stock.</p>
        <p>Si la talla o producto solicitado no se encuentra disponible, el cliente podrá elegir entre las alternativas que MARK ALTITUDE pueda ofrecer, incluyendo:</p>
        <ul>
          <li>Esperar una reposición.</li>
          <li>Cambiar por otro producto disponible.</li>
          <li>Recibir la devolución del importe correspondiente.</li>
        </ul>
        <p>Si el nuevo producto tiene un precio mayor, el cliente deberá pagar la diferencia antes del despacho.</p>
        <p>Si tiene un precio menor, MARK ALTITUDE devolverá la diferencia mediante el método acordado con el cliente.</p>
        <p>El cambio será procesado después de que MARK ALTITUDE reciba y verifique el estado del producto original.</p>

        <h2>19. DEVOLUCIÓN DEL DINERO</h2>
        <p>Cuando una devolución sea aprobada, MARK ALTITUDE gestionará el reembolso del importe pagado por el producto.</p>
        <p>El reembolso podrá realizarse mediante el mismo medio utilizado para la compra o mediante otro mecanismo acordado con el cliente cuando el método original no permita procesarlo directamente.</p>
        <p>El tiempo en que el importe se refleje en la cuenta del cliente puede depender del banco, proveedor de pagos o entidad financiera correspondiente.</p>
        <p>Los costos de envío cobrados en el checkout corresponden al servicio de transporte ya gestionado y no forman parte del importe reembolsado del producto, salvo que la devolución sea consecuencia de una causa atribuible a MARK ALTITUDE y corresponda asumirlos conforme a ley.</p>

        <h2>20. PRODUCTOS CON DEFECTOS O PEDIDOS INCORRECTOS</h2>
        <p>Si el cliente recibe un producto con un posible defecto de fabricación, daño, faltante o características diferentes de las ofrecidas, deberá comunicarse con MARK ALTITUDE mediante <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a>.</p>
        <p>La comunicación deberá incluir, cuando sea posible:</p>
        <ul>
          <li>Número de pedido.</li>
          <li>Descripción de la incidencia.</li>
          <li>Fotografías o videos del producto.</li>
          <li>Fotografías del empaque y etiqueta de envío.</li>
          <li>Cualquier otra información que permita evaluar el caso.</li>
        </ul>
        <p>MARK ALTITUDE evaluará la solicitud y ofrecerá la medida que corresponda, de acuerdo con la naturaleza del caso y la normativa aplicable. Esto podrá incluir la reparación, cambio, entrega del producto correcto o devolución del importe pagado.</p>
        <p>No se considerarán defectos de fabricación los daños derivados de:</p>
        <ul>
          <li>Uso contrario a las instrucciones o finalidad del producto.</li>
          <li>Lavado o cuidado inadecuado.</li>
          <li>Desgaste natural.</li>
          <li>Accidentes.</li>
          <li>Alteraciones o reparaciones realizadas por terceros.</li>
          <li>Uso negligente o indebido.</li>
        </ul>
        <p>Lo anterior se aplicará sin perjuicio de los derechos legales del consumidor.</p>

        <h2>21. CUIDADO DE LOS PRODUCTOS</h2>
        <p>El cliente deberá seguir las instrucciones de cuidado, lavado, almacenamiento y mantenimiento indicadas en las etiquetas, empaques, fichas de producto o comunicaciones proporcionadas por MARK ALTITUDE.</p>
        <p>El uso de métodos de limpieza, productos químicos, temperaturas o procedimientos no recomendados podría deteriorar los materiales y afectar la durabilidad del producto.</p>
        <p>En artículos de cuero, las variaciones naturales de textura, grano o marcas propias del material no necesariamente constituyen defectos, siempre que correspondan a las características del cuero utilizado y no afecten la funcionalidad del producto.</p>

        <h2>22. COMUNICACIONES ELECTRÓNICAS</h2>
        <p>Al realizar una compra, el cliente autoriza a MARK ALTITUDE a enviar comunicaciones necesarias para gestionar la operación, incluyendo:</p>
        <ul>
          <li>Confirmación de pedido.</li>
          <li>Validación del pago.</li>
          <li>Estado del pedido.</li>
          <li>Coordinación del envío.</li>
          <li>Atención posventa.</li>
          <li>Cambios, devoluciones o reembolsos.</li>
          <li>Alertas de seguridad o información contractual.</li>
        </ul>
        <p>Estas comunicaciones son necesarias para ejecutar la compra y son independientes de las comunicaciones comerciales.</p>
        <p>MARK ALTITUDE solo enviará publicidad, promociones, novedades o campañas cuando exista autorización del usuario o una base legal que lo permita.</p>
        <p>El usuario podrá retirar su consentimiento para comunicaciones comerciales sin afectar los mensajes necesarios relacionados con pedidos en curso.</p>

        <h2>23. PROTECCIÓN DE DATOS PERSONALES</h2>
        <p>El tratamiento de los datos personales se realiza conforme a la Política de Privacidad de MARK ALTITUDE y a la legislación peruana aplicable.</p>
        <p>Los datos proporcionados podrán utilizarse para procesar pedidos, verificar pagos, coordinar envíos, atender solicitudes, prevenir fraudes y cumplir obligaciones legales.</p>
        <p>Cuando sea necesario, los datos indispensables para la entrega podrán ser compartidos con Shalom y otros proveedores que intervengan en la operación.</p>
        <p>La Política de Privacidad forma parte integral de estos Términos y Condiciones.</p>

        <h2>24. PROPIEDAD INTELECTUAL</h2>
        <p>Todos los elementos del sitio web y de los canales oficiales de MARK ALTITUDE, incluyendo, entre otros:</p>
        <ul>
          <li>Nombre comercial.</li>
          <li>Logotipo.</li>
          <li>Identidad visual.</li>
          <li>Fotografías.</li>
          <li>Videos.</li>
          <li>Textos.</li>
          <li>Diseños.</li>
          <li>Gráficos.</li>
          <li>Ilustraciones.</li>
          <li>Fichas de producto.</li>
          <li>Campañas.</li>
          <li>Elementos de interfaz.</li>
          <li>Contenido editorial.</li>
          <li>Código y estructura del sitio.</li>
        </ul>
        <p>se encuentran protegidos por la legislación aplicable sobre propiedad intelectual, derecho de autor, marcas y competencia desleal.</p>
        <p>No está permitido copiar, reproducir, modificar, distribuir, publicar, comercializar o utilizar estos elementos sin autorización previa y expresa de MARK ALTITUDE o del titular correspondiente.</p>
        <p>El acceso al sitio web no otorga al usuario ningún derecho de propiedad sobre sus contenidos.</p>

        <h2>25. USO PERMITIDO DEL SITIO WEB</h2>
        <p>El usuario se compromete a utilizar el sitio web de manera lícita y de buena fe.</p>
        <p>Queda prohibido:</p>
        <ul>
          <li>Utilizar el sitio para realizar actividades fraudulentas.</li>
          <li>Proporcionar información falsa o utilizar datos de terceros sin autorización.</li>
          <li>Intentar acceder sin autorización a sistemas, cuentas o información.</li>
          <li>Interferir con el funcionamiento o seguridad del sitio.</li>
          <li>Introducir virus, código malicioso o herramientas automatizadas perjudiciales.</li>
          <li>Copiar o extraer sistemáticamente información del sitio.</li>
          <li>Utilizar el contenido de MARK ALTITUDE con fines comerciales no autorizados.</li>
          <li>Suplantar la identidad de otra persona.</li>
        </ul>
        <p>MARK ALTITUDE podrá restringir el acceso o cancelar pedidos vinculados con actividades fraudulentas o contrarias a estos Términos y Condiciones, sin perjuicio de las acciones legales correspondientes.</p>

        <h2>26. DISPONIBILIDAD DEL SITIO WEB</h2>
        <p>MARK ALTITUDE procura mantener el sitio web disponible y funcionando correctamente.</p>
        <p>No obstante, el acceso puede verse temporalmente interrumpido por mantenimiento, actualizaciones, fallas técnicas, problemas de conectividad, servicios de terceros o circunstancias fuera del control razonable de MARK ALTITUDE.</p>
        <p>Cuando resulte posible, se adoptarán medidas para restablecer el servicio y reducir el impacto sobre los usuarios.</p>
        <p>Las interrupciones del sitio no afectarán los derechos derivados de pedidos previamente confirmados.</p>

        <h2>27. ENLACES Y SERVICIOS DE TERCEROS</h2>
        <p>El sitio web puede contener enlaces, aplicaciones o integraciones proporcionadas por terceros, incluyendo proveedores de pago, redes sociales, herramientas de analítica y servicios logísticos.</p>
        <p>El uso de dichos servicios puede encontrarse sujeto a sus propios términos, políticas y condiciones.</p>
        <p>MARK ALTITUDE no controla el contenido ni las prácticas independientes de sitios o plataformas externas. Sin embargo, esto no limita la responsabilidad que le corresponda como proveedor frente al consumidor conforme a la legislación aplicable.</p>

        <h2>28. RESPONSABILIDAD</h2>
        <p>MARK ALTITUDE responderá por el cumplimiento de las condiciones ofrecidas, la idoneidad de sus productos y las obligaciones que le correspondan conforme a la legislación peruana.</p>
        <p>MARK ALTITUDE no será responsable por daños derivados exclusivamente de:</p>
        <ul>
          <li>Uso incorrecto del producto.</li>
          <li>Incumplimiento de instrucciones de cuidado.</li>
          <li>Información incorrecta proporcionada por el cliente.</li>
          <li>Actos fraudulentos realizados por terceros ajenos a su control razonable.</li>
          <li>Circunstancias imprevisibles o inevitables debidamente acreditadas.</li>
        </ul>
        <p>Ninguna disposición de estos Términos y Condiciones excluye la responsabilidad por dolo, culpa inexcusable ni cualquier otra responsabilidad que no pueda limitarse legalmente.</p>

        <h2>29. CASO FORTUITO O FUERZA MAYOR</h2>
        <p>MARK ALTITUDE no será responsable por retrasos ocasionados por acontecimientos extraordinarios, imprevisibles o inevitables que impidan temporalmente el cumplimiento de una obligación.</p>
        <p>Estos acontecimientos pueden incluir desastres naturales, bloqueos de vías, restricciones de transporte, conflictos sociales, interrupciones generales de servicios, disposiciones de autoridades o eventos similares fuera del control razonable de MARK ALTITUDE.</p>
        <p>Cuando una situación de esta naturaleza afecte un pedido, MARK ALTITUDE procurará informar al cliente y adoptar una solución razonable, sin perjuicio de los derechos reconocidos por ley.</p>

        <h2>30. MODIFICACIONES DE LOS TÉRMINOS Y CONDICIONES</h2>
        <p>MARK ALTITUDE podrá modificar estos Términos y Condiciones para reflejar cambios legales, comerciales, operativos o tecnológicos.</p>
        <p>La versión vigente será publicada en el sitio web con la fecha de su última actualización.</p>
        <p>Las modificaciones se aplicarán a las compras realizadas después de su publicación y no alterarán las condiciones de pedidos confirmados con anterioridad, salvo que el cambio sea requerido por una norma de obligatorio cumplimiento.</p>

        <h2>31. NULIDAD PARCIAL</h2>
        <p>Si alguna disposición de estos Términos y Condiciones fuera declarada inválida, ilegal o inaplicable, las demás disposiciones conservarán su vigencia.</p>
        <p>La disposición afectada será interpretada o sustituida en la medida necesaria para preservar su finalidad dentro de los límites permitidos por la legislación aplicable.</p>

        <h2>32. LEGISLACIÓN APLICABLE Y SOLUCIÓN DE CONTROVERSIAS</h2>
        <p>Los presentes Términos y Condiciones se rigen por las leyes de la República del Perú.</p>
        <p>Ante cualquier inconveniente, el cliente podrá comunicarse directamente con MARK ALTITUDE para buscar una solución.</p>
        <p>El cliente también podrá utilizar el Libro de Reclamaciones o acudir a las autoridades y mecanismos de protección al consumidor que resulten competentes.</p>
        <p>Ninguna disposición obliga al consumidor a renunciar a la jurisdicción, autoridad o mecanismo de protección que le corresponda conforme a ley.</p>

        <h2>33. LIBRO DE RECLAMACIONES</h2>
        <p>MARK ALTITUDE cuenta con un Libro de Reclamaciones virtual, disponible mediante el enlace visible y accesible incorporado en el sitio web.</p>
        <p>La presentación de un reclamo o queja mediante el Libro de Reclamaciones no impide que el consumidor utilice otros mecanismos de solución de controversias ni constituye un requisito previo para acudir ante el Indecopi.</p>
        <p>Los reclamos y quejas serán atendidos dentro del plazo máximo establecido por la normativa vigente.</p>

        <h2>34. CONTACTO</h2>
        <p>Para consultas, solicitudes o comunicaciones relacionadas con estos Términos y Condiciones, el cliente puede comunicarse mediante:</p>
        <p><strong>MARK ALTITUDE</strong><br>
        <strong>RUC N.º 10737617985</strong><br>
        <strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
        <strong>Domicilio:</strong> Calle Zepita N° 208<br>
        <strong>País:</strong> Perú</p>
      `
    },
    'terminos': null, // set dynamically below

    'reclamaciones': {
      eyebrow: 'LEGAL',
      title: 'LIBRO DE RECLAMACIONES',
      intro: 'Conforme a lo establecido en el Código de Protección y Defensa del Consumidor (Ley N.º 29571), MARK ALTITUDE pone a disposición su Libro de Reclamaciones virtual.',
      body: `
        <p>De acuerdo con el artículo 150 del Código de Protección y Defensa del Consumidor (Ley N.º 29571) y su reglamento, todo establecimiento comercial está obligado a contar con un Libro de Reclamaciones a disposición de sus consumidores.</p>

        <p>MARK ALTITUDE cuenta con un Libro de Reclamaciones virtual mediante el cual el consumidor puede registrar sus reclamos o quejas de forma sencilla y oportuna.</p>

        <h2>¿CÓMO PRESENTAR UN RECLAMO O QUEJA?</h2>
        <p>Para registrar tu reclamo o queja, comunícate con nosotros directamente:</p>
        <p>
          <strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
          <strong>Domicilio:</strong> Calle Zepita N° 208, Perú
        </p>
        <p>Indica en tu mensaje los siguientes datos:</p>
        <ul>
          <li>Nombre completo.</li>
          <li>Número de documento de identidad.</li>
          <li>Número de teléfono o correo de contacto.</li>
          <li>Número de pedido (si aplica).</li>
          <li>Tipo de solicitud: <strong>Reclamo</strong> (disconformidad con un producto o servicio) o <strong>Queja</strong> (disconformidad con la atención).</li>
          <li>Descripción detallada del motivo.</li>
          <li>Detalle del pedido, monto involucrado y cualquier otra información relevante.</li>
        </ul>

        <h2>DIFERENCIA ENTRE RECLAMO Y QUEJA</h2>
        <ul>
          <li><strong>Reclamo:</strong> Disconformidad relacionada con los productos o servicios adquiridos (defectos, incumplimiento, diferencias con lo ofrecido, etc.).</li>
          <li><strong>Queja:</strong> Disconformidad relacionada con la atención recibida, sin estar necesariamente vinculada a un producto o servicio específico.</li>
        </ul>

        <h2>PLAZOS DE ATENCIÓN</h2>
        <p>MARK ALTITUDE atenderá los reclamos y quejas dentro del plazo máximo de <strong>15 días hábiles</strong> contados desde la fecha de recepción de la solicitud, conforme a la normativa vigente.</p>
        <p>Si el caso requiere una evaluación adicional, comunicaremos al consumidor cualquier extensión del plazo con la debida anticipación.</p>

        <h2>RESULTADO DEL TRÁMITE</h2>
        <p>Una vez evaluado el reclamo o queja, MARK ALTITUDE informará al consumidor el resultado y las acciones adoptadas o a adoptar.</p>
        <p>La presentación de un reclamo o queja no impide que el consumidor recurra a otras instancias, incluyendo el Indecopi u otras autoridades competentes.</p>

        <h2>DERECHOS DEL CONSUMIDOR</h2>
        <p>El registro de un reclamo o queja no elimina ni restringe el derecho del consumidor a:</p>
        <ul>
          <li>Acudir al Indecopi para presentar una denuncia.</li>
          <li>Utilizar los mecanismos alternativos de solución de controversias.</li>
          <li>Ejercer cualquier otra acción legal que corresponda conforme a ley.</li>
        </ul>

        <h2>IDENTIFICACIÓN DEL PROVEEDOR</h2>
        <p>
          <strong>MARK ALTITUDE</strong><br>
          <strong>RUC N.º 10737617985</strong><br>
          <strong>Correo electrónico:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
          <strong>Domicilio:</strong> Calle Zepita N° 208<br>
          <strong>País:</strong> Perú
        </p>
      `
    },

    'refund': {
      eyebrow: 'POLÍTICA',
      title: 'POLÍTICA DE REEMBOLSO',
      intro: 'Tiempos, métodos y condiciones para recibir tu dinero de vuelta. Procesamos cada caso de manera personal — no usamos respuestas automáticas.',
      body: `
        <h2>Plazo de procesamiento</h2>
        <p>Una vez que recibimos la prenda en nuestro almacén y verificamos su estado, iniciamos el reembolso en un plazo máximo de <strong>5 días hábiles</strong>. Dependiendo del banco emisor, el dinero puede tardar entre <strong>5 y 10 días hábiles adicionales</strong> en aparecer en tu cuenta.</p>

        <h2>Método de reembolso</h2>
        <p>Devolvemos al <strong>mismo medio de pago</strong> que usaste originalmente. No hacemos reembolsos en efectivo ni a cuentas distintas a la del pago.</p>
        <ul>
          <li><strong>Tarjeta de crédito / débito:</strong> reembolso a la tarjeta original.</li>
          <li><strong>Yape / Plin:</strong> al mismo número de origen.</li>
          <li><strong>Transferencia bancaria:</strong> a la cuenta de origen.</li>
        </ul>

        <h2>Monto reembolsado</h2>
        <p>Devolvemos el <strong>100% del precio del producto</strong>. Los costos de envío original solo se reembolsan si la devolución se debe a un error nuestro (talla o color equivocado, prenda con defecto).</p>

        <h2>Excepciones</h2>
        <ul>
          <li>Productos en <strong>oferta final</strong> (marcados explícitamente) no son reembolsables.</li>
          <li>Productos personalizados o hechos a medida.</li>
          <li>Prendas devueltas con signos de uso, lavado o sin etiquetas.</li>
        </ul>

        <h2>Cómo solicitar un reembolso</h2>
        <ol>
          <li>Inicia el proceso desde nuestra <a href="/search?view=minfo&p=returns">Política de devoluciones</a>.</li>
          <li>Recibe la guía de devolución y entrega la prenda al courier.</li>
          <li>Una vez recibida, verificamos y procesamos el reembolso automáticamente.</li>
          <li>Recibes confirmación por email cuando se inicia el reembolso desde nuestro lado.</li>
        </ol>

        <p class="info-page__note">Si han pasado más de 15 días hábiles desde nuestra confirmación de reembolso y no ves el monto, escríbenos a <strong>hola@markaltitude.com</strong> con el comprobante y lo escalamos directamente con el banco.</p>
      `
    }
  },
  en: {
    'about': {
      eyebrow: 'MANIFESTO',
      title: 'OUR STORY',
      intro: 'ROOTED IN PERU. BUILT WITH A GLOBAL VISION.',
      heroText: `
        <p class="history-hero__paragraph">MARK ALTITUDE was born from a conviction: a brand built in Peru can compete at an international standard.</p>
        <p class="history-hero__paragraph">Not through imitation, but through a vision of its own.</p>
        <p class="history-hero__paragraph">Nothing is conceived in isolation. Product, identity, quality, and experience are shaped by the same direction.</p>
        <p class="history-hero__paragraph">We do not aspire to be recognized simply as a good Peruvian brand. We aim to build a great brand. And to do it proudly from Peru.</p>
      `,
      bannerTitle: 'A HIGHER STANDARD.',
      bannerSubtitle: '<span class="history-feature-item">Contemporary design.</span> <span class="history-feature-item">Elevated quality.</span> <span class="history-feature-item">Purposeful functionality.</span>',
      bannerImg: 'mark-altitude-editorial-estandar-alto-casaca-plumas.jpg',
      closingLead: 'This is the starting point.',
      closingTitle: 'MARK ALTITUDE CONTINUES.',
      ctaText: 'DISCOVER THE SYSTEM'
    },
    'philosophy': {
      eyebrow: 'DNA',
      title: 'PHILOSOPHY',
      intro: 'LESS NOISE. MORE INTENTION.',
      heroBgImg: 'mark-altitude-editorial-filosofia-polo-negro.jpg',
      heroText: `
        <p class="history-hero__paragraph">MARK ALTITUDE stems from a conviction: presence does not depend on excess.</p>
        <p class="history-hero__paragraph">It is built through precise choices, high-quality materials, and pieces that fulfill a real function. We design for the contemporary man who finds confidence in clarity, not in ostentation.</p>
      `,
      bannerSubtitle: '<span class="history-feature-item">CONTEMPORARY DESIGN.</span> <span class="history-feature-item">ELEVATED QUALITY.</span> <span class="history-feature-item">PURPOSEFUL FUNCTIONALITY.</span>',
      ctaText: 'DISCOVER THE SYSTEM',
      pillars: [
        {
          title: 'THE ESSENTIAL, ELEVATED.',
          body: `
            <p>We believe in a wardrobe built with fewer pieces and greater purpose.</p>
            <p>We do not design to fill a collection nor to respond to a fleeting trend. Each product must integrate naturally, accompany different moments, and remain relevant beyond a single season.</p>
            <p>We eliminate the unnecessary until retaining only that which enhances form, touch, and user experience.</p>
          `
        },
        {
          title: 'FORM AND FUNCTION.',
          body: `
            <p>Esthetics and functionality should not compete.</p>
            <p>A clean silhouette, a precise fit, and a functional detail must respond to the same intention. Each element has a reason to be present; nothing is added solely to draw attention.</p>
            <p>Design should feel natural: pieces that adapt to real life without losing character.</p>
          `
        },
        {
          title: 'QUALITY IS PERCEIVED.',
          body: `
            <p>Quality begins with the choice of material and continues through construction, fit, and how a piece responds over time.</p>
            <p>We do not seek to demonstrate it through excess. We seek for it to be felt from first contact and confirmed through use.</p>
            <p>A product must look good, feel good, and fulfill its purpose correctly.</p>
          `
        },
        {
          title: 'EFFORTLESS PRESENCE.',
          body: `
            <p>MARK ALTITUDE proposes a contemporary vision of masculinity: confident, restrained, and intentional.</p>
            <p>Clothing should not dominate the wearer. It must provide structure, freedom, and confidence without demanding attention.</p>
            <p>True presence does not need to announce itself.</p>
          `
        },
        {
          title: 'A SYSTEM, NOT NOISE.',
          body: `
            <p>Each piece has a reason to exist and a place within the system.</p>
            <div class="philosophy-system-list">
              <span class="philosophy-system-item">Fewer elements.</span>
              <span class="philosophy-system-item">More clarity.</span>
              <span class="philosophy-system-item">More intention.</span>
            </div>
          `
        }
      ]
    },
    'filosofia': null,
    'contact': {
      eyebrow: 'WRITE TO US',
      title: 'WE\'RE HERE TO HELP',
      intro: 'Whether it\'s a sizing question, a return, a collaboration or anything else — we prefer to answer personally. We respond within 24 business hours.',
      body: `<!-- Contact uses a custom layout, body unused -->`,
      contact: {
        emailLabel: 'Email',
        emailValue: 'markaltitude.co@gmail.com',
        whatsappLabel: 'WhatsApp',
        whatsappValue: '+51 916 643 733',
        hoursLabel: 'Hours',
        hoursValue: 'Mon – Fri · 9:00 – 18:00 (GMT-5)',
        addressLabel: 'Company / Address',
        addressValue: 'MARK ALTITUDE (RUC N.º 10737617985) · Calle Zepita N° 208 · Peru',
        instagramLabel: 'Instagram',
        instagramValue: '@mark.altitude',
        formTitle: 'Send us a message',
        nameLabel: 'Name',
        emailFormLabel: 'Email address',
        subjectLabel: 'Subject',
        subjectOptions: ['General inquiry', 'Order / shipping', 'Return / exchange', 'Collaboration', 'Other'],
        messageLabel: 'Your message',
        submit: 'SEND MESSAGE',
        submitSuccess: 'Message sent. We\'ll get back to you soon.'
      }
    },
    'blog': {
      eyebrow: 'JOURNAL',
      title: 'MARK ALTITUDE JOURNAL',
      intro: 'Notes on materials, garment care and the way we dress to move between altitude and the city.',
      body: `<!-- Blog uses a custom layout, body unused -->`,
      articles: [
        {
          category: 'CARE',
          date: 'March 15, 2026',
          title: 'How to care for your down jacket so it lasts for years',
          excerpt: 'Natural down loses warmth if you wash it wrong. We explain the proper washing, drying and storing method to keep your jacket like new season after season.',
          read: 'Read article'
        },
        {
          category: 'MATERIALS',
          date: 'March 02, 2026',
          title: 'Pima cotton: why it\'s among the best in the world',
          excerpt: 'Peruvian Pima has been grown in coastal valleys for over 4,000 years. Its extra-long fiber is what separates a tee that lasts one summer from one that lasts a decade.',
          read: 'Read article'
        },
        {
          category: 'STYLE',
          date: 'February 20, 2026',
          title: 'The art of urban layering',
          excerpt: 'Three layers, a neutral palette and a single rule: each piece must work on its own. How to build a look that goes from work to weekend effortlessly.',
          read: 'Read article'
        }
      ]
    },
    'returns': {
      eyebrow: 'POLICY',
      title: 'RETURNS & EXCHANGES',
      intro: 'We want it to fit perfectly. If something doesn\'t work, we return or exchange without hassle — free within Peru during the first 30 days.',
      body: `
        <h2>Time frame</h2>
        <p>You have <strong>30 days from the date of receipt</strong> to start a return or exchange. After that, we cannot process the request.</p>

        <h2>Conditions</h2>
        <ul>
          <li>The garment must be <strong>unused</strong>, unwashed and with all original tags attached.</li>
          <li>It must arrive in its original packaging (or equivalent that protects it).</li>
          <li>We don't accept returns of final-sale items or custom products.</li>
        </ul>

        <h2>Size or color exchanges</h2>
        <p>Exchanges within Peru are <strong>free</strong>. We send you the correct size or color and pick up the original at no charge. Subject to availability.</p>

        <h2>Refunds</h2>
        <p>Once we receive the garment and verify its condition, we process the refund to the original payment method within <strong>5 to 10 business days</strong>. For refund details, see our <a href="/search?view=minfo&p=refund">Refund policy</a>.</p>

        <h2>How to start a return</h2>
        <ol>
          <li>Email us at <strong>markaltitude.co@gmail.com</strong> with your order number and reason.</li>
          <li>We confirm within 24 business hours and send the return label.</li>
          <li>You pack the garment and hand it to the courier (we coordinate it free of charge in Peru).</li>
          <li>We receive, inspect and process exchange or refund.</li>
        </ol>

        <h2>International shipping</h2>
        <p>For orders outside Peru, return shipping costs are the customer's responsibility. The refund is processed once the garment is received in our warehouse.</p>

        <p class="info-page__note">More questions? Reach out via <a href="/search?view=minfo&p=contact">contact</a> and we'll help.</p>
      `
    },
    'privacy': {
      eyebrow: 'LEGAL',
      title: 'PRIVACY POLICY',
      intro: 'Your personal information is yours. We only collect what\'s needed to process your order and improve your experience. We never sell data to third parties.',
      body: `
        <p class="info-page__updated">Last updated: February 15, 2026</p>

        <h2>1. Data we collect</h2>
        <p>When you buy or subscribe we collect: name, email, shipping address, phone and payment information. When you browse, we record anonymous technical data (browser, IP, pages visited) via cookies.</p>

        <h2>2. Use of data</h2>
        <ul>
          <li>Process and ship your order.</li>
          <li>Communicate shipping and return status.</li>
          <li>Send you offers and news, only if you explicitly subscribed.</li>
          <li>Improve our site (anonymous analytics).</li>
        </ul>

        <h2>3. Cookies</h2>
        <p>We use strictly necessary cookies (cart, session) and anonymous analytics cookies. You can disable them in your browser, though some site features may not work correctly.</p>

        <h2>4. Your rights</h2>
        <p>Per <strong>Peru's Personal Data Protection Law N° 29733</strong> and applicable international regulations, you have the right to:</p>
        <ul>
          <li>Access the data we hold about you.</li>
          <li>Request its correction or update.</li>
          <li>Request its deletion.</li>
          <li>Object to processing or withdraw your consent.</li>
        </ul>

        <h2>5. Payment processors</h2>
        <p>We never store credit card data on our servers. Payments are processed by PCI-DSS certified providers.</p>

        <h2>6. Retention</h2>
        <p>We keep your data while you have an active account or as needed to comply with legal obligations (invoicing, warranty).</p>

        <h2>7. Contact</h2>
        <p>To exercise any right, write to <strong>privacy@markaltitude.com</strong>. We respond within 10 business days.</p>
      `
    },
    'terms': {
      eyebrow: 'LEGAL',
      title: 'TERMS & CONDITIONS',
      intro: 'The rules governing the use of markaltitude.com and the purchase of our products. Read them at your own pace — they\'re written to be clear.',
      body: `
        <p class="info-page__updated">Last updated: February 15, 2026</p>

        <h2>1. Acceptance</h2>
        <p>By using this site or making a purchase, you accept these terms in full. If you don't agree, please don't continue.</p>

        <h2>2. Products and prices</h2>
        <p>Images are referential: there may be slight tone variations due to your screen. Prices are in Peruvian Soles (S/) or US Dollars (USD) depending on the selected currency, and include VAT where applicable. We reserve the right to change prices without prior notice.</p>

        <h2>3. Orders</h2>
        <p>An order is considered confirmed when we send the confirmation email. We reserve the right to reject orders due to lack of stock, information errors or suspicion of fraud.</p>

        <h2>4. Payments</h2>
        <p>We accept Visa, Mastercard, American Express, Yape and Plin (Peru). All payments are processed by certified external providers.</p>

        <h2>5. Shipping</h2>
        <p>We detail times and costs in the <a href="/#faq">FAQ</a>. Risk of loss transfers to the customer upon delivery.</p>

        <h2>6. Returns</h2>
        <p>See our <a href="/search?view=minfo&p=returns">Returns policy</a> and <a href="/search?view=minfo&p=refund">Refund policy</a>.</p>

        <h2>7. Intellectual property</h2>
        <p>All site content (logos, photos, copy, design) is property of MARK ALTITUDE or used under license. It cannot be reproduced without written authorization.</p>

        <h2>8. Limitation of liability</h2>
        <p>MARK ALTITUDE is not liable for indirect damages arising from use of the site or the garments beyond the value of the order.</p>
            <p class="info-page__note">If more than 15 business days have passed since our refund confirmation and you don't see the amount, write to <strong>markaltitude.co@gmail.com</strong> with proof and we'll escalate it directly with the bank.</p>
      `
    },
    'faq': {
      eyebrow: 'HELP',
      title: 'FREQUENTLY ASKED QUESTIONS',
      intro: 'We answer the most common questions about our products, shipping, payments, sizing and care. If you don\'t find the answer you\'re looking for, we are here to assist you personally via WhatsApp at +51 916 643 733.',
      body: `
        <h2>1. PRODUCTS AND MATERIALS</h2>
        <p><strong>What materials are the jackets made of?</strong><br>
        Our jackets feature high-quality 90/10 duck down insulation with RDS (Responsible Down Standard) certification and a windproof exterior with DWR water-repellent finish.</p>

        <p><strong>What material are the t-shirts made of?</strong><br>
        Our t-shirts are crafted from 100% Peruvian Pima Cotton with extra-long staple fibers, delivering maximum softness, breathability, and a structured drape that lasts wash after wash.</p>

        <h2>2. SIZES AND FIT RECOMMENDATION</h2>
        <p><strong>How do I choose my correct size?</strong><br>
        You can check our <a href="/search?view=minfo&p=tallas">Size Guide</a> or use our fit recommender by entering your height and weight on any product page.</p>

        <p><strong>Are the guide measurements for the garment or the body?</strong><br>
        Measurements are body reference metrics. Recommendations may vary slightly depending on individual proportions.</p>

        <p><strong>What should I do if I am between two sizes?</strong><br>
        If between sizes, we recommend sizing up. We are here to assist you personally via WhatsApp at <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>

        <h2>3. SHIPPING AND DELIVERY TIMES</h2>
        <p><strong>Which company handles shipping?</strong><br>
        International orders (USD) are shipped via DHL Express. Orders within Peru are shipped via Shalom.</p>

        <p><strong>How much is shipping?</strong><br>
        International orders over $100 USD include free shipping. Orders within Peru over S/ 349.00 include free shipping. For purchases below these amounts, shipping cost is calculated and charged at checkout, with MARK ALTITUDE making payment directly to Shalom.</p>

        <p><strong>What is the processing and shipping time?</strong><br>
        Orders are prepared and dispatched within 24 business hours of payment confirmation. Estimated delivery time for international shipping via DHL is 3 to 7 business days. Delivery within Peru takes 2 to 4 business days.</p>

        <h2>4. RETURNS AND EXCHANGES</h2>
        <p><strong>What is the deadline to request an exchange or return?</strong><br>
        Exchanges and returns can be requested within 30 days of receiving your order.</p>

        <p><strong>What conditions must the product meet?</strong><br>
        Products must be unworn, with original tags attached and in original packaging.</p>

        <p><strong>Does MARK ALTITUDE charge extra fees for exchanges?</strong><br>
        MARK ALTITUDE does not charge extra fees for size exchanges or returns. The customer only covers the return shipping cost to MARK ALTITUDE.</p>

        <h2>5. PAYMENT METHODS</h2>
        <p><strong>What payment methods do you accept?</strong><br>
        We accept Visa, Mastercard, American Express, Yape, Plin, and direct bank transfer. All payments are processed securely with SSL encryption.</p>

        <p class="info-page__note">Have more questions? Reach out via WhatsApp at <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a> and we'll help immediately.</p>
      `
    },
    'tallas': {
      eyebrow: 'GUIDE',
      title: 'SIZE GUIDE',
      intro: 'Measurements serve as a body reference. Recommendations may vary slightly according to individual body proportions.',
      body: `
        <p>This measurement table applies to both t-shirts and jackets (T-01 Essential Pima and J-01 Down Jacket).</p>

        <h2>SIZE CHART (IN CENTIMETERS)</h2>

        <table style="width: 100%; border-collapse: collapse; margin: 1.5rem 0; font-size: 0.9rem;">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.2); text-align: left;">
              <th style="padding: 0.75rem 0;">SIZE</th>
              <th style="padding: 0.75rem 0;">CHEST</th>
              <th style="padding: 0.75rem 0;">WAIST</th>
              <th style="padding: 0.75rem 0;">HEIGHT</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>S</strong></td>
              <td style="padding: 0.75rem 0;">92–96</td>
              <td style="padding: 0.75rem 0;">78–82</td>
              <td style="padding: 0.75rem 0;">165–170</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>M</strong></td>
              <td style="padding: 0.75rem 0;">96–100</td>
              <td style="padding: 0.75rem 0;">82–86</td>
              <td style="padding: 0.75rem 0;">170–175</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>L</strong></td>
              <td style="padding: 0.75rem 0;">100–105</td>
              <td style="padding: 0.75rem 0;">86–91</td>
              <td style="padding: 0.75rem 0;">175–180</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>XL</strong></td>
              <td style="padding: 0.75rem 0;">105–110</td>
              <td style="padding: 0.75rem 0;">91–96</td>
              <td style="padding: 0.75rem 0;">180–185</td>
            </tr>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.08);">
              <td style="padding: 0.75rem 0;"><strong>XXL</strong></td>
              <td style="padding: 0.75rem 0;">110–115</td>
              <td style="padding: 0.75rem 0;">96–102</td>
              <td style="padding: 0.75rem 0;">180–185</td>
            </tr>
          </tbody>
        </table>

        <h2>FIND YOUR SIZE MODULE</h2>
        <p>Once you enter your metrics, we will show your recommended size at MARK ALTITUDE.</p>
        <p>We use your height and weight solely to calculate the best fit. This data is not linked to your identity.</p>

        <p class="info-page__note">If between sizes, size up. Reach out via WhatsApp at <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a> and we'll assist you personally.</p>
      `
    },
    'envios': {
      eyebrow: 'LOGISTICS',
      title: 'SHIPPING & DELIVERIES',
      intro: 'International orders (USD) are shipped via DHL Express with free shipping on orders over $100 USD. Orders within Peru are handled via Shalom.',
      body: `
        <h2>CARRIER</h2>
        <p>International shipments are handled via DHL Express. Domestic Peru shipments are handled by Shalom.</p>

        <h2>SHIPPING COSTS</h2>
        <p><strong>Free International Shipping (USD):</strong> Orders over $100 USD include free shipping.</p>
        <p><strong>Free Shipping in Peru (PEN):</strong> Orders over S/ 349.00 include free shipping.</p>
        <p><strong>Orders below threshold:</strong> Shipping cost is calculated at checkout or paid upon pickup/delivery.</p>

        <h2>PROCESSING TIME</h2>
        <p>Orders are prepared and shipped within 24 business hours following payment confirmation.</p>

        <h2>ESTIMATED DELIVERY TIME</h2>
        <ul>
          <li><strong>International (DHL):</strong> 3 to 7 business days after dispatch.</li>
          <li><strong>Metropolitan Lima & Provinces (Shalom):</strong> 2 to 4 business days after dispatch.</li>
        </ul>

        <h2>TRACKING INFORMATION</h2>
        <p>Once your package is handed over to the carrier (DHL / Shalom), we will send tracking details to your WhatsApp / email.</p>

        <p class="info-page__note">For inquiries regarding your shipment, write to us on WhatsApp at <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer">+51 916 643 733</a>.</p>
      `
    },
    'reclamaciones': {
      eyebrow: 'LEGAL',
      title: 'COMPLAINTS BOOK',
      intro: 'In compliance with the Consumer Protection and Defense Code (Law No. 29571), MARK ALTITUDE provides its virtual Complaints Book.',
      body: `
        <p>In accordance with Article 150 of the Consumer Protection and Defense Code (Law No. 29571) and its regulations, every commercial establishment is required to make a Complaints Book available to its consumers.</p>

        <p>MARK ALTITUDE has a virtual Complaints Book through which consumers can register their claims or complaints easily and promptly.</p>

        <h2>HOW TO SUBMIT A CLAIM OR COMPLAINT?</h2>
        <p>To register your claim or complaint, contact us directly:</p>
        <p>
          <strong>Email:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
          <strong>Address:</strong> Calle Zepita N° 208, Peru
        </p>
        <p>Please include the following information in your message:</p>
        <ul>
          <li>Full name.</li>
          <li>Identity document number (DNI / Passport).</li>
          <li>Contact phone number or email.</li>
          <li>Order number (if applicable).</li>
          <li>Request type: <strong>Claim</strong> (dissatisfaction with a product or service) or <strong>Complaint</strong> (dissatisfaction with customer service/attention).</li>
          <li>Detailed description of the reason.</li>
          <li>Order details, amount involved, and any other relevant information.</li>
        </ul>

        <h2>DIFFERENCE BETWEEN CLAIM AND COMPLAINT</h2>
        <ul>
          <li><strong>Claim:</strong> Dissatisfaction related to the products or services purchased (defects, non-compliance, differences from what was offered, etc.).</li>
          <li><strong>Complaint:</strong> Dissatisfaction related to customer service or attention received, not necessarily linked to a specific product or service.</li>
        </ul>

        <h2>RESPONSE TIMEFRAMES</h2>
        <p>MARK ALTITUDE will address claims and complaints within a maximum of <strong>15 business days</strong> from the date of receipt of the request, in accordance with current legislation.</p>
        <p>If the case requires additional evaluation, we will notify the consumer of any deadline extension with due notice.</p>

        <h2>PROCEDURE OUTCOME</h2>
        <p>Once the claim or complaint is evaluated, MARK ALTITUDE will inform the consumer of the outcome and the actions taken or to be taken.</p>
        <p>Filing a claim or complaint does not prevent the consumer from resorting to other instances, including Indecopi or other competent authorities.</p>

        <h2>CONSUMER RIGHTS</h2>
        <p>Registering a claim or complaint does not eliminate or restrict the consumer's right to:</p>
        <ul>
          <li>Go to Indecopi to file a complaint.</li>
          <li>Use alternative dispute resolution mechanisms.</li>
          <li>Exercise any other legal action corresponding under the law.</li>
        </ul>

        <h2>PROVIDER IDENTIFICATION</h2>
        <p>
          <strong>MARK ALTITUDE</strong><br>
          <strong>RUC No. 10737617985</strong><br>
          <strong>Email:</strong> <a href="mailto:markaltitude.co@gmail.com">markaltitude.co@gmail.com</a><br>
          <strong>Address:</strong> Calle Zepita N° 208<br>
          <strong>Country:</strong> Peru
        </p>
      `
    }
  }
};
// Spanish aliases
INFO_CONTENT.es.privacidad = INFO_CONTENT.es.privacy;
INFO_CONTENT.es.terminos = INFO_CONTENT.es.terms;
INFO_CONTENT.es.contacto = INFO_CONTENT.es.contact;
INFO_CONTENT.es['size-guide'] = INFO_CONTENT.es.tallas;
INFO_CONTENT.es.shipping = INFO_CONTENT.es.envios;
INFO_CONTENT.es.returns = INFO_CONTENT.es.devoluciones;
INFO_CONTENT.es.devoluciones = INFO_CONTENT.es.devoluciones;
INFO_CONTENT.es.filosofia = INFO_CONTENT.es.philosophy;
INFO_CONTENT.es.reclamaciones = INFO_CONTENT.es.reclamaciones;
INFO_CONTENT.es['claims_book'] = INFO_CONTENT.es.reclamaciones;
INFO_CONTENT.es['claims'] = INFO_CONTENT.es.reclamaciones;
INFO_CONTENT.es.faqs = INFO_CONTENT.es.faq;
INFO_CONTENT.es.nosotros = INFO_CONTENT.es.about;

// English aliases
INFO_CONTENT.en.privacidad = INFO_CONTENT.en.privacy;
INFO_CONTENT.en.terminos = INFO_CONTENT.en.terms;
INFO_CONTENT.en.contacto = INFO_CONTENT.en.contact;
INFO_CONTENT.en['size-guide'] = INFO_CONTENT.en.tallas;
INFO_CONTENT.en.shipping = INFO_CONTENT.en.envios;
INFO_CONTENT.en.devoluciones = INFO_CONTENT.en.returns;
INFO_CONTENT.en.returns = INFO_CONTENT.en.returns;
INFO_CONTENT.en.filosofia = INFO_CONTENT.en.philosophy;
INFO_CONTENT.en.reclamaciones = INFO_CONTENT.en.reclamaciones;
INFO_CONTENT.en['claims_book'] = INFO_CONTENT.en.reclamaciones;
INFO_CONTENT.en['claims'] = INFO_CONTENT.en.reclamaciones;
INFO_CONTENT.en.faqs = INFO_CONTENT.en.faq;
INFO_CONTENT.en.nosotros = INFO_CONTENT.en.about;

// ─────────────────────────────────────────────────────────────────────────────
// PRODUCT CATALOG
// ─────────────────────────────────────────────────────────────────────────────
function getConfiguredCommercePrice(source, productId, field) {
  const value = field ? source?.[productId]?.[field] : source?.[productId];
  const number = Number(value);
  if (!Number.isFinite(number)) {
    throw new Error(`[MA Commerce] Missing ${field || 'reference'} price for ${productId}`);
  }
  return number;
}

const MA_REFERENCE_PRICES_USD = window.MA_REFERENCE_PRICES_USD || {
  'MA-DJ-01': 240, 'MA-DF-01': 190, 'MA-TE-BK': 75, 'MA-TE-WH': 75
};
const MA_TRANSACTION_PRICES_PEN = window.MA_TRANSACTION_PRICES_PEN || {
  'MA-DJ-01': { product: 890, S: 890, M: 890, L: 890, XL: 890 },
  'MA-DF-01': { product: 690, S: 690, M: 690, L: 690, XL: 690 },
  'MA-TE-BK': { product: 129, S: 129, M: 129, L: 129, XL: 129 },
  'MA-TE-WH': { product: 129, S: 129, M: 129, L: 129, XL: 129 }
};

const PRODUCTS = {
  'MA-DJ-01': {
    id: 'MA-DJ-01',
    name: 'J-01 DOWN JACKET - BLACK',
    color: 'black',
    priceUsd: getConfiguredCommercePrice(MA_REFERENCE_PRICES_USD, 'MA-DJ-01'),
    pricePen: getConfiguredCommercePrice(MA_TRANSACTION_PRICES_PEN, 'MA-DJ-01', 'product'),
    sizes: ['S', 'M', 'L', 'XL'],
    outOfStockSizes: ['XL'],
    badge: 'bestseller',
    placeholder: 'puffer',
    label: 'DOWN',
    bannerImage: 'j01-casaca-plumas-the-purpose.jpg',
    bannerTitle: 'Designed for Everywhere',
    descKey: 'product.dj01.desc',
    materialsKey: 'product.dj01.materials',
    careKey: 'product.jacket.care',
    relatedIds: ['MA-TE-BK', 'MA-TE-WH'],
    features: [
      { icon: 'icono-j01-relleno-pluma-90-10.jpg', titleKey: 'pdp.feat.down' },
      { icon: 'icono-j01-repelente-agua.jpg', titleKey: 'pdp.feat.water' },
      { icon: 'icono-j01-aislamiento-termico.jpg', titleKey: 'pdp.feat.warmth' },
      { icon: 'icono-j01-construccion-ligera.jpg', titleKey: 'pdp.feat.breathable' }
    ],
    modelInfo: {
      heightEn: '185cm',
      heightEs: '185cm',
      weightEn: '80kg',
      weightEs: '80kg',
      wearingSize: 'L'
    },
    fitDescription: {
      en: 'Regular silhouette designed for everyday layering.',
      es: 'CASACA LIGERA CON RELLENO DE PLUMA 90/10, ACABADO REPELENTE AL AGUA Y DISEÑO TERMORREGULADOR.'
    },
    fabricDescription: {
      en: 'Lightweight technical shell with a matte surface and structured silhouette. Designed for transitional urban weather.',
      es: 'Exterior técnico ultraligero de superficie mate y silueta estructurada. Diseñado para el clima urbano de transición.'
    },
    inventory: {
      'S': 5,
      'M': 2,
      'L': 10,
      'XL': 0
    },
    images: ['j01-casaca-plumas-miniatura-home.jpg']
  },
  'MA-TE-BK': {
    id: 'MA-TE-BK',
    name: 'T-01 ESSENTIAL PIMA - BLACK',
    color: 'black',
    priceUsd: getConfiguredCommercePrice(MA_REFERENCE_PRICES_USD, 'MA-TE-BK'),
    pricePen: getConfiguredCommercePrice(MA_TRANSACTION_PRICES_PEN, 'MA-TE-BK', 'product'),
    sizes: ['S', 'M', 'L', 'XL'],
    outOfStockSizes: ['XL'],
    badge: 'new',
    placeholder: 'tee-black',
    label: 'TEE',
    bannerImage: 't01-polo-negro-the-purpose.jpg',
    bannerTitle: 'Designed for Everyday',
    images: ['t01-polo-negro-miniatura-home.jpg'],
    descKey: 'product.tee.desc',
    materialsKey: 'product.tee.materials',
    careKey: 'product.tee.care',
    relatedIds: ['MA-TE-WH', 'MA-DJ-01'],
    features: [
      { icon: 'icono-t01-algodon-pima.jpg', titleKey: 'pdp.feat.cotton' },
      { icon: 'icono-t01-costuras-reforzadas.jpg', titleKey: 'pdp.feat.stitching' },
      { icon: 'icono-t01-confort.jpg', titleKey: 'pdp.feat.comfort' },
      { icon: 'icono-t01-ajuste-regular.jpg', titleKey: 'pdp.feat.fit' }
    ],
    modelInfo: {
      heightEn: '180cm',
      heightEs: '180cm',
      weightEn: '75kg',
      weightEs: '75kg',
      wearingSize: 'M'
    },
    fitDescription: {
      en: 'Clean silhouette designed to wear solo or under outerwear.',
      es: 'POLO ESENCIAL ELABORADO EN 100% ALGODÓN PIMA PERUANO, ACABADO ULTRASUAVE Y AJUSTE CLÁSICO.'
    },
    fabricDescription: {
      en: 'Extra-long-staple Peruvian Pima cotton with an ultra-soft handle and clean drape.',
      es: 'Algodón Pima peruano de fibra extra larga con un tacto ultra suave y una caída limpia.'
    },
    inventory: {
      'S': 3,
      'M': 8,
      'L': 1,
      'XL': 0
    }
  },
  'MA-TE-WH': {
    id: 'MA-TE-WH',
    name: 'T-01 ESSENTIAL PIMA - WHITE',
    color: 'white',
    priceUsd: getConfiguredCommercePrice(MA_REFERENCE_PRICES_USD, 'MA-TE-WH'),
    pricePen: getConfiguredCommercePrice(MA_TRANSACTION_PRICES_PEN, 'MA-TE-WH', 'product'),
    sizes: ['S', 'M', 'L', 'XL'],
    outOfStockSizes: ['XL'],
    badge: 'new',
    placeholder: 'tee-white',
    label: 'TEE',
    bannerImage: 't01-polo-blanco-the-purpose.jpg',
    bannerTitle: 'Designed for Everyday',
    images: ['t01-polo-blanco-miniatura-home.jpg'],
    descKey: 'product.tee.desc',
    materialsKey: 'product.tee.materials',
    careKey: 'product.tee.care',
    relatedIds: ['MA-TE-BK', 'MA-DJ-01'],
    features: [
      { icon: 'icono-t01-algodon-pima.jpg', titleKey: 'pdp.feat.cotton' },
      { icon: 'icono-t01-costuras-reforzadas.jpg', titleKey: 'pdp.feat.stitching' },
      { icon: 'icono-t01-confort.jpg', titleKey: 'pdp.feat.comfort' },
      { icon: 'icono-t01-ajuste-regular.jpg', titleKey: 'pdp.feat.fit' }
    ],
    modelInfo: {
      heightEn: '180cm',
      heightEs: '180cm',
      weightEn: '75kg',
      weightEs: '75kg',
      wearingSize: 'M'
    },
    fitDescription: {
      en: 'Clean silhouette designed to wear solo or under outerwear.',
      es: 'POLO ESENCIAL ELABORADO EN 100% ALGODÓN PIMA PERUANO, ACABADO ULTRASUAVE Y AJUSTE CLÁSICO.'
    },
    fabricDescription: {
      en: 'Extra-long-staple Peruvian Pima cotton with an ultra-soft handle and clean drape.',
      es: 'Algodón Pima peruano de fibra extra larga con un tacto ultra suave y una caída limpia.'
    },
    inventory: {
      'S': 1,
      'M': 10,
      'L': 12,
      'XL': 0
    }
  },
  'MA-DF-01': {
    id: 'MA-DF-01',
    name: 'C-01 TRAVEL DUFFEL',
    color: 'black',
    priceUsd: getConfiguredCommercePrice(MA_REFERENCE_PRICES_USD, 'MA-DF-01'),
    pricePen: getConfiguredCommercePrice(MA_TRANSACTION_PRICES_PEN, 'MA-DF-01', 'product'),
    sizes: ['O/S'],
    outOfStockSizes: [],
    badge: 'new',
    placeholder: 'duffel',
    label: 'BAG',
    bannerImage: 'c01-bolso-viaje-the-purpose.jpg',
    bannerTitle: 'Designed for Movement',
    descKey: 'product.duffel.desc',
    materialsKey: 'product.duffel.materials',
    careKey: 'product.duffel.care',
    relatedIds: ['MA-DJ-01', 'MA-TE-BK'],
    features: [
      { icon: 'icono-c01-cuero-full-grain.jpg', titleKey: 'pdp.feat.leather' },
      { icon: 'icono-c01-herrajes-metalicos.jpg', titleKey: 'pdp.feat.hardware' },
      { icon: 'icono-c01-compartimento-calzado.jpg', titleKey: 'pdp.feat.shoes' },
      { icon: 'icono-c01-portatraje.jpg', titleKey: 'pdp.feat.access' }
    ],
    modelInfo: {
      customEn: 'DIMENSIONS: 56 × 28 × 26 CM · APPROXIMATE CAPACITY: 40 L',
      customEs: 'DIMENSIONES: 56 × 28 × 26 CM · CAPACIDAD APROXIMADA: 40 L'
    },
    fitDescription: {
      en: 'Full-grain leather travel bag designed for short trips, weekend escapes, and urban travel.',
      es: 'Bolso de viaje de cuero full-grain diseñado para viajes cortos, escapadas de fin de semana y desplazamientos urbanos.'
    },
    fabricDescription: {
      en: '100% premium full-grain leather with high-resistance metal hardware and full-access opening.',
      es: '100% cuero de grano entero premium con herrajes metálicos de alta resistencia y apertura de acceso total.'
    },
    inventory: {
      'O/S': 5
    },
    images: ['c01-bolso-viaje-cuero-miniatura-home.jpg']
  }
};
window.PRODUCTS = PRODUCTS;

const PRODUCT_URLS = {
  'MA-TE-BK': '/products/polo-negro-algodon-pima-hombre',
  'MA-TE-WH': '/products/polo-blanco-algodon-pima-hombre',
  'MA-DJ-01': '/products/casaca-plumas-hombre',
  'MA-DF-01': '/products/bolso-viaje-cuero-hombre'
};

function getProductUrl(id) {
  let url = PRODUCT_URLS[id] || '/collections/all';
  const pathname = window.location.pathname;
  let prefix = '';

  if (pathname.startsWith('/en-international') || pathname.startsWith('/en')) {
    prefix = '/en-international';
    if (id === 'MA-TE-BK') {
      url = '/products/mens-black-pima-cotton-t-shirt';
    } else if (id === 'MA-TE-WH') {
      url = '/products/mens-white-pima-cotton-t-shirt';
    } else if (id === 'MA-DF-01') {
      url = '/products/mens-leather-travel-duffel-bag';
    } else if (id === 'MA-DJ-01') {
      url = '/products/mens-down-jacket';
    }
  } else {
    prefix = '';
    if (id === 'MA-TE-BK') {
      url = '/products/polo-negro-algodon-pima-hombre';
    } else if (id === 'MA-TE-WH') {
      url = '/products/polo-blanco-algodon-pima-hombre';
    } else if (id === 'MA-DF-01') {
      url = '/products/bolso-viaje-cuero-hombre';
    } else if (id === 'MA-DJ-01') {
      url = '/products/casaca-plumas-hombre';
    }
  }
  return prefix + url;
}

if (typeof document !== 'undefined') {
  // ── Liquid PDP: intercept size selector when no fit profile exists ──────────
  const initLiquidPdpSizeInterceptor = () => {
    const pdpSizeSelect = document.getElementById('pdp-size-select');
    if (!pdpSizeSelect) return;

    const pid = window.MA_CURRENT_PRODUCT_ID
      || document.getElementById('product-detail')?.dataset.productId;

    // Sync SSR variant state (add-to-cart button availability)
    const syncSsrVariantState = () => {
      const selectedOption = pdpSizeSelect.selectedOptions?.[0];
      const addButton = document.getElementById('pdp-add');
      if (!selectedOption || !addButton) return;
      const selectedAvailable = selectedOption.dataset.available !== 'false';
      addButton.disabled = !selectedAvailable;
      addButton.dataset.selectedAvailable = String(selectedAvailable);
      const esLabel = addButton.querySelector('.ma-lang-block--es');
      const enLabel = addButton.querySelector('.ma-lang-block--en');
      if (esLabel) esLabel.textContent = selectedAvailable ? 'AÑADIR AL CARRITO' : 'AGOTADO';
      if (enLabel) enLabel.textContent = selectedAvailable ? 'ADD TO BAG' : 'OUT OF STOCK';
      const root = document.getElementById('product-detail');
      if (root) root.dataset.currentVariantId = selectedOption.value;
      window.MA_PDP_SELECTED_VARIANT_ID = selectedOption.value;
    };

    // Skip O/S products — they don't need the fit drawer
    const productData = (typeof PRODUCTS !== 'undefined' && pid) ? PRODUCTS[pid] : null;
    const isOneSize = productData && Array.isArray(productData.sizes)
      && productData.sizes.length === 1
      && String(productData.sizes[0]).trim().toUpperCase() === 'O/S';
    if (isOneSize) {
      // O/S: just sync add-to-cart state normally
      pdpSizeSelect.addEventListener('change', syncSsrVariantState);
      syncSsrVariantState();
      return;
    }

    const checkHasProfile = () => {
      try {
        const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
        if (repo && repo.exists()) {
          const p = repo.getProfile();
          if (p && p.height && p.weight) return true;
        }
      } catch (_) {}
      return false;
    };

    // Refresh helper for PDP size select
    const refreshPdpSelect = (sz) => {
      if (pdpSizeSelect && productData) {
        const hasProfile = checkHasProfile();
        const effectiveSz = hasProfile ? sz : '';
        const { html, recommendedSize } = buildPdpSizeOptionsHTML(productData, effectiveSz);
        pdpSizeSelect.innerHTML = html;
        const targetVal = effectiveSz || (hasProfile ? recommendedSize : '');
        if (targetVal) {
          const optToSelect = Array.from(pdpSizeSelect.options).find(opt =>
            opt.getAttribute('data-size') === targetVal || opt.value === targetVal
          );
          if (optToSelect) {
            pdpSizeSelect.value = optToSelect.value;
          }
        } else {
          pdpSizeSelect.value = '';
        }
        syncSsrVariantState();
      }
    };
    window._refreshPdpSizeSelector = refreshPdpSelect;

    // Trigger initial option rendering based on current profile state
    refreshPdpSelect('');

    // Capture interceptor: dynamically checks checkHasProfile() at runtime
    const interceptNoProfileClick = (e) => {
      const pData = (typeof PRODUCTS !== 'undefined' && pid) ? PRODUCTS[pid] : null;
      const isOneSize = pData && pData.sizes && pData.sizes.length === 1 && String(pData.sizes[0]).trim().toUpperCase() === 'O/S';
      if (window._isClosingFitDrawer || isOneSize) return;
      if (!checkHasProfile()) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        if (document.activeElement === pdpSizeSelect) pdpSizeSelect.blur();

        if (typeof window.openFitModalForPdp === 'function' && pData) {
          window.openFitModalForPdp(pData, window._refreshPdpSizeSelector);
        }
        return false;
      }
    };

    const events = ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'click', 'focus'];
    const wrapperEl = pdpSizeSelect.closest('.pdp-size-select-wrapper');
    events.forEach(evt => {
      pdpSizeSelect.addEventListener(evt, interceptNoProfileClick, { capture: true });
      if (wrapperEl) wrapperEl.addEventListener(evt, interceptNoProfileClick, { capture: true });
    });

    // Handle change: if user has a profile and selects 'find-size' option, re-open Fit Drawer
    const handleSelectChange = () => {
      if (pdpSizeSelect.value === 'find-size') {
        const pData = (typeof PRODUCTS !== 'undefined' && pid) ? PRODUCTS[pid] : null;
        if (typeof window.openFitModalForPdp === 'function' && pData) {
          window.openFitModalForPdp(pData, window._refreshPdpSizeSelector);
        }
        return;
      }
      syncSsrVariantState();
    };
    pdpSizeSelect.addEventListener('change', handleSelectChange);
  };

  // Redirect international links
  const initInternationalLinks = () => {
    if (window.MA_IS_INTERNATIONAL === true) {
      document.querySelectorAll('a[href*="/products/bolso-viaje-cuero-hombre"]').forEach(a => {
        a.setAttribute('href', '/en-international/products/mens-leather-travel-duffel-bag');
      });
      document.querySelectorAll('a[href*="/products/polo-negro-algodon-pima-hombre"], a[href*="/products/polo-negro-hombre-algodon-pima"]').forEach(a => {
        a.setAttribute('href', '/en-international/products/mens-black-pima-cotton-t-shirt');
      });
      document.querySelectorAll('a[href*="/products/polo-blanco-algodon-pima-hombre"], a[href*="/products/polo-blanco-hombre-algodon-pima"]').forEach(a => {
        a.setAttribute('href', '/en-international/products/mens-white-pima-cotton-t-shirt');
      });
      document.querySelectorAll('a[href*="/products/casaca-plumas-hombre"], a[href*="/products/casaca-negra-plumas-hombre"]').forEach(a => {
        a.setAttribute('href', '/en-international/products/mens-down-jacket');
      });
    }
  };

  const initPdpPageSelector = () => {
    initInternationalLinks();
    initLiquidPdpSizeInterceptor();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpPageSelector);
  } else {
    initPdpPageSelector();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#pdp-add');
    if (!btn) return;

    if (btn.dataset.isOos === 'true') {
      if (typeof btn._oosHandler === 'function') {
        btn._oosHandler(e);
      }
      return;
    }

    const pdpRoot = document.getElementById('product-detail');
    const pid = window.MA_CURRENT_PRODUCT_ID || (pdpRoot ? pdpRoot.dataset.productId : null) || 'MA-DF-01';
    const prod = PRODUCTS[pid] || PRODUCTS['MA-DF-01'];
    if (!prod) return;

    const isOneSize = prod.sizes && prod.sizes.length === 1 && String(prod.sizes[0]).trim().toUpperCase() === 'O/S';
    const sizeSelect = document.getElementById('pdp-size-select');
    const selectedOption = sizeSelect?.selectedOptions?.[0];
    const selectVal = sizeSelect ? sizeSelect.value : '';

    let hasProfile = false;
    try {
      const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
      if (repo && repo.exists()) {
        const p = repo.getProfile();
        if (p && p.height && p.weight) hasProfile = true;
      }
    } catch (_) {}

    // IF MULTI-SIZE AND NO PROFILE / NO SIZE SELECTED ("ENCUENTRA TU TALLA"):
    if (!isOneSize && (!hasProfile || !selectVal || selectVal === 'find-size')) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (typeof window.openFitModalForPdp === 'function') {
        window.openFitModalForPdp(prod, window._refreshPdpSizeSelector);
      }
      return false;
    }

    const selectedUnavailable = selectedOption && selectedOption.dataset.available === 'false';
    const selectedAvailable = selectedOption && !selectedUnavailable;
    if (!selectedAvailable) return;
    if (btn.dataset.handled === 'true') return;

    btn.dataset.handled = 'true';
    setTimeout(() => { delete btn.dataset.handled; }, 500);

    let chosenSize = 'O/S';
    const chosenVariantId = selectedOption.value;
    if (selectedOption) {
      chosenSize = selectedOption.getAttribute('data-size') || selectedOption.text || 'O/S';
    }

    const addSuccess = cart.add({
      id: prod.id,
      name: prod.name,
      color: prod.color,
      size: chosenSize,
      variantId: chosenVariantId,
      priceUsd: prod.priceUsd,
      pricePen: prod.pricePen,
      qty: 1
    });

    if (addSuccess !== false) {
      const flySource = document.querySelector('.ma-pdp-media img') || document.querySelector('.ma-pdp-media') || document.getElementById('product-gallery');
      if (typeof animateAddToCart === 'function') animateAddToCart(flySource);

      if (typeof showToast === 'function') {
        showToast(getLang() === 'en' ? 'ADDED TO BAG' : 'AÑADIDO AL CARRITO');
      }
      setTimeout(() => {
        if (typeof openCart === 'function') openCart();
      }, 280);
    }
  });
}

const BUNDLES = {
  'MA-DJ-01': {
    members: ['MA-DJ-01', 'MA-TE-WH'],
    discountRate: 0.085
  },
  'MA-TE-BK': {
    members: ['MA-TE-BK', 'MA-TE-WH'],
    discountRate: 0.0
  },
  'MA-TE-WH': {
    members: ['MA-TE-WH', 'MA-TE-BK'],
    discountRate: 0.0
  }
};

const CURRENCY = {
  en: { symbol: '$',  attr: 'data-price-usd', code: 'USD' },
  es: { symbol: 'S/ ', attr: 'data-price-pen', code: 'PEN' }
};

function getLang() {
  const htmlLang = (document.documentElement.lang || document.documentElement.getAttribute('lang') || document.documentElement.getAttribute('data-lang') || '').toLowerCase();
  if (htmlLang.startsWith('en')) return 'en';
  if (window.location && window.location.pathname && (window.location.pathname.startsWith('/en-international') || window.location.pathname.startsWith('/en'))) return 'en';
  return 'es';
}

function getAssetUrl(src) {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) return src;
  const filename = src.split('/').pop();
  if (window.MA_ASSETS && window.MA_ASSETS[filename]) {
    return window.MA_ASSETS[filename];
  }
  if (window.ShopifyAssetUrl) {
    return window.ShopifyAssetUrl + filename;
  }
  if (!src.includes('/')) {
    return `images/${filename}`;
  }
  return src;
}

function getCartThumb(id) {
  if (id === 'MA-TE-BK') return getAssetUrl('t01-polo-negro-miniatura-home.jpg');
  if (id === 'MA-TE-WH') return getAssetUrl('t01-polo-blanco-miniatura-home.jpg');
  if (id === 'MA-DF-01') return getAssetUrl('c01-bolso-viaje-cuero-miniatura-home.jpg');
  if (id === 'MA-DJ-01') return getAssetUrl('j01-casaca-plumas-miniatura-home.jpg');
  return '';
}

function t(key) {
  const dict = I18N[getLang()] || I18N.es;
  return dict[key] !== undefined ? dict[key] : key;
}

// ─────────────────────────────────────────────────────────────────────────────
// Apply translations & prices
// ─────────────────────────────────────────────────────────────────────────────
function getRegion() {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/en-international') || pathname.startsWith('/es-international')) {
    return 'international-usd';
  }
  return window.MA_IS_INTERNATIONAL === true ? 'international-usd' : 'peru-pen';
}

function initGeoDetection() {
  const currentRegion = getRegion();
  setRegion(currentRegion, false);

  // 1. Clean legacy permanent localStorage flag if present
  try {
    localStorage.removeItem('mark-altitude-geo-redirected');
  } catch (_) {}

  // 2. Priority 1: User explicit manual choice (stored permanently in localStorage)
  try {
    const isUserChosen = localStorage.getItem('mark-altitude-region-user-chosen') === 'true';
    if (isUserChosen) {
      const savedRegion = localStorage.getItem('mark-altitude-region');
      if (savedRegion === 'peru-pen' || savedRegion === 'international-usd') {
        const currentMarket = getRegion();
        if (currentMarket !== savedRegion) {
          const targetUrl = getRegionTargetUrl(savedRegion);
          if (targetUrl !== window.location.href) {
            window.location.href = targetUrl;
            return;
          }
        }
        return;
      }
    }
  } catch (_) {}

  // 3. Priority 2: Session-cached GeoIP detection (same-session self-correction without re-fetching)
  try {
    const sessionDetectedRegion = sessionStorage.getItem('mark-altitude-detected-region');
    if (sessionDetectedRegion === 'peru-pen' || sessionDetectedRegion === 'international-usd') {
      const currentMarket = getRegion();
      if (currentMarket !== sessionDetectedRegion) {
        const targetUrl = getRegionTargetUrl(sessionDetectedRegion);
        if (targetUrl !== window.location.href) {
          window.location.href = targetUrl;
          return;
        }
      }
      return;
    }
  } catch (_) {}

  // 4. Priority 3: First-time GeoIP detection in session via official Shopify browsing_context_suggestions.json
  const rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cleanRoot = rootRoute.replace(/\/+$/, '');
  const suggestionsUrl = `${cleanRoot}/browsing_context_suggestions.json?country[enabled]=true`;

  const fetchOptions = {};
  if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
    fetchOptions.signal = AbortSignal.timeout(2000);
  } else if (typeof AbortController !== 'undefined') {
    const controller = new AbortController();
    setTimeout(() => {
      try { controller.abort(); } catch (_) {}
    }, 2000);
    fetchOptions.signal = controller.signal;
  }

  fetch(suggestionsUrl, fetchOptions)
    .then(res => {
      if (!res.ok) throw new Error('Network response not ok');
      return res.json();
    })
    .then(data => {
      const countryCode = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!countryCode || typeof countryCode !== 'string' || countryCode.length < 2) {
        return;
      }

      const targetRegion = (countryCode.toUpperCase() === 'PE') ? 'peru-pen' : 'international-usd';
      const currentMarket = getRegion();

      try {
        sessionStorage.setItem('mark-altitude-detected-region', targetRegion);
      } catch (_) {}

      if (currentMarket !== targetRegion) {
        const targetUrl = getRegionTargetUrl(targetRegion);
        if (targetUrl !== window.location.href) {
          window.location.href = targetUrl;
        }
      }
    })
    .catch(() => {
      // Graceful fallback: on timeout, network error, or invalid JSON, do nothing.
      // The current page remains active and the user can use the manual region selector.
    });
}

function getRegionTargetUrl(regionId) {
  const currentUrl = new URL(window.location.href);
  let path = currentUrl.pathname;

  path = path.replace(/^\/(es-international|en-international|es|en)(\/|$)/, '/');
  if (!path.startsWith('/')) path = '/' + path;

  // Handle mapping for T-01 Black
  if (path.includes('/products/polo-negro-algodon-pima-hombre') || path.includes('/products/polo-negro-hombre-algodon-pima') || path.includes('/products/mens-black-pima-cotton-t-shirt')) {
    path = (regionId === 'international-usd')
      ? '/products/mens-black-pima-cotton-t-shirt'
      : '/products/polo-negro-algodon-pima-hombre';
  }
  // Handle mapping for T-01 White
  else if (path.includes('/products/polo-blanco-algodon-pima-hombre') || path.includes('/products/polo-blanco-hombre-algodon-pima') || path.includes('/products/mens-white-pima-cotton-t-shirt')) {
    path = (regionId === 'international-usd')
      ? '/products/mens-white-pima-cotton-t-shirt'
      : '/products/polo-blanco-algodon-pima-hombre';
  }
  // Handle mapping for C-01 Travel Duffel
  else if (path.includes('/products/mens-leather-travel-duffel-bag') || path.includes('/products/mens-leather-garment-duffel-bag') || path.includes('/products/bolso-viaje-cuero-hombre')) {
    path = (regionId === 'international-usd')
      ? '/products/mens-leather-travel-duffel-bag'
      : '/products/bolso-viaje-cuero-hombre';
  }
  // Handle mapping for J-01 Down Jacket
  else if (path.includes('/products/casaca-plumas-hombre') || path.includes('/products/casaca-negra-plumas-hombre') || path.includes('/products/mens-down-jacket')) {
    path = (regionId === 'international-usd')
      ? '/products/mens-down-jacket'
      : '/products/casaca-plumas-hombre';
  }

  let targetPrefix = '';
  if (regionId === 'international-usd') {
    targetPrefix = '/en-international';
  }

  if (targetPrefix) {
    path = targetPrefix + (path === '/' ? '' : path);
  }

  currentUrl.pathname = path;
  return currentUrl.toString();
}

function setRegion(regionId, isUserAction = false) {
  if (regionId !== 'international-usd') {
    regionId = 'peru-pen';
  }

  if (isUserAction) {
    try {
      localStorage.setItem('mark-altitude-region-user-chosen', 'true');
      localStorage.setItem('mark-altitude-region', regionId);
    } catch (_) {}
    const targetUrl = getRegionTargetUrl(regionId);
    if (targetUrl !== window.location.href) {
      window.location.href = targetUrl;
      return;
    }
  }

  let lang = 'es';
  let currencyCode = 'PEN';

  if (regionId === 'international-usd') {
    lang = 'en';
    currencyCode = 'USD';
  } else if (regionId === 'internacional-usd') {
    lang = 'es';
    currencyCode = 'USD';
  } else {
    lang = 'es';
    currencyCode = 'PEN';
  }

  setLanguage(lang, currencyCode);

  document.querySelectorAll('[data-region]').forEach(btn => {
    btn.classList.toggle('is-active', btn.getAttribute('data-region') === regionId);
  });

  const peruOptions = document.querySelectorAll('[data-region="peru-pen"]');
  peruOptions.forEach(btn => {
    btn.textContent = (regionId === 'international-usd') ? 'PERU · PEN' : 'PERÚ · PEN';
  });

  const regionDisplay = document.getElementById('footer-region-display');
  if (regionDisplay) {
    if (regionId === 'peru-pen') {
      regionDisplay.textContent = (lang === 'en') ? 'PERU | PEN' : 'PERÚ | PEN';
    } else if (regionId === 'internacional-usd') {
      regionDisplay.textContent = 'INTERNACIONAL | USD';
    } else {
      regionDisplay.textContent = 'INTERNATIONAL | USD';
    }
  }

  if (isUserAction) {
    window.location.reload();
  }
}

function setLanguage(lang, currencyCodeOverride) {
  if (!I18N[lang]) lang = 'es';
  const dict = I18N[lang];
  
  let cur = CURRENCY[lang];
  if (currencyCodeOverride === 'USD') {
    cur = CURRENCY.en;
  } else if (currencyCodeOverride === 'PEN') {
    cur = CURRENCY.es;
  } else {
    const region = getRegion();
    if (region === 'international-usd' || region === 'internacional-usd') {
      cur = CURRENCY.en;
    }
  }

  const currentRegion = typeof getRegion === 'function' ? getRegion() : 'peru-pen';

  // NOTE: Global text (footer, cart title, size guide) is now server-rendered via
  // Shopify locale {{ 'key' | t }} — no JS replacement needed for static labels.
  // Only cart.free_shipping is updated dynamically based on selected region.
  const cartBannerEl = document.querySelector('[data-i18n="cart.free_shipping"]');
  if (cartBannerEl) {
    if (currentRegion === 'international-usd') {
      cartBannerEl.textContent = 'FREE SHIPPING ON ORDERS OVER $100 USD';
    } else if (currentRegion === 'internacional-usd') {
      cartBannerEl.textContent = 'ENVÍO GRATIS POR PEDIDOS SUPERIORES A $100 USD';
    } else {
      cartBannerEl.textContent = 'ENVÍO GRATIS POR PEDIDOS SUPERIORES A S/349.00 PEN';
    }
  }

  document.querySelectorAll('[data-i18n-html]').forEach(el => {
    const key = el.getAttribute('data-i18n-html');
    if (dict[key] !== undefined) el.innerHTML = dict[key];
  });

  document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    if (dict[key] !== undefined) el.setAttribute('placeholder', dict[key]);
  });


  // Update displayed prices on cards
  document.querySelectorAll('[data-price-display]').forEach(el => {
    const value = el.getAttribute(cur.attr);
    if (value !== null) el.textContent = `${cur.symbol}${Number(value).toFixed(2)}`;
  });

  // Header label
  const langCurrentLabel = document.getElementById('lang-current-label');
  if (langCurrentLabel) langCurrentLabel.textContent = lang.toUpperCase();

  document.documentElement.setAttribute('lang', lang);
  document.documentElement.setAttribute('data-lang', lang);

  // Toggle language content blocks (e.g. C-01 SEO section)
  document.querySelectorAll('.ma-lang-block--es').forEach(el => {
    el.style.display = (lang === 'en') ? 'none' : 'block';
  });
  document.querySelectorAll('.ma-lang-block--en').forEach(el => {
    el.style.display = (lang === 'en') ? 'block' : 'none';
  });

  try { localStorage.setItem('mark-altitude-lang', lang); } catch (_) {}

  document.querySelectorAll('[data-lang]').forEach(btn => {
    btn.classList.toggle('is-active', btn.getAttribute('data-lang') === lang);
  });
  const footerSelect = document.getElementById('footer-country');
  if (footerSelect) footerSelect.value = lang;

  // Re-render dynamic content
  cart.render();
  if (!window.MA_LANGUAGE_BOOTSTRAP && typeof renderProductPage === 'function' && document.getElementById('product-detail') && document.querySelector('.product-info')) {
    renderProductPage({ force: true });
  }
  if (typeof renderCheckoutSummary === 'function' && document.getElementById('checkout-summary')) {
    renderCheckoutSummary();
  }
  if (typeof renderInfoPage === 'function' && document.getElementById('info-page')) {
    renderInfoPage();
  }
  if (typeof window.lockInlineButtonWidths === 'function') {
    window.lockInlineButtonWidths();
  }
}

// Region selection listeners
document.addEventListener('click', e => {
  const regionBtn = e.target.closest('[data-region]');
  if (regionBtn) {
    const region = regionBtn.getAttribute('data-region');
    setRegion(region, true);
  }
});

document.querySelectorAll('[data-lang]').forEach(btn => {
  btn.addEventListener('click', () => setLanguage(btn.getAttribute('data-lang')));
});

const footerCountry = document.getElementById('footer-country');
if (footerCountry) {
  footerCountry.addEventListener('change', e => setLanguage(e.target.value));
}

// ─────────────────────────────────────────────────────────────────────────────
// Customer Reviews — verified purchase integration & legacy cleanup
// ─────────────────────────────────────────────────────────────────────────────
try {
  localStorage.removeItem('mark-altitude-reviews');
  localStorage.removeItem('mark-altitude-reviews-seed-v');
} catch (_) {}

// ─────────────────────────────────────────────────────────────────────────────
// Cart
// ─────────────────────────────────────────────────────────────────────────────
const cart = {
  items: [],

  consolidateItems() {
    if (!Array.isArray(this.items)) {
      this.items = [];
      return;
    }
    const consolidated = [];
    this.items.forEach(item => {
      if (!item) return;
      const cleanName = (item.name || '').split(' - ')[0];
      const existing = consolidated.find(it =>
        it.id === item.id &&
        String(it.color || '').toLowerCase() === String(item.color || '').toLowerCase() &&
        String(it.size || '').toUpperCase() === String(item.size || '').toUpperCase()
      );
      if (existing) {
        existing.qty += (item.qty || 1);
      } else {
        consolidated.push({
          ...item,
          name: cleanName,
          bundleId: null,
          bundleGroupId: null,
          qty: item.qty || 1
        });
      }
    });
    this.items = consolidated;
  },

  autoPromoteTeeBundles() {
    this.consolidateItems();
  },

  load() {
    if (window.location.pathname.includes('thank_you') || window.location.pathname.includes('/orders/')) {
      localStorage.removeItem('mark-altitude-cart');
      this.items = [];
      return;
    }
    try {
      const raw = localStorage.getItem('mark-altitude-cart');
      this.items = raw ? JSON.parse(raw) : [];
      this.items = window.MACommerce.rehydrateCartItems(this.items, PRODUCTS);
      this.consolidateItems();
      this.autoPromoteTeeBundles();
      this.consolidateItems();
    } catch (_) {
      this.items = [];
    }
  },
  save() {
    try { localStorage.setItem('mark-altitude-cart', JSON.stringify(this.items)); } catch (_) {}
  },
  getMaxAvailableStock(productId, size, color) {
    const prod = PRODUCTS[productId];
    if (window.SHOPIFY_INVENTORY) {
      const pCode = (productId || '').toUpperCase().replace(/^MA-/, '').replace(/[\s\-_]+/g, '');
      const prodNameUpper = prod ? prod.name.toUpperCase().replace(/[\s\-_]+/g, '') : '';
      for (const [pTitle, variants] of Object.entries(window.SHOPIFY_INVENTORY)) {
        const titleUpper = pTitle.toUpperCase().replace(/[\s\-_]+/g, '');
        const isMatch = (pCode && titleUpper.includes(pCode))
          || (prodNameUpper && (titleUpper.includes(prodNameUpper) || prodNameUpper.includes(titleUpper)))
          || (prod?.label && titleUpper.includes(prod.label.toUpperCase()))
          || (productId === 'MA-TE-BK' && (titleUpper.includes('T01') || titleUpper.includes('PIMA')))
          || (productId === 'MA-TE-WH' && (titleUpper.includes('T01') || titleUpper.includes('PIMA')))
          || (productId === 'MA-DJ-01' && (titleUpper.includes('J01') || titleUpper.includes('DOWN') || titleUpper.includes('JACKET')))
          || (productId === 'MA-DF-01' && (titleUpper.includes('C01') || titleUpper.includes('DUFFEL') || titleUpper.includes('BOLSO')));

        if (isMatch) {
          for (const [vTitle, data] of Object.entries(variants)) {
            const sizeClean = String(size).toUpperCase().trim();
            const vClean = String(vTitle).toUpperCase().trim();
            if (vClean === sizeClean || vTitle === 'Default Title' || sizeClean === 'O/S') {
              if (data.available === false) return 0;
              if (typeof data.inventory === 'number' && data.policy !== 'continue') {
                return Math.max(0, data.inventory);
              }
            }
          }
        }
      }
    }
    if (prod && prod.outOfStockSizes && prod.outOfStockSizes.includes(size)) {
      return 0;
    }
    return 99;
  },

  add(item) {
    const cleanName = (item.name || '').split(' - ')[0];
    const canonicalProduct = PRODUCTS[item.id];
    if (!canonicalProduct) return false;
    const itemToAdd = {
      ...item,
      name: cleanName,
      priceUsd: canonicalProduct.priceUsd,
      pricePen: canonicalProduct.pricePen,
      qty: item.qty || 1
    };

    const currentTotalInCart = this.items
      .filter(it =>
        it.id === itemToAdd.id &&
        String(it.color || '').toLowerCase() === String(itemToAdd.color || '').toLowerCase() &&
        String(it.size || '').toUpperCase() === String(itemToAdd.size || '').toUpperCase()
      )
      .reduce((sum, it) => sum + (it.qty || 1), 0);

    const maxStock = this.getMaxAvailableStock(itemToAdd.id, itemToAdd.size, itemToAdd.color);
    const lang = getLang();
    const dict = I18N[lang] || {};

    if (currentTotalInCart + itemToAdd.qty > maxStock) {
      const allowed = Math.max(0, maxStock - currentTotalInCart);
      if (allowed <= 0) {
        showToast(dict['cart.stock_limit_reached'] || (lang === 'en' ? 'Available inventory limit reached for this item.' : 'Ha alcanzado el límite de inventario disponible para este producto.'));
        return false;
      }
      itemToAdd.qty = allowed;
      showToast(dict['cart.stock_limit_reached'] || (lang === 'en' ? 'Quantity adjusted to available stock limit.' : 'Se ajustó la cantidad al stock máximo disponible.'));
    }

    const existing = this.items.find(it =>
      it.id === itemToAdd.id &&
      String(it.color || '').toLowerCase() === String(itemToAdd.color || '').toLowerCase() &&
      String(it.size || '').toUpperCase() === String(itemToAdd.size || '').toUpperCase()
    );

    if (existing) {
      existing.qty += itemToAdd.qty;
    } else {
      this.items.push({
        ...itemToAdd,
        bundleId: null,
        bundleGroupId: null
      });
    }
    this.consolidateItems();
    this.save();
    this.render();
  },
  addAt(item, idx) {
    this.add(item);
  },
  promoteToBundle(memberId, size, bundleId) {
    return -1;
  },
  remove(idx) {
    this.items.splice(idx, 1);
    this.autoPromoteTeeBundles();
    this.save();
    this.render();
  },
  setQty(idx, qty) {
    if (qty < 1) {
      this.remove(idx);
      return;
    }
    const item = this.items[idx];
    const lang = getLang();
    const dict = I18N[lang] || {};
    if (item && qty > item.qty) {
      const otherItemsQty = this.items
        .filter((it, i) => i !== idx && it.id === item.id && String(it.size).toUpperCase() === String(item.size).toUpperCase() && String(it.color || '').toLowerCase() === String(item.color || '').toLowerCase())
        .reduce((s, it) => s + (it.qty || 1), 0);
      const maxStock = this.getMaxAvailableStock(item.id, item.size, item.color);
      if (qty + otherItemsQty > maxStock) {
        showToast(dict['cart.stock_limit_reached'] || (lang === 'en' ? 'Maximum available inventory reached.' : 'Ha alcanzado el límite de inventario disponible para este producto.'));
        return;
      }
    }
    this.items[idx].qty = qty;
    this.autoPromoteTeeBundles();
    this.save();
    this.render();
  },
  count() {
    return this.items.reduce((sum, it) => sum + it.qty, 0);
  },
  bundleInstances(bundleId) {
    return 0;
  },
  bundleDiscount(lang) {
    return 0;
  },
  itemsTotal() {
    const key = isUsdRegion() ? 'priceUsd' : 'pricePen';
    return this.items.reduce((sum, it) => sum + (it[key] * it.qty), 0);
  },
  subtotal() {
    return this.itemsTotal();
  },
  render() {
    const lang   = getLang();
    const cur    = getCurrencyObj();
    const dict   = I18N[lang];
    const body   = document.getElementById('cart-body');
    const sub    = document.getElementById('cart-subtotal');
    const subLbl = document.querySelector('.cart-drawer__subtotal > span:first-child');
    const count  = document.getElementById('cart-count');
    const countMobile = document.getElementById('cart-count-mobile');
    const currentCount = this.count();

    if (count) {
      count.textContent = currentCount;
      count.classList.toggle('is-visible', currentCount > 0);
    }
    if (countMobile) {
      countMobile.textContent = currentCount;
      countMobile.classList.toggle('is-visible', currentCount > 0);
    }

    if (!body) return;

    if (this.items.length === 0) {
      body.innerHTML = `<p class="cart-drawer__empty">${dict['cart.empty']}</p>`;
    } else {
      const itemsHtml = this.items.map((it, idx) => {
        const colorKey = `color.${(it.color || '').toLowerCase()}`;
        let colorLabel = dict[colorKey] || it.color;
        if (colorLabel === 'Negro') colorLabel = 'Black';
        if (colorLabel === 'Blanco') colorLabel = 'White';
        const price = isUsdRegion() ? it.priceUsd : it.pricePen;
        const cleanName = (it.name || '').split(' - ')[0];
        return `
          <article class="cart-item" data-idx="${idx}">
            <img class="cart-item__thumb cart-item__thumb--${it.color} ${it.id === 'MA-DJ-01' ? 'cart-item__thumb--puffer' : ''}" src="${getCartThumb(it.id)}" alt="${cleanName}">
            <div class="cart-item__info">
              <p class="cart-item__name">${cleanName}</p>
              <p class="cart-item__meta">${dict['cart.color']}: ${colorLabel} · ${dict['cart.size']}: ${it.size}</p>
              <div class="cart-item__qty">
                <button class="cart-item__qty-btn" data-action="dec" aria-label="${lang === 'en' ? 'Decrease quantity' : 'Disminuir cantidad'}">−</button>
                <span class="cart-item__qty-value">${it.qty}</span>
                <button class="cart-item__qty-btn" data-action="inc" aria-label="${lang === 'en' ? 'Increase quantity' : 'Aumentar cantidad'}">+</button>
                <button class="cart-item__remove" data-action="remove">${dict['cart.remove']}</button>
              </div>
              <div class="cart-item__price">${cur.symbol}${Number(price * it.qty).toFixed(2)}</div>
            </div>
          </article>
        `;
      }).join('');

      body.innerHTML = itemsHtml;
    }

    if (subLbl) {
      subLbl.textContent = dict['cart.subtotal'] || 'SUBTOTAL';
    }

    if (sub) {
      const newText = `${cur.symbol}${Number(this.subtotal()).toFixed(2)}`;
      if (sub.textContent !== newText && sub.textContent !== '') {
        // Flip animation: brief lift + fade, then swap text
        sub.classList.add('is-flipping');
        setTimeout(() => {
          sub.textContent = newText;
          sub.classList.remove('is-flipping');
        }, 220);
      } else {
        sub.textContent = newText;
      }
    }

    // Discrete reference notice for USD region in cart drawer
    let currencyNoticeEl = document.getElementById('cart-currency-notice');
    if (window.MA_IS_INTERNATIONAL === true) {
      if (!currencyNoticeEl) {
        currencyNoticeEl = document.createElement('p');
        currencyNoticeEl.id = 'cart-currency-notice';
        currencyNoticeEl.className = 'cart-drawer__currency-notice';
        const drawerFooter = document.querySelector('.cart-drawer__footer');
        const cartCheckout = document.getElementById('cart-checkout');
        if (drawerFooter && cartCheckout) drawerFooter.insertBefore(currencyNoticeEl, cartCheckout);
      }
      if (currencyNoticeEl) {
        currencyNoticeEl.textContent = 'Prices are shown in USD for reference. Your order will be charged in Peruvian Soles (PEN) at checkout. Your bank or card issuer may apply its own exchange rate and fees.';
      }
    } else if (currencyNoticeEl) {
      currencyNoticeEl.remove();
    }

    document.dispatchEvent(new CustomEvent('cart:changed'));
  }
};

cart.load();

// Cart drawer events
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.createElement('div');
cartOverlay.className = 'cart-drawer__overlay';
document.body.appendChild(cartOverlay);

const cartTrigger = document.getElementById('cart-trigger');
const cartClose   = document.getElementById('cart-close');
const cartBody    = document.getElementById('cart-body');
const cartCheckout= document.getElementById('cart-checkout');

let cartOpenerEl = null;

function handleCartKeydown(e) {
  if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    closeCart();
    return;
  }

  if (e.key === 'Tab') {
    const focusables = cartDrawer.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const firstEl = focusables[0];
    const lastEl = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstEl || !cartDrawer.contains(document.activeElement)) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl || !cartDrawer.contains(document.activeElement)) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  }
}

function openCart(triggerEl) {
  cartOpenerEl = triggerEl || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  cartOverlay.classList.add('is-visible');
  document.body.classList.add('cart-open');
  document.documentElement.classList.add('cart-open');
  document.body.style.overflow = 'hidden';

  document.removeEventListener('keydown', handleCartKeydown);
  document.addEventListener('keydown', handleCartKeydown);

  requestAnimationFrame(() => {
    if (cartClose) {
      cartClose.focus();
    } else {
      const first = cartDrawer.querySelector('button, [href], input, select');
      if (first) first.focus();
    }
  });
}

function closeCart() {
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartOverlay.classList.remove('is-visible');
  document.body.classList.remove('cart-open');
  document.documentElement.classList.remove('cart-open');
  document.body.style.overflow = '';

  document.removeEventListener('keydown', handleCartKeydown);

  if (cartOpenerEl && typeof cartOpenerEl.focus === 'function' && document.body.contains(cartOpenerEl)) {
    try { cartOpenerEl.focus(); } catch(e) {}
  }
}

// ─────────────────────────────────────────────────────────────────────────────
// Add-to-cart animation: flying clone + cart icon bounce + badge pulse
// ─────────────────────────────────────────────────────────────────────────────
function animateAddToCart(sourceEl) {
  const cartBtn = document.getElementById('cart-trigger');
  const cartBtnMobile = document.getElementById('cart-trigger-mobile');
  const badge   = document.getElementById('cart-count');
  const badgeMobile = document.getElementById('cart-count-mobile');
  const reduce  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const buttons = [cartBtn, cartBtnMobile].filter(Boolean);
  const badges = [badge, badgeMobile].filter(Boolean);

  // Always do the bounce + badge pulse (cheap, expressive)
  if (!reduce) {
    buttons.forEach(btn => {
      btn.classList.remove('is-bouncing');
      // Force reflow so the animation can re-trigger on rapid adds
      void btn.offsetWidth;
      btn.classList.add('is-bouncing');
      setTimeout(() => btn.classList.remove('is-bouncing'), 750);
    });
    badges.forEach(bdg => {
      bdg.classList.remove('is-pulsing');
      void bdg.offsetWidth;
      bdg.classList.add('is-pulsing');
      setTimeout(() => bdg.classList.remove('is-pulsing'), 550);
    });
  }

  // Skip flying clone if no source, no cart icon, or reduced motion
  if (!sourceEl || buttons.length === 0 || reduce) return;

  const srcRect = sourceEl.getBoundingClientRect();
  const activeCartBtn = buttons.find(btn => {
    const rect = btn.getBoundingClientRect();
    const style = getComputedStyle(btn);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden';
  });
  if (!activeCartBtn) return;
  const dstRect = activeCartBtn.getBoundingClientRect();
  if (srcRect.width === 0 || srcRect.height === 0) return;

  // Clone the visual: prefer an inner <img>, fall back to a div w/ same bg
  const innerImg = sourceEl.querySelector('img');
  const fly = document.createElement('div');
  fly.className = 'fly-to-cart';
  fly.style.left   = srcRect.left + 'px';
  fly.style.top    = srcRect.top + 'px';
  fly.style.width  = srcRect.width + 'px';
  fly.style.height = srcRect.height + 'px';
  if (innerImg && innerImg.src) {
    const img = document.createElement('img');
    img.src = innerImg.src;
    img.alt = '';
    fly.appendChild(img);
  } else {
    // Use the computed background of the placeholder media
    const cs = getComputedStyle(sourceEl);
    fly.style.background = cs.background;
  }
  document.body.appendChild(fly);

  // Target: center of cart icon, shrunk small
  const targetSize = 28;
  const dx = (dstRect.left + dstRect.width / 2) - (srcRect.left + targetSize / 2);
  const dy = (dstRect.top  + dstRect.height / 2) - (srcRect.top  + targetSize / 2);

  // Trigger animation on next frame so the initial state paints first
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fly.style.transform = `translate(${dx}px, ${dy}px) rotate(8deg)`;
      fly.style.width  = targetSize + 'px';
      fly.style.height = targetSize + 'px';
      fly.style.opacity = '0.15';
    });
  });

  // Cleanup
  setTimeout(() => fly.remove(), 800);
}

const cartTriggerMobile = document.getElementById('cart-trigger-mobile');
if (cartTrigger) cartTrigger.addEventListener('click', () => openCart(cartTrigger));
if (cartTriggerMobile) cartTriggerMobile.addEventListener('click', () => openCart(cartTriggerMobile));
if (cartClose)   cartClose.addEventListener('click', closeCart);
cartOverlay.addEventListener('click', closeCart);

if (cartCheckout) {
  cartCheckout.addEventListener('click', () => {
    if (cart.items.length === 0) return;
    shopifyCheckout();
  });
}

// ─── Shopify Checkout Integration ────────────────────────────────────────────
// Maps our localStorage cart → Shopify variant IDs → Shopify native cart → /checkout

// Runtime fallback: fetch all products from Shopify Ajax API and populate SHOPIFY_VARIANTS
async function ensureShopifyVariants() {
  if (window.SHOPIFY_VARIANTS && Object.keys(window.SHOPIFY_VARIANTS).length > 0) {
    return; // Already populated by Liquid
  }
  console.log('[MA Checkout] SHOPIFY_VARIANTS empty, fetching from /products.json...');
  try {
    const res = await fetch('/products.json');
    if (!res.ok) throw new Error('Failed to fetch products: ' + res.status);
    const data = await res.json();
    window.SHOPIFY_VARIANTS = {};
    for (const product of (data.products || [])) {
      window.SHOPIFY_VARIANTS[product.title] = {};
      for (const variant of (product.variants || [])) {
        window.SHOPIFY_VARIANTS[product.title][variant.title] = variant.id;
      }
    }
    console.log('[MA Checkout] Loaded from Ajax API:', Object.keys(window.SHOPIFY_VARIANTS));
  } catch (err) {
    console.error('[MA Checkout] Ajax fallback failed:', err);
  }
}

async function shopifyCheckout() {
  const items = cart.items;
  if (!items.length) return;

  const checkoutBtn = document.getElementById('cart-checkout');
  const originalText = checkoutBtn ? checkoutBtn.textContent : '';
  if (checkoutBtn) {
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = '...';
  }

  try {
    // 0. Ensure we have variant data (Liquid injection or Ajax fallback)
    await ensureShopifyVariants();

    // 1. Clear Shopify's native cart
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    // 2. For each cart item, find the matching Shopify variant ID
    const lineItems = [];
    const missing = [];

    for (const item of items) {
      const product = PRODUCTS[item.id];
      if (!product) continue;

      const variantId = item.variantId || findShopifyVariantId(product.name, item.size);
      if (!variantId) {
        missing.push(product.name + ' (' + item.size + ')');
        continue;
      }

      lineItems.push({ id: variantId, quantity: item.qty });
    }

    if (lineItems.length === 0) {
      const msg = getLang() === 'en'
        ? 'Products not available for checkout yet. Please create them in Shopify Admin first.'
        : 'Productos aún no disponibles para pago. Créalos en Shopify Admin primero.';
      showToast(msg);
      return;
    }

    if (missing.length > 0) {
      console.warn('Products not found in Shopify:', missing);
    }

    // 3. Add all items to Shopify cart in one request
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    });

    if (!addRes.ok) {
      const errBody = await addRes.json().catch(() => ({}));
      console.error('[MA Checkout] /cart/add.js error:', errBody);
      throw new Error(errBody.description || errBody.message || 'Cart add failed');
    }

    // 4. Redirect to Shopify checkout without clearing local cart (cart clears only upon order completion)
    window.location.href = '/checkout';

  } catch (err) {
    console.error('Checkout error:', err);
    const msg = getLang() === 'en'
      ? 'Checkout error. Please try again.'
      : 'Error al procesar. Intenta de nuevo.';
    showToast(msg);
  } finally {
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = originalText;
    }
  }
}

// Finds a Shopify variant ID by matching product name and size
// Uses the SHOPIFY_VARIANTS object injected by Liquid in theme.liquid
function findShopifyVariantId(productName, size) {
  if (!window.SHOPIFY_VARIANTS || Object.keys(window.SHOPIFY_VARIANTS).length === 0) {
    console.warn('[MA Checkout] SHOPIFY_VARIANTS is empty or not loaded. Products may not be in any collection.');
    return null;
  }

  // Helper: normalize a string for comparison (uppercase, strip extra spaces/dashes)
  const normalize = (s) => s.toUpperCase().replace(/[\s\-–—]+/g, ' ').trim();
  const nameNorm = normalize(productName);
  // Map of full size names to abbreviations for matching
  const SIZE_ALIASES = {
    'S': ['S', 'SMALL', 'CH', 'CHICO', 'P', 'PETIT'],
    'M': ['M', 'MEDIUM', 'MEDIANO', 'MED'],
    'L': ['L', 'LARGE', 'GRANDE', 'GR'],
    'XL': ['XL', 'EXTRA LARGE', 'EXTRA GRANDE'],
    'XS': ['XS', 'EXTRA SMALL', 'EXTRA CHICO'],
    'XXL': ['XXL', '2XL']
  };

  // ─── STOQ Restock Integration ───────────────────────────────────────────────
let _allProductsCache = null;

async function resolveVariantIdForStoq(productInternalId, productName, size) {
  // 1. Fetch live product catalog via Shopify standard API if not cached
  if (!_allProductsCache) {
    try {
      const res = await fetch('/products.json?limit=250');
      if (res.ok) {
        const data = await res.json();
        _allProductsCache = data.products || [];
      }
    } catch (e) {
      console.warn('[MA Stoq] Error fetching /products.json:', e);
    }
  }

  const handlesMap = {
    'MA-DJ-01': ['casaca-plumas-hombre', 'casaca-de-plumas-hombre-j01', 'casaca-negra-plumas-hombre', 'mens-down-jacket'],
    'MA-TE-BK': ['polo-negro-algodon-pima-hombre', 'polo-negro-hombre-algodon-pima', 'polo-algodon-pima-negro', 'mens-black-pima-cotton-t-shirt'],
    'MA-TE-WH': ['polo-blanco-algodon-pima-hombre', 'polo-blanco-hombre-algodon-pima', 'polo-algodon-pima-blanco', 'mens-white-pima-cotton-t-shirt'],
    'MA-DF-01': ['bolso-viaje-cuero-hombre', 'mens-leather-travel-duffel-bag']
  };

  const targetHandles = handlesMap[productInternalId] || [];
  const sizeUp = String(size).toUpperCase().trim();
  const aliases = { S: ['S','SMALL','CH','P'], M: ['M','MEDIUM','MED','MEDIANO'], L: ['L','LARGE','GRANDE','GR'], XL: ['XL','EXTRA LARGE','EXTRA GRANDE'] };
  const sizeCandidates = aliases[sizeUp] || [sizeUp];

  if (_allProductsCache && _allProductsCache.length > 0) {
    for (const p of _allProductsCache) {
      const matchHandle = targetHandles.includes(p.handle);
      const matchTitle = productName ? p.title.toUpperCase().includes(productName.toUpperCase().split(' - ')[0]) : false;
      if (matchHandle || matchTitle) {
        for (const v of (p.variants || [])) {
          const vTitle = v.title.toUpperCase().trim();
          for (const cand of sizeCandidates) {
            if (vTitle === cand || vTitle.startsWith(cand + ' ') || vTitle.startsWith(cand + '/') || vTitle.endsWith(' ' + cand) || vTitle.endsWith('/' + cand) || vTitle === 'DEFAULT TITLE') {
              console.log('[MA Stoq] Resolved via /products.json:', p.title, 'variant:', v.title, '-> variantId:', v.id, 'productId:', p.id);
              return { variantId: Number(v.id), productId: Number(p.id) };
            }
          }
        }
      }
    }
  }

  // 2. Resolve via in-page SHOPIFY_VARIANTS & SHOPIFY_PRODUCT_IDS
  if (window.SHOPIFY_VARIANTS && window.SHOPIFY_PRODUCT_IDS) {
    for (const pTitle of Object.keys(window.SHOPIFY_VARIANTS)) {
      if (productName && pTitle.toUpperCase().includes(productName.toUpperCase().split(' - ')[0])) {
        const variants = window.SHOPIFY_VARIANTS[pTitle];
        const pid = window.SHOPIFY_PRODUCT_IDS[pTitle];
        const vid = findVariantBySize(variants, size);
        if (vid && pid) {
          console.log('[MA Stoq] Resolved via SHOPIFY_VARIANTS:', pTitle, '-> variantId:', vid, 'productId:', pid);
          return { variantId: Number(vid), productId: Number(pid) };
        }
      }
    }
  }

  const fast = findShopifyVariantId(productName, size);
  if (fast) {
    let pid = null;
    if (window.SHOPIFY_PRODUCT_IDS && productName) {
      for (const pTitle of Object.keys(window.SHOPIFY_PRODUCT_IDS)) {
        if (pTitle.toUpperCase().includes(productName.toUpperCase().split(' - ')[0])) {
          pid = window.SHOPIFY_PRODUCT_IDS[pTitle];
          break;
        }
      }
    }
    return { variantId: Number(fast), productId: pid ? Number(pid) : null };
  }

  return null;
}
window.resolveVariantIdForStoq = resolveVariantIdForStoq;

async function sendStoqRestockRequest(productInternalId, productName, size, email) {
  return true;
}
window.sendStoqRestockRequest = sendStoqRestockRequest;

function getStoqSDKWhenReady(timeout = 15000) {
  return new Promise((resolve) => {
    console.log('[MA STOQ INITIAL STATE]', {
      RestockRocketType: typeof window._RestockRocket,
      openInlineFormType: typeof window._RestockRocket?.openInlineForm
    });

    if (window._RestockRocket && typeof window._RestockRocket.openInlineForm === 'function') {
      console.log('[MA STOQ SDK READY]');
      resolve(window._RestockRocket);
      return;
    }

    let finished = false;

    const cleanup = () => {
      window.removeEventListener('stoq:loaded', onLoaded);
    };

    const onLoaded = (event) => {
      console.log('[MA STOQ LOADED EVENT]', {
        pageType: event.detail?.pageType,
        enabled: event.detail?.enabled
      });

      if (event.detail && event.detail.enabled === false) {
        console.error('[MA STOQ DISABLED] STOQ App Embed is explicitly disabled for this pageType:', event.detail.pageType);
      }

      if (window._RestockRocket && typeof window._RestockRocket.openInlineForm === 'function') {
        finished = true;
        cleanup();
        console.log('[MA STOQ SDK READY]');
        resolve(window._RestockRocket);
      }
    };

    window.addEventListener('stoq:loaded', onLoaded);

    const interval = setInterval(() => {
      if (window._RestockRocket && typeof window._RestockRocket.openInlineForm === 'function') {
        finished = true;
        clearInterval(interval);
        cleanup();
        console.log('[MA STOQ SDK READY]');
        resolve(window._RestockRocket);
      }
    }, 150);

    setTimeout(() => {
      if (finished) return;
      clearInterval(interval);
      cleanup();
      console.error('[MA STOQ SDK TIMEOUT]');
      resolve(null);
    }, timeout);
  });
}
window.getStoqSDKWhenReady = getStoqSDKWhenReady;

async function mountStoqInlineForm(productInternalId, productName, size) {
  const container = document.getElementById('ma-restock-stoq');
  if (!container) return;

  const stoqSDK = await getStoqSDKWhenReady();
  if (!stoqSDK) return;

  const info = await resolveVariantIdForStoq(productInternalId, productName, size);
  if (!info || !info.productId || !info.variantId) {
    console.error('[MA STOQ] Product/variant resolution failed');
    return;
  }

  console.log('[MA STOQ PRODUCT]', info.productId);
  console.log('[MA STOQ VARIANT]', info.variantId);
  console.log('[MA STOQ SIZE]', size);

  const currentContainer = document.getElementById('ma-restock-stoq');
  if (!currentContainer) return;

  try {
    console.log('[MA STOQ OPEN INLINE CALLED]');
    const productData = {
      id: Number(info.productId),
      variants: [
        {
          id: Number(info.variantId),
          available: false
        }
      ]
    };

    stoqSDK.openInlineForm(
      productData,
      String(info.variantId),
      null,
      '#ma-restock-stoq',
      'beforeend'
    );

    setTimeout(() => {
      const cont = document.querySelector('#ma-restock-stoq');
      console.log(
        '[MA STOQ INLINE CHILDREN]',
        cont ? cont.children.length : 'CONTAINER_REMOVED'
      );
    }, 300);
  } catch (e) {
    console.error('[MA STOQ INLINE ERROR]', e);
  }
}
window.mountStoqInlineForm = mountStoqInlineForm;

  // Flexible size matching: checks if a variant title matches the requested size
  function findVariantBySize(variants, targetSize) {
    const keys = Object.keys(variants);
    const sizeUp = String(targetSize || '').toUpperCase().trim();
    console.log('[MA Checkout] Available variant keys:', keys, '| Looking for size:', targetSize);

    // 1. Direct exact match
    if (variants[targetSize]) return variants[targetSize];

    // 2. Case-insensitive exact match
    for (const key of keys) {
      if (key.toUpperCase() === sizeUp) return variants[key];
    }

    // 3. Variant title starts with size (e.g., "M / Black" starts with "M")
    for (const key of keys) {
      const keyUp = key.toUpperCase().trim();
      if (keyUp.startsWith(sizeUp + ' ') || keyUp.startsWith(sizeUp + '/') || keyUp === sizeUp) {
        console.log('[MA Checkout] Size prefix match:', key, '→', targetSize);
        return variants[key];
      }
    }

    // 4. Variant title contains size as a word boundary (e.g., "Black / M", "Color: M")
    for (const key of keys) {
      const keyUp = key.toUpperCase();
      // Match size as standalone token: preceded and followed by non-alphanumeric or string boundary
      const sizeRegex = new RegExp('(^|[^A-Z])' + sizeUp.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^A-Z])');
      if (sizeRegex.test(keyUp)) {
        console.log('[MA Checkout] Size word-boundary match:', key, '→', targetSize);
        return variants[key];
      }
    }

    // 5. Alias matching (e.g., "Medium" → "M")
    const aliases = SIZE_ALIASES[sizeUp] || [sizeUp];
    for (const key of keys) {
      const keyUp = key.toUpperCase().trim();
      for (const alias of aliases) {
        if (keyUp === alias || keyUp.startsWith(alias + ' ') || keyUp.startsWith(alias + '/')) {
          console.log('[MA Checkout] Size alias match:', key, '→', targetSize, '(alias:', alias + ')');
          return variants[key];
        }
      }
    }

    // 6. Default Title fallback (single-variant product)
    if (variants['Default Title']) return variants['Default Title'];

    return null;
  }

  console.log('[MA Checkout] Looking for:', productName, '| Size:', size);
  console.log('[MA Checkout] Available Shopify products:', Object.keys(window.SHOPIFY_VARIANTS));

  // Helper to try matching a product's variants with flexible size matching
  function tryMatch(title, variants, matchType) {
    const result = findVariantBySize(variants, size);
    if (result) {
      console.log('[MA Checkout] ✓ Match via', matchType + ':', title, '| Variant ID:', result);
    }
    return result;
  }

  // 1. Exact title match
  if (window.SHOPIFY_VARIANTS[productName]) {
    const r = tryMatch(productName, window.SHOPIFY_VARIANTS[productName], 'exact');
    if (r) return r;
  }

  // 2. Normalized exact match
  for (const [title, variants] of Object.entries(window.SHOPIFY_VARIANTS)) {
    if (normalize(title) === nameNorm) {
      const r = tryMatch(title, variants, 'normalized');
      if (r) return r;
    }
  }

  // 3. Fuzzy match: one title contains the other
  for (const [title, variants] of Object.entries(window.SHOPIFY_VARIANTS)) {
    const titleNorm = normalize(title);
    if (nameNorm.includes(titleNorm) || titleNorm.includes(nameNorm)) {
      const r = tryMatch(title, variants, 'fuzzy');
      if (r) return r;
    }
  }

  // 4. Keyword match
  const extractKeywords = (s) => normalize(s).split(' ').filter(w => w.length > 1);
  const nameKeywords = extractKeywords(productName);
  for (const [title, variants] of Object.entries(window.SHOPIFY_VARIANTS)) {
    const titleKeywords = extractKeywords(title);
    const overlap = nameKeywords.filter(kw => titleKeywords.includes(kw));
    if (overlap.length >= 2 || (titleKeywords.length > 0 && titleKeywords.every(kw => nameKeywords.includes(kw)))) {
      const r = tryMatch(title, variants, 'keyword');
      if (r) return r;
    }
  }

  console.warn('[MA Checkout] No match found for:', productName, '| Size:', size);
  return null;
}

// ─── STOQ variant resolver ──────────────────────────────────────────────────
// Maps internal PRODUCTS IDs to Shopify handles for /products/handle.json lookup
const MA_SHOPIFY_HANDLES = {
  'MA-DJ-01': 'casaca-plumas-hombre',
  'MA-TE-BK': 'polo-negro-algodon-pima-hombre',
  'MA-TE-WH': 'polo-blanco-algodon-pima-hombre',
  'MA-DF-01': 'bolso-viaje-cuero-hombre'
};

// Returns { variantId, productId } for STOQ intent payload.
// Strategy 1: SHOPIFY_VARIANTS fuzzy lookup (instant)
// Strategy 2: /products/handle.json fetch (reliable fallback)
async function resolveVariantIdForStoq(productInternalId, productName, size) {
  // 1. Fast path via in-page SHOPIFY_VARIANTS
  const fast = findShopifyVariantId(productName, size);
  if (fast) {
    // Try to get the Shopify product ID from the handle JSON
    const handle = MA_SHOPIFY_HANDLES[productInternalId];
    let shopifyProductId = null;
    if (handle) {
      try {
        const r = await fetch('/products/' + handle + '.json');
        if (r.ok) { const d = await r.json(); shopifyProductId = d.product ? d.product.id : null; }
      } catch(e) { /* fallback without product ID */ }
    }
    console.log('[MA Stoq] variant via SHOPIFY_VARIANTS:', fast, 'productId:', shopifyProductId);
    return { variantId: Number(fast), productId: shopifyProductId };
  }

  // 2. Reliable path: fetch /products/handle.json
  const handle = MA_SHOPIFY_HANDLES[productInternalId];
  if (!handle) { console.warn('[MA Stoq] No handle for:', productInternalId); return null; }
  try {
    const resp = await fetch('/products/' + handle + '.json');
    if (!resp.ok) throw new Error('HTTP ' + resp.status);
    const data = await resp.json();
    const shopifyProductId = data.product ? data.product.id : null;
    const sizeUp = String(size).toUpperCase().trim();
    const aliases = { S: ['SMALL','CH','P'], M: ['MEDIUM','MED','MEDIANO'], L: ['LARGE','GRANDE','GR'], XL: ['EXTRA LARGE','EXTRA GRANDE'] };
    const candidates = [sizeUp, ...(aliases[sizeUp] || [])];
    for (const v of (data.product && data.product.variants || [])) {
      const vUp = v.title.toUpperCase().trim();
      for (const a of candidates) {
        if (vUp === a || vUp.startsWith(a + ' ') || vUp.startsWith(a + '/') || vUp.endsWith(' ' + a) || vUp.endsWith('/' + a)) {
          console.log('[MA Stoq] variant via API:', handle, size, '\u2192', v.id, 'productId:', shopifyProductId);
          return { variantId: Number(v.id), productId: shopifyProductId };
        }
      }
    }
    console.warn('[MA Stoq] No variant in API for', handle, size, '| Available:', (data.product && data.product.variants || []).map(function(v) { return v.title; }));
  } catch (err) {
    console.warn('[MA Stoq] API fetch error for', handle + ':', err);
  }
  return null;
}
window.resolveVariantIdForStoq = resolveVariantIdForStoq;


// Quantity controls inside cart drawer
if (cartBody) {
  cartBody.addEventListener('click', e => {
    const action = e.target.getAttribute('data-action');
    if (!action) return;

    if (action.endsWith('-bundle')) {
      const groupId = e.target.getAttribute('data-group-id');
      if (!groupId) return;
      const groupItems = cart.items.map((it, i) => ({ ...it, idx: i })).filter(it => it.bundleGroupId === groupId);
      if (groupItems.length === 0) return;
      
      if (action === 'remove-bundle') {
        groupItems.sort((a,b) => b.idx - a.idx).forEach(it => cart.items.splice(it.idx, 1));
        cart.autoPromoteTeeBundles();
        cart.save();
        cart.render();
      } else if (action === 'inc-bundle') {
        groupItems.forEach(it => cart.items[it.idx].qty += 1);
        cart.autoPromoteTeeBundles();
        cart.save();
        cart.render();
      } else if (action === 'dec-bundle') {
        const anyZero = groupItems.some(it => cart.items[it.idx].qty <= 1);
        if (anyZero) {
          groupItems.sort((a,b) => b.idx - a.idx).forEach(it => cart.items.splice(it.idx, 1));
        } else {
          groupItems.forEach(it => cart.items[it.idx].qty -= 1);
        }
        cart.autoPromoteTeeBundles();
        cart.save();
        cart.render();
      }
      return;
    }

    const item = e.target.closest('.cart-item');
    if (!item) return;
    const idx = Number(item.getAttribute('data-idx'));
    if (action === 'inc') cart.setQty(idx, cart.items[idx].qty + 1);
    else if (action === 'dec') cart.setQty(idx, cart.items[idx].qty - 1);
    else if (action === 'remove') cart.remove(idx);
  });
}

// ─────────────────────────────────────────────────────────────────────────────
// Size selector + Quick add
// ─────────────────────────────────────────────────────────────────────────────
document.querySelectorAll('.product-card').forEach(card => {
  const sizeBtns = card.querySelectorAll('.size-btn');
  const addBtn   = card.querySelector('[data-quick-add]');

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (addBtn) addBtn.classList.add('is-ready');
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const activeSize = card.querySelector('.size-btn.is-active');
      if (!activeSize) {
        showToast(t('toast.select_size'));
        card.querySelector('.product-card__sizes')?.classList.add('is-pulsing');
        setTimeout(() => {
          card.querySelector('.product-card__sizes')?.classList.remove('is-pulsing');
        }, 800);
        return;
      }
      const addSuccess = cart.add({
        id: card.getAttribute('data-product-id'),
        name: card.getAttribute('data-product-name'),
        color: card.getAttribute('data-product-color'),
        size: activeSize.getAttribute('data-size'),
        priceUsd: Number(card.getAttribute('data-price-usd')),
        pricePen: Number(card.getAttribute('data-price-pen')),
        qty: 1
      });
      if (addSuccess !== false) {
        animateAddToCart(card.querySelector('.product-card__media'));
        showToast(t('toast.added'));
        // Delay cart drawer slightly so the flying clone is visible before the drawer covers the icon
        setTimeout(openCart, 280);
      }
    });
  }
});

// ─────────────────────────────────────────────────────────────────────────────
// Size guide modal
// ─────────────────────────────────────────────────────────────────────────────
const sizeGuideModal   = document.getElementById('size-guide-modal');
const sizeGuideClose   = document.getElementById('size-guide-close');
const sizeGuideOverlay = document.getElementById('size-guide-overlay');

let sizeGuideOpenerEl = null;

function handleSizeGuideKeydown(e) {
  if (!sizeGuideModal || !sizeGuideModal.classList.contains('is-open')) return;
  if (e.key === 'Escape') {
    e.preventDefault();
    closeSizeGuide();
  }
}

function openSizeGuide(triggerEl) {
  sizeGuideOpenerEl = triggerEl || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
  sizeGuideModal.classList.add('is-open');
  sizeGuideModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  document.removeEventListener('keydown', handleSizeGuideKeydown);
  document.addEventListener('keydown', handleSizeGuideKeydown);

  requestAnimationFrame(() => {
    if (sizeGuideClose) sizeGuideClose.focus();
  });
}

function closeSizeGuide() {
  sizeGuideModal.classList.remove('is-open');
  sizeGuideModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';

  document.removeEventListener('keydown', handleSizeGuideKeydown);

  if (sizeGuideOpenerEl && typeof sizeGuideOpenerEl.focus === 'function' && document.body.contains(sizeGuideOpenerEl)) {
    try { sizeGuideOpenerEl.focus(); } catch(e) {}
  }
}

document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-open="size-guide"]');
  if (trigger) {
    e.preventDefault();
    openSizeGuide(trigger);
  }
});
if (sizeGuideClose)   sizeGuideClose.addEventListener('click', closeSizeGuide);
if (sizeGuideOverlay) sizeGuideOverlay.addEventListener('click', closeSizeGuide);



// ─────────────────────────────────────────────────────────────────────────────
// Toast
// ─────────────────────────────────────────────────────────────────────────────
let toastTimer = null;
function showToast(message) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
}

// ─────────────────────────────────────────────────────────────────────────────
// Mobile menu
// ─────────────────────────────────────────────────────────────────────────────
const hamburger     = document.getElementById('nav-hamburger');
const mobileMenu    = document.getElementById('mobile-menu');
const mobileOverlay = document.getElementById('mobile-overlay');
const mobileClose   = document.getElementById('mobile-menu-close');

function openMenu() {
  document.querySelectorAll('.pdp-drawer.is-open, .cart-drawer.is-open, .fit-drawer.is-open').forEach(el => el.classList.remove('is-open'));
  const pdpOverlay = document.getElementById('pdp-drawer-overlay');
  if (pdpOverlay) pdpOverlay.classList.remove('is-visible');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  if (cartOverlay) cartOverlay.classList.remove('is-visible');

  mobileMenu.classList.add('is-open');
  mobileMenu.setAttribute('aria-hidden', 'false');
  if (mobileOverlay) mobileOverlay.classList.add('is-visible');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  document.body.classList.add('menu-open');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.remove('is-open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  if (mobileOverlay) mobileOverlay.classList.remove('is-visible');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
  document.body.style.overflow = '';

  const subItems = mobileMenu.querySelectorAll('.mobile-menu__item--has-sub');
  subItems.forEach(item => {
    item.classList.remove('is-active');
    const toggleBtn = item.querySelector('[aria-expanded]');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });
}

if (hamburger)     hamburger.addEventListener('click', openMenu);
if (mobileClose)   mobileClose.addEventListener('click', closeMenu);
if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);
if (mobileMenu) {
  mobileMenu.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (link) {
      closeMenu();
    }
  });
}

// Synchronous capture listener for mobile menu close actions to ensure instant Safari bar restoration
document.addEventListener('click', (e) => {
  const target = e.target;
  if (!target || typeof target.closest !== 'function') return;
  if (target.closest('#mobile-menu-close, .mobile-menu__close, #mobile-overlay, .mobile-menu__overlay')) {
    document.body.classList.remove('menu-open');
  }
}, true);

// ─── Header Region Dropdown Toggle & Outside Click ───
document.addEventListener('click', (e) => {
  const worldDropdown = document.getElementById('world-dropdown-wrapper');
  const worldMenu = document.getElementById('world-menu');
  const worldTrigger = document.getElementById('world-trigger');

  if (worldDropdown && worldMenu) {
    if (worldTrigger && worldTrigger.contains(e.target)) {
      e.preventDefault();
      worldMenu.classList.toggle('is-open');
    } else if (!worldDropdown.contains(e.target)) {
      worldMenu.classList.remove('is-open');
    }
  }
});

// Global Escape: close any open overlay
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  const worldMenu = document.getElementById('world-menu');
  if (worldMenu?.classList.contains('is-open')) worldMenu.classList.remove('is-open');
  if (mobileMenu?.classList.contains('is-open')) closeMenu();
  if (cartDrawer?.classList.contains('is-open')) closeCart();
  if (sizeGuideModal?.classList.contains('is-open')) closeSizeGuide();
});

// ─────────────────────────────────────────────────────────────────────────────
// Shop dropdown
// ─────────────────────────────────────────────────────────────────────────────
const shopTrigger  = document.getElementById('shop-trigger');
const shopDropdown = document.getElementById('shop-dropdown');

if (shopTrigger && shopDropdown) {
  shopTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    shopDropdown.classList.toggle('is-open', !expanded);
  });
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav__item--has-dropdown')) {
      shopTrigger.setAttribute('aria-expanded', 'false');
      shopDropdown.classList.remove('is-open');
    }
  });
}

// ─────────────────────────────────────────────────────────────────────────────
// FAQ accordion
// ─────────────────────────────────────────────────────────────────────────────
document.querySelectorAll('.faq__question').forEach(button => {
  button.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';

    document.querySelectorAll('.faq__question').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const answerId = btn.getAttribute('aria-controls');
      const answer   = document.getElementById(answerId);
      if (answer) answer.classList.remove('is-open');
    });

    if (!isExpanded) {
      this.setAttribute('aria-expanded', 'true');
      const answerId = this.getAttribute('aria-controls');
      const answer   = document.getElementById(answerId);
      if (answer) answer.classList.add('is-open');
    }
  });
});



// ─────────────────────────────────────────────────────────────────────────────
// Transparent header — smart contrast adaptation (permanently transparent)
// The header never gains a background. Only text/logo/icon colors change
// based on whether the header overlaps a dark or light section.
// ─────────────────────────────────────────────────────────────────────────────
const siteHeader = document.getElementById('site-header');
(function initEditorialHeader() {
  if (!siteHeader) return;

  // Ensure body has page-product class if on product page
  if (document.getElementById('product-detail') && !document.body.classList.contains('page-product')) {
    document.body.classList.add('page-product');
  }

  const hoverZone = document.getElementById('header-hover-zone');
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // ── State ──────────────────────────────────────────────────────────────────
  let currentMode = null; // 'editorial' | 'hidden'
  let isPeeking = false;
  let peekTimeout = null;
  let lastScrollY = window.scrollY;
  let scrollTicking = false;
  const SCROLL_THRESHOLD = 5; // px delta to detect direction
  const PEEK_DELAY = 700; // ms before hiding after mouseleave

  // ── Tone Adaptation State (moved here to avoid TDZ ReferenceErrors) ────────
  const darkSectionsInView = new Set();
  let observedToneElements = new WeakSet();

  // ── Header State Helpers ───────────────────────────────────────────────────
  function showEditorial() {
    siteHeader.classList.remove('is-header-hidden', 'is-header-peek');
    siteHeader.classList.add('is-header-editorial');
    isPeeking = false;
    clearPeekTimeout();
    if (hoverZone) hoverZone.style.pointerEvents = 'none';
  }

  function hideHeader() {
    // Disabled for always-present header experiment
  }

  function showPeek() {
    siteHeader.classList.remove('is-header-hidden', 'is-header-editorial');
    siteHeader.classList.add('is-header-peek');
    isPeeking = true;
    clearPeekTimeout();
  }

  function clearPeekTimeout() {
    if (peekTimeout) {
      clearTimeout(peekTimeout);
      peekTimeout = null;
    }
  }

  function isOverlappingImage() {
    if (!siteHeader) return false;
    const headerRect = siteHeader.getBoundingClientRect();
    const headerBottom = headerRect.bottom;

    // Check if the product gallery grid frame is active and overlaps the header
    const gallerySplit = document.getElementById('product-gallery');
    if (gallerySplit) {
      const rect = gallerySplit.getBoundingClientRect();
      const offset = 30;
      if (rect.bottom > headerBottom + offset) {
        return true;
      }
    }

    const elements = document.querySelectorAll('img, picture, [style*="background-image"], .hero, .product-campaign, .spotlight, [data-header-mode="editorial"], .c01-purpose-hero');

    for (let i = 0; i < elements.length; i++) {
      const el = elements[i];
      if (
        el.closest('.site-header') ||
        el.closest('.announcement-bar') ||
        el.closest('#cart-drawer') ||
        el.closest('#mobile-menu') ||
        el.closest('.cart-drawer') ||
        el.closest('.pdp-features') ||
        el.closest('.reviews') ||
        el.closest('.review-card') ||
        el.closest('#product-gallery') // Ignore individual images inside the gallery container
      ) {
        continue;
      }

      const rect = el.getBoundingClientRect();
      if (rect.width < 30 || rect.height < 30) {
        continue;
      }

      const offset = 30;
      if (rect.top < headerBottom && rect.bottom > headerBottom + offset) {
        return true;
      }
    }

    return false;
  }

  function applyPDPHeaderTransparency() {
    const isProductPage = document.body.classList.contains('page-product') || document.body.classList.contains('template-product') || !!document.getElementById('product-detail');
    if (!isProductPage) return;
    if (window.innerWidth < 990) return;

    const headerSelectors = [
      '#shopify-section-header',
      '.shopify-section-header',
      '.header-wrapper',
      '.site-header',
      '.site-header-wrapper',
      'header',
      '.header'
    ];

    headerSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.setProperty('background', 'transparent', 'important');
        el.style.setProperty('background-color', 'transparent', 'important');
        el.style.setProperty('box-shadow', 'none', 'important');
        el.style.setProperty('border', '0', 'important');
      });
    });

    document.body.classList.add('ma-product-header-transparent');
  }

  document.addEventListener('DOMContentLoaded', applyPDPHeaderTransparency);
  window.addEventListener('load', applyPDPHeaderTransparency);
  applyPDPHeaderTransparency();

  function updateHeaderMode() {
    // On product pages: start with transparent editorial header so the first
    // gallery image appears fully behind it (Saint Laurent style).
    // The normal image-detection then takes over for the rest of the scroll.
    const isProductPage = document.body.classList.contains('page-product') || !!document.getElementById('product-detail');
    siteHeader.classList.remove('is-header-at-top');
    if (isProductPage && window.scrollY < 20) {
      if (currentMode !== 'editorial') {
        currentMode = 'editorial';
        showEditorial();
      }
      return;
    }

    const mode = isOverlappingImage() ? 'editorial' : 'hidden';

    if (mode !== currentMode) {
      currentMode = mode;
      if (mode === 'editorial') {
        showEditorial();
      } else {
        showPeek();
      }
    }
  }

  function updateHeaderLogoVisibility() {
    const hero = document.querySelector('.hero');
    const logo = siteHeader ? siteHeader.querySelector('.header-logo') : null;
    if (!logo) return;
    if (!hero) {
      siteHeader.classList.add('show-logo');
      return;
    }
    const threshold = hero.offsetHeight - 39;
    const isOverHero = darkSectionsInView.has(hero) || (window.scrollY < threshold);
    if (isOverHero) {
      siteHeader.classList.remove('show-logo');
    } else {
      siteHeader.classList.add('show-logo');
    }
  }

  // Initial mode check
  updateHeaderMode();
  updateHeaderLogoVisibility();
  document.addEventListener('DOMContentLoaded', updateHeaderLogoVisibility);
  window.addEventListener('load', updateHeaderLogoVisibility);

  // ── Scroll Event Listener ──────────────────────────────────────────────────
  const checkPdpScroll = () => {
    if (window.scrollY > 15) {
      document.body.classList.add('pdp-scrolled');
    } else {
      document.body.classList.remove('pdp-scrolled');
    }
  };
  checkPdpScroll();

  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      requestAnimationFrame(() => {
        updateHeaderMode();
        updateTone();
        checkPdpScroll();
        updateHeaderLogoVisibility();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // ── Tone Adaptation (preserved from previous system) ───────────────────────
  // ONLY watches sections explicitly marked with [data-header-tone="dark"]
  // to toggle site-header--light (white text). This restricts the white
  // header to full-width editorial banners (Hero, J-01, T-01 campaign).

  function updateTone() {
    if (darkSectionsInView.size > 0) {
      // Check if the only intersecting elements are in the related section (COMPLETA EL LOOK)
      let onlyRelated = true;
      for (const el of darkSectionsInView) {
        if (!el.closest('.complete-system') && !el.closest('.related') && !el.closest('.ma-look')) {
          onlyRelated = false;
          break;
        }
      }

      if (onlyRelated) {
        siteHeader.classList.remove('site-header--light');
        siteHeader.classList.add('site-header--only-links-light');
      } else {
        siteHeader.classList.add('site-header--light');
        siteHeader.classList.remove('site-header--only-links-light');
      }
      siteHeader.classList.remove('site-header--dropdown-dark');
      siteHeader.classList.add('site-header--dropdown-light');
    } else {
      siteHeader.classList.remove('site-header--light');
      siteHeader.classList.remove('site-header--only-links-light');
      
      // Mismatch handling at scroll 0:
      // If we are at scroll 0 on a page with a dark banner at the top,
      // the dropdown is over the dark banner, so it should have white text (light tone).
      const firstSection = document.querySelector('main > [data-header-tone]');
      if (window.scrollY < 20 && firstSection && firstSection.getAttribute('data-header-tone') === 'dark') {
        siteHeader.classList.add('site-header--dropdown-light');
        siteHeader.classList.remove('site-header--dropdown-dark');
      } else {
        siteHeader.classList.add('site-header--dropdown-dark');
        siteHeader.classList.remove('site-header--dropdown-light');
      }
    }
    updateHeaderLogoVisibility();
  }

  // Initial tone check
  updateTone();

  function createToneObserver() {
    const topMargin = -21;
    const bottomMargin = -(window.innerHeight - 39);
    return new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          darkSectionsInView.add(entry.target);
        } else {
          darkSectionsInView.delete(entry.target);
        }
      });
      updateTone();
    }, {
      root: null,
      rootMargin: `${topMargin}px 0px ${bottomMargin}px 0px`,
      threshold: 0
    });
  }

  let toneObserver = createToneObserver();

  function observeAllDark() {
    // Observe:
    // 1. Campaign banners with dark tone
    // 2. Product card media (thumbnails in bestsellers and related)
    // 3. Product detail gallery tiles (pdp hero and gallery images)
    // 4. THE PURPOSE editorial hero section (.c01-purpose-hero)
    const elementsToObserve = document.querySelectorAll(
      '[data-header-tone="dark"], ' +
      '.c01-purpose-hero, ' +
      '[data-c01-seo], ' +
      'section.bestsellers .product-card__media, ' +
      '.complete-system .product-card__media, ' +
      '.related .product-card__media, ' +
      '.ma-look-item__media, ' +
      '.product-gallery__hero-tile, ' +
      '.product-gallery__tile'
    );
    elementsToObserve.forEach(el => {
      if (!observedToneElements.has(el)) {
        observedToneElements.add(el);
        toneObserver.observe(el);
      }
    });
  }

  // Initial observation
  observeAllDark();

  // MutationObserver — picks up dynamically-injected dark sections (e.g. PDP, info pages)
  const domObserver = new MutationObserver(() => { observeAllDark(); });
  domObserver.observe(document.body, { childList: true, subtree: true });

  // Handle resize — recalculate
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      toneObserver.disconnect();
      darkSectionsInView.clear();
      observedToneElements = new WeakSet();
      toneObserver = createToneObserver();
      observeAllDark();
    }, 200);
  }, { passive: true });

  // Expose global rescan for external callers (e.g. after PDP renders)
  window.rescanHeaderTone = observeAllDark;

  // ── Account Dialog / Modal Open Tinting (Web Behaviors Skill) ───────────────
  function initAccountDialogTinting() {
    let pollingInterval = null;

    function checkAllAccountDialogs() {
      let isAnyOpen = false;
      document.querySelectorAll('shopify-account').forEach(acc => {
        const shadow = acc.shadowRoot;
        if (!shadow) return;
        const dialog = shadow.querySelector('dialog');
        if (dialog && (dialog.hasAttribute('open') || dialog.open === true)) {
          isAnyOpen = true;
        }
      });

      const wasOpen = document.body.classList.contains('account-dialog-open');

      if (isAnyOpen) {
        if (!wasOpen) {
          document.body.classList.add('account-dialog-open');
        }
        if (!pollingInterval) {
          pollingInterval = setInterval(checkAllAccountDialogs, 60);
        }
      } else {
        if (wasOpen) {
          document.body.classList.remove('account-dialog-open');
          updateHeaderMode();
          updateTone();
        }
        if (pollingInterval) {
          clearInterval(pollingInterval);
          pollingInterval = null;
        }
      }
    }

    function bindShopifyAccount(el) {
      if (!el || el._maDialogBound) return;
      el._maDialogBound = true;

      const setupListeners = () => {
        const shadow = el.shadowRoot;
        if (!shadow) return false;
        const dialog = shadow.querySelector('dialog');
        if (!dialog) return false;

        const obs = new MutationObserver(checkAllAccountDialogs);
        obs.observe(dialog, { attributes: true, attributeFilter: ['open', 'class', 'style'] });

        dialog.addEventListener('close', checkAllAccountDialogs);
        dialog.addEventListener('cancel', checkAllAccountDialogs);

        shadow.addEventListener('click', () => {
          checkAllAccountDialogs();
          setTimeout(checkAllAccountDialogs, 30);
          setTimeout(checkAllAccountDialogs, 100);
          setTimeout(checkAllAccountDialogs, 250);
        });

        shadow.addEventListener('touchstart', checkAllAccountDialogs, { passive: true });
        shadow.addEventListener('touchend', () => {
          setTimeout(checkAllAccountDialogs, 30);
          setTimeout(checkAllAccountDialogs, 100);
        }, { passive: true });

        return true;
      };

      if (!setupListeners()) {
        const compObserver = new MutationObserver(() => {
          if (setupListeners()) {
            compObserver.disconnect();
          }
        });
        compObserver.observe(el, { childList: true, subtree: true });
      }

      el.addEventListener('click', () => {
        checkAllAccountDialogs();
        setTimeout(checkAllAccountDialogs, 30);
        setTimeout(checkAllAccountDialogs, 100);
      });
      el.addEventListener('touchstart', checkAllAccountDialogs, { passive: true });
    }

    document.querySelectorAll('shopify-account').forEach(bindShopifyAccount);

    const bodyObs = new MutationObserver(() => {
      document.querySelectorAll('shopify-account').forEach(bindShopifyAccount);
      checkAllAccountDialogs();
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });

    ['click', 'touchstart', 'touchend', 'scroll'].forEach((evt) => {
      window.addEventListener(evt, () => {
        if (document.body.classList.contains('account-dialog-open')) {
          checkAllAccountDialogs();
        }
      }, { passive: true, capture: true });
    });

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setTimeout(checkAllAccountDialogs, 30);
      }
    }, true);

    // Wire mobile account trigger to trigger shopify-account dialog
    document.addEventListener('click', (e) => {
      const mobileBtn = e.target && typeof e.target.closest === 'function' ? e.target.closest('#account-trigger-mobile') : null;
      if (mobileBtn) {
        e.preventDefault();
        const desktopAcc = document.querySelector('shopify-account');
        if (desktopAcc && desktopAcc.shadowRoot) {
          const btn = desktopAcc.shadowRoot.querySelector('.account-button');
          if (btn) {
            btn.click();
          }
          const dialog = desktopAcc.shadowRoot.querySelector('dialog');
          if (dialog && !dialog.open) {
            try {
              dialog.showModal();
            } catch (_) {
              dialog.setAttribute('open', '');
            }
          }
          checkAllAccountDialogs();
        } else if (desktopAcc) {
          desktopAcc.click();
          setTimeout(checkAllAccountDialogs, 100);
        }
      }
    });
  }

  initAccountDialogTinting();

  // ── Initial State ──────────────────────────────────────────────────────────
  // On page load, determine initial mode from the first visible section
  if (document.querySelectorAll('[data-header-mode]').length === 0) {
    // No sections with data-header-mode (e.g. info pages, checkout)
    // Default to editorial (always visible)
    showEditorial();
  }
})();

// ─────────────────────────────────────────────────────────────────────────────
// Smooth scroll for internal anchors
// ─────────────────────────────────────────────────────────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    if (href === '#' || this.hasAttribute('data-open')) return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (mobileMenu?.classList.contains('is-open')) closeMenu();
    }
  });
});

// ─────────────────────────────────────────────────────────────────────────────
// PRODUCT DETAIL PAGE (only runs on product.html)
function isUsdRegion() {
  return window.MA_IS_INTERNATIONAL === true;
}
window.isUsdRegion = isUsdRegion;

function getCurrencyObj() {
  return isUsdRegion() ? CURRENCY.en : CURRENCY.es;
}

function formatPrice(value) {
  const cur = getCurrencyObj();
  return `${cur.symbol}${Number(value).toFixed(2)}`;
}

function getProductPrice(product) {
  if (!product) return 0;
  return isUsdRegion() ? (product.priceUsd || product.price_usd || product.price) : (product.pricePen || product.price_pen || product.price);
}

const PDP_IMAGE_COUNT = 8;

function getPdpDynamicGalleryItems(product) {
  const galleries = window.MA_QUICK_BUY_GALLERIES || {};
  const gallery = product ? galleries[product.id] : null;
  if (!gallery) return [];

  const isMobile = window.matchMedia('(max-width: 989px)').matches;
  const preferredItems = isMobile ? gallery.mobile : gallery.desktop;
  const alternateItems = isMobile ? gallery.desktop : gallery.mobile;
  const items = Array.isArray(preferredItems) && preferredItems.length
    ? preferredItems
    : alternateItems;

  return Array.isArray(items)
    ? items.filter(item => typeof item === 'string' ? Boolean(item) : Boolean(item && item.src))
    : [];
}

function getPdpDynamicGalleryItem(product, index) {
  return getPdpDynamicGalleryItems(product)[index] || null;
}

function getPdpImages(product) {
  const isCurrentProduct = product.id === window.MA_CURRENT_PRODUCT_ID;
  const isMobile = window.matchMedia('(max-width: 989px)').matches;
  let rawImages = [];

  const mobileImages = isCurrentProduct && isMobile && Array.isArray(window.MA_PDP_MOBILE_IMAGES)
    ? window.MA_PDP_MOBILE_IMAGES.filter(Boolean)
    : [];

  const liquidImages = isCurrentProduct && Array.isArray(window.MA_PDP_IMAGES)
    ? window.MA_PDP_IMAGES.filter(Boolean)
    : [];

  const dynamicGalleryItems = getPdpDynamicGalleryItems(product);

  if (mobileImages.length) {
    rawImages = mobileImages;
  } else if (liquidImages.length) {
    rawImages = liquidImages;
  } else if (dynamicGalleryItems.length) {
    rawImages = dynamicGalleryItems.map(item => typeof item === 'string' ? item : item.src);
  } else {
    const productImages = Array.isArray(product.images) ? product.images.filter(Boolean) : [];
    const fallbackImage = productImages[0] || getCartThumb(product.id);
    rawImages = fallbackImage
      ? Array.from({ length: PDP_IMAGE_COUNT }, () => fallbackImage)
      : Array.from({ length: PDP_IMAGE_COUNT }, (_, index) => `placeholder-${index + 1}`);
  }

  return rawImages;
}

function getPdpDesktopOrderedItems(items) {
  const sourceItems = Array.isArray(items) ? items.filter(Boolean) : [];
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  const desktopOrder = Array.isArray(window.MA_PDP_DESKTOP_ORDER)
    ? window.MA_PDP_DESKTOP_ORDER.map(Number)
    : [];

  if (!isDesktop || desktopOrder.length !== sourceItems.length) {
    return sourceItems;
  }

  const seenIndexes = new Set();
  const orderedItems = desktopOrder.map(position => {
    const sourceIndex = position - 1;
    if (
      !Number.isInteger(sourceIndex) ||
      sourceIndex < 0 ||
      sourceIndex >= sourceItems.length ||
      seenIndexes.has(sourceIndex)
    ) {
      return null;
    }
    seenIndexes.add(sourceIndex);
    return sourceItems[sourceIndex];
  });

  return orderedItems.every(Boolean) ? orderedItems : sourceItems;
}

function getPdpDisplayImages(product) {
  const images = getPdpImages(product);
  return product.id === window.MA_CURRENT_PRODUCT_ID
    ? getPdpDesktopOrderedItems(images)
    : images;
}

function getPdpImageAlt(product, index) {
  const isMobile = window.matchMedia('(max-width: 989px)').matches;
  if (
    product.id === window.MA_CURRENT_PRODUCT_ID &&
    isMobile &&
    Array.isArray(window.MA_PDP_MOBILE_IMAGE_ALTS)
  ) {
    const mobileAlt = window.MA_PDP_MOBILE_IMAGE_ALTS[index];
    if (mobileAlt) return mobileAlt;
  }

  if (product.id === window.MA_CURRENT_PRODUCT_ID && Array.isArray(window.MA_PDP_IMAGE_ALTS)) {
    const liquidAlts = getPdpDesktopOrderedItems(window.MA_PDP_IMAGE_ALTS);
    const liquidAlt = liquidAlts[index];
    if (liquidAlt) return liquidAlt;
  }

  const galleryItem = getPdpDynamicGalleryItem(product, index);
  if (galleryItem && typeof galleryItem !== 'string' && galleryItem.alt) {
    return galleryItem.alt;
  }

  return `${product.name} ${String(index + 1).padStart(2, '0')}`;
}

function getPdpImageDimensions(product, index) {
  const isMobile = window.matchMedia('(max-width: 989px)').matches;
  if (
    product.id === window.MA_CURRENT_PRODUCT_ID &&
    isMobile &&
    Array.isArray(window.MA_PDP_MOBILE_IMAGE_DIMENSIONS)
  ) {
    const dimensions = window.MA_PDP_MOBILE_IMAGE_DIMENSIONS[index];
    if (Array.isArray(dimensions) && dimensions.length === 2) {
      const width = Number(dimensions[0]);
      const height = Number(dimensions[1]);
      if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
        return { width, height };
      }
    }
  }

  const galleryItem = getPdpDynamicGalleryItem(product, index);
  if (!galleryItem || typeof galleryItem === 'string') return null;

  const width = Number(galleryItem.width);
  const height = Number(galleryItem.height);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;

  return { width, height };
}

const PDP_RESPONSIVE_WIDTHS = [480, 720, 960, 1200, 1440, 1800, 2200];

function buildPdpResponsiveSrcset(src, intrinsicWidth, candidateWidths = PDP_RESPONSIVE_WIDTHS) {
  const resolvedSrc = getAssetUrl(src);
  const masterWidth = Number(intrinsicWidth);
  if (!resolvedSrc || !Number.isFinite(masterWidth) || masterWidth <= 0) return '';

  try {
    const widths = candidateWidths
      .map(Number)
      .filter(width => Number.isFinite(width) && width > 0 && width < masterWidth);
    widths.push(masterWidth);

    return [...new Set(widths)].map(width => {
      const url = new URL(resolvedSrc, window.location.origin);
      url.searchParams.set('width', width);
      return `${url.toString()} ${width}w`;
    }).join(', ');
  } catch (error) {
    return '';
  }
}

function escapePdpHtmlAttribute(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function renderPdpGalleryImageHTML(slide, index) {
  const defaultImage = slide && slide.defaultImage ? slide.defaultImage : null;
  if (!defaultImage || !defaultImage.src) return '';

  const defaultSrc = getAssetUrl(defaultImage.src);
  const defaultSrcset = defaultImage.srcset || buildPdpResponsiveSrcset(defaultSrc, defaultImage.width);
  const defaultSizes = defaultImage.sizes || '(min-width: 901px) 50vw, 100vw';
  const defaultWidth = Number(defaultImage.width);
  const defaultHeight = Number(defaultImage.height);
  const defaultDimensions = Number.isFinite(defaultWidth) && defaultWidth > 0 && Number.isFinite(defaultHeight) && defaultHeight > 0
    ? ` width="${defaultWidth}" height="${defaultHeight}"`
    : '';
  const responsiveAttributes = defaultSrcset
    ? ` srcset="${escapePdpHtmlAttribute(defaultSrcset)}" sizes="${escapePdpHtmlAttribute(defaultSizes)}"`
    : '';

  const desktopImage = slide.desktopImage;
  let desktopSource = '';
  if (desktopImage && desktopImage.src) {
    const desktopSrcset = desktopImage.srcset || buildPdpResponsiveSrcset(desktopImage.src, desktopImage.width);
    if (desktopSrcset) {
      const desktopWidth = Number(desktopImage.width);
      const desktopHeight = Number(desktopImage.height);
      const desktopDimensions = Number.isFinite(desktopWidth) && desktopWidth > 0 && Number.isFinite(desktopHeight) && desktopHeight > 0
        ? ` width="${desktopWidth}" height="${desktopHeight}"`
        : '';
      desktopSource = `<source media="(min-width: 901px)" srcset="${escapePdpHtmlAttribute(desktopSrcset)}" sizes="${escapePdpHtmlAttribute(desktopImage.sizes || '50vw')}"${desktopDimensions}>`;
    }
  }

  const priorityAttributes = index === 0
    ? ' loading="eager" fetchpriority="high"'
    : ' loading="lazy"';

  return `<picture>${desktopSource}<img class="ma-pdp-image image-reveal" src="${escapePdpHtmlAttribute(defaultSrc)}"${responsiveAttributes}${defaultDimensions} alt="${escapePdpHtmlAttribute(slide.alt)}"${priorityAttributes} decoding="async" onload="this.classList.add('is-loaded')"></picture>`;
}

function getPdpResponsiveSrcset(src) {
  const resolvedSrc = getAssetUrl(src);
  if (!resolvedSrc || !resolvedSrc.includes('cdn.shopify.com')) return '';

  try {
    const widths = [480, 720, 960, 1200];
    return widths.map(width => {
      const url = new URL(resolvedSrc, window.location.origin);
      url.searchParams.set('width', width);
      return `${url.toString()} ${width}w`;
    }).join(', ');
  } catch (error) {
    return '';
  }
}

function getPdpGallerySlide(product, imgUrl, index) {
  if (
    product.id === window.MA_CURRENT_PRODUCT_ID &&
    Array.isArray(window.MA_PDP_GALLERY) &&
    window.MA_PDP_GALLERY[index]
  ) {
    return window.MA_PDP_GALLERY[index];
  }

  const imageDimensions = getPdpImageDimensions(product, index);
  const resolvedSrc = getAssetUrl(imgUrl);
  return {
    defaultImage: {
      src: resolvedSrc,
      srcset: imageDimensions
        ? buildPdpResponsiveSrcset(resolvedSrc, imageDimensions.width)
        : getPdpResponsiveSrcset(imgUrl),
      sizes: window.matchMedia('(max-width: 989px)').matches ? '100vw' : '50vw',
      width: imageDimensions ? imageDimensions.width : null,
      height: imageDimensions ? imageDimensions.height : null
    },
    desktopImage: null,
    alt: getPdpImageAlt(product, index)
  };
}

function isPdpPlaceholderImage(src) {
  return typeof src === 'string' && src.startsWith('placeholder-');
}

function getPdpDefaultSize(product) {
  return null;
}

function getPdpShortDescription(product, dict) {
  const body = (dict[product.descKey] || '').replace(/\s+/g, ' ').trim();
  const firstSentence = body.match(/^.*?[.!?](?:\s|$)/);
  return (firstSentence ? firstSentence[0] : body).trim();
}

function getPdpDeliveryText() {
  return getLang() === 'en'
    ? 'AVERAGE DELIVERY TIME: 1-3 WORKING DAYS'
    : 'TIEMPO PROMEDIO DE ENTREGA: 1-3 DIAS HABILES';
}

// Sync inventory with Shopify's real availability dynamically
async function syncInventoryWithShopify() {
  const isShopify = window.Shopify && window.Shopify.shop;
  if (!isShopify) return; // Only run on live Shopify site

  try {
    const res = await fetch('/products.json');
    if (!res.ok) return;
    const data = await res.json();

    (data.products || []).forEach(sp => {
      // Normalize titles to match local PRODUCTS keys/names robustly
      const match = Object.values(PRODUCTS).find(lp => {
        const lpName = lp.name.toUpperCase().replace(/\s+/g, '').replace('COTTON', '');
        const spTitle = sp.title.toUpperCase().replace(/\s+/g, '').replace('COTTON', '');
        return lpName === spTitle;
      });

      if (match) {
        const oos = [];
        (sp.variants || []).forEach(v => {
          const sizeOpt = (v.option1 || v.option2 || v.option3 || v.title || '').toUpperCase().trim();
          let resolvedSize = null;
          if (sizeOpt === 'S' || sizeOpt === 'SMALL') resolvedSize = 'S';
          else if (sizeOpt === 'M' || sizeOpt === 'MEDIUM') resolvedSize = 'M';
          else if (sizeOpt === 'L' || sizeOpt === 'LARGE') resolvedSize = 'L';
          else if (sizeOpt === 'XL' || sizeOpt === 'EXTRA LARGE' || sizeOpt === 'EXTRA GRANDE') resolvedSize = 'XL';
          else if (sizeOpt === 'XXL' || sizeOpt === 'XX-LARGE') resolvedSize = 'XXL';

          if (resolvedSize && !v.available) {
            oos.push(resolvedSize);
          }
        });
        match.outOfStockSizes = oos;
        console.log(`[MA Inventory] Synced ${match.name} OOS sizes from Shopify:`, oos);
      }
    });
  } catch (err) {
    console.warn('[MA Inventory] Sync failed:', err);
  }
}

function buildPdpSizeOptionsHTML(productData, activeSize) {
  const isEn = (typeof getLang === 'function' ? getLang() : 'es') === 'en';
  const dict = I18N[isEn ? 'en' : 'es'];
  const sizes = productData ? (productData.sizes || []) : [];
  const variantRecords = productData?.id === window.MA_CURRENT_PRODUCT_ID && Array.isArray(window.MA_PDP_VARIANTS)
    ? window.MA_PDP_VARIANTS
    : [];
  const variantForSize = (size) => variantRecords.find((variant) => String(variant.size).toUpperCase() === String(size).toUpperCase());
  const optionMarkup = (size, selected, label) => {
    const variant = variantForSize(size);
    const value = variant ? variant.id : size;
    const available = variant ? variant.available !== false : !(productData?.outOfStockSizes || []).includes(size);
    return `<option value="${value}" data-size="${size}" data-available="${available}" ${selected ? 'selected' : ''}${variant && !available ? ' disabled' : ''}>${label}</option>`;
  };
  const isOneSize = sizes.length === 1 && String(sizes[0]).trim().toUpperCase() === 'O/S';

  if (isOneSize) {
    const isOos = productData && productData.outOfStockSizes && productData.outOfStockSizes.includes('O/S');
    return {
      html: optionMarkup('O/S', true, `O/S${isOos ? ` (${dict['product.sold_out']})` : ''}`),
      hasProfile: false,
      recommendedSize: 'O/S',
      isOneSize: true
    };
  }

  let repo = null;
  try {
    if (window.FitProfileRepository) {
      repo = new window.FitProfileRepository();
    }
  } catch (e) {}

  let hasProfile = false;
  let recommendedSize = window.MA_RECOMMENDED_SIZE || '';
  if (repo && repo.exists()) {
    hasProfile = true;
    if (!recommendedSize && window.FitRecommendationEngine && productData && productData.sizes) {
      try {
        const profile = repo.getProfile();
        if (profile && profile.height && profile.weight) {
          const engine = new window.FitRecommendationEngine();
          const productType = (typeof getProductType === 'function' ? getProductType(productData.id) : (window.getProductType ? window.getProductType(productData.id) : null)) || 't01';
          const res = engine.recommend(profile.height, profile.weight, productType || 't01');
          if (res && res.size) {
            recommendedSize = res.size;
            window.MA_RECOMMENDED_SIZE = recommendedSize;
          }
        }
      } catch (e) {}
    }
  }

  let html = '';

  if (!hasProfile) {
    // ── NO PROFILE: ENCUENTRA TU TALLA placeholder as first option ──
    const findLabel = dict['product.find_your_size'];
    html += `<option value="" ${!activeSize ? 'selected' : ''}>${findLabel}</option>`;
    sizes.forEach(sz => {
      const isOos = productData && productData.outOfStockSizes && productData.outOfStockSizes.includes(sz);
      const outStr = ` (${dict['product.sold_out']})`;
      const isSelected = sz === activeSize;
      html += optionMarkup(sz, isSelected, `${sz}${isOos ? outStr : ''}`);
    });
  } else {
    // ── HAS PROFILE: Preselect recommended size (even if OOS) ──
    const targetSize = activeSize || recommendedSize || (sizes[0] || '');
    sizes.forEach(sz => {
      const isOos = productData && productData.outOfStockSizes && productData.outOfStockSizes.includes(sz);
      const outStr = ` (${dict['product.sold_out']})`;
      const recStr = sz === recommendedSize ? ` (${dict['product.recommended']})` : '';
      const labelExtra = isOos ? (recStr ? ` (${dict['product.sold_out']} - ${dict['product.recommended']})` : outStr) : recStr;
      const isSelected = sz === targetSize;
      html += optionMarkup(sz, isSelected, `${sz}${labelExtra}`);
    });
    const findLabel = dict['product.find_your_size'];
    html += `<option value="find-size" style="font-weight: 500;">${findLabel}</option>`;
  }

  return { html, hasProfile, recommendedSize, isOneSize: false };
}

// ── Fit Modal for PDP — top-level so it works on Liquid SSR PDPs without renderProductPage ──
function openFitModalForPdp(productData, refreshSelectorFn) {
  let drawerUI = window._fitDrawerGlobalInstance;
  const isEn = (typeof getLang === 'function' ? getLang() : 'es') === 'en';

  if (!drawerUI && window.FitDrawerUI) {
    drawerUI = new window.FitDrawerUI();
    drawerUI.render(isEn ? 'en' : 'es');
    window._fitDrawerGlobalInstance = drawerUI;
  }

  if (drawerUI && productData) {
    const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
    const engine = window.FitRecommendationEngine ? new window.FitRecommendationEngine() : null;
    const resolver = window.ShopifyVariantResolver ? new window.ShopifyVariantResolver(productData) : null;
    const productType = (typeof getProductType === 'function' ? getProductType(productData.id) : (window.getProductType ? window.getProductType(productData.id) : null)) || 't01';

    drawerUI.onSubmit(() => {
      const metrics = drawerUI.getMetricValues();
      drawerUI.hideError();
      if (!metrics) return;

      const { heightCm, weightKg } = metrics;
      if (engine) {
        const validation = engine.validate(heightCm, weightKg);
        if (!validation.valid) {
          if (validation.field === 'height') {
            if (drawerUI._heightUnit === 'in') {
              drawerUI.showFieldError('height', isEn
                ? 'Enter a valid height between 59 and 81 inches.'
                : 'Ingresa una altura válida entre 59 y 81 pulgadas.');
            } else {
              drawerUI.showFieldError('height', isEn
                ? 'Enter a valid height between 150 and 205 cm.'
                : 'Ingresa una altura válida entre 150 y 205 cm.');
            }
          } else {
            if (drawerUI._weightUnit === 'lbs') {
              drawerUI.showFieldError('weight', isEn
                ? 'Enter a valid weight between 99 and 265 lbs.'
                : 'Ingresa un peso válido entre 99 y 265 lbs.');
            } else {
              drawerUI.showFieldError('weight', isEn
                ? 'Enter a valid weight between 45 and 120 kg.'
                : 'Ingresa un peso válido entre 45 y 120 kg.');
            }
          }
          return;
        }

        const result = engine.recommend(heightCm, weightKg, productType);
        if (result && result.size) {
          window.MA_RECOMMENDED_SIZE = result.size;
        }

        if (repo) repo.saveProfile(heightCm, weightKg);

        const available = resolver ? resolver.isAvailable(result.size) : true;
        const productSizesNormalized = productData.sizes
          ? productData.sizes.map(s => String(s).trim().toUpperCase())
          : [];
        const sizeExists = productSizesNormalized.includes(String(result.size).trim().toUpperCase());

        drawerUI.showResult(result.size, available, isEn ? 'en' : 'es', sizeExists);
      }
    });

    drawerUI.onApply(() => {
      const applyBtn = document.querySelector('[data-fit-apply]');
      const sizeToApply = applyBtn ? applyBtn.dataset.fitApplySize : null;
      if (!sizeToApply) return;

      const metrics = drawerUI.getMetricValues();
      if (metrics && repo) {
        repo.saveProfile(metrics.heightCm, metrics.weightKg);
      }

      if (engine && metrics) {
        const res = engine.recommend(metrics.heightCm, metrics.weightKg, productType);
        if (res && res.size) window.MA_RECOMMENDED_SIZE = res.size;
      }


      // Add to cart directly when user clicks "AÑADIR TALLA X AL CARRITO" inside the fit modal
      const cartObj = typeof cart !== 'undefined' ? cart : (window.cart || null);
      let addSuccess = true;
      if (cartObj && productData) {
        const variantForSize = (productData.id === window.MA_CURRENT_PRODUCT_ID && Array.isArray(window.MA_PDP_VARIANTS))
          ? window.MA_PDP_VARIANTS.find(v => String(v.size).toUpperCase() === String(sizeToApply).toUpperCase())
          : null;
        addSuccess = cartObj.add({
          id: productData.id,
          name: productData.name,
          color: productData.color,
          size: sizeToApply,
          variantId: variantForSize ? variantForSize.id : null,
          priceUsd: productData.priceUsd,
          pricePen: productData.pricePen,
          qty: 1
        });
        if (addSuccess !== false) {
          if (typeof showToast === 'function') {
            showToast(getLang() === 'en' ? 'ADDED TO BAG' : 'AÑADIDO AL CARRITO');
          }
        }
      }

      if (addSuccess !== false) {
        if (applyBtn) {
          applyBtn.textContent = isEn ? '✓ SELECTED' : '✓ SELECCIONADO';
          applyBtn.classList.add('is-applied');
        }
        setTimeout(() => {
          drawerUI.close();
          if (applyBtn) applyBtn.classList.remove('is-applied');
          const refreshFn = typeof refreshSelectorFn === 'function'
            ? refreshSelectorFn
            : (typeof window._refreshPdpSizeSelector === 'function' ? window._refreshPdpSizeSelector : null);
          if (refreshFn) {
            refreshFn(sizeToApply);
          }
          if (typeof openCart === 'function') openCart();
        }, 300);
      }
    });

    drawerUI.onClose(() => {
      window._isClosingFitDrawer = true;
      setTimeout(() => { window._isClosingFitDrawer = false; }, 600);
      let recSize = window.MA_RECOMMENDED_SIZE;
      if (!recSize && repo && repo.exists()) {
        const p = repo.getProfile();
        if (p && p.height && p.weight && engine) {
          const res = engine.recommend(p.height, p.weight, productType);
          if (res && res.size) recSize = res.size;
        }
      }
      const refreshFn = typeof refreshSelectorFn === 'function'
        ? refreshSelectorFn
        : (typeof window._refreshPdpSizeSelector === 'function' ? window._refreshPdpSizeSelector : null);
      if (refreshFn && recSize) {
        refreshFn(recSize);
      }
    });

    drawerUI.onClear(() => {
      window._isClosingFitDrawer = true;
      setTimeout(() => { window._isClosingFitDrawer = false; }, 600);
      if (repo) repo.clearProfile();
      window.MA_RECOMMENDED_SIZE = null;
      drawerUI.close();
      const selectEl = document.getElementById('pdp-size-select');
      if (selectEl && document.activeElement === selectEl) {
        selectEl.blur();
      }
      const refreshFn = typeof refreshSelectorFn === 'function'
        ? refreshSelectorFn
        : (typeof window._refreshPdpSizeSelector === 'function' ? window._refreshPdpSizeSelector : null);
      if (refreshFn) {
        refreshFn('');
      }
    });

    const profile = repo ? repo.getProfile() : null;
    drawerUI.open(profile, productData, null);
  }
}
window.openFitModalForPdp = openFitModalForPdp;

async function renderProductPage(options = {}) {
  const root = document.getElementById('product-detail');
  if (!root) return;
  if (root.dataset.maRendering === 'true') return;
  if (root.dataset.maRenderState === 'ready' && options.force !== true) return;

  const c01SeoContentHtml = root.querySelector('[data-c01-seo]')?.outerHTML || '';
  root.dataset.maRendering = 'true';

  const params = new URLSearchParams(window.location.search);

  // Show toast if form posted successfully
  if (params.get('contact_posted') === 'true' || window.location.search.includes('customer_posted=true') || window.location.hash === '#contact-form' || window.location.hash === '#contact_form') {
    setTimeout(() => {
      showToast(getLang() === 'en' ? 'REQUEST RECEIVED. WE WILL NOTIFY YOU.' : 'SOLICITUD RECIBIDA. TE AVISAREMOS POR CORREO.');
    }, 600);
  }

  const id = params.get('id') || root.dataset.productId || window.MA_CURRENT_PRODUCT_ID;
  const product = PRODUCTS[id];
  const dict = I18N[getLang()] || I18N.es;

  if (!product) {
    if (root.querySelector('[data-c01-seo]') || (root.children && root.children.length > 0)) {
      root.dataset.maRendering = 'false';
      root.dataset.maRenderState = 'ready';
      return;
    }
    root.innerHTML = getLang() === 'en'
      ? '<div class="container" style="padding:5rem 0;text-align:center;"><p>Product not found.</p><a href="/">Back to home</a></div>'
      : '<div class="container" style="padding:5rem 0;text-align:center;"><p>Producto no encontrado.</p><a href="/">Volver al inicio</a></div>';
    root.dataset.maRendering = 'false';
    root.dataset.maRenderState = 'ready';
    return;
  }

  if (product.id === window.MA_CURRENT_PRODUCT_ID && Array.isArray(window.MA_PDP_OUT_OF_STOCK_SIZES)) {
    product.outOfStockSizes = [...window.MA_PDP_OUT_OF_STOCK_SIZES];
  }

  // Track product view in Recently Viewed list
  trackRecentlyViewed(product.id);

  const colorLabel = dict[`color.${product.color}`] || product.color;
  const badgeLabel = product.badge === 'bestseller' ? dict['badge.bestseller'] : dict['badge.new'];
  const placeholderLabel = product.label;
  const images = getPdpDisplayImages(product);
  const selectedVariant = Array.isArray(window.MA_PDP_VARIANTS)
    ? window.MA_PDP_VARIANTS.find((variant) => String(variant.id) === String(window.MA_PDP_SELECTED_VARIANT_ID))
    : null;
  const defaultSize = selectedVariant?.size || getPdpDefaultSize(product);
  const shortDescription = getPdpShortDescription(product, dict);
  const deliveryText = getPdpDeliveryText();
  const colorThumb = images.find(imgUrl => !isPdpPlaceholderImage(imgUrl));

  // Force site header to float transparently at y=0 on PDP load
  const siteHeaderEl = document.getElementById('site-header');
  if (siteHeaderEl) {
    siteHeaderEl.classList.remove('is-header-at-top', 'is-header-peek');
    siteHeaderEl.classList.add('is-header-editorial');
    siteHeaderEl.style.setProperty('position', 'fixed', 'important');
    siteHeaderEl.style.setProperty('top', '0', 'important');
    siteHeaderEl.style.setProperty('background', 'transparent', 'important');
    siteHeaderEl.style.setProperty('background-color', 'transparent', 'important');
    siteHeaderEl.style.setProperty('border-bottom', 'none', 'important');
    siteHeaderEl.style.setProperty('box-shadow', 'none', 'important');
    const headerBg = siteHeaderEl.querySelector('.site-header__bg');
    if (headerBg) {
      headerBg.style.setProperty('display', 'none', 'important');
      headerBg.style.setProperty('opacity', '0', 'important');
    }
  }

  const isT01 = product.id === 'MA-TE-BK' || product.id === 'MA-TE-WH';
  const nameRoot = product.name.split(' - ')[0];
  const isC01 = product.id === 'MA-DF-01';
  const productHeading = isC01 ? (lang === 'en' ? "MEN'S LEATHER GARMENT DUFFEL BAG" : 'BOLSO DE VIAJE DE CUERO PARA HOMBRE') : nameRoot;
  const productCodeHtml = isC01 ? `<p class="product-info__c01-code">${nameRoot}</p>` : '';
  const colorVariants = Object.values(PRODUCTS).filter(p => p.name.split(' - ')[0] === nameRoot);
  const hasMultipleColors = colorVariants.length >= 2;
  const isMobilePinnedColorReveal = hasMultipleColors && window.matchMedia('(max-width: 768px)').matches;
  const galleryCounterHtml = `
    <div class="ma-pdp-counter product-gallery__counter" id="gallery-counter" aria-hidden="true">
      <span data-ma-current>1</span>
      <span class="ma-counter-line"></span>
      <span>${images.length}</span>
    </div>
  `;
  const galleryTrackHtml = `
    <div class="ma-pdp-gallery-track">
      ${images.map((imgUrl, i) => {
        const indexLabel = String(i + 1).padStart(2, '0');
        if (isPdpPlaceholderImage(imgUrl)) {
          return `
            <figure class="ma-pdp-media product-card__media--${product.placeholder}" data-index="${i + 1}">
              <span class="product-card__placeholder-label">${placeholderLabel} ${indexLabel}</span>
            </figure>
          `;
        } else {
          const slide = getPdpGallerySlide(product, imgUrl, i);

          return `
            <figure class="ma-pdp-media" data-index="${i + 1}">
              ${renderPdpGalleryImageHTML(slide, i)}
            </figure>
          `;
        }
      }).join('')}
    </div>
  `;
  const mobileColorThumbnailsHtml = isMobilePinnedColorReveal
    ? `
      <div class="color-thumbnails-block">
        <div class="color-thumbnails-container">
          ${colorVariants.map(variant => {
            const isActive = variant.id === product.id;
            const variantImages = getPdpImages(variant);
            const variantThumb = variantImages.find(imgUrl => !isPdpPlaceholderImage(imgUrl)) || variantImages[0];
            const variantLabel = dict[`color.${variant.color}`] || variant.color;
            const variantUrl = getProductUrl(variant.id);
            return variantThumb ? `
              <a href="${variantUrl}" class="color-thumbnail-item${isActive ? ' is-active' : ''}" aria-label="${variantLabel}">
                <img src="${getAssetUrl(variantThumb)}" alt="${variantLabel}" loading="lazy" decoding="async">
              </a>
            ` : '';
          }).join('')}
        </div>
      </div>
    `
    : '';

  const galleryHtml = `
    <div class="ma-pdp-gallery" id="product-gallery" aria-label="${product.name} gallery">
      ${galleryCounterHtml}
      ${galleryTrackHtml}
      ${isT01 ? `
        <div class="t01-reveal-colors">
          <a href="${getProductUrl('MA-TE-BK')}" class="t01-reveal-color${product.id === 'MA-TE-BK' ? ' is-active' : ''}" aria-label="BLACK">
            <div class="t01-reveal-color__media">
              <img src="${getAssetUrl('t01-polo-negro-miniatura-home.jpg')}" alt="NEGRO" loading="lazy">
            </div>
          </a>
          <a href="${getProductUrl('MA-TE-WH')}" class="t01-reveal-color${product.id === 'MA-TE-WH' ? ' is-active' : ''}" aria-label="WHITE">
            <div class="t01-reveal-color__media">
              <img src="${getAssetUrl('t01-polo-blanco-miniatura-home.jpg')}" alt="BLANCO" loading="lazy">
            </div>
          </a>
        </div>
      ` : ''}
    </div>
  `;

  root.innerHTML = `
    <section class="product-detail ma-pdp-scroll${isT01 ? ' is-t01-pdp' : ''}" data-header-mode="editorial" style="margin-top:0!important;padding-top:0!important;position:relative!important;top:0!important;">
      ${galleryHtml}

      <aside class="ma-pdp-info">
        <div class="ma-pdp-info-inner product-info">
          <div class="product-info__header-row">
            <div class="product-info__header-left">
              ${productCodeHtml}
              <h1 class="product-info__name" ${isC01 ? 'data-i18n="pdp.c01.title"' : ''}>${productHeading}</h1>
            </div>
            <div class="product-info__header-right">
              <p class="product-info__price">${formatPrice(getProductPrice(product))}</p>
            </div>
          </div>

          <div class="product-info__color-select pdp-color-block" aria-label="${dict['cart.color']}">
            <span class="pdp-color-name" id="color-label-current">${colorLabel}</span>
            <div class="pdp-color-thumbs" aria-label="${dict['cart.color']} options">
              ${colorVariants.map(variant => {
                const isActive = variant.id === product.id;
                let vThumb = '';
                if (variant.id === 'MA-TE-BK') {
                  vThumb = 't01-polo-negro-miniatura-home.jpg';
                } else if (variant.id === 'MA-TE-WH') {
                  vThumb = 't01-polo-blanco-miniatura-home.jpg';
                } else if (variant.id === 'MA-DJ-01') {
                  vThumb = 'j01-casaca-plumas-miniatura-home.jpg';
                } else if (variant.id === 'MA-DF-01') {
                  vThumb = 'c01-bolso-viaje-cuero-miniatura-home.jpg';
                } else {
                  const vImages = getPdpImages(variant);
                  vThumb = vImages.find(imgUrl => !isPdpPlaceholderImage(imgUrl));
                }
                const vLabel = dict[`color.${variant.color}`] || variant.color;
                const vUrl = getProductUrl(variant.id);
                return vThumb ? `
                  <a href="${vUrl}" class="pdp-color-thumb${isActive ? ' is-active' : ''}" aria-label="${vLabel}" style="display:block;text-decoration:none;">
                    <img src="${getAssetUrl(vThumb)}" alt="${vLabel}" loading="lazy">
                  </a>
                ` : `
                  <a href="${vUrl}" class="swatch swatch--${variant.color}${isActive ? ' is-active' : ''}" title="${vLabel}" style="display:block;"></a>
                `;
              }).join('')}
            </div>
          </div>

          <div class="product-info__size-select pdp-size-select">
            <div class="pdp-size-select-wrapper">
              <select class="pdp-size-select-dropdown" id="pdp-size-select" data-fit-sizes>
                ${(function() {
                  let profileConfigured = false;
                  try {
                    const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
                    if (repo && repo.exists() && repo.getProfile() && repo.getProfile().height) {
                      profileConfigured = true;
                    }
                  } catch (e) {}
                  const initialSz = profileConfigured ? defaultSize : '';
                  const opts = buildPdpSizeOptionsHTML(product, initialSz);
                  return opts.html;
                })()}
              </select>
            </div>
            <div class="fit-inline" data-fit-inline></div>
            <button type="button" class="pdp-size-guide" data-fit-open style="display:none!important;" aria-hidden="true">${getLang() === 'en' ? 'FIND YOUR SIZE' : 'ENCUENTRA TU TALLA'} &gt;</button>
          </div>

          <p class="pdp-short-description">${shortDescription}</p>

          <button type="button" class="btn btn--dark checkout-submit" id="pdp-add">${dict['product.add']}</button>

          <div class="product-info__qty" aria-hidden="true">
            <span class="product-info__label">${dict['product.qty']}</span>
            <div class="qty-stepper">
              <button type="button" class="qty-stepper__btn" id="qty-dec" aria-label="−">−</button>
              <span class="qty-stepper__value" id="qty-value">1</span>
              <button type="button" class="qty-stepper__btn" id="qty-inc" aria-label="+">+</button>
            </div>
          </div>

          <div class="pdp-features-row">
            ${(product.features || []).map(feat => `
              <div class="pdp-feature-item">
                <img src="${getAssetUrl(feat.icon)}" class="pdp-feature-icon" alt="" />
                <span class="pdp-feature-title">${dict[feat.titleKey] || feat.titleKey}</span>
              </div>
            `).join('')}
          </div>

          <div class="pdp-summary-links" aria-label="Product service links">
            <button type="button" class="pdp-summary-link" data-pdp-drawer-trigger="details">${getLang() === 'en' ? 'CARE & SPECIFICATIONS' : 'CUIDADOS Y ESPECIFICACIONES'} &gt;</button>
            <button type="button" class="pdp-summary-link" data-pdp-drawer-trigger="shipping">${getLang() === 'en' ? 'SHIPPING AND RETURNS' : 'ENVÍOS Y DEVOLUCIONES'} &gt;</button>
            <button type="button" class="pdp-summary-link" data-pdp-drawer-trigger="service">${getLang() === 'en' ? 'CUSTOMER SERVICE' : 'SERVICIO AL CLIENTE'} &gt;</button>
          </div>
        </div>
      </aside>
    </section>

    <section class="reviews reviews-section" id="reviews" data-header-mode="hidden">
      <div class="container">
        <div class="reviews-header">
          <h2 class="reviews-title" data-i18n="reviews.title">${dict['reviews.title'] || 'RESEÑAS'}</h2>
        </div>
        <div id="judgeme_product_reviews" class="jdgm-widget jdgm-review-widget" data-product-title="${product.name || ''}" data-id="${product.id || ''}" data-auto-install="false"></div>
      </div>
    </section>

    <section class="complete-system gallery-v2 v2-section is-visible" data-header-mode="hidden" data-reveal="up-sm">
      <div class="v2-container">
        <div class="gallery-v2__header">
          <h2 class="gallery-v2__title">COMPLETE THE SYSTEM</h2>
        </div>
        <div class="gallery-v2__wrapper" id="complete-system-grid"></div>
      </div>
    </section>

    <!-- Mobile Size Sheet Bottom Sheet -->
    <div class="ma-size-overlay" id="ma-size-overlay"></div>
    <div class="ma-size-sheet" id="ma-size-sheet" role="listbox" aria-label="${dict['product.find_your_size']}">
      ${product.sizes.map(s => {
        const isOos = product.outOfStockSizes && product.outOfStockSizes.includes(s);
        const isActive = s === defaultSize;
        return `
          <div class="ma-size-option${isOos ? ' is-disabled' : ''}${isActive ? ' is-active' : ''}" data-size="${s}" role="option" aria-selected="${isActive}" aria-disabled="${isOos}">
            ${s} ${isOos ? ` - ${dict['product.unavailable']}` : ''}
          </div>
        `;
      }).join('')}
    </div>
  `;

  root.dataset.maRendering = 'false';
  root.dataset.maRenderState = 'ready';

  // Wire reviews section
  wireReviews(product);

  // Render COMPLETE THE SYSTEM section
  renderCompleteSystem(product, dict);
  // Wire up size selector
  const sizeButtons = document.querySelectorAll('#pdp-sizes .size-btn');

  // Wire THE MARK ALTITUDE DIFFERENCE reveal animations (dynamically rendered, not caught by initial observer)
  const diffSection = document.querySelector('.difference-mark');
  if (diffSection) {
    // Handled by global initScrollReveal
  }
  const pdpAddBtn = document.getElementById('pdp-add');
  const qtySection = document.querySelector('.product-info__qty');
  const stickyBtn = document.getElementById('sticky-cart-btn');
  const sizeRow = document.getElementById('pdp-size-row');
  const sizeMenu = document.getElementById('pdp-sizes');
  const pdpSizeCurrent = document.querySelector('[data-pdp-size-current]');

  const syncSelectedSizeText = (size) => {
    let recommendedSize = window.MA_RECOMMENDED_SIZE;
    if (!recommendedSize) {
      try {
        const rawProfile = localStorage.getItem('mark-altitude-fit-profile-v3.1');
        if (rawProfile) {
          const profile = JSON.parse(rawProfile);
          if (profile && profile.heightCm && profile.weightKg) {
            const productId = window._fitCurrentProduct ? window._fitCurrentProduct.id : (document.querySelector('[data-product-id]')?.dataset.productId || null);
            const productType = (typeof window.getProductType === 'function' ? window.getProductType(productId) : (typeof getProductType === 'function' ? getProductType(productId) : null)) || 't01';
            if (typeof window.FitRecommendationEngine !== 'undefined') {
              const engine = new window.FitRecommendationEngine();
              recommendedSize = engine.recommendSize(profile.heightCm, profile.weightKg, productType);
              window.MA_RECOMMENDED_SIZE = recommendedSize;
            }
          }
        }
      } catch (e) {
        console.error('Error reading profile for size text:', e);
      }
    }

    const valueWrap = document.querySelector('.pdp-size-value-wrap');
    if (valueWrap) {
      const isEn = (typeof getLang === 'function' ? getLang() : 'es') === 'en';
      if (recommendedSize) {
        const labelText = isEn ? 'RECOMMENDED:' : 'RECOMENDADO:';
        valueWrap.innerHTML = `<span style="text-transform: uppercase;">${labelText}&nbsp;</span><span data-pdp-size-current>${recommendedSize}</span>`;
      } else {
        valueWrap.innerHTML = ``;
      }
    }

    const sizeValueSpan = document.getElementById('ma-size-value');
    if (sizeValueSpan) {
      sizeValueSpan.textContent = size || '';
    }
  };

  window.syncSelectedSizeText = syncSelectedSizeText;
  syncSelectedSizeText(defaultSize);

  // Mobile PDP horizontal gallery progress indicator & size sheet wiring
  const trackEl = root.querySelector('.ma-pdp-gallery-track');
  const counterEl = root.querySelector('#gallery-counter');
  const slidesEls = root.querySelectorAll('.ma-pdp-media');
  if (counterEl) {
    counterEl.style.setProperty('--ma-total-slides', slidesEls.length || 8);
  }

  if (trackEl && counterEl) {
    let isTicking = false;
    const numSlides = slidesEls.length || 1;

    const updateFluidProgress = () => {
      if (numSlides <= 1) {
        counterEl.style.display = 'none';
        return;
      }
      const maxScroll = trackEl.scrollWidth - trackEl.clientWidth;
      if (maxScroll <= 0) {
        counterEl.style.display = 'none';
        return;
      }
      counterEl.style.display = 'block';

      const progress = Math.min(Math.max(trackEl.scrollLeft / maxScroll, 0), 1);
      const trackWidth = 120;
      const thumbWidth = Math.max(trackWidth / numSlides, 20);
      const thumbX = progress * (trackWidth - thumbWidth);
      const thumbEnd = thumbX + thumbWidth;

      const progressBackground = `linear-gradient(to right, #ff0000 0px, #ff0000 ${thumbX}px, #000000 ${thumbX}px, #000000 ${thumbEnd}px, #ff0000 ${thumbEnd}px, #ff0000 ${trackWidth}px)`;
      counterEl.style.setProperty('background', progressBackground, 'important');
      isTicking = false;
    };

    const onScroll = () => {
      if (!isTicking) {
        requestAnimationFrame(updateFluidProgress);
        isTicking = true;
      }
    };

    trackEl.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateFluidProgress, { passive: true });
    window.addEventListener('orientationchange', updateFluidProgress, { passive: true });
    updateFluidProgress();
  }

  // Mobile Bottom Sheet size selector wiring
  const mobileSizeSheet = root.querySelector('#ma-size-sheet');
  const mobileSizeOverlay = root.querySelector('#ma-size-overlay');

  const openMobileSheet = () => {
    if (window.innerWidth <= 989) {
      mobileSizeSheet?.classList.add('is-open');
      mobileSizeOverlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeMobileSheet = () => {
    mobileSizeSheet?.classList.remove('is-open');
    mobileSizeOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  mobileSizeOverlay?.addEventListener('click', closeMobileSheet);

  root.querySelectorAll('.ma-size-option').forEach(opt => {
    opt.addEventListener('click', () => {
      if (opt.classList.contains('is-disabled')) return;
      const selectedSize = opt.getAttribute('data-size');
      if (selectedSize) {
        syncSelectedSizeText(selectedSize);
        root.querySelectorAll('.size-btn').forEach(btn => {
          btn.classList.toggle('is-active', btn.getAttribute('data-size') === selectedSize);
        });
        root.querySelectorAll('.ma-size-option').forEach(o => {
          o.classList.toggle('is-active', o.getAttribute('data-size') === selectedSize);
        });
      }
      closeMobileSheet();
    });
  });

  // Size row click listener removed to keep the size menu always open and non-clickable

  const pdpSizeSelect = document.getElementById('pdp-size-select');

  window.openFitModalForPdp = openFitModalForPdp;

  const handlePdpSizeChange = (chosenSize) => {
    if (!chosenSize || chosenSize === 'find-size') return;
    syncSelectedSizeText(chosenSize);

    const isOos = product.outOfStockSizes && product.outOfStockSizes.includes(chosenSize);
    const pdpAddBtn = document.getElementById('pdp-add');
    const qtySection = document.querySelector('.product-info__qty');
    const stickyBtn = document.getElementById('sticky-add-to-cart');
    const descEl = document.querySelector('.pdp-short-description');
    const isEn = getLang() === 'en';

    // 1. Dynamic Product Description Text Replacement on PDP
    if (descEl) {
      if (!descEl.dataset.originalDesc) {
        descEl.dataset.originalDesc = descEl.textContent;
      }
      if (isOos) {
        descEl.classList.add('pdp-short-description--oos');
        descEl.textContent = isEn
          ? 'This size is temporarily out of stock. Leave us your email and we will notify you when it is available again.'
          : 'Esta talla está temporalmente agotada. Déjanos tu correo y te avisaremos cuando vuelva a estar disponible.';
      } else {
        descEl.classList.remove('pdp-short-description--oos');
        descEl.textContent = descEl.dataset.originalDesc;
      }
    }

    const existingContainer = document.getElementById('pdp-restock-container');
    if (existingContainer) existingContainer.remove();

    if (isOos) {
      if (qtySection) qtySection.style.display = 'none';

      // Form container on PDP:
      const formDiv = document.createElement('div');
      formDiv.id = 'pdp-restock-container';
      formDiv.className = 'pdp-restock-container';
      formDiv.style.marginTop = '1rem';
      formDiv.style.width = '100%';

      formDiv.innerHTML = `
        <form id="pdp-restock-form" class="ma-pdp-oos-form" style="display: flex; flex-direction: column; gap: 0.75rem; width: 100%;">
          <input type="email" id="restock-email" class="ma-pdp-oos-input" placeholder="${isEn ? 'EMAIL ADDRESS' : 'CORREO ELECTRÓNICO'}" required 
            style="width: 100%; height: 48px; padding: 0 1rem; border: 1px solid var(--color-black); border-radius: 0; font-family: inherit; font-size: 0.75rem; letter-spacing: 0.05em; text-transform: uppercase; background: var(--color-white); color: var(--color-black); outline: none; box-sizing: border-box;">
          
          <div class="ma-pdp-oos-mobile-btn-wrap" style="display: none;">
            <button type="submit" class="btn btn--dark ma-pdp-oos-mobile-btn" style="height: 48px; padding: 0 1.5rem; font-size: 0.75rem; letter-spacing: 0.1em; white-space: nowrap;">
              ${isEn ? 'NOTIFY ME' : 'AVÍSAME'}
            </button>
          </div>
          <p id="restock-success-msg" style="display: none; font-size: 0.7rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; color: #15803d; margin-top: 0.5rem;"></p>
          <div id="ma-restock-stoq" style="width: 100%;"></div>
        </form>
      `;

      if (pdpAddBtn && pdpAddBtn.parentNode) {
        pdpAddBtn.parentNode.insertBefore(formDiv, pdpAddBtn);
      }

      if (typeof mountStoqInlineForm === 'function') {
        mountStoqInlineForm(product.id, product.name, chosenSize);
      }

      if (pdpAddBtn) {
        pdpAddBtn.disabled = false;
        pdpAddBtn.dataset.isOos = 'true';
        pdpAddBtn.textContent = isEn ? 'NOTIFY ME WHEN AVAILABLE' : 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
      }

      if (stickyBtn) {
        stickyBtn.disabled = false;
        stickyBtn.textContent = isEn ? 'NOTIFY ME WHEN AVAILABLE' : 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
        stickyBtn.dataset.isOos = 'true';
      }

      const submitOosRequest = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const emailInput = document.getElementById('restock-email');
        const emailVal = emailInput ? emailInput.value.trim() : '';
        if (!emailVal) {
          if (emailInput) {
            emailInput.focus();
            emailInput.style.borderColor = '#dc2626';
            setTimeout(() => emailInput.style.borderColor = 'var(--color-black)', 1500);
          }
          return;
        }

        const mobBtn = formDiv.querySelector('.ma-pdp-oos-mobile-btn');
        if (pdpAddBtn) { pdpAddBtn.disabled = true; pdpAddBtn.textContent = isEn ? 'SENDING...' : 'ENVIANDO...'; }
        if (mobBtn) { mobBtn.disabled = true; mobBtn.textContent = isEn ? 'SENDING...' : 'ENVIANDO...'; }

        const reqs = JSON.parse(localStorage.getItem('ma_restock_requests') || '[]');
        reqs.push({
          email: emailVal,
          productId: product.id,
          productName: product.name,
          size: chosenSize,
          date: new Date().toISOString()
        });
        localStorage.setItem('ma_restock_requests', JSON.stringify(reqs));

        // STOQ Restock API
        let stoqOk = false;
        if (typeof sendStoqRestockRequest === 'function') {
          stoqOk = await sendStoqRestockRequest(product.id, product.name, chosenSize, emailVal);
        }

        if (stoqOk) {
          if (emailInput) emailInput.style.display = 'none';
          if (pdpAddBtn) pdpAddBtn.style.display = 'none';
          if (mobBtn) mobBtn.style.display = 'none';
          const msg = document.getElementById('restock-success-msg');
          if (msg) {
            msg.style.display = 'block';
            msg.textContent = isEn ? 'YOU WILL BE NOTIFIED WHEN RESTOCKED.' : 'TE AVISAREMOS CUANDO VUELVA A ESTAR DISPONIBLE.';
          }
        } else {
          if (pdpAddBtn) { pdpAddBtn.disabled = false; pdpAddBtn.textContent = isEn ? 'NOTIFY ME WHEN AVAILABLE' : 'AVÍSAME CUANDO ESTÉ DISPONIBLE'; }
          if (mobBtn) { mobBtn.disabled = false; mobBtn.textContent = isEn ? 'NOTIFY ME WHEN AVAILABLE' : 'AVÍSAME CUANDO ESTÉ DISPONIBLE'; }
          if (emailInput) {
            emailInput.style.borderColor = '#dc2626';
            setTimeout(() => emailInput.style.borderColor = 'var(--color-black)', 2000);
          }
        }
      };

      const rForm = document.getElementById('pdp-restock-form');
      if (rForm) rForm.addEventListener('submit', submitOosRequest);

      pdpAddBtn._oosHandler = submitOosRequest;

    } else {
      if (qtySection) qtySection.style.display = '';
      if (pdpAddBtn) {
        pdpAddBtn.style.display = '';
        pdpAddBtn.disabled = false;
        pdpAddBtn.dataset.selectedAvailable = 'true';
        delete pdpAddBtn.dataset.isOos;
        pdpAddBtn.textContent = dict['product.add'];
        pdpAddBtn._oosHandler = null;
      }
      if (stickyBtn) {
        stickyBtn.textContent = dict['product.add'];
        delete stickyBtn.dataset.isOos;
      }
    }
  };

  const setupPdpSizeSelector = (productData, initialSize) => {
    const selectEl = document.getElementById('pdp-size-select');
    if (!selectEl || !productData) return;
    const wrapperEl = selectEl.closest('.pdp-size-select-wrapper');

    const refreshSelector = (activeSize) => {
      let profileConfigured = false;
      try {
        const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
        if (repo && repo.exists()) {
          const profile = repo.getProfile();
          if (profile && profile.height && profile.weight) {
            profileConfigured = true;
          }
        }
      } catch (e) {}

      const effectiveSize = profileConfigured ? (activeSize || '') : '';
      const { html, hasProfile, recommendedSize, isOneSize } = buildPdpSizeOptionsHTML(productData, effectiveSize);
      selectEl.innerHTML = html;

      if (selectEl._pdpFitCleanup) {
        selectEl._pdpFitCleanup();
        selectEl._pdpFitCleanup = null;
      }
      selectEl.onchange = null;

      if (isOneSize) {
        selectEl.value = 'O/S';
        handlePdpSizeChange('O/S');
        return;
      }

      if (!hasProfile) {
        selectEl.value = '';
        const triggerFitDrawer = (e) => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }
          }
          if (document.activeElement === selectEl) {
            selectEl.blur();
          }
          openFitModalForPdp(productData, refreshSelector);
          return false;
        };

        selectEl._pdpFitHandler = triggerFitDrawer;
        const events = ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'click', 'focus'];
        events.forEach(evtType => {
          selectEl.addEventListener(evtType, triggerFitDrawer, { capture: true });
          if (wrapperEl) wrapperEl.addEventListener(evtType, triggerFitDrawer, { capture: true });
        });

        selectEl._pdpFitCleanup = () => {
          events.forEach(evtType => {
            selectEl.removeEventListener(evtType, triggerFitDrawer, { capture: true });
            if (wrapperEl) wrapperEl.removeEventListener(evtType, triggerFitDrawer, { capture: true });
          });
        };
      } else {
        selectEl.onchange = (e) => {
          const val = e.target.value;
          if (val === 'find-size') {
            const optToSelect = Array.from(selectEl.options).find(opt =>
              opt.getAttribute('data-size') === recommendedSize || opt.value === recommendedSize
            );
            if (optToSelect) {
              selectEl.value = optToSelect.value;
            }
            if (document.activeElement === selectEl) selectEl.blur();
            openFitModalForPdp(productData, refreshSelector);
            return;
          }
          handlePdpSizeChange(val);
        };

        const selectedVal = activeSize || recommendedSize || '';
        if (selectedVal) {
          const optToSelect = Array.from(selectEl.options).find(opt =>
            opt.getAttribute('data-size') === selectedVal || opt.value === selectedVal
          );
          if (optToSelect) {
            selectEl.value = optToSelect.value;
          }
          handlePdpSizeChange(selectedVal);
        }
      }
    };

    refreshSelector(initialSize);
    window._refreshPdpSizeSelector = refreshSelector;
  };

  if (pdpSizeSelect) {
    setupPdpSizeSelector(product, defaultSize);
  }

  sizeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const chosenSize = btn.getAttribute('data-size');
      if (pdpSizeSelect) {
        pdpSizeSelect.value = chosenSize;
      }
      handlePdpSizeChange(chosenSize);
    });
  });
  // Quantity stepper
  let qty = 1;
  const qtyValue = document.getElementById('qty-value');
  const qtyDec = document.getElementById('qty-dec');
  const qtyInc = document.getElementById('qty-inc');
  if (qtyDec && qtyInc && qtyValue) {
    qtyDec.addEventListener('click', () => {
      if (qty > 1) { qty--; qtyValue.textContent = qty; }
    });
    qtyInc.addEventListener('click', () => {
      qty++; qtyValue.textContent = qty;
    });
  }

  // Add to cart / OOS notify from PDP
  document.getElementById('pdp-add').addEventListener('click', (e) => {
    e.stopPropagation();
    const btn = e.currentTarget;
    if (btn.dataset.isOos === 'true' && typeof btn._oosHandler === 'function') {
      btn._oosHandler(e);
      return;
    }
    const sizeSelect = document.getElementById('pdp-size-select');
    const selectedOption = sizeSelect?.selectedOptions?.[0];
    const selectedUnavailable = selectedOption && selectedOption.dataset.available === 'false';
    const selectedAvailable = selectedOption && !selectedUnavailable;
    if (!selectedAvailable) return;
    const chosenSize = selectedOption ? (selectedOption.dataset.size || selectedOption.text) : (document.querySelector('#pdp-sizes .size-btn.is-active')?.getAttribute('data-size') || '');
    const chosenVariantId = selectedOption?.value || null;
    if (!chosenSize) {
      // Check if no fit profile is configured → open ENCUENTRA TU TALLA modal
      const hasProfile = (() => {
        try {
          const rawProfile = localStorage.getItem('mark-altitude-fit-profile-v3.1');
          if (rawProfile) {
            const profile = JSON.parse(rawProfile);
            return !!(profile && profile.heightCm && profile.weightKg);
          }
        } catch (e) {}
        return false;
      })();

      if (!hasProfile) {
        // Open fit drawer — no profile configured yet
        openFitModalForPdp(product, window._refreshPdpSizeSelector);
      } else {
        // Profile exists but no size selected — show toast and pulse the selector
        showToast(t('toast.select_size'));
        if (sizeSelect) {
          sizeSelect.classList.add('is-pulsing');
          sizeSelect.focus();
          setTimeout(() => sizeSelect.classList.remove('is-pulsing'), 800);
        }
      }
      return;
    }
    const addSuccess = cart.add({
      id: product.id,
      name: product.name,
      color: product.color,
      size: chosenSize,
      variantId: chosenVariantId,
      priceUsd: product.priceUsd,
      pricePen: product.pricePen,
      qty: qty
    });
    if (addSuccess !== false) {
      const flySource = document.querySelector('.ma-pdp-media img') ||
                        document.querySelector('.ma-pdp-media') ||
                        document.getElementById('product-gallery');
      if (typeof animateAddToCart === 'function') animateAddToCart(flySource);
      showToast(t('toast.added'));
      setTimeout(openCart, 280);
    }
  });

  // ─── MOBILE: Enable CSS :active on iOS Safari (needs touchstart listener) ───
  if ('ontouchstart' in window) {
    document.querySelectorAll('.btn, .product-info__add, .fit-drawer__submit, .fit-drawer__apply, .fit-drawer__recalc-btn, .checkout-submit').forEach(el => {
      el.addEventListener('touchstart', () => {}, { passive: true });
    });
  }

  // ─── PRODUCT GALLERY COUNTER (DESKTOP) ───
  if (typeof initDesktopCounter === 'function' && window.innerWidth > 768) {
    initDesktopCounter();
  }

  // PDP accordion
  document.querySelectorAll('.pdp-acc__q').forEach(btn => {
    btn.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      const panel = this.nextElementSibling;
      if (panel) panel.classList.toggle('is-open', !expanded);
    });
  });

  // ─── Sticky Cart Bar (Levi's grid 4 cols) ───
  const stickyBar   = document.getElementById('sticky-cart-bar');
  const stickyTitle = document.getElementById('sticky-cart-title');
  const stickyPrice = document.getElementById('sticky-cart-price');
  const sizeBtn     = document.getElementById('ma-size-btn');
  const popover     = document.getElementById('ma-popover');
  const primaryBtn  = document.getElementById('pdp-add');

  if (stickyBar && primaryBtn && popover && sizeBtn) {
    // Populate static data
    stickyTitle.textContent = product.name;
    stickyPrice.textContent = formatPrice(getProductPrice(product));

    // Populate size popover buttons
    popover.innerHTML = product.sizes.map(s => {
      const isOos = product.outOfStockSizes && product.outOfStockSizes.includes(s);
      return `<button class="ma-popover__opt${isOos ? ' is-disabled' : ''}" data-size="${s}">${s}</button>`;
    }).join('');

    // STATE VARIABLES FOR STICKY
    let primaryPassed = false;
    let passedGallery = false;

    const updateSticky = () => {
      if (primaryPassed && !passedGallery) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    };

    // OBSERVER 1 — track primary add-to-cart button
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          primaryPassed = false;
        } else {
          // It's passed only if it's scrolled above the viewport
          primaryPassed = entry.boundingClientRect.top < 0;
        }
        updateSticky();
      },
      { threshold: 0 }
    );
    observer.observe(primaryBtn);

    // OBSERVER 2 — track when content below the gallery appears (.complete-system, .related or #pdp-bundle-container)
    const tailSection = document.getElementById('pdp-bundle-container') || document.querySelector('.complete-system, .related, .ma-look');
    if (tailSection) {
      const observerTail = new IntersectionObserver(
        ([entry]) => {
          passedGallery = entry.isIntersecting;
          updateSticky();
        },
        { threshold: 0 }
      );
      observerTail.observe(tailSection);
    }

    // Toggle popover or open fit system drawer on size button click
    sizeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const hasProfile = localStorage.getItem('mark-altitude-fit-profile') !== null;
      if (!hasProfile) {
        // Caso A: Open fit drawer directly
        const fitOpenBtn = document.querySelector('[data-fit-open]');
        if (fitOpenBtn) fitOpenBtn.click();
      } else {
        // Caso B: Toggle popover for traditional selection
        popover.classList.toggle('is-open');
      }
    });

    // Close popover on click outside
    document.addEventListener('click', (e) => {
      if (!popover.contains(e.target) && e.target !== sizeBtn) {
        popover.classList.remove('is-open');
      }
    });

    // Size option click → select talla, update text, close popover
    popover.addEventListener('click', (e) => {
      const opt = e.target.closest('.ma-popover__opt');
      if (!opt) return;

      const size = opt.dataset.size;
      const sizeValueSpan = document.getElementById('ma-size-value');
      if (sizeValueSpan) {
        sizeValueSpan.textContent = size; // Update span text with chosen size
      }

      // Select variant on PDP to sync
      const pdpBtn = document.querySelector(`#pdp-sizes .size-btn[data-size="${size}"]`);
      if (pdpBtn) pdpBtn.click();

      // Close popover
      popover.classList.remove('is-open');
    });

    // Add to cart click
    stickyBtn.addEventListener('click', () => {
      if (stickyBtn.dataset.isOos === 'true') {
        const formContainer = document.getElementById('pdp-restock-container');
        if (formContainer) {
          formContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const emailInput = document.getElementById('restock-email');
          if (emailInput) setTimeout(() => emailInput.focus(), 600);
        }
      } else {
        primaryBtn.click();

        // If a size is selected, show feedback (primaryBtn will handle cart addition)
        const sizeValueSpan = document.getElementById('ma-size-value');
        if (sizeValueSpan && sizeValueSpan.textContent.trim() !== '') {
          const originalText = stickyBtn.textContent;
          stickyBtn.textContent = 'AÑADIDO';
          setTimeout(() => {
            stickyBtn.textContent = originalText;
          }, 800);
        }
      }
    });

    // Dynamic sticky styling for the PDP info panel to bypass CSS caching & support responsive sizes
    const adjustProductInfoStyle = () => {
      const info = document.querySelector('.ma-pdp-info-inner');
      if (info) {
        if (window.innerWidth >= 1025) {
          info.style.setProperty('position', 'sticky', 'important');
          info.style.setProperty('top', '0', 'important');
          info.style.setProperty('height', '100vh', 'important');
        } else {
          info.style.removeProperty('position');
          info.style.removeProperty('top');
          info.style.removeProperty('height');
        }
      }
    };
    window.addEventListener('resize', adjustProductInfoStyle);
    adjustProductInfoStyle();
  }

  // Initialize Find Your Fit independently from the optional sticky cart bar.
  // T-01 and J-01 receive the interactive drawer; O/S products are excluded
  // by initFitSystem while retaining their visible static size presentation.
  if (typeof window.initFitSystem === 'function') {
    window.initFitSystem(product, getLang());
  }

  // Initialize PDP auxiliary info drawers (Details, Shipping, Customer Service)
  if (typeof initPDPAuxDrawers === 'function') {
    initPDPAuxDrawers(product, getLang());
  }

  // ── REVIEWS + COMPLETE THE SYSTEM ────────────────────────────────────────
  // Position the reviews section and complete-system section after the PDP section
  const pdpRoot = document.getElementById('product-detail');
  if (pdpRoot) {
    const dict = I18N[getLang()] || I18N['es'];

    const reviewsTitle = document.querySelector('.reviews-title');
    if (reviewsTitle) {
      reviewsTitle.textContent = dict['reviews.title'] || 'RESEÑAS';
    }

    // Position THE PURPOSE (.c01-purpose-wrapper) right AFTER .reviews
    const currentReviewsSec = document.querySelector('#reviews, #product-reviews-section, .reviews-section, .reviews');
    const purposeHero = document.querySelector('.c01-purpose-wrapper, .c01-purpose-hero, [data-c01-seo]');
    if (currentReviewsSec && purposeHero && currentReviewsSec.nextElementSibling !== purposeHero) {
      currentReviewsSec.insertAdjacentElement('afterend', purposeHero);
    }

    // Position COMPLETE THE SYSTEM (.complete-system) right AFTER THE PURPOSE
    let csSec = document.querySelector('.complete-system');
    if (!csSec) {
      const sysWrap = document.createElement('div');
      sysWrap.innerHTML = `
        <section class="complete-system gallery-v2 v2-section is-visible" data-header-mode="hidden" data-reveal="up-sm">
          <div class="v2-container">
            <div class="gallery-v2__header">
              <h2 class="gallery-v2__title">COMPLETE THE SYSTEM</h2>
            </div>
            <div class="gallery-v2__wrapper" id="complete-system-grid"></div>
          </div>
        </section>
      `;
      csSec = sysWrap.firstElementChild;
    }
    const csAnchor = document.querySelector('.c01-purpose-wrapper, .c01-purpose-hero, [data-c01-seo]') || currentReviewsSec || pdpRoot;
    if (csSec && csAnchor) {
      csAnchor.insertAdjacentElement('afterend', csSec);
    }

    // Wire reviews interactivity
    wireReviews(product);

    // Render complete-system products
    renderCompleteSystem(product, dict);
  }

  // Initialize Pinned Scroll Reveal Lock for Multi-color products
  if (isMobilePinnedColorReveal) {
    initPdpScrollLock();
  }

  function initPdpScrollLock() {
    const gallery = document.getElementById('product-gallery');
    const mainImgBlock = gallery ? gallery.querySelector('.main-image-block') : null;
    const thumbsBlock = gallery ? gallery.querySelector('.color-thumbnails-block') : null;
    const info = document.querySelector('.ma-pdp-info');
    if (!gallery || !info || !mainImgBlock || !thumbsBlock) return;

    const handleScroll = () => {
      // Pinned reveal effect is ONLY for mobile screens (width <= 768px)
      if (window.innerWidth > 768) {
        info.style.removeProperty('transform');
        info.style.removeProperty('position');
        info.style.removeProperty('z-index');
        mainImgBlock.style.removeProperty('transform');
        thumbsBlock.style.removeProperty('transform');
        document.documentElement.classList.remove('pdp-has-reveal');
        return;
      }

      // Apply pdp-has-reveal class to HTML on mobile
      document.documentElement.classList.add('pdp-has-reveal');
      info.style.setProperty('position', 'relative', 'important');
      info.style.setProperty('z-index', '10', 'important');

      const sy = window.scrollY;
      
      // Thumbnails block is 112px tall.
      // To reveal thumbnails at normal 1x scroll speed:
      // Keep main image and thumbnails scrolling naturally (no transform),
      // while pinning the info section at its screen position until 112px of scroll.
      if (sy < 112) {
        info.style.setProperty('transform', `translateY(${sy}px)`, 'important');
      } else {
        info.style.setProperty('transform', 'translateY(112px)', 'important');
      }
      
      mainImgBlock.style.removeProperty('transform');
      thumbsBlock.style.removeProperty('transform');
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll();
  }

  // Always initialize scroll reveal for PDP elements
  window.initScrollReveal?.();

  // Render WhatsApp button instead of chat
  let waBtn = document.querySelector('.whatsapp-btn');
  if (!waBtn) {
    waBtn = document.createElement('a');
    waBtn.className = 'whatsapp-btn ma-pdp-wa-btn';
    waBtn.href = 'https://wa.me/51999999999';
    waBtn.target = '_blank';
    waBtn.rel = 'noopener noreferrer';
    waBtn.innerHTML = `<img src="${getAssetUrl('icono-social-whatsapp.svg')}" alt="WhatsApp">`;
    // Place it above the price visually if possible, or just append to body (CSS handles fixed position)
  }
}

// ─── DESKTOP PDP GALLERY COUNTER (PC VERTICAL SCROLL) ───
let desktopCounterCleanup = null;

function initDesktopCounter() {
  if (typeof desktopCounterCleanup === 'function') {
    desktopCounterCleanup();
    desktopCounterCleanup = null;
  }

  if (window.innerWidth <= 768) return;

  const gallery = document.getElementById('product-gallery');
  const counter = document.getElementById('gallery-counter');
  if (!gallery || !counter) return;

  const counterCurrent = counter.querySelector('[data-ma-current]');
  if (!counterCurrent) return;

  const galleryItems = Array.from(gallery.querySelectorAll('.ma-pdp-media'));
  if (!galleryItems.length) return;

  const updateActiveSlide = () => {
    if (window.innerWidth <= 768) return;

    // Sticky counter reference line at 50vh (middle of viewport)
    const focalY = window.innerHeight * 0.5;
    let closestItem = galleryItems[0];
    let minDistance = Infinity;

    for (let i = 0; i < galleryItems.length; i++) {
      const rect = galleryItems[i].getBoundingClientRect();
      if (rect.top <= focalY && rect.bottom > focalY) {
        closestItem = galleryItems[i];
        break;
      }
      const itemCenter = (rect.top + rect.bottom) / 2;
      const dist = Math.abs(itemCenter - focalY);
      if (dist < minDistance) {
        minDistance = dist;
        closestItem = galleryItems[i];
      }
    }

    const rawIndex = closestItem.getAttribute('data-index') ||
                     closestItem.getAttribute('data-position') ||
                     String(galleryItems.indexOf(closestItem) + 1);
    const activeIndex = String(parseInt(rawIndex, 10) || 1);

    if (counterCurrent.textContent !== activeIndex) {
      counterCurrent.textContent = activeIndex;
    }
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateActiveSlide();
      ticking = false;
    });
  };

  const onResize = () => {
    if (window.innerWidth <= 768) return;
    updateActiveSlide();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  desktopCounterCleanup = () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
  };

  updateActiveSlide();
}

// Independent DOM-ready initializer for Shopify SSR PDP
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 768) initDesktopCounter();
  });
} else {
  if (window.innerWidth > 768) initDesktopCounter();
}

// PDP Auxiliary Info Drawers (Details, Shipping, Customer Service)
function initPDPAuxDrawers(product, lang) {
  const hasExistingDrawers = document.getElementById('pdp-drawer-details') && document.getElementById('pdp-drawer-care');
  
  if (!hasExistingDrawers) {
    if (!product) {
      const handle = window.location.pathname;
      if (handle.includes('bolso-viaje-cuero-hombre') || handle.includes('mens-leather-travel-duffel-bag') || handle.includes('mens-leather-garment-duffel-bag')) {
        product = (window.PRODUCTS && window.PRODUCTS['MA-DF-01']) ? window.PRODUCTS['MA-DF-01'] : { id: 'MA-DF-01', name: 'C-01 TRAVEL DUFFEL' };
      } else if (handle.includes('casaca')) {
        product = (window.PRODUCTS && window.PRODUCTS['MA-DJ-01']) ? window.PRODUCTS['MA-DJ-01'] : { id: 'MA-DJ-01', name: 'J-01 DOWN JACKET' };
      } else if (handle.includes('blanco')) {
        product = (window.PRODUCTS && window.PRODUCTS['MA-TE-WH']) ? window.PRODUCTS['MA-TE-WH'] : { id: 'MA-TE-WH', name: 'T-01 ESSENTIAL PIMA WHITE' };
      } else {
        product = (window.PRODUCTS && window.PRODUCTS['MA-TE-BK']) ? window.PRODUCTS['MA-TE-BK'] : { id: 'MA-TE-BK', name: 'T-01 ESSENTIAL PIMA BLACK' };
      }
    }
    if (!lang) lang = typeof getLang === 'function' ? getLang() : 'es';

    document.querySelectorAll('.pdp-drawer, .pdp-drawer-overlay').forEach(el => el.remove());

    const isEn = lang === 'en';

    const overlay = document.createElement('div');
    overlay.className = 'pdp-drawer-overlay';
    overlay.id = 'pdp-drawer-overlay';
    document.body.appendChild(overlay);

    function createDrawer(id, title, contentHtml) {
      const drawer = document.createElement('div');
      drawer.className = 'pdp-drawer';
      drawer.id = `pdp-drawer-${id}`;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-labelledby', `pdp-drawer-${id}-title`);
      drawer.innerHTML = `
        <header class="pdp-drawer__header">
          <button class="pdp-drawer__close" data-pdp-drawer-close aria-label="${isEn ? 'Close' : 'Cerrar'}">✕</button>
        </header>
        <div class="pdp-drawer__body">
          <h2 class="pdp-drawer__title" id="pdp-drawer-${id}-title">${title}</h2>
          <div class="pdp-drawer__content">${contentHtml}</div>
        </div>
      `;
      document.body.appendChild(drawer);
      return drawer;
    }

    const detailsHtml = `
      <div class="pdp-drawer-section">
        <h3>${isEn ? 'A TRAVEL BAG DESIGNED FOR BETTER MOVEMENT' : 'UN BOLSO DE VIAJE DISEÑADO PARA MOVERTE MEJOR'}</h3>
        <p>${isEn ? 'The C-01 combines the commanding presence of a leather duffel with the organization required for a short trip. Its flexible structure allows you to pack clothing, footwear, and accessories in one place, while top handles and a removable strap offer two versatile carry modes.' : 'El C-01 reúne la presencia de un bolso de cuero con la organización que exige un viaje corto. Su estructura flexible permite preparar ropa, calzado y accesorios en un solo lugar, mientras las asas y la correa removible ofrecen dos formas de llevarlo.'}</p>
      </div>
      <hr class="pdp-drawer-divider">
      <div class="pdp-drawer-section">
        <h3>${isEn ? 'FULL-GRAIN LEATHER: DURABILITY AND CHARACTER' : 'CUERO FULL-GRAIN: RESISTENCIA Y CARÁCTER'}</h3>
        <p>${isEn ? 'The exterior is crafted from full-grain leather, preserving the hide\'s natural grain texture while developing rich character over time. As a result, every bag develops a unique patina through constant use.' : 'El exterior está elaborado en cuero full-grain, que conserva la textura natural de la piel y desarrolla carácter con el uso. Por eso, cada bolso adquiere una apariencia propia con el paso del tiempo.'}</p>
        <p>${isEn ? 'Heavy-duty metallic hardware and zippers accompany a durable black interior lining. The C-01 is built for daily movement and weekend escapes without losing its clean, architectural silhouette.' : 'Los cierres y herrajes metálicos acompañan un forro interior de tela negra. El C-01 está pensado para el movimiento cotidiano y para escapadas de fin de semana, sin perder una línea sobria.'}</p>
      </div>
      <hr class="pdp-drawer-divider">
      <div class="pdp-drawer-section">
        <h3>${isEn ? 'GARMENT BAG OPENING AND INTERIOR ORGANIZATION' : 'APERTURA PORTATRAJE Y ORGANIZACIÓN INTERIOR'}</h3>
        <h4>${isEn ? 'Independent shoe compartment' : 'Compartimento independiente para calzado'}</h4>
        <p>${isEn ? 'Separates footwear from clean clothing, maintaining hygiene and structure within the main storage space.' : 'Separa los zapatos del resto del contenido y ayuda a mantener ordenado el espacio principal.'}</p>
        <h4>${isEn ? 'Main compartment for clothing and accessories' : 'Espacio principal para ropa y accesorios'}</h4>
        <p>${isEn ? 'Full lay-flat opening transforms the bag into a spacious surface for effortless packing and organization.' : 'La apertura completa convierte el bolso en una superficie amplia para distribuir prendas y preparar el viaje con mayor claridad.'}</p>
        <h4>${isEn ? 'Interior pockets for personal items' : 'Bolsillos interiores para objetos personales'}</h4>
        <p>${isEn ? 'Dedicated interior pockets keep essential travel documents, cables, and small items securely within reach.' : 'Los bolsillos interiores mantienen a mano documentos, cargadores y otros objetos pequeños durante el traslado.'}</p>
      </div>
    `;

    const careHtml = `
      <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">${isEn ? 'CARE' : 'CUIDADOS'}</h3>
      <p style="margin-bottom: 16px; font-size: 12px; color: #555;">${isEn ? 'Wash the T-01 with similar colors and avoid aggressive treatments that may affect the fabric or color.' : 'Lava el T-01 con colores similares y evita tratamientos agresivos que puedan afectar el tejido o el color.'}</p>
      <div class="pdp-drawer-care-list" style="display: flex; flex-direction: column; gap: 16px; margin-bottom: 28px;">
        <div class="pdp-drawer-care-item" style="display: flex; align-items: center; gap: 16px;">
          <img src="${getAssetUrl('icono-cuidado-lavado-maquina-30c.png')}" class="pdp-drawer-care-icon" style="width: 22px; height: 22px; object-fit: contain; flex-shrink: 0;" alt="" />
          <span class="pdp-drawer-care-title" style="font-size: 11px; font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase;">${isEn ? 'MACHINE WASH MAX. 30ºC. SHORT SPIN' : 'LAVAR A MAQUINA MAX. 30ºC. CENTRIFUGADO CORTO'}</span>
        </div>
        <div class="pdp-drawer-care-item" style="display: flex; align-items: center; gap: 16px;">
          <img src="${getAssetUrl('icono-cuidado-no-usar-lejia.png')}" class="pdp-drawer-care-icon" style="width: 22px; height: 22px; object-fit: contain; flex-shrink: 0;" alt="" />
          <span class="pdp-drawer-care-title" style="font-size: 11px; font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase;">${isEn ? 'DO NOT BLEACH' : 'NO USAR LEJÍA / BLANQUEADOR'}</span>
        </div>
        <div class="pdp-drawer-care-item" style="display: flex; align-items: center; gap: 16px;">
          <img src="${getAssetUrl('icono-cuidado-planchar-maximo-110c.png')}" class="pdp-drawer-care-icon" style="width: 22px; height: 22px; object-fit: contain; flex-shrink: 0;" alt="" />
          <span class="pdp-drawer-care-title" style="font-size: 11px; font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase;">${isEn ? 'IRON MAX 110 ºC' : 'PLANCHAR MAXIMO 110 º C'}</span>
        </div>
        <div class="pdp-drawer-care-item" style="display: flex; align-items: center; gap: 16px;">
          <img src="${getAssetUrl('icono-cuidado-no-secadora.png')}" class="pdp-drawer-care-icon" style="width: 22px; height: 22px; object-fit: contain; flex-shrink: 0;" alt="" />
          <span class="pdp-drawer-care-title" style="font-size: 11px; font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase;">${isEn ? 'DO NOT TUMBLE DRY' : 'NO USAR SECADORA'}</span>
        </div>
      </div>
      <h3 class="pdp-drawer-subtitle" style="margin-top: 24px;">${isEn ? 'SPECIFICATIONS' : 'ESPECIFICACIONES'}</h3>
      <dl class="pdp-specs-grid">
        <div class="pdp-spec-row"><dt>${isEn ? 'SIZE' : 'TALLA'}</dt><dd>O/S</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'SHELL MATERIAL' : 'MATERIAL EXTERIOR'}</dt><dd>${isEn ? '100% FULL-GRAIN COWHIDE LEATHER' : 'CUERO VACUNO FULL-GRAIN'}</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'COLOR' : 'COLOR'}</dt><dd>${isEn ? 'BLACK' : 'NEGRO'}</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'LENGTH' : 'LARGO'}</dt><dd>56 CM</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'DEPTH' : 'FONDO'}</dt><dd>28 CM</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'HEIGHT' : 'ALTO'}</dt><dd>26 CM</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'CARRY OPTIONS' : 'TRANSPORTE'}</dt><dd>${isEn ? 'LEATHER HANDLES / REMOVABLE STRAP' : 'ASAS DE CUERO / CORREA REMOVIBLE'}</dd></div>
        <div class="pdp-spec-row"><dt>${isEn ? 'ORIGIN' : 'ORIGIN'}</dt><dd>${isEn ? 'PERU' : 'PERÚ'}</dd></div>
      </dl>
    `;

    const faqHtml = `
      <div class="pdp-faq-accordions">
        <details class="pdp-faq-accordion" open>
          <summary class="pdp-faq-summary"><h3>${isEn ? 'WHAT FITS IN THE C-01 TRAVEL DUFFEL?' : '¿QUÉ CABE EN EL C-01 TRAVEL DUFFEL?'}</h3><span class="pdp-faq-icon">+</span></summary>
          <div class="pdp-faq-answer"><p>${isEn ? 'Its 56 × 28 × 26 cm format provides ample space for garments, shoes, and personal essentials for short trips. The full lay-flat opening allows clean organization before zipping closed.' : 'Su formato de 56 × 28 × 26 cm ofrece espacio para ropa, calzado y objetos personales de un viaje corto. La apertura completa permite organizar el contenido antes de cerrar el bolso.'}</p></div>
        </details>
        <details class="pdp-faq-accordion">
          <summary class="pdp-faq-summary"><h3>${isEn ? 'CAN IT BE USED AS CARRY-ON LUGGAGE?' : '¿SE PUEDE USAR COMO EQUIPAJE DE MANO?'}</h3><span class="pdp-faq-icon">+</span></summary>
          <div class="pdp-faq-answer"><p>${isEn ? 'Carry-on luggage rules vary depending on the airline, flight route, and fare tier. Before traveling, verify the C-01 dimensions—56 × 28 × 26 cm—against your airline\'s current limits.' : 'Las políticas de equipaje de mano cambian según la aerolínea, la ruta y la tarifa. Antes de viajar, compara las medidas del C-01 —56 × 28 × 26 cm— con los límites vigentes de tu aerolínea.'}</p></div>
        </details>
        <details class="pdp-faq-accordion">
          <summary class="pdp-faq-summary"><h3>${isEn ? 'TRAVEL DUFFEL OR BACKPACK FOR A SHORT TRIP?' : '¿BOLSO DE VIAJE O MOCHILA PARA UN VIAJE CORTO?'}</h3><span class="pdp-faq-icon">+</span></summary>
          <div class="pdp-faq-answer"><p>${isEn ? 'For folded garments, shoes, and tailored clothing, the duffel format of the C-01 offers a significantly wider opening than a backpack. A backpack may be preferable when carrying weight on your shoulders over long walking distances.' : 'Para ropa doblada, calzado y prendas que quieres mantener más ordenadas, el formato duffel del C-01 ofrece una apertura más amplia que una mochila. Una mochila puede resultar más práctica cuando necesitas llevar el peso en la espalda durante trayectos largos.'}</p></div>
        </details>
        <details class="pdp-faq-accordion">
          <summary class="pdp-faq-summary"><h3>${isEn ? 'HOW DOES THE GARMENT BAG OPENING WORK?' : '¿CÓMO FUNCIONA LA APERTURA PORTATRAJE?'}</h3><span class="pdp-faq-icon">+</span></summary>
          <div class="pdp-faq-answer"><p>${isEn ? 'The C-01 unzips flat into a garment suit carrier. You lay your jacket or suit flat, secure it in place, and zip the duffel back into shape, keeping fine clothing wrinkle-free during transit.' : 'El C-01 se abre por completo para extender el compartimento portatraje, colocar la prenda y asegurarla antes de volver a cerrar el bolso. Así separa y organiza la ropa dentro del mismo formato de viaje.'}</p></div>
        </details>
      </div>
    `;

    const isUsdRegion = (typeof getRegion === 'function' ? (getRegion() === 'international-usd' || getRegion() === 'internacional-usd') : false) || (typeof getLang === 'function' && getLang() === 'en');

    const shippingHtml = isUsdRegion ? (isEn ? `
      <div class="pdp-drawer-section">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">INTERNATIONAL SHIPPING</h3>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">International shipping via DHL Express. Free shipping on orders over $100 USD.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">For purchases below this amount, shipping costs are calculated during checkout.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;"><strong>Estimated transit time:</strong> 3 to 7 business days depending on destination.</p>
      </div>
      <div class="pdp-drawer-section" style="margin-top: 24px;">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">RETURNS &amp; EXCHANGES</h3>
        <p style="margin: 0 0 24px; font-size: 12px; line-height: 1.6;">Exchanges and returns can be requested within 14 calendar days of delivery.</p>
      </div>
    ` : `
      <div class="pdp-drawer-section">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">ENVÍOS INTERNACIONALES</h3>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">Envíos internacionales a través de la empresa DHL Express. Pedidos superiores a 100 USD cuentan con envío gratuito.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">Para compras que no alcancen este monto, el costo del envío se calcula en el checkout.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;"><strong>Plazo estimado:</strong> 3 a 7 días hábiles según destino.</p>
      </div>
      <div class="pdp-drawer-section" style="margin-top: 24px;">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">CAMBIOS Y DEVOLUCIONES</h3>
        <p style="margin: 0 0 24px; font-size: 12px; line-height: 1.6;">Los cambios y devoluciones pueden solicitarse dentro de los 14 días calendario posteriores a la entrega.</p>
      </div>
    `) : (isEn ? `
      <div class="pdp-drawer-section">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">DOMESTIC SHIPPING</h3>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">Shipping throughout Peru via Shalom. Orders over S/ 349.00 feature free shipping.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;"><strong>Estimated transit time:</strong> 24 to 72 business hours depending on destination.</p>
      </div>
      <div class="pdp-drawer-section" style="margin-top: 24px;">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">RETURNS &amp; EXCHANGES</h3>
        <p style="margin: 0 0 24px; font-size: 12px; line-height: 1.6;">Exchanges and returns can be requested within 14 calendar days of delivery.</p>
      </div>
    ` : `
      <div class="pdp-drawer-section">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">ENVÍOS NACIONALES</h3>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;">Envíos a todo el Perú a través de la empresa Shalom Empresarial S.A.C. El costo del envío se cobra en el checkout.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;"><strong>Envío gratis:</strong> En compras superiores a S/ 349.00.</p>
        <p style="margin: 0 0 16px; font-size: 12px; line-height: 1.6;"><strong>Plazo estimado:</strong> 24 a 72 horas hábiles según destino.</p>
      </div>
      <div class="pdp-drawer-section" style="margin-top: 24px;">
        <h3 class="pdp-drawer-subtitle" style="margin-top: 0 !important;">CAMBIOS Y DEVOLUCIONES</h3>
        <p style="margin: 0 0 24px; font-size: 12px; line-height: 1.6;">Aceptamos solicitudes de cambio dentro de los 14 días calendario posteriores a la entrega.</p>
      </div>
    `);

    const serviceHtml = `
      <p style="margin: 0 0 24px; font-size: 12px; line-height: 1.6;">${isEn ? 'If you have questions about fit, care, shipping or returns, we are here to assist you personally.' : 'Si tienes preguntas sobre la talla, cuidados, envíos o devoluciones, estamos aquí para ayudarte personalmente.'}</p>
      <div style="margin-bottom: 20px;">
        <h3 style="font-size: 10px; font-weight: 500; color: #666; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 5px;">WHATSAPP</h3>
        <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer" style="font-size: 12px; color: #111; text-decoration: underline;">+51 916 643 733</a>
      </div>
      <div style="margin-bottom: 20px;">
        <h3 style="font-size: 10px; font-weight: 500; color: #666; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 5px;">EMAIL</h3>
        <a href="mailto:markaltitude.co@gmail.com" style="font-size: 12px; color: #111; text-decoration: underline;">markaltitude.co@gmail.com</a>
      </div>
    `;

    createDrawer('details', isEn ? 'PRODUCT DETAILS' : 'DETALLES DEL PRODUCTO', detailsHtml);
    createDrawer('care', isEn ? 'CARE & SPECIFICATIONS' : 'CUIDADOS Y ESPECIFICACIONES', careHtml);
    createDrawer('faq', isEn ? 'FREQUENTLY ASKED QUESTIONS' : 'PREGUNTAS FRECUENTES', faqHtml);
    createDrawer('shipping', isEn ? 'SHIPPING AND RETURNS' : 'ENVÍOS Y DEVOLUCIONES', shippingHtml);
    createDrawer('service', isEn ? 'CUSTOMER SERVICE' : 'SERVICIO AL CLIENTE', serviceHtml);
  }

  function closeAll() {
    document.querySelectorAll('.pdp-drawer').forEach(d => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    const overlay = document.getElementById('pdp-drawer-overlay');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('pdp-drawer-open');
    document.documentElement.classList.remove('pdp-drawer-open');
    document.body.style.overflow = '';
  }

  window.closePDPAuxDrawers = closeAll;

  // Teleport all drawers to <body> so they escape any stacking context
  // (The Liquid snippet renders them inside <aside> which has transforms/overflow)
  function teleportDrawersToBody() {
    const overlay = document.getElementById('pdp-drawer-overlay');
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    document.querySelectorAll('.pdp-drawer').forEach(d => {
      if (d.parentElement !== document.body) {
        document.body.appendChild(d);
      }
    });
  }
  teleportDrawersToBody();

  function openDrawer(type) {
    const target = document.getElementById(`pdp-drawer-${type}`);
    if (!target) return;
    const overlay = document.getElementById('pdp-drawer-overlay');

    // Make sure they're at body level
    if (target.parentElement !== document.body) document.body.appendChild(target);
    if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);

    // Close any open drawers first (instant, no transition)
    document.querySelectorAll('.pdp-drawer.is-open').forEach(d => {
      d.classList.remove('is-open');
    });
    if (overlay) overlay.classList.remove('is-visible');

    // Force a reflow so the browser registers the "closed" state, THEN add is-open
    // This guarantees the CSS transition from translateX(100%) → translateX(0) fires
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        target.classList.add('is-open');
        target.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.classList.add('is-visible');
        document.body.classList.add('pdp-drawer-open');
        document.documentElement.classList.add('pdp-drawer-open');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  document.querySelectorAll('[data-pdp-drawer-trigger]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const type = btn.getAttribute('data-pdp-drawer-trigger');
      btn.setAttribute('aria-expanded', 'true');
      openDrawer(type);
    });
  });

  window.openPDPDrawer = openDrawer;

  document.querySelectorAll('[data-pdp-drawer-close], #pdp-drawer-overlay').forEach(el => {
    el.addEventListener('click', closeAll);
  });
}

window.initPDPAuxDrawers = initPDPAuxDrawers;

// Global event delegation for PDP drawers (fallback for Liquid SSR triggers)
document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-pdp-drawer-trigger]');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    const type = trigger.getAttribute('data-pdp-drawer-trigger');

    // Ensure initPDPAuxDrawers has run (binds teleport + creates JS drawers if needed)
    if (typeof initPDPAuxDrawers === 'function' && !window._pdpDrawersInited) {
      window._pdpDrawersInited = true;
      initPDPAuxDrawers(null, typeof getLang === 'function' ? getLang() : 'es');
    }

    if (typeof window.openPDPDrawer === 'function') {
      window.openPDPDrawer(type);
    }
    return;
  }

  const closeBtn = e.target.closest('[data-pdp-drawer-close]');
  const isOverlay = e.target.matches('#pdp-drawer-overlay');
  if (closeBtn || isOverlay) {
    if (typeof window.closePDPAuxDrawers === 'function') {
      window.closePDPAuxDrawers();
    }
  }
});


// ─────────────────────────────────────────────────────────────────────────────
// COMPLETA EL LOOK — Editorial bundle (PDP only, products with BUNDLES entry)
// ─────────────────────────────────────────────────────────────────────────────
function renderBundleHTML(jacket, dict, selectedTeeId = null) {
  const bundle = BUNDLES[jacket.id];
  if (!bundle) return '';
  const teeId = selectedTeeId || window._maActiveBundleTeeId || bundle.members.find(id => id !== jacket.id);
  window._maActiveBundleTeeId = teeId;
  const tee = PRODUCTS[teeId];
  if (!tee) return '';

  const isTeeBundle = jacket.id === 'MA-TE-BK' || jacket.id === 'MA-TE-WH';
  const bundleTitle = isTeeBundle ? dict['product.bundle.tee.label'] : dict['product.bundle.label'];
  const buyCta = isTeeBundle ? dict['product.bundle.tee.cta'] : dict['product.bundle.cta'];
  const addedCta = isTeeBundle ? dict['product.bundle.tee.added'] : dict['product.bundle.added'];

  const totalPen = jacket.pricePen + tee.pricePen;
  const totalUsd = jacket.priceUsd + tee.priceUsd;
  
  let finalPen = totalPen - Math.round(totalPen * bundle.discountRate);
  let finalUsd = totalUsd - Math.round(totalUsd * bundle.discountRate);
  
  if (isTeeBundle) {
    finalPen = totalPen - 29;
    finalUsd = totalUsd - 9;
  }
  
  const total    = getLang() === 'en' ? totalUsd : totalPen;
  const final    = getLang() === 'en' ? finalUsd : finalPen;

  const jacketMedia = jacket.images
    ? `<img src="${getAssetUrl(jacket.images[0])}" alt="${jacket.name}">`
    : `<div class="ma-look-item__placeholder product-card__media--${jacket.placeholder}">
         <span class="product-card__placeholder-label">${jacket.label}</span>
       </div>`;

  const teeMedia = tee.images
    ? `<img src="${getAssetUrl(tee.images[0])}" alt="${tee.name}">`
    : `<div class="ma-look-item__placeholder product-card__media--${tee.placeholder}">
         <span class="product-card__placeholder-label">${tee.label}</span>
       </div>`;

  const savingsAmt = (dict['product.bundle.savings'] || 'Ahorra {amount}')
    .replace('{amount}', formatPrice(total - final));

  const jacketSizes = jacket.sizes.map(s => {
    const isOos = jacket.outOfStockSizes && jacket.outOfStockSizes.includes(s);
    return `<button type="button" class="size-btn${isOos ? ' is-disabled' : ''}" data-size="${s}">${s}</button>`;
  }).join('');
  const teeSizes = tee.sizes.map(s => {
    const isOos = tee.outOfStockSizes && tee.outOfStockSizes.includes(s);
    return `<button type="button" class="size-btn${isOos ? ' is-disabled' : ''}" data-size="${s}">${s}</button>`;
  }).join('');

  return `
    <section class="ma-look" data-bundle-id="${jacket.id}" data-header-mode="hidden" data-reveal="up-sm">
      <div class="container">
        <div class="ma-look-header">
          <div class="ma-look-header-title">
            <span class="ma-look-label">${bundleTitle}</span>
            <span class="ma-look-savings">${savingsAmt}</span>
          </div>
          <div class="fit-inline fit-inline--bundle" data-fit-inline-bundle></div>
        </div>

        <div class="ma-look-panel">
          <div class="ma-look-items">
            <div class="ma-look-item" data-bundle-member="${jacket.id}">
              <div class="ma-look-item__media">${jacketMedia}</div>
              <div class="ma-look-item__info">
                <span class="ma-look-item__name">${jacket.name}</span>
                <span class="ma-look-item__price">${formatPrice(getProductPrice(jacket))}</span>
                <div class="ma-look-colors" id="ma-look-colors-${jacket.id}">
                  <span class="swatch swatch--black is-active" data-color="black" title="Negro"></span>
                </div>
                <div class="ma-look-controls">
                  <div class="ma-look-sizes" id="ma-look-sizes-${jacket.id}">${jacketSizes}</div>
                  ${isTeeBundle ? '' : `
                  <div class="ma-look-qty" id="ma-look-qty-${jacket.id}">
                    <button type="button" class="ma-look-qty__btn" data-action="dec" aria-label="−">−</button>
                    <span class="ma-look-qty__value" data-qty-value>1</span>
                    <button type="button" class="ma-look-qty__btn" data-action="inc" aria-label="+">+</button>
                  </div>
                  `}
                </div>
              </div>
            </div>

            <div class="ma-look-item" data-bundle-member="${tee.id}">
              <div class="ma-look-item__media">${teeMedia}</div>
              <div class="ma-look-item__info">
                <span class="ma-look-item__name">${tee.name}</span>
                <span class="ma-look-item__price">${formatPrice(getProductPrice(tee))}</span>
                <div class="ma-look-colors" id="ma-look-colors-${tee.id}">
                  <span class="swatch swatch--white ${tee.color === 'white' ? 'is-active' : ''}" data-color="white" title="Blanco"></span>
                  <span class="swatch swatch--black ${tee.color === 'black' ? 'is-active' : ''}" data-color="black" title="Negro"></span>
                </div>
                <div class="ma-look-controls">
                  <div class="ma-look-sizes" id="ma-look-sizes-${tee.id}">${teeSizes}</div>
                  ${isTeeBundle ? '' : `
                  <div class="ma-look-qty" id="ma-look-qty-${tee.id}">
                    <button type="button" class="ma-look-qty__btn" data-action="dec" aria-label="−">−</button>
                    <span class="ma-look-qty__value" data-qty-value>1</span>
                    <button type="button" class="ma-look-qty__btn" data-action="inc" aria-label="+">+</button>
                  </div>
                  `}
                </div>
              </div>
            </div>
          </div>

          <div class="ma-look-footer">
            <div class="ma-look-prices">
              <span class="ma-look-old">${formatPrice(total)}</span>
              <span class="ma-look-final">${formatPrice(final)}</span>
            </div>
            <div class="ma-look-cta-row" style="display:flex; gap:1rem; width:100%; align-items:center;">
              ${isTeeBundle ? `
                <div class="ma-look-qty" id="ma-look-qty-bundle">
                  <button type="button" class="ma-look-qty__btn" data-action="dec-pdp-bundle" aria-label="−">−</button>
                  <span class="ma-look-qty__value" data-qty-value>2</span>
                  <button type="button" class="ma-look-qty__btn" data-action="inc-pdp-bundle" aria-label="+">+</button>
                </div>
              ` : ''}
              <div class="ma-look-cta" style="flex:1;">
                <button type="button" class="ma-look-btn" id="ma-look-add"
                  data-cta-buy="${buyCta}"
                  data-cta-view="${dict['product.bundle.view']}"
                  data-cta-added="${addedCta}">${buyCta}</button>
              <p class="ma-look-hint" id="ma-look-hint" hidden></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;
}

function bundleSizeInCart(bundleId) {
  const b = BUNDLES[bundleId];
  if (!b) return null;
  const jacketId = b.members[0];
  const jacketLine = cart.items.find(it => it.id === jacketId && it.bundleId === bundleId);
  return jacketLine ? jacketLine.size : null;
}

function updateBundleCTA(jacket) {
  const btn = document.getElementById('ma-look-add');
  const hint = document.getElementById('ma-look-hint');
  if (!btn || !jacket) return;
  const bundleId = jacket.id;
  const bundleSize = bundleSizeInCart(bundleId);
  const activeSizeEl = document.querySelector('#ma-look-sizes-' + bundleId + ' .size-btn.is-active');
  const activeSize = activeSizeEl ? activeSizeEl.getAttribute('data-size') : null;
  const dict = I18N[getLang()];

  // Mode: if there's a bundle in cart whose size matches the active selection (or no selection yet, default to "view"),
  // show "VER CARRITO". Otherwise "COMPRAR LOOK".
  const sameSize = bundleSize && (!activeSize || bundleSize === activeSize);
  if (sameSize) {
    btn.textContent = btn.dataset.ctaView;
    btn.dataset.mode = 'view';
  } else {
    btn.textContent = btn.dataset.ctaBuy;
    btn.dataset.mode = 'buy';
  }

  if (hint) {
    if (bundleSize && activeSize && bundleSize !== activeSize) {
      hint.textContent = (dict['product.bundle.alreadyInSize'] || '').replace('{size}', bundleSize);
      hint.hidden = false;
    } else {
      hint.hidden = true;
      hint.textContent = '';
    }
  }
}

function wireBundle(jacket, selectedTeeId = null) {
  const bundle = BUNDLES[jacket.id];
  if (!bundle) return;
  const teeId = selectedTeeId || window._maActiveBundleTeeId || bundle.members.find(id => id !== jacket.id);
  window._maActiveBundleTeeId = teeId;
  const tee = PRODUCTS[teeId];
  if (!tee) return;

  const btn = document.getElementById('ma-look-add');
  if (!btn) return;

  updateBundleCTA(jacket);

  // Register a single global listener for cart changes that targets the current bundle product.
  // Re-renders (language switch) reset window._maBundleProduct so we don't leak listeners.
  window._maBundleProduct = jacket;
  if (!window._maBundleListenerAttached) {
    document.addEventListener('cart:changed', () => {
      if (window._maBundleProduct) updateBundleCTA(window._maBundleProduct);
    });
    window._maBundleListenerAttached = true;
  }

  // Wire independent size selectors inside the bundle section
  [jacket.id, tee.id].forEach(memberId => {
    const container = document.getElementById('ma-look-sizes-' + memberId);
    if (!container) return;
    container.querySelectorAll('.size-btn').forEach(sBtn => {
      sBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent bubbling to any parent handlers
        container.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-active'));
        sBtn.classList.add('is-active');
        updateBundleCTA(jacket);
      });
    });
  });

  // Wire independent color selectors inside the bundle section
  [jacket.id, tee.id].forEach(memberId => {
    const colorContainer = document.getElementById('ma-look-colors-' + memberId);
    if (!colorContainer) return;
    colorContainer.querySelectorAll('.swatch').forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent click bubbling to parent handlers
        const chosenColor = swatch.getAttribute('data-color');
        if (memberId === jacket.id) return; // Jacket only has Black

        let newTeeId = 'MA-TE-WH'; // default White
        if (chosenColor === 'black') {
          newTeeId = 'MA-TE-BK';
        }
        if (newTeeId === window._maActiveBundleTeeId) return;

        // Save current selections
        const jacketSize = document.querySelector('#ma-look-sizes-' + jacket.id + ' .size-btn.is-active')?.getAttribute('data-size');
        const teeSize = document.querySelector('#ma-look-sizes-' + teeId + ' .size-btn.is-active')?.getAttribute('data-size');
        const jacketQty = document.querySelector('#ma-look-qty-' + jacket.id + ' [data-qty-value]')?.textContent || '1';
        const teeQty = document.querySelector('#ma-look-qty-' + teeId + ' [data-qty-value]')?.textContent || '1';

        // Update active Tee ID
        window._maActiveBundleTeeId = newTeeId;

        // Re-render bundle container with opacity fade to prevent white flash
        const bundleContainer = document.getElementById('pdp-bundle-container');
        if (bundleContainer) {
          bundleContainer.classList.add('is-swapping');
          requestAnimationFrame(() => {
            bundleContainer.innerHTML = renderBundleHTML(jacket, I18N[getLang()], newTeeId);
            
            // Re-wire and re-apply selections
            wireBundle(jacket, newTeeId);

            // Restore jacket size
            if (jacketSize) {
              const btn = document.querySelector('#ma-look-sizes-' + jacket.id + ' .size-btn[data-size="' + jacketSize + '"]');
              if (btn && !btn.classList.contains('is-disabled')) btn.classList.add('is-active');
            }
            // Restore tee size (if available in new Tee product)
            if (teeSize) {
              const btn = document.querySelector('#ma-look-sizes-' + newTeeId + ' .size-btn[data-size="' + teeSize + '"]');
              if (btn && !btn.classList.contains('is-disabled')) btn.classList.add('is-active');
            }
            // Restore Qty
            const jacketQtyEl = document.querySelector('#ma-look-qty-' + jacket.id + ' [data-qty-value]');
            if (jacketQtyEl) jacketQtyEl.textContent = jacketQty;
            const teeQtyEl = document.querySelector('#ma-look-qty-' + newTeeId + ' [data-qty-value]');
            if (teeQtyEl) teeQtyEl.textContent = teeQty;

            // Update bundle CTA
            updateBundleCTA(jacket);

            // Remove swapping class after re-render (fade back in)
            requestAnimationFrame(() => bundleContainer.classList.remove('is-swapping'));
          });
        }
      });
    });
  });

  // Wire qty steppers per item
  const isTeeBundlePDP = jacket.id === 'MA-TE-BK' || jacket.id === 'MA-TE-WH';
  if (isTeeBundlePDP) {
    const stepper = document.getElementById('ma-look-qty-bundle');
    if (stepper) {
      const valueEl = stepper.querySelector('[data-qty-value]');
      stepper.querySelectorAll('.ma-look-qty__btn').forEach(qBtn => {
        qBtn.addEventListener('click', () => {
          let n = parseInt(valueEl.textContent, 10) || 2;
          if (qBtn.dataset.action === 'inc-pdp-bundle' && n < 18) n += 2;
          if (qBtn.dataset.action === 'dec-pdp-bundle' && n > 2) n -= 2;
          valueEl.textContent = String(n);
          
          const bundleTotalPen = (jacket.pricePen + tee.pricePen) * (n / 2);
          const bundleTotalUsd = (jacket.priceUsd + tee.priceUsd) * (n / 2);
          const bundleFinalPen = bundleTotalPen - Math.round(bundleTotalPen * bundle.discountRate);
          const bundleFinalUsd = bundleTotalUsd - Math.round(bundleTotalUsd * bundle.discountRate);
          
          document.querySelector('.ma-look-prices .ma-look-old').textContent = formatPrice(isUsdRegion() ? bundleTotalUsd : bundleTotalPen);
          document.querySelector('.ma-look-prices .ma-look-final').textContent = formatPrice(isUsdRegion() ? bundleFinalUsd : bundleFinalPen);
        });
      });
    }
  } else {
    [jacket.id, tee.id].forEach(memberId => {
      const stepper = document.getElementById('ma-look-qty-' + memberId);
      if (!stepper) return;
      const valueEl = stepper.querySelector('[data-qty-value]');
      stepper.querySelectorAll('.ma-look-qty__btn').forEach(qBtn => {
        qBtn.addEventListener('click', () => {
          let n = parseInt(valueEl.textContent, 10) || 1;
          if (qBtn.dataset.action === 'inc' && n < 9) n += 1;
          if (qBtn.dataset.action === 'dec' && n > 1) n -= 1;
          valueEl.textContent = String(n);
        });
      });
    });
  }

  btn.addEventListener('click', () => {
    if (btn.disabled) return;

    if (btn.dataset.mode === 'view') {
      openCart();
      return;
    }

    const jacketSizeEl = document.querySelector('#ma-look-sizes-' + jacket.id + ' .size-btn.is-active');
    const teeSizeEl    = document.querySelector('#ma-look-sizes-' + tee.id    + ' .size-btn.is-active');
    if (!jacketSizeEl || !teeSizeEl) {
      showToast(t('toast.select_size'));
      [jacket.id, tee.id].forEach(mid => {
        const el = document.getElementById('ma-look-sizes-' + mid);
        if (!el || el.querySelector('.size-btn.is-active')) return;
        el.classList.add('is-pulsing');
        setTimeout(() => el.classList.remove('is-pulsing'), 800);
      });
      return;
    }
    const jacketSize = jacketSizeEl.getAttribute('data-size');
    const teeSize    = teeSizeEl.getAttribute('data-size');
    let jacketQty = 1;
    let teeQty = 1;
    if (isTeeBundlePDP) {
      const bundleQty = parseInt(document.querySelector('#ma-look-qty-bundle [data-qty-value]')?.textContent, 10) || 2;
      jacketQty = bundleQty / 2;
      teeQty = bundleQty / 2;
    } else {
      jacketQty = parseInt(document.querySelector('#ma-look-qty-' + jacket.id + ' [data-qty-value]')?.textContent, 10) || 1;
      teeQty    = parseInt(document.querySelector('#ma-look-qty-' + tee.id    + ' [data-qty-value]')?.textContent, 10) || 1;
    }

    btn.disabled = true;
    btn.style.opacity = '0.6';

    const jacketEl = document.querySelector('.ma-look-item[data-bundle-member="' + jacket.id + '"] .ma-look-item__media');
    const teeEl    = document.querySelector('.ma-look-item[data-bundle-member="' + tee.id + '"] .ma-look-item__media');
    if (jacketEl) animateAddToCart(jacketEl);
    setTimeout(() => {
      if (teeEl && teeEl.isConnected) animateAddToCart(teeEl);
    }, 120);

    // Promote any existing untagged items to bundled lines (only when adding qty 1 — preserves visual order)
    const jacketIdx = jacketQty === 1 && !isTeeBundlePDP ? cart.promoteToBundle(jacket.id, jacketSize, jacket.id) : -1;
    cart.addAt({
      id: jacket.id,
      name: jacket.name,
      color: jacket.color,
      size: jacketSize,
      priceUsd: jacket.priceUsd,
      pricePen: jacket.pricePen,
      qty: jacketQty,
      bundleId: isTeeBundlePDP ? null : jacket.id
    }, jacketIdx);

    const teeIdx = teeQty === 1 && !isTeeBundlePDP ? cart.promoteToBundle(tee.id, teeSize, jacket.id) : -1;
    cart.addAt({
      id: tee.id,
      name: tee.name,
      color: tee.color,
      size: teeSize,
      priceUsd: tee.priceUsd,
      pricePen: tee.pricePen,
      qty: teeQty,
      bundleId: isTeeBundlePDP ? null : jacket.id
    }, teeIdx);

    btn.textContent = btn.dataset.ctaAdded;
    setTimeout(() => {
      btn.disabled = false;
      btn.style.opacity = '';
      updateBundleCTA(jacket);
    }, 800);

    showToast(t('toast.added'));
    setTimeout(openCart, 280);
  });
}

// ─────────────────────────────────────────────────────────────────────────────
// Reviews — UI rendering & wiring
// ─────────────────────────────────────────────────────────────────────────────
// Render a single star SVG. `fillRatio` ∈ [0..1]: 0 empty, 1 fully filled, fractional → partial.
function renderStarSVG(fillRatio, px) {
  const path = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77 5.82 21.02 7 14.14 2 9.27l6.91-1.01z';
  const ratio = Math.max(0, Math.min(1, fillRatio));
  // Inline-styled fg path: hidden when 0, full when 1, clipped when partial.
  let fgStyle = '';
  if (ratio <= 0)        fgStyle = 'display:none';
  else if (ratio < 1)    fgStyle = `clip-path: inset(0 ${((1 - ratio) * 100).toFixed(2)}% 0 0)`;
  return `<svg viewBox="0 0 24 24" width="${px}" height="${px}" class="star" aria-hidden="true">
    <path d="${path}" fill="#d4d4d4"/>
    <path d="${path}" fill="#000" style="${fgStyle}"/>
  </svg>`;
}

function renderStars(rating, size) {
  const sz = size || 'sm';
  const px = sz === 'lg' ? 28 : sz === 'md' ? 18 : 13;
  const items = [1, 2, 3, 4, 5].map(i => renderStarSVG(rating - (i - 1), px)).join('');
  return `<span class="stars stars--${sz}" aria-label="${rating} / 5">${items}</span>`;
}

function formatReviewDate(iso) {
  if (!iso) return '';
  const parts = iso.split('-');
  if (parts.length !== 3) return iso;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

// ─────────────────────────────────────────────────────────────────────────────
// THE MARK ALTITUDE DIFFERENCE — Brand storytelling section (global across all PDPs)
// ─────────────────────────────────────────────────────────────────────────────
function renderDifferenceMarkHTML(dict) {
  const panels = [
    { img: 'diff-peru.jpeg', labelKey: 'diff.peru' },
    { img: 'diff-care.jpeg', labelKey: 'diff.care' },
    { img: 'diff-made.png', labelKey: 'diff.last' }
  ];
  return `
    <section class="difference-mark" data-header-mode="hidden">
      <div class="difference-mark__inner">
        <h2 class="difference-mark__heading" data-reveal="up-sm">${dict['diff.heading']}</h2>
        <div class="difference-mark__grid" data-reveal-stagger="120">
          ${panels.map(p => `
            <div class="difference-mark__item" data-reveal="up-sm">
              <img class="difference-mark__img" src="${getAssetUrl(p.img)}" alt="${dict[p.labelKey]}" loading="lazy">
              <div class="difference-mark__overlay">
                <span class="difference-mark__label">${dict[p.labelKey]}</span>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    </section>
  `;
}

const REVIEW_TRANSLATIONS_EN = {
  // T-01 ESSENTIAL PIMA — BLACK
  'buen polo, recomendado': 'Great T-shirt, recommended.',
  'buena calidad y buen fit, pedi m y me quedo perfecto (1.72 - 77 kg)': 'Great quality and fit. I ordered size M and it fit me perfectly (1.72 m - 77 kg).',
  'buena calidad y buen fit, pedí m y me quedo perfecto (1.72 - 77 kg)': 'Great quality and fit. I ordered size M and it fit me perfectly (1.72 m - 77 kg).',
  'ya lo lave unas tres veces y sigue igual, 100% recomendado': "I've washed it about three times and it still looks the same. 100% recommended.",
  'ya lo lavé unas tres veces y sigue igual, 100% recomendado': "I've washed it about three times and it still looks the same. 100% recommended.",
  'el mejor basico, la tela es muy suave y es regular fit': 'The perfect basic. The fabric is very soft and it has a regular fit.',
  'el mejor básico, la tela es muy suave y es regular fit': 'The perfect basic. The fabric is very soft and it has a regular fit.',

  // T-01 ESSENTIAL PIMA — WHITE
  'compre primero el negro y luego pedi este, excelente calidad': 'I bought the black one first and then ordered this one. Excellent quality.',
  'compré primero el negro y luego pedí este, excelente calidad': 'I bought the black one first and then ordered this one. Excellent quality.',
  'el algodon pima se siente muy suave, buenos acabados': 'The Pima cotton feels very soft and the finishing is excellent.',
  'el algodón pima se siente muy suave, buenos acabados': 'The Pima cotton feels very soft and the finishing is excellent.',
  'el corte es regular fit y el cuello no se deforma, me encanto el polo': 'It has a regular fit and the collar keeps its shape. I loved the T-shirt.',
  'el corte es regular fit y el cuello no se deforma, me encantó el polo': 'It has a regular fit and the collar keeps its shape. I loved the T-shirt.',
  'todo bien con el polo, el sistema de tallas muy practico': 'Everything is great with the T-shirt. The sizing system is very practical.',
  'todo bien con el polo, el sistema de tallas muy práctico': 'Everything is great with the T-shirt. The sizing system is very practical.',

  // J-01 DOWN JACKET — BLACK
  'abriga muy bien, es ligera y no hace sudar 100% recomendada': "It keeps me very warm, it's lightweight and doesn't make me sweat. 100% recommended.",
  'llevaba tiempo buscando una casaca asi y la talla me quedo perfecta (soy talla m 1.70 - 75 kg)': "I'd been looking for a jacket like this for a while and the size fit me perfectly (I'm size M, 1.70 m - 75 kg).",
  'llevaba tiempo buscando una casaca así y la talla me quedó perfecta (soy talla m 1.70 - 75 kg)': "I'd been looking for a jacket like this for a while and the size fit me perfectly (I'm size M, 1.70 m - 75 kg).",
  'llevaba tiempo buscando una casaca asi y la talla me quedo perfecta (soy talla m, 1.70 m - 75 kg)': "I'd been looking for a jacket like this for a while and the size fit me perfectly (I'm size M, 1.70 m - 75 kg).",
  'llevaba tiempo buscando una casaca así y la talla me quedó perfecta (soy talla m, 1.70 m - 75 kg)': "I'd been looking for a jacket like this for a while and the size fit me perfectly (I'm size M, 1.70 m - 75 kg).",
  'feliz con la compra,combina con todo': 'Very happy with the purchase. It goes with everything.',
  'feliz con la compra, combina con todo': 'Very happy with the purchase. It goes with everything.',
  'me gusta que no se vea tan inflada como otras casacas, abriga rico': "I like that it doesn't look as puffy as other jackets. It keeps me really warm.",

  // C-01 TRAVEL DUFFEL
  'me encanto, lo uso siempre para viajar': 'I loved it. I use it every time I travel.',
  'me encantó, lo uso siempre para viajar': 'I loved it. I use it every time I travel.',
  'es bastante espacioso y facil de llevar, lo recomiendo': "It's very spacious and easy to carry. I recommend it.",
  'es bastante espacioso y fácil de llevar, lo recomiendo': "It's very spacious and easy to carry. I recommend it.",
  'me gusto mucho que se pueda abrir todo para llevar terno y guardar la ropa': 'I really like that it opens fully, making it easy to carry a suit and pack my clothes.',
  'me gustó mucho que se pueda abrir todo para llevar terno y guardar la ropa': 'I really like that it opens fully, making it easy to carry a suit and pack my clothes.',
  'excelente calidad y acabados': 'Excellent quality and finishing.',
  'el cuero es hermoso tiene un olor particular y entran muchas cosas, buena compra': 'The leather is beautiful, it has that distinctive leather smell, and it holds a lot. Great purchase.'
};

function stripDiacritics(str) {
  return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

// ── MARK ALTITUDE REVIEWS ARCHITECTURE (PHASES 2, 3 & 4) ──
// Judge.me DOM = Engine / Data Source (unmodified & non-destructively hidden)
// MARK DOM = Visual Presentation (.ma-reviews-list)

const _maReviewsCache = new Map();
let _maVisibleCount = 5;
let _maIsFetching = false;
let _maFetchTimeoutId = null;
let _maReviewsStableObserver = null;

function extractReviewData(card) {
  if (!card) return null;
  const id = card.getAttribute('data-review-id') ||
             card.getAttribute('data-id') ||
             (card.dataset ? (card.dataset.reviewId || card.dataset.id) : '') ||
             '';

  const ratingEl = card.querySelector('.jdgm-rev__rating');
  let rating = 5;
  if (ratingEl) {
    const scoreAttr = ratingEl.getAttribute('data-score');
    if (scoreAttr) rating = parseFloat(scoreAttr) || 5;
    else {
      const fullStars = ratingEl.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm-star--on').length;
      if (fullStars > 0) rating = fullStars;
    }
  }

  const authorEl = card.querySelector('.jdgm-rev__author');
  const author = (authorEl ? authorEl.textContent : '') || 'Anónimo';

  const timestampEl = card.querySelector('.jdgm-rev__timestamp');
  const date = (timestampEl ? timestampEl.textContent : '') || '';

  const bodyEl = card.querySelector('.jdgm-rev__body');
  const bodyHTML = bodyEl ? bodyEl.innerHTML : '';
  const bodyText = bodyEl ? (bodyEl.textContent || '').trim() : '';

  const verifiedBuyer = card.getAttribute('data-verified-buyer') === 'true' ||
                        card.querySelector('.jdgm-rev__buyer-badge, .jdgm-verified-badge') !== null;

  const pictures = [];
  const picEls = card.querySelectorAll('.jdgm-rev__pic-link, .jdgm-rev__pic-img, .jdgm-rev__pics img');
  picEls.forEach(img => {
    const src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('href');
    if (src && !pictures.includes(src)) pictures.push(src);
  });

  const finalId = id || `${author.trim()}_${date.trim()}_${bodyText.substring(0, 40)}`;

  return {
    id: finalId,
    rating,
    author: author.trim(),
    date: date.trim(),
    bodyHTML,
    bodyText,
    verifiedBuyer,
    pictures
  };
}

function ingestJudgeMeReviews(reviewsContainer) {
  const source = reviewsContainer.querySelector('#ma-judgeme-visual-source') || reviewsContainer;
  const cards = source.querySelectorAll('.jdgm-rev');
  let newCount = 0;
  cards.forEach(card => {
    const data = extractReviewData(card);
    if (data && !_maReviewsCache.has(data.id)) {
      _maReviewsCache.set(data.id, data);
      newCount++;
    }
  });
  return newCount;
}

function getTotalReviewCount(reviewsContainer) {
  const widg = reviewsContainer.querySelector('.jdgm-rev-widg');
  let total = _maReviewsCache.size;
  if (widg && widg.dataset.numberOfReviews) {
    const parsed = parseInt(widg.dataset.numberOfReviews, 10);
    if (!isNaN(parsed) && parsed > total) total = parsed;
  }
  const summaryText = reviewsContainer.querySelector('.jdgm-rev-widg__summary-text, .ma-summary-left');
  if (summaryText) {
    const m = (summaryText.textContent || '').match(/(\d+)\s*(?:reseñas?|reviews?)/i);
    if (m) {
      const parsed = parseInt(m[1], 10);
      if (!isNaN(parsed) && parsed > total) total = parsed;
    }
  }
  return Math.max(total, _maReviewsCache.size);
}

function renderMarkReviewCard(data, isEn) {
  const article = document.createElement('article');
  article.className = 'ma-review';
  article.setAttribute('data-review-id', data.id);

  // Meta row: Rating left, Date right
  const meta = document.createElement('div');
  meta.className = 'ma-review-meta';

  const ratingDiv = document.createElement('div');
  ratingDiv.className = 'jdgm-rev__rating';
  ratingDiv.setAttribute('data-score', data.rating);
  ratingDiv.setAttribute('tabindex', '0');
  ratingDiv.setAttribute('aria-label', `${data.rating} / 5`);

  for (let i = 1; i <= 5; i++) {
    const star = document.createElement('span');
    star.className = `jdgm-star jdgm--font ${i <= Math.round(data.rating) ? 'jdgm--on' : 'jdgm--off'}`;
    ratingDiv.appendChild(star);
  }
  meta.appendChild(ratingDiv);

  const timestamp = document.createElement('span');
  timestamp.className = 'jdgm-rev__timestamp';
  let formattedDate = data.date;
  if (isEn && formattedDate) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dmy = formattedDate.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (dmy) {
      const day = dmy[1];
      const mIdx = parseInt(dmy[2], 10) - 1;
      const year = dmy[3];
      if (mIdx >= 0 && mIdx < 12) {
        formattedDate = `${day} ${months[mIdx]} ${year}`;
      }
    }
  }
  timestamp.textContent = formattedDate;
  meta.appendChild(timestamp);

  // Author row
  const author = document.createElement('div');
  author.className = 'ma-review-author';
  author.textContent = data.author;

  if (data.verifiedBuyer) {
    const badge = document.createElement('span');
    badge.className = 'ma-review-verified-badge';
    badge.textContent = isEn ? 'VERIFIED PURCHASE' : 'COMPRA VERIFICADA';
    author.appendChild(badge);
  }

  // Body
  const body = document.createElement('div');
  body.className = 'ma-review-body';
  let bodyText = data.bodyText;
  if (isEn && bodyText) {
    const cleanKey = bodyText.toLowerCase().replace(/\s+/g, ' ');
    const unaccentedKey = stripDiacritics(cleanKey);
    const translated = REVIEW_TRANSLATIONS_EN[cleanKey] ||
                       REVIEW_TRANSLATIONS_EN[unaccentedKey] ||
                       REVIEW_TRANSLATIONS_EN[cleanKey.replace(/[.,]/g, '')] ||
                       REVIEW_TRANSLATIONS_EN[unaccentedKey.replace(/[.,]/g, '')] ||
                       REVIEW_TRANSLATIONS_EN[cleanKey.replace(/\.$/, '')] ||
                       REVIEW_TRANSLATIONS_EN[unaccentedKey.replace(/\.$/, '')];
    if (translated) {
      bodyText = translated;
    }
  }

  if (data.bodyHTML && !isEn) {
    body.innerHTML = data.bodyHTML;
  } else {
    body.textContent = bodyText;
  }

  article.appendChild(meta);
  article.appendChild(author);
  article.appendChild(body);

  if (data.pictures && data.pictures.length > 0) {
    const pics = document.createElement('div');
    pics.className = 'jdgm-rev__pics';
    data.pictures.forEach(src => {
      const a = document.createElement('a');
      a.className = 'jdgm-rev__pic-link';
      a.href = src;
      a.target = '_blank';
      const img = document.createElement('img');
      img.className = 'jdgm-rev__pic-img';
      img.src = src;
      a.appendChild(img);
      pics.appendChild(a);
    });
    article.appendChild(pics);
  }

  return article;
}

function updatePaginationControls(reviewsContainer, totalCount, loadedCount, visibleCount, isEn) {
  let controls = reviewsContainer.querySelector('.ma-reviews-pagination-controls');
  if (!controls) {
    controls = document.createElement('div');
    controls.className = 'ma-reviews-pagination-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', isEn ? 'Review pagination controls' : 'Controles de paginación de reseñas');

    const markList = reviewsContainer.querySelector('.ma-reviews-list');
    if (markList) {
      markList.insertAdjacentElement('afterend', controls);
    } else {
      const container = reviewsContainer.querySelector('.container') || reviewsContainer;
      container.appendChild(controls);
    }
  } else {
    controls.setAttribute('aria-label', isEn ? 'Review pagination controls' : 'Controles de paginación de reseñas');
    const markList = reviewsContainer.querySelector('.ma-reviews-list');
    if (markList && controls.previousElementSibling !== markList) {
      markList.insertAdjacentElement('afterend', controls);
    }
  }

  let showMoreBtn = controls.querySelector('.ma-show-more-reviews-btn');
  let showLessBtn = controls.querySelector('.ma-show-less-reviews-btn');

  const INITIAL_VISIBLE = 5;

  if (totalCount <= INITIAL_VISIBLE && loadedCount <= INITIAL_VISIBLE) {
    controls.style.setProperty('display', 'none', 'important');
    return;
  }

  controls.style.setProperty('display', 'flex', 'important');

  const textShowMore = isEn ? 'SHOW MORE' : 'MOSTRAR MÁS';
  const textShowLess = isEn ? 'SHOW LESS' : 'MOSTRAR MENOS';

  const hasMoreToReveal = visibleCount < totalCount || loadedCount < totalCount;
  if (hasMoreToReveal) {
    if (!showMoreBtn) {
      showMoreBtn = document.createElement('button');
      showMoreBtn.type = 'button';
      showMoreBtn.className = 'ma-show-more-reviews-btn';
      controls.appendChild(showMoreBtn);
    }
    showMoreBtn.textContent = textShowMore;
    showMoreBtn.setAttribute('aria-label', textShowMore);
    showMoreBtn.setAttribute('aria-expanded', visibleCount > INITIAL_VISIBLE ? 'true' : 'false');
    showMoreBtn.style.setProperty('display', 'inline-block', 'important');

    if (!_maIsFetching) {
      showMoreBtn.disabled = false;
      showMoreBtn.removeAttribute('aria-busy');
    }

    if (!showMoreBtn._hasMaListener) {
      showMoreBtn._hasMaListener = true;
      showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        handleShowMore(reviewsContainer, isEn);
      });
    }
  } else {
    if (showMoreBtn) showMoreBtn.style.setProperty('display', 'none', 'important');
  }

  if (visibleCount > INITIAL_VISIBLE) {
    if (!showLessBtn) {
      showLessBtn = document.createElement('button');
      showLessBtn.type = 'button';
      showLessBtn.className = 'ma-show-less-reviews-btn';
      controls.appendChild(showLessBtn);
    }
    showLessBtn.textContent = textShowLess;
    showLessBtn.setAttribute('aria-label', textShowLess);
    showLessBtn.style.setProperty('display', 'inline-block', 'important');

    if (!showLessBtn._hasMaListener) {
      showLessBtn._hasMaListener = true;
      showLessBtn.addEventListener('click', (e) => {
        e.preventDefault();
        handleShowLess(reviewsContainer, isEn);
      });
    }
  } else {
    if (showLessBtn) showLessBtn.style.setProperty('display', 'none', 'important');
  }

  if (showMoreBtn && showLessBtn) {
    controls.appendChild(showMoreBtn);
    controls.appendChild(showLessBtn);
  }
}

function renderMarkReviewsList(reviewsContainer, isEn) {
  let markList = reviewsContainer.querySelector('.ma-reviews-list');
  const visualSource = reviewsContainer.querySelector('#ma-judgeme-visual-source') || reviewsContainer;
  const headerBlock = visualSource.querySelector('.jdgm-rev-widg__header') || visualSource.querySelector('.jdgm-row-stars') || visualSource.querySelector('.jdgm-rev-widg__summary');

  if (!markList) {
    markList = document.createElement('div');
    markList.className = 'ma-reviews-list';
    if (headerBlock) {
      headerBlock.insertAdjacentElement('afterend', markList);
    } else if (visualSource && visualSource.parentNode) {
      visualSource.parentNode.insertBefore(markList, visualSource);
    } else {
      const container = reviewsContainer.querySelector('.container') || reviewsContainer;
      container.appendChild(markList);
    }
  } else if (headerBlock && markList.previousElementSibling !== headerBlock) {
    headerBlock.insertAdjacentElement('afterend', markList);
  }

  ingestJudgeMeReviews(reviewsContainer);

  const totalCount = getTotalReviewCount(reviewsContainer);
  const loadedCount = _maReviewsCache.size;
  const visibleCount = _maVisibleCount;

  // Render visible cards into MARK list
  markList.innerHTML = '';
  let count = 0;
  for (const [id, data] of _maReviewsCache.entries()) {
    if (count >= visibleCount) break;
    const article = renderMarkReviewCard(data, isEn);
    markList.appendChild(article);
    count++;
  }

  updatePaginationControls(reviewsContainer, totalCount, loadedCount, visibleCount, isEn);
}

function handleShowMore(reviewsContainer, isEn) {
  if (_maIsFetching) return;

  ingestJudgeMeReviews(reviewsContainer);
  const totalCount = getTotalReviewCount(reviewsContainer);
  const loadedCount = _maReviewsCache.size;

  // 1. Cache first
  if (_maVisibleCount < loadedCount) {
    _maVisibleCount = Math.min(_maVisibleCount + 5, loadedCount);
    renderMarkReviewsList(reviewsContainer, isEn);
    return;
  }

  // 2. Fetch next batch from Judge.me engine
  if (loadedCount < totalCount) {
    _maIsFetching = true;
    const controls = reviewsContainer.querySelector('.ma-reviews-pagination-controls');
    const showMoreBtn = controls ? controls.querySelector('.ma-show-more-reviews-btn') : null;
    if (showMoreBtn) {
      showMoreBtn.disabled = true;
      showMoreBtn.setAttribute('aria-busy', 'true');
    }

    const nextPageIndex = Math.floor(loadedCount / 5) + 1;
    const source = reviewsContainer.querySelector('#ma-judgeme-visual-source') || reviewsContainer;

    // Fail-safe 8s
    if (_maFetchTimeoutId) clearTimeout(_maFetchTimeoutId);
    _maFetchTimeoutId = setTimeout(() => {
      if (_maIsFetching) {
        console.warn('[MARK Reviews] Judge.me pagination timeout');
        _maIsFetching = false;
        if (showMoreBtn) {
          showMoreBtn.disabled = false;
          showMoreBtn.removeAttribute('aria-busy');
        }
        renderMarkReviewsList(reviewsContainer, isEn);
      }
    }, 8000);

    // Disparar paginación nativa Judge.me
    const pageBtn = source.querySelector(`.jdgm-paginate__page[data-page="${nextPageIndex}"]`) ||
                    source.querySelector('.jdgm-paginate__next-page') ||
                    source.querySelector('.jdgm-paginate__page:not(.jdgm-curt):not(.jdgm-cur-page)');

    if (pageBtn) {
      const jdgm = window.jdgm || window.judgeme || {};
      const $ = jdgm.$ || window.jQuery;
      if ($) {
        $(pageBtn).trigger('click');
      }
      pageBtn.click();
      pageBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }

    // Carga de lote a través del motor Judge.me API
    const jdgm = window.jdgm || window.judgeme || {};
    const shopParams = jdgm.shopParams ? jdgm.shopParams() : { url: window.location.hostname, shop_domain: '9b64fv-9m.myshopify.com', platform: 'shopify' };
    const widg = source.querySelector('.jdgm-rev-widg') || source;
    const productId = widg.getAttribute('data-id') || (widg.dataset ? widg.dataset.id : '') || '8846865924295';
    const params = Object.assign({}, shopParams, {
      page: nextPageIndex,
      per_page: 5,
      product_id: productId
    });

    const apiUrl = "https://api.judge.me/reviews/reviews_for_widget?" + new URLSearchParams(params).toString();
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        if (data && data.reviews && data.reviews.length > 0) {
          data.reviews.forEach(r => {
            const revObj = {
              id: r.uuid || r.id,
              rating: r.rating || 5,
              author: r.reviewer_name || 'Anónimo',
              date: r.created_at ? r.created_at.substring(0, 10) : '',
              bodyHTML: r.body_html || '',
              bodyText: r.body_html ? r.body_html.replace(/<[^>]+>/g, '').trim() : '',
              verifiedBuyer: !!r.verified_buyer,
              pictures: r.pictures_urls || []
            };
            if (!_maReviewsCache.has(revObj.id)) {
              _maReviewsCache.set(revObj.id, revObj);
            }
          });

          if (_maIsFetching) {
            _maVisibleCount = Math.min(_maVisibleCount + 5, _maReviewsCache.size);
            _maIsFetching = false;
            if (_maFetchTimeoutId) clearTimeout(_maFetchTimeoutId);
            if (showMoreBtn) {
              showMoreBtn.disabled = false;
              showMoreBtn.removeAttribute('aria-busy');
            }
            renderMarkReviewsList(reviewsContainer, isEn);
          }
        }
      })
      .catch(err => {
        console.warn('[MARK Reviews] Error fetching next page:', err);
      });
  }
}

function handleShowLess(reviewsContainer, isEn) {
  _maVisibleCount = 5;
  renderMarkReviewsList(reviewsContainer, isEn);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reviewsSection = document.getElementById('reviews') || document.getElementById('product-reviews-section') || reviewsContainer;
  if (reviewsSection) {
    reviewsSection.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  }
}

function attachStableJudgeMeObserver(reviewsContainer, isEn) {
  const source = reviewsContainer.querySelector('#ma-judgeme-visual-source') || reviewsContainer;
  if (!source) return;

  if (_maReviewsStableObserver) {
    _maReviewsStableObserver.disconnect();
  }

  _maReviewsStableObserver = new MutationObserver(() => {
    const added = ingestJudgeMeReviews(reviewsContainer);
    if (added > 0) {
      if (_maIsFetching) {
        _maVisibleCount = Math.min(_maVisibleCount + 5, _maReviewsCache.size);
        _maIsFetching = false;
        if (_maFetchTimeoutId) clearTimeout(_maFetchTimeoutId);
      }
      renderMarkReviewsList(reviewsContainer, isEn);
    }
  });

  _maReviewsStableObserver.observe(source, {
    childList: true,
    subtree: true
  });
}

function applyJudgeMeTransforms() {
  if (window._maIsApplyingJudgeMeTransforms) return;
  window._maIsApplyingJudgeMeTransforms = true;

  try {
    const reviewsContainer = document.getElementById('reviews') || document.getElementById('product-reviews-section');
    if (!reviewsContainer) return;

    // 1. Clean non-review elements in header / summary only
    const jdgmTitle = reviewsContainer.querySelector('.jdgm-rev-widg__title');
    if (jdgmTitle) jdgmTitle.style.display = 'none';

    // Summary formatting
    const summaryInner = reviewsContainer.querySelector('.jdgm-rev-widg__summary-inner') || reviewsContainer.querySelector('.jdgm-rev-widg__summary');
    const summaryStars = reviewsContainer.querySelector('.jdgm-rev-widg__summary-stars');
    const widg = reviewsContainer.querySelector('.jdgm-rev-widg');

    if (summaryInner) {
      if (summaryStars) summaryStars.remove();

      const nativeSummaryTexts = summaryInner.querySelectorAll('.jdgm-rev-widg__summary-text, .jdgm-prev-badge__text');
      nativeSummaryTexts.forEach(el => {
        if (!el.classList.contains('ma-summary-based-on')) {
          el.style.display = 'none';
        }
      });

      let avgRating = 4.75;
      if (widg && widg.dataset.averageRating) {
        avgRating = parseFloat(widg.dataset.averageRating) || 4.75;
      } else if (summaryStars && summaryStars.getAttribute('data-score')) {
        avgRating = parseFloat(summaryStars.getAttribute('data-score')) || 4.75;
      }

      let revCount = 4;
      if (widg && widg.dataset.numberOfReviews) {
        const p = parseInt(widg.dataset.numberOfReviews, 10);
        if (!isNaN(p) && p > 0) revCount = p;
      }

      const isEnPage = (typeof isInternationalMarket === 'function' && isInternationalMarket()) ||
                       (typeof getLang === 'function' && getLang() === 'en') ||
                       window.location.pathname.startsWith('/en-international') ||
                       ((document.documentElement.lang || document.documentElement.getAttribute('lang') || document.documentElement.getAttribute('data-lang') || '').startsWith('en'));

      const basedOnText = isEnPage
        ? (revCount === 1 ? 'BASED ON 1 REVIEW' : `BASED ON ${revCount} REVIEWS`)
        : (revCount === 1 ? 'BASADO EN 1 RESEÑA' : `BASADO EN ${revCount} RESEÑAS`);

      const roundedRating = Math.round(avgRating * 10) / 10;
      const displayAvgScore = Number.isInteger(roundedRating) ? `${roundedRating} / 5` : `${roundedRating.toFixed(1)} / 5`;

      let leftCol = summaryInner.querySelector('.ma-summary-left');
      if (!leftCol) {
        leftCol = document.createElement('div');
        leftCol.className = 'ma-summary-left';

        const starsEl = document.createElement('span');
        starsEl.className = 'ma-average-stars';
        starsEl.style.setProperty('--rating', avgRating);
        starsEl.setAttribute('aria-label', displayAvgScore);
        leftCol.appendChild(starsEl);

        const avgEl = document.createElement('div');
        avgEl.className = 'ma-summary-avg-score';
        avgEl.textContent = displayAvgScore;
        leftCol.appendChild(avgEl);

        const basedOnEl = document.createElement('span');
        basedOnEl.className = 'ma-summary-based-on';
        basedOnEl.textContent = basedOnText;
        leftCol.appendChild(basedOnEl);

        summaryInner.insertBefore(leftCol, summaryInner.firstChild);
      } else {
        let starsEl = leftCol.querySelector('.ma-average-stars');
        if (!starsEl) {
          starsEl = document.createElement('span');
          starsEl.className = 'ma-average-stars';
          leftCol.appendChild(starsEl);
        }
        starsEl.style.setProperty('--rating', avgRating);
        starsEl.setAttribute('aria-label', displayAvgScore);

        let avgEl = leftCol.querySelector('.ma-summary-avg-score');
        if (!avgEl) {
          avgEl = document.createElement('div');
          avgEl.className = 'ma-summary-avg-score';
          leftCol.appendChild(avgEl);
        }
        avgEl.textContent = displayAvgScore;

        let basedOnEl = leftCol.querySelector('.ma-summary-based-on');
        if (!basedOnEl) {
          basedOnEl = document.createElement('span');
          basedOnEl.className = 'ma-summary-based-on';
          leftCol.appendChild(basedOnEl);
        }
        basedOnEl.textContent = basedOnText;
      }
    }

    const isEn = (typeof isInternationalMarket === 'function' && isInternationalMarket()) ||
                 (typeof getLang === 'function' && getLang() === 'en') ||
                 window.location.pathname.startsWith('/en-international') ||
                 ((document.documentElement.lang || document.documentElement.getAttribute('lang') || document.documentElement.getAttribute('data-lang') || '').startsWith('en'));

    // 2. Render MARK visual presentation
    renderMarkReviewsList(reviewsContainer, isEn);
    attachStableJudgeMeObserver(reviewsContainer, isEn);
  } finally {
    window._maIsApplyingJudgeMeTransforms = false;
  }
}

function initJudgeMeObserver() {
  const reviewsContainer = document.getElementById('reviews') || document.getElementById('product-reviews-section');
  if (!reviewsContainer) return;

  applyJudgeMeTransforms();

  if (window._jdgmReviewObserver) {
    window._jdgmReviewObserver.disconnect();
  }

  let debounceTimer = null;
  window._jdgmReviewObserver = new MutationObserver(() => {
    if (window._maIsApplyingJudgeMeTransforms) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      applyJudgeMeTransforms();
    }, 50);
  });

  window._jdgmReviewObserver.observe(reviewsContainer, {
    childList: true,
    subtree: false,
    characterData: false
  });

  [100, 300, 800, 1500, 3000].forEach(delay => {
    setTimeout(applyJudgeMeTransforms, delay);
  });
}

// Ensure listeners are registered for Judge.me lifecycle events
if (typeof document !== 'undefined') {
  document.addEventListener('jdgm.widgetLoaded', initJudgeMeObserver);
  document.addEventListener('jdgm.doneSetup', initJudgeMeObserver);
  document.addEventListener('DOMContentLoaded', initJudgeMeObserver);
  window.addEventListener('load', initJudgeMeObserver);
}

function wireReviews(product) {
  // Initialize Judge.me translation observer
  initJudgeMeObserver();

  // Accessible photo lightbox for review photo thumbnails
  document.addEventListener('click', e => {
    const img = e.target.closest('.jdgm-rev__photo, .jdgm-rev__pic-link img, .jdgm-rev__pic-img, .review-card__photo');
    if (!img) return;
    openPhotoLightbox(img.dataset.src || img.src);
  });
}

function openPhotoLightbox(src) {
  if (!src) return;
  let box = document.getElementById('review-lightbox');
  if (!box) {
    box = document.createElement('div');
    box.id = 'review-lightbox';
    box.className = 'review-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Review Photo');
    box.innerHTML = `<button class="review-lightbox__close" aria-label="Close">&#10005;</button><img class="review-lightbox__img" alt="Review Photo">`;
    document.body.appendChild(box);
    box.addEventListener('click', e => {
      if (e.target === box || e.target.closest('.review-lightbox__close')) {
        box.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && box.classList.contains('is-open')) {
        box.classList.remove('is-open');
      }
    });
  }
  const imgEl = box.querySelector('img');
  if (imgEl) imgEl.src = src;
  box.classList.add('is-open');
}

function renderCompleteSystem(currentProduct, dict) {
  const grid = document.getElementById('complete-system-grid');
  const section = grid ? grid.closest('.complete-system') : null;
  if (!grid) return;

  // Determine system products to display:
  // If current is T-01 Black (MA-TE-BK) -> show T-01 White (MA-TE-WH), J-01 (MA-DJ-01) and C-01 (MA-DF-01)
  // If current is T-01 White (MA-TE-WH) -> show T-01 Black (MA-TE-BK), J-01 (MA-DJ-01) and C-01 (MA-DF-01)
  // If current is J-01 (MA-DJ-01) -> show T-01 Black (MA-TE-BK), T-01 White (MA-TE-WH) and C-01 (MA-DF-01)
  // If current is C-01 (MA-DF-01) -> show T-01 Black (MA-TE-BK), T-01 White (MA-TE-WH) and J-01 (MA-DJ-01)
  const pid = currentProduct ? (currentProduct.id || '') : '';
  const handle = currentProduct ? (currentProduct.handle || '') : '';
  let ids = [];
  if (pid === 'MA-TE-BK' || handle.includes('polo-negro')) {
    ids = ['MA-TE-WH', 'MA-DJ-01', 'MA-DF-01'];
  } else if (pid === 'MA-TE-WH' || handle.includes('polo-blanco')) {
    ids = ['MA-TE-BK', 'MA-DJ-01', 'MA-DF-01'];
  } else if (pid === 'MA-DJ-01' || handle.includes('casaca')) {
    ids = ['MA-TE-BK', 'MA-TE-WH', 'MA-DF-01'];
  } else if (pid === 'MA-DF-01' || handle.includes('bolso') || handle.includes('duffel')) {
    ids = ['MA-TE-BK', 'MA-TE-WH', 'MA-DJ-01'];
  } else {
    ids = ['MA-TE-BK', 'MA-TE-WH', 'MA-DJ-01'];
  }

  if (!ids.length) {
    if (section) section.style.display = 'none';
    return;
  }
  if (section) section.style.display = 'block';

  // Set grid class name to inherit gallery-v2__wrapper styling with dynamic items layout
  grid.className = `gallery-v2__wrapper items-${ids.length}`;

  const cur = getCurrencyObj();

  grid.innerHTML = ids.map(rid => {
    const p = PRODUCTS[rid];
    if (!p) return '';
    const colorLabel = dict[`color.${p.color}`] || p.color;
    const price = isUsdRegion() ? p.priceUsd : p.pricePen;
    
    // Determine sizes list markup for this card
    const sizesHtml = p.sizes.map(s => {
      const isOos = p.outOfStockSizes && p.outOfStockSizes.includes(s);
      return `<button class="gallery-v2__size-opt${isOos ? ' is-disabled' : ''}" data-size="${s}" ${isOos ? 'disabled' : ''}>${s}</button>`;
    }).join('');

    return `
      <article class="gallery-v2__card" data-product-id="${p.id}" data-product-name="${p.name}" data-product-color="${p.color}" data-price-usd="${p.priceUsd}" data-price-pen="${p.pricePen}">
        <div class="gallery-v2__media">
          <a href="${getProductUrl(p.id)}" class="gallery-v2__media-link">
             <img class="gallery-v2__img is-loaded" src="${getCartThumb(p.id)}" alt="${p.name}" loading="lazy" style="pointer-events: none !important;">
          </a>
          <button class="gallery-v2__quick-add-trigger" type="button" onclick="event.preventDefault(); event.stopPropagation(); openQuickBuy('${p.id}');">+</button>
          <div class="gallery-v2__sizing-panel">
            <div class="gallery-v2__sizing-title">
              <span>TALLAJE</span>
              <button class="gallery-v2__sizing-close">✕</button>
            </div>
            <div class="gallery-v2__sizes-list">
              ${sizesHtml}
            </div>
          </div>
        </div>
        <div class="gallery-v2__info">
          <div class="gallery-v2__header-left">
            <h3 class="gallery-v2__name">${(p.id === 'MA-TE-BK' || p.id === 'MA-TE-WH') ? p.name.replace(' - ', ' — ') : p.name.split(' - ')[0]}</h3>
            <p class="gallery-v2__color">${colorLabel}</p>
          </div>
          <div class="gallery-v2__header-right">
            <span class="gallery-v2__price">${cur.symbol}${Number(price).toFixed(2)}</span>
          </div>
        </div>
      </article>
    `;
  }).join('');

  // Wire quick buy triggers
  initGlobalQuickBuy();

  window.initScrollReveal?.();
}

function trackRecentlyViewed(currentId) {
  try {
    let list = JSON.parse(localStorage.getItem('mark-altitude-recently-viewed') || '[]');
    list = list.filter(id => id !== currentId);
    list.unshift(currentId);
    if (list.length > 5) {
      list = list.slice(0, 5);
    }
    localStorage.setItem('mark-altitude-recently-viewed', JSON.stringify(list));
  } catch (_) {}
}

function renderRecentlyViewed(currentProductId, dict) {
  const container = document.getElementById('pdp-recently-viewed');
  if (!container) return;

  let list = [];
  try {
    list = JSON.parse(localStorage.getItem('mark-altitude-recently-viewed') || '[]');
  } catch (_) {}

  const items = list.filter(id => id !== currentProductId && PRODUCTS[id]);
  if (items.length === 0) {
    container.innerHTML = '';
    return;
  }

  const displayedItems = items.slice(0, 4);
  const cur = getCurrencyObj();
  const isEn = getLang() === 'en';
  const heading = isEn ? 'RECENTLY VIEWED' : 'VISTO RECIENTEMENTE';

  const cardsHtml = displayedItems.map(rid => {
    const p = PRODUCTS[rid];
    if (!p) return '';
    const colorLabel = dict[`color.${p.color}`] || p.color;
    const price = isUsdRegion() ? p.priceUsd : p.pricePen;
    const badge = p.badge === 'bestseller' ? dict['badge.bestseller'] : dict['badge.new'];
    
    const mediaHtml = p.images && p.images.length > 0
      ? `<div class="product-card__media">
          <img class="product-card__image image-reveal" src="${getAssetUrl(p.images[0])}" alt="${p.name}" onload="this.classList.add('is-loaded')">
          ${p.badge ? `<span class="product-card__badge">${badge}</span>` : ''}
         </div>`
      : `<div class="product-card__media product-card__media--${p.placeholder}">
          <span class="product-card__placeholder-label">${p.label}</span>
          ${p.badge ? `<span class="product-card__badge">${badge}</span>` : ''}
         </div>`;

    return `
      <article class="product-card">
        <a href="${getProductUrl(p.id)}" class="product-card__media-link">
          ${mediaHtml}
        </a>
        <div class="product-card__info">
          <a href="${getProductUrl(p.id)}" class="product-card__name-link">
            <h3 class="product-card__name">${p.name}</h3>
          </a>
          <p class="product-card__color">${colorLabel}</p>
          <div class="product-card__price">
            <span class="product-card__price-current">${cur.symbol}${Number(price).toFixed(2)}</span>
          </div>
        </div>
      </article>
    `;
  }).join('');

  container.innerHTML = `
    <section class="recently-viewed" data-header-mode="hidden" style="padding-top: 4rem; border-top: 1px solid var(--color-gray-200); margin-top: 4rem; margin-bottom: 4rem;">
      <div class="container">
        <h2 class="section-heading" style="text-align:center; font-size: 0.85rem; font-weight: 500; letter-spacing: 0.05em; margin-bottom: 2.5rem; text-transform: uppercase;">${heading}</h2>
        <div class="product-grid">${cardsHtml}</div>
      </div>
    </section>
  `;
  window.initScrollReveal?.();
}

// ─────────────────────────────────────────────────────────────────────────────
// CHECKOUT PAGE (only runs on checkout.html)
// ─────────────────────────────────────────────────────────────────────────────
function renderCheckoutPage() {
  const root = document.getElementById('checkout-page');
  if (!root) return;

  const dict = I18N[getLang()];

  if (cart.items.length === 0 && !root.dataset.success) {
    root.innerHTML = `
      <div class="checkout-empty">
        <p>${dict['checkout.empty']}</p>
        <a href="index.html" class="btn btn--dark" style="margin-top:1.5rem;">${dict['checkout.back']}</a>
      </div>
    `;
    return;
  }

  if (root.dataset.success === 'true') return; // success already shown

  root.innerHTML = `
    <div class="checkout-grid">
      <section class="checkout-form" data-header-mode="hidden">
        <a href="index.html" class="checkout-back">${dict['checkout.back']}</a>

        <fieldset class="checkout-section">
          <legend>${dict['checkout.contact']}</legend>
          <div class="checkout-field">
            <label for="email">${dict['checkout.email']}</label>
            <input type="email" id="email" name="email" required autocomplete="email">
          </div>
        </fieldset>

        <fieldset class="checkout-section">
          <legend>${dict['checkout.shipping']}</legend>
          <div class="checkout-row">
            <div class="checkout-field">
              <label for="firstname">${dict['checkout.firstname']}</label>
              <input type="text" id="firstname" name="firstname" required autocomplete="given-name">
            </div>
            <div class="checkout-field">
              <label for="lastname">${dict['checkout.lastname']}</label>
              <input type="text" id="lastname" name="lastname" required autocomplete="family-name">
            </div>
          </div>
          <div class="checkout-field">
            <label for="address">${dict['checkout.address']}</label>
            <input type="text" id="address" name="address" required autocomplete="street-address">
          </div>
          <div class="checkout-row">
            <div class="checkout-field">
              <label for="city">${dict['checkout.city']}</label>
              <input type="text" id="city" name="city" required autocomplete="address-level2">
            </div>
            <div class="checkout-field">
              <label for="postal">${dict['checkout.postal']}</label>
              <input type="text" id="postal" name="postal" required autocomplete="postal-code">
            </div>
          </div>
          <div class="checkout-row">
            <div class="checkout-field">
              <label for="country">${dict['checkout.country']}</label>
              <select id="country" name="country" required>
                <option value="PE">Perú</option>
                <option value="US">United States</option>
                <option value="MX">México</option>
                <option value="CL">Chile</option>
                <option value="AR">Argentina</option>
                <option value="CO">Colombia</option>
                <option value="ES">España</option>
              </select>
            </div>
            <div class="checkout-field">
              <label for="phone">${dict['checkout.phone']}</label>
              <input type="tel" id="phone" name="phone" required autocomplete="tel">
            </div>
          </div>
        </fieldset>

        <fieldset class="checkout-section">
          <legend>${dict['checkout.payment']}</legend>
          <div class="checkout-payment-methods">
            <span class="pay-badge">VISA</span>
            <span class="pay-badge">MC</span>
            <span class="pay-badge">AMEX</span>
            <span class="pay-badge">YAPE</span>
            <span class="pay-badge">PLIN</span>
          </div>
          <div class="checkout-field">
            <label for="cardnumber">${dict['checkout.card.number']}</label>
            <input type="text" id="cardnumber" name="cardnumber" required autocomplete="cc-number" inputmode="numeric" placeholder="•••• •••• •••• ••••">
          </div>
          <div class="checkout-row">
            <div class="checkout-field">
              <label for="cardexp">${dict['checkout.card.exp']}</label>
              <input type="text" id="cardexp" name="cardexp" required autocomplete="cc-exp" placeholder="MM / AA">
            </div>
            <div class="checkout-field">
              <label for="cardcvv">${dict['checkout.card.cvv']}</label>
              <input type="text" id="cardcvv" name="cardcvv" required autocomplete="cc-csc" inputmode="numeric" placeholder="•••">
            </div>
          </div>
          <div class="checkout-field">
            <label for="cardname">${dict['checkout.card.name']}</label>
            <input type="text" id="cardname" name="cardname" required autocomplete="cc-name">
          </div>
        </fieldset>

        <button type="button" class="btn btn--dark checkout-submit" id="place-order">${dict['checkout.place_order']}</button>
      </section>

      <aside class="checkout-summary" id="checkout-summary"></aside>
    </div>
  `;

  renderCheckoutSummary();

  document.getElementById('place-order').addEventListener('click', placeOrder);
}

function renderCheckoutSummary() {
  const sum = document.getElementById('checkout-summary');
  if (!sum) return;
  const dict = I18N[getLang()];
  const cur  = getCurrencyObj();
  const subtotal = cart.subtotal();

  sum.innerHTML = `
    <h2 class="checkout-summary__title">${dict['checkout.summary']}</h2>
    <div class="checkout-summary__items">
      ${cart.items.map(it => {
        const colorLabel = dict[`color.${it.color}`] || it.color;
        const linePrice = isUsdRegion() ? it.priceUsd * it.qty : it.pricePen * it.qty;
        return `
          <div class="checkout-item">
            <div class="checkout-item__thumb">
              <img class="cart-item__thumb--${it.color} ${it.id === 'MA-DJ-01' ? 'cart-item__thumb--puffer' : ''}" src="${getCartThumb(it.id)}" alt="${it.name}" style="width:100%; height:100%; object-fit:cover; border-radius:inherit; display:block;">
              <span class="checkout-item__qty-badge">${it.qty}</span>
            </div>
            <div class="checkout-item__info">
              <p class="checkout-item__name">${it.name}</p>
              <p class="checkout-item__meta">${colorLabel} · ${it.size}</p>
            </div>
            <p class="checkout-item__price">${cur.symbol}${Number(linePrice).toFixed(2)}</p>
          </div>
        `;
      }).join('')}
    </div>

    <div class="checkout-promo">
      <input type="text" placeholder="${dict['checkout.discount']}" id="promo-code">
      <button type="button" class="checkout-promo__apply">${dict['checkout.apply']}</button>
    </div>

    <div class="checkout-summary__lines">
      <div class="checkout-summary__line">
        <span>${dict['cart.subtotal']}</span>
        <span>${cur.symbol}${Number(subtotal).toFixed(2)}</span>
      </div>
      <div class="checkout-summary__line">
        <span>${dict['checkout.shipping.line']}</span>
        <span class="is-free">${dict['checkout.shipping.free']}</span>
      </div>
      <div class="checkout-summary__line checkout-summary__line--total">
        <span>${dict['checkout.total']}</span>
        <span>${cur.symbol}${Number(subtotal).toFixed(2)}</span>
      </div>
    </div>
  `;
}

function placeOrder() {
  const form = document.querySelector('.checkout-form');
  if (!form) return;
  const inputs = form.querySelectorAll('input[required], select[required]');
  let allValid = true;
  let firstInvalid = null;
  inputs.forEach(input => {
    const valid = input.value.trim() !== '';
    // Remove + reflow + re-add so the shake keyframe re-triggers on each attempt
    input.classList.remove('is-invalid');
    if (!valid) {
      void input.offsetWidth;
      input.classList.add('is-invalid');
      if (!firstInvalid) firstInvalid = input;
      allValid = false;
    }
  });
  if (!allValid) {
    (firstInvalid || inputs[0]).scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => firstInvalid?.focus({ preventScroll: true }), 350);
    return;
  }

  // Show spinner on the button briefly before showing success (feels real)
  const btn = document.getElementById('place-order');
  if (btn) btn.classList.add('is-loading');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = reduce ? 0 : 750;
  setTimeout(() => commitOrderSuccess(form), wait);
}

function commitOrderSuccess(form) {
  const dict = I18N[getLang()];
  const email = form.querySelector('#email').value;
  const orderId = 'MA-' + Date.now().toString().slice(-8);

  const root = document.getElementById('checkout-page');
  root.dataset.success = 'true';
  root.innerHTML = `
    <div class="checkout-success">
      <div class="checkout-success__icon" aria-hidden="true">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="9 12 11 14 15.5 9.5"></polyline>
        </svg>
      </div>
      <h1 class="checkout-success__title">${dict['checkout.success.title']}</h1>
      <p class="checkout-success__order">${dict['checkout.success.order']} <strong>#${orderId}</strong></p>
      <p class="checkout-success__body">${dict['checkout.success.body'].replace('{email}', email)}</p>
      <a href="index.html" class="btn btn--dark checkout-success__cta">${dict['checkout.success.continue']}</a>
    </div>
  `;

  // Clear cart after successful order
  cart.items = [];
  cart.save();
  cart.render();
}

// ─────────────────────────────────────────────────────────────────────────────
// INFO PAGES — render content based on ?p= param
// ─────────────────────────────────────────────────────────────────────────────
function renderInfoPage() {
  const root = document.getElementById('info-page');
  if (!root) return;
  const lang = getLang();
  const dict = INFO_CONTENT[lang] || INFO_CONTENT.es;
  const params = new URLSearchParams(window.location.search);
  const slugRaw = (params.get('p') || 'about').toLowerCase();
  const slugMap = {
    'filosofia': 'philosophy',
    'devoluciones': (lang === 'en') ? 'returns' : 'devoluciones',
    'returns': (lang === 'es') ? 'devoluciones' : 'returns',
    'tallas': 'tallas',
    'size-guide': 'tallas',
    'envios': 'envios',
    'shipping': 'envios',
    'reclamaciones': 'reclamaciones',
    'claims': 'reclamaciones',
    'claims_book': 'reclamaciones'
  };
  const slug = slugMap[slugRaw] || slugRaw;
  const page = dict[slug] || dict[slugRaw] || dict.about;
  const resolvedSlug = (dict[slug] || dict[slugRaw]) ? slug : 'about';
  const fallbackSlug = (resolvedSlug === 'devoluciones') ? 'returns' : resolvedSlug;

  // Update document title
  document.title = `MARK ALTITUDE — ${page.title}`;

  // Build the layout based on page type
  let bodyHtml = '';
  let contentHtml = '';

  if (fallbackSlug === 'contact') {
    const c = page.contact;
    bodyHtml = `
      <div class="info-page__contact-info-only">
        <div class="info-page__contact-block">
          <h3 class="info-page__contact-label">${c.emailLabel}</h3>
          <a href="mailto:${c.emailValue}" class="info-page__contact-value">${c.emailValue}</a>
        </div>
        <div class="info-page__contact-block">
          <h3 class="info-page__contact-label">${c.whatsappLabel}</h3>
          <a href="https://wa.me/51916643733" target="_blank" rel="noopener noreferrer" class="info-page__contact-value">${c.whatsappValue}</a>
        </div>
        <div class="info-page__contact-block">
          <h3 class="info-page__contact-label">${c.hoursLabel}</h3>
          <p class="info-page__contact-value">${c.hoursValue}</p>
        </div>
        <div class="info-page__contact-block">
          <h3 class="info-page__contact-label">${c.addressLabel}</h3>
          <p class="info-page__contact-value">${c.addressValue}</p>
        </div>
        <div class="info-page__contact-block">
          <h3 class="info-page__contact-label">${c.instagramLabel}</h3>
          <a href="https://www.instagram.com/mark.altitude/" target="_blank" rel="noopener noreferrer" class="info-page__contact-value">${c.instagramValue}</a>
        </div>
      </div>
    `;
  } else if (fallbackSlug === 'blog') {
    bodyHtml = `
      <div class="info-page__articles">
        ${page.articles.map((a, i) => `
          <article class="info-page__article" style="--article-i:${i};">
            <a href="#" class="info-page__article-link">
              <div class="info-page__article-media info-page__article-media--${i}">
                <span class="info-page__article-media-label">MARK</span>
              </div>
              <div class="info-page__article-meta">
                <span class="info-page__article-cat">${a.category}</span>
                <span class="info-page__article-date">${a.date}</span>
              </div>
              <h3 class="info-page__article-title">${a.title}</h3>
              <p class="info-page__article-excerpt">${a.excerpt}</p>
              <span class="info-page__article-read">${a.read} →</span>
            </a>
          </article>
        `).join('')}
      </div>
    `;
  } else if (fallbackSlug === 'about') {
    const c = page;
    contentHtml = `
      <div class="history-page">
        <!-- 1. Hero Banner with Mountain BG & Centered Text -->
        <section class="history-hero" data-reveal>
          <div class="history-hero__bg">
            <img src="${getAssetUrl('mark-altitude-editorial-montanas-peru.jpg')}" alt="Mountain Peru — MARK ALTITUDE" loading="lazy">
            <div class="history-hero__overlay"></div>
          </div>
          <div class="history-hero__content container">
            <div class="history-hero__text-box" data-reveal="up-sm">
              ${c.heroText}
            </div>
          </div>
        </section>

        <!-- 2. "UN ESTÁNDAR MÁS ALTO." Single Banner Section with Overlay Closing Content -->
        <section class="history-banner-section" data-reveal style="margin-top: 5rem; margin-bottom: 4rem; text-align: center;">
          <div class="container">
            <h2 class="history-banner-section__title">${c.bannerTitle}</h2>
            <p class="history-banner-section__subtitle">${c.bannerSubtitle}</p>
          </div>
          <div class="history-banner-media" data-reveal="fade" style="margin-top: 2.5rem;">
            <img src="${getAssetUrl(c.bannerImg)}" alt="${c.bannerTitle}" loading="lazy">
            <div class="history-banner-media__overlay"></div>
            
            <div class="history-banner-media__content">
              <a href="/#collection" class="btn btn--editorial history-closing__cta" style="display: inline-block;">${c.ctaText}</a>
            </div>
          </div>
        </section>
      </div>
    `;
  } else if (fallbackSlug === 'philosophy' || fallbackSlug === 'filosofia') {
    const c = page.pillars ? page : (dict.philosophy || page);
    contentHtml = `
      <div class="history-page philosophy-page">
        <!-- 1. Hero Banner with Banner FILOSOFÍA.jpeg BG & Intro -->
        <section class="history-hero philosophy-hero-bg" data-reveal>
          <div class="history-hero__bg">
            <img src="${getAssetUrl(c.heroBgImg || 'mark-altitude-editorial-filosofia-polo-negro.jpg')}" alt="MARK ALTITUDE — ${c.title}" loading="lazy">
            <div class="history-hero__overlay"></div>
          </div>
          <div class="history-hero__content container">
            <div class="history-hero__text-box" data-reveal="up-sm">
              ${c.heroText}
            </div>
          </div>
        </section>

        <!-- 2. Philosophy Pillars Section -->
        <section class="philosophy-pillars-section container" data-reveal>
          <div class="philosophy-pillars-grid">
            ${(c.pillars || []).map((p, idx) => {
              const isLast = idx === ((c.pillars || []).length - 1);
              return `
                <div class="philosophy-pillar-card ${isLast ? 'philosophy-pillar-card--centered' : ''}" data-reveal="up">
                  <h3 class="philosophy-pillar__title">${p.title}</h3>
                  <div class="philosophy-pillar__body">${p.body}</div>
                </div>
              `;
            }).join('')}
          </div>
        </section>

        <!-- 3. Closing Section with CTA Button -->
        <section class="philosophy-closing-section" data-reveal>
          <div class="container">
            <div class="philosophy-closing__action">
              <a href="/#collection" class="btn btn--editorial history-closing__cta" style="display: inline-block;">${c.ctaText}</a>
            </div>
          </div>
        </section>
      </div>
    `;
  } else {
    bodyHtml = `<div class="info-page__body">${page.body}</div>`;
  }

  // If contentHtml wasn't set (by the 'about' case), wrap bodyHtml in container
  if (!contentHtml) {
    contentHtml = `
      <div class="container">
        ${bodyHtml}
      </div>
    `;
  }

  root.innerHTML = `
    <article class="info-page info-page--${fallbackSlug}">
      <header class="info-page__hero container">
        <p class="info-page__eyebrow">${page.eyebrow || ''}</p>
        <h1 class="info-page__title">${page.title}</h1>
        <p class="info-page__intro">${page.intro || ''}</p>
      </header>
      ${contentHtml}
    </article>
  `;

  // Wire contact form
  const form = document.getElementById('contact-form');
  if (form) {
    form.addEventListener('submit', e => {
      const inputs = form.querySelectorAll('input[required], select[required], textarea[required]');
      let valid = true;
      inputs.forEach(input => {
        const ok = input.value.trim() !== '';
        input.classList.remove('is-invalid');
        if (!ok) {
          void input.offsetWidth;
          input.classList.add('is-invalid');
          valid = false;
        }
      });
      if (!valid) {
        e.preventDefault();
        return;
      }

      const name = form.querySelector('[name="contact[name]"]')?.value || '';
      const email = form.querySelector('[name="contact[email]"]')?.value || '';
      const subject = form.querySelector('[name="contact[Asunto]"]')?.value || 'Consulta General';
      const msg = form.querySelector('[name="contact[body]"]')?.value || '';

      const mailtoUrl = `mailto:markaltitude.co@gmail.com?subject=${encodeURIComponent('MARK ALTITUDE Contacto: ' + subject)}&body=${encodeURIComponent('Nombre: ' + name + '\nEmail: ' + email + '\n\nMensaje:\n' + msg)}`;

      // If running inside Shopify theme frame or window, allow POST submit and fallback mailto
      setTimeout(() => {
        window.location.href = mailtoUrl;
      }, 300);

      showToast(INFO_CONTENT[getLang()].contact.contact.submitSuccess);
    });
  }

  // Observe dynamically added elements for scroll animations
  setTimeout(() => {
    window.initScrollReveal?.();
  }, 100);
}

// ─────────────────────────────────────────────────────────────────────────────
// Initial language: stored preference, fallback ES (default)
// ─────────────────────────────────────────────────────────────────────────────
(function initLanguage() {
  const legacyProductId = new URLSearchParams(window.location.search).get('id');
  const legacyCanonicalUrl = window.MA_LEGACY_CANONICAL_PRODUCT_URLS?.[legacyProductId];
  if (legacyCanonicalUrl) {
    window.location.replace(legacyCanonicalUrl);
    return;
  }

  window.MA_LANGUAGE_BOOTSTRAP = true;
  initGeoDetection();
  window.MA_LANGUAGE_BOOTSTRAP = false;

  // Initialize PDP drawers if on PDP page
  if (document.querySelector('.template-product, .ma-pdp-info, #product-detail, aside.ma-pdp-info')) {
    window._pdpDrawersInited = true;
    initPDPAuxDrawers(null, typeof getLang === 'function' ? getLang() : 'es');
  }

  // Inject reviews + complete-system independently of renderProductPage.
  // This is needed because product.liquid pre-sets data-ma-render-state="ready",
  // causing renderProductPage() to return early without injecting these sections.
  if (document.getElementById('product-detail')) {
    const pdpRoot = document.getElementById('product-detail');
    const _pdpId = window.MA_CURRENT_PRODUCT_ID || (pdpRoot ? pdpRoot.dataset.productId : null) || 'MA-DF-01';
    const _pdpProduct = (PRODUCTS && PRODUCTS[_pdpId]) ? PRODUCTS[_pdpId] : (PRODUCTS ? PRODUCTS['MA-DF-01'] : { id: 'MA-DF-01', name: 'C-01 TRAVEL DUFFEL' });
    const _pdpDict = I18N[getLang()] || I18N['es'];

    // Position THE PURPOSE (.c01-purpose-wrapper) right AFTER .reviews
    const _rvEl = document.querySelector('#reviews, #product-reviews-section, .reviews-section, .reviews');
    const _purposeEl = document.querySelector('.c01-purpose-wrapper, .c01-purpose-hero, [data-c01-seo]');
    if (_rvEl && _purposeEl && _rvEl.nextElementSibling !== _purposeEl) {
      _rvEl.insertAdjacentElement('afterend', _purposeEl);
    }

    // Position COMPLETE THE SYSTEM (.complete-system) right AFTER THE PURPOSE
    let _csSec = document.querySelector('.complete-system');
    if (!_csSec) {
      const _csWrap = document.createElement('div');
      _csWrap.innerHTML = `
        <section class="complete-system gallery-v2 v2-section is-visible" data-header-mode="hidden">
          <div class="v2-container">
            <div class="gallery-v2__header">
              <h2 class="gallery-v2__title">${_pdpDict['complete_the_system'] || 'COMPLETE THE SYSTEM'}</h2>
            </div>
            <div class="gallery-v2__wrapper" id="complete-system-grid"></div>
          </div>
        </section>
      `;
      _csSec = _csWrap.firstElementChild;
    }
    const _csAnchor = _purposeEl || _rvEl || pdpRoot;
    if (_csSec && _csAnchor && _csAnchor.nextElementSibling !== _csSec) {
      _csAnchor.insertAdjacentElement('afterend', _csSec);
    }
    // Wire interactivity and render complete system grid
    wireReviews(_pdpProduct);
    renderCompleteSystem(_pdpProduct, _pdpDict);
  }

  // Auto-scroll to reviews if returning from review login (?review_return=1)
  (function handleReviewReturnScroll() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('review_return') === '1') {
      const scrollToReviews = () => {
        const target = document.getElementById('reviews') || document.getElementById('product-reviews-section') || document.querySelector('.reviews');
        if (target) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('review_return');
          const finalUrl = cleanUrl.pathname + (cleanUrl.searchParams.toString() ? '?' + cleanUrl.searchParams.toString() : '') + cleanUrl.hash;
          window.history.replaceState(null, '', finalUrl);
        } catch (_) {}
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          requestAnimationFrame(scrollToReviews);
        }, { once: true });
      } else {
        requestAnimationFrame(scrollToReviews);
      }
    }
  })();

  // Render page-specific content after language is set
  if (document.getElementById('product-detail')) renderProductPage();
  if (document.getElementById('checkout-page'))  renderCheckoutPage();
  if (document.getElementById('info-page'))      renderInfoPage();
})();

// Early teleport for Liquid SSR drawers — runs before any user interaction
// Ensures .pdp-drawer elements are children of <body>, not trapped in <aside>
(function teleportSSRDrawers() {
  function doTeleport() {
    const overlay = document.getElementById('pdp-drawer-overlay');
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    document.querySelectorAll('.pdp-drawer').forEach(d => {
      if (d.parentElement !== document.body) {
        document.body.appendChild(d);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doTeleport);
  } else {
    doTeleport();
  }
})();

// ─────────────────────────────────────────────────────────────────────────────
// MOTION — Phase 1: hero load + scroll reveal system
// ─────────────────────────────────────────────────────────────────────────────
(function initMotion() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Hero load-in: fire as soon as DOM is ready (defer paint to next frame
  //    so the "from" state is honored before transitioning to the "to" state).
  const triggerLoaded = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => document.body.classList.add('is-loaded'));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', triggerLoaded, { once: true });
  } else {
    triggerLoaded();
  }

  // 2) Scroll reveal — single shared IntersectionObserver.
  //    - [data-reveal] on an element animates it in.
  //    - [data-reveal-stagger="<ms>"] on a parent applies a staggered delay
  //      to its direct children with [data-reveal] (default 90ms).
  window.initScrollReveal = function() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Auto-tag common patterns so we don't have to litter the HTML.
    // Added product page grid, features, and accordion to make details stagger in
    document.querySelectorAll(
      '.benefits__grid, .product-grid, .features__grid, .faq__list, .lookbook__content, .newsletter__container, .footer__inner, .product-gallery__grid, .pdp-features, .product-info__accordion'
    ).forEach(group => {
      if (!group.hasAttribute('data-reveal-stagger')) group.setAttribute('data-reveal-stagger', '90');
      Array.from(group.children).forEach(child => {
        if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', '');
      });
    });

    // Apply per-child stagger delays now that everything is tagged.
    document.querySelectorAll('[data-reveal-stagger]').forEach(parent => {
      const step = parseInt(parent.getAttribute('data-reveal-stagger'), 10) || 90;
      Array.from(parent.children)
        .filter(child => child.hasAttribute('data-reveal'))
        .forEach((child, i) => {
          if (!child.style.getPropertyValue('--reveal-delay')) {
            child.style.setProperty('--reveal-delay', (i * step) + 'ms');
          }
        });
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-visible'));
      return;
    }

    if (!window.scrollRevealObserver) {
      window.scrollRevealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            window.scrollRevealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      });
    }

    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(el => {
      window.scrollRevealObserver.observe(el);
    });
  };

  // Run on initial load
  window.initScrollReveal();
})();

// ─────────────────────────────────────────────────────────────────────────────
// MOTION — Phase 4: page transitions, blur-up, scroll progress, cursor follower
// ─────────────────────────────────────────────────────────────────────────────
(function initPhase4() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── 4.1 (Page transition overlay removed by user request) ──────────────────
  // Clean up any stale flag from previous sessions.
  sessionStorage.removeItem('ma-page-transitioning');

  // ── 4.2 Blur-up image lazy load ────────────────────────────────────────────
  // Auto-tag content images (skip logos, icons, decorative SVGs).
  document.querySelectorAll('img').forEach(img => {
    if (img.hasAttribute('data-no-blur')) return;
    if (/logo|icon/i.test(img.className) || /\.svg$/i.test(img.src || '')) return;
    if (img.hasAttribute('data-blur')) return;
    img.setAttribute('data-blur', '');
  });
  document.querySelectorAll('img[data-blur]').forEach(img => {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load',  () => img.classList.add('is-loaded'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
    }
  });

  // ── 4.3 Scroll progress bar (Disabled per user request) ─────────────────────────────
  const isLongPage = false;
  if (isLongPage && !reduceMotion) {
    const progress = document.createElement('div');
    progress.className = 'scroll-progress';
    progress.innerHTML = '<div class="scroll-progress__bar"></div>';
    document.body.appendChild(progress);
    const bar = progress.firstElementChild;
    let ticking = false;
    const update = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const pct = total > 0 ? Math.min(100, (h.scrollTop / total) * 100) : 0;
      bar.style.width = pct + '%';
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ── 4.4 (Button Width Freeze Interaction Logic) ───────────────
  (function initButtonWidthFreeze() {
    const targetSelectors = '.product-campaign__cta, .product-showcase__cta-editorial, .btn--editorial, .editorial-modal__success-button';

    const getNaturalWidth = (btn) => {
      // Clone the button to measure natural width off-screen at scale(1)
      const clone = btn.cloneNode(true);
      clone.style.setProperty('width', 'auto', 'important');
      clone.style.setProperty('letter-spacing', '0.25em', 'important');
      clone.style.setProperty('transform', 'none', 'important');
      clone.style.setProperty('position', 'absolute', 'important');
      clone.style.setProperty('visibility', 'hidden', 'important');
      clone.style.setProperty('display', 'inline-block', 'important');
      
      document.body.appendChild(clone);
      const width = clone.getBoundingClientRect().width;
      document.body.removeChild(clone);
      return width;
    };

    function lockInlineButtonWidths() {
      document.querySelectorAll(targetSelectors).forEach(btn => {
        btn.style.width = '';
        const width = getNaturalWidth(btn);
        if (width > 0) {
          btn.style.width = `${width}px`;
        }
      });
    }

    // Run on load states
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lockInlineButtonWidths);
    } else {
      lockInlineButtonWidths();
    }
    window.addEventListener('load', lockInlineButtonWidths);
    window.addEventListener('resize', () => {
      lockInlineButtonWidths();
    });

    // Safeguards for font loading/async translations
    setTimeout(lockInlineButtonWidths, 100);
    setTimeout(lockInlineButtonWidths, 500);
    setTimeout(lockInlineButtonWidths, 2000);
  })();

  // ── 4.5 View Transitions API — morph card → PDP (Chrome/Edge only) ─────────
  // Tags product card images and PDP gallery main with matching view-transition-name.
  // The browser handles the morph automatically when navigating.
  if ('startViewTransition' in document && !reduceMotion) {
    // Read product id from URL on PDP, tag the gallery main with the matching name.
    const pdpRoot = document.getElementById('product-detail');
    if (pdpRoot) {
      const params = new URLSearchParams(window.location.search);
      const pid = params.get('id') || pdpRoot.dataset.productId || window.MA_CURRENT_PRODUCT_ID;
      if (pid) {
        // Wait until renderProductPage completes
        const tagPdp = () => {
          const firstTile = document.querySelector('.ma-pdp-gallery');
          if (firstTile) firstTile.style.viewTransitionName = `product-${pid}`;
        };
        if (document.querySelector('.ma-pdp-gallery')) tagPdp();
        else setTimeout(tagPdp, 100);
      }
    }
    // On homepage, tag each product card media with its product id.
    document.querySelectorAll('.product-card[data-product-id]').forEach(card => {
      const pid = card.getAttribute('data-product-id');
      const media = card.querySelector('.product-card__media');
      if (pid && media) media.style.viewTransitionName = `product-${pid}`;
    });
  }
})();

// ─────────────────────────────────────────────────────────────────────────────
// Mobile Menu Navigation Accordions
// ─────────────────────────────────────────────────────────────────────────────
(function initMobileSubmenuAccordions() {
  // ── Accordion / Submenu toggles ──
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('#submenu-shop-toggle, .mobile-menu__link--toggle');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      const item = toggleBtn.closest('.mobile-menu__item--has-sub');
      if (item) {
        const isCurrentlyActive = item.classList.contains('is-active');
        item.classList.toggle('is-active', !isCurrentlyActive);
        toggleBtn.setAttribute('aria-expanded', !isCurrentlyActive ? 'true' : 'false');
      }
    }
  });
})();

// ── Duo Banner Expand / Collapse Interaction (85% / 15%) ──
(function initDuoBannerInteraction() {
  const setupDuoBanner = () => {
    const spotlightSection = document.querySelector('.spotlight');
    if (!spotlightSection) return;

    const container = spotlightSection.querySelector('.spotlight__columns');
    const spotlightCols = spotlightSection.querySelectorAll('.spotlight__col');
    if (!container || !spotlightCols.length) return;

    let hasRevealedOnce = false;
    let activeIndex = 0;
    let wasInView = false;

    function setActiveColumn(index) {
      if (window.innerWidth < 1300) return;
      if (index < 0 || index >= spotlightCols.length) return;
      activeIndex = index;
      spotlightCols.forEach((c, i) => {
        if (i === index) c.classList.add('is-active');
        else c.classList.remove('is-active');
      });
      container.classList.add('has-revealed');
    }

    function triggerScrollReveal() {
      if (window.innerWidth < 1300) return;
      if (hasRevealedOnce) return;
      hasRevealedOnce = true;
      setActiveColumn(0);
    }

    function toggleOutofViewBanner() {
      if (window.innerWidth < 1300) return;
      const nextIndex = activeIndex === 0 ? 1 : 0;
      setActiveColumn(nextIndex);
    }

    // 1. IntersectionObserver para detección de vista y cambio automático fuera de pantalla en PC
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!hasRevealedOnce) {
              triggerScrollReveal();
            }
            wasInView = true;
          } else if (wasInView) {
            // El banner estuvo visible y ahora salió completamente de la vista en PC -> alternar al otro banner
            toggleOutofViewBanner();
          }
        });
      }, { threshold: 0.05 });

      observer.observe(spotlightSection);
    }

    // 2. Fallback por evento scroll y verificación inicial
    function checkVisibility() {
      if (window.innerWidth < 1300) {
        container.classList.remove('has-revealed');
        spotlightCols.forEach(c => c.classList.remove('is-active'));
        return;
      }
      const rect = spotlightSection.getBoundingClientRect();
      const inView = rect.top <= window.innerHeight * 0.85 && rect.bottom >= 0;

      if (inView) {
        if (!hasRevealedOnce) triggerScrollReveal();
        wasInView = true;
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();
    setTimeout(checkVisibility, 100);
    setTimeout(checkVisibility, 400);

    // 3. Hover / Touch interacción
    spotlightCols.forEach((col, idx) => {
      const handleActivate = () => {
        if (window.innerWidth < 1300) return;
        setActiveColumn(idx);
      };

      col.addEventListener('mouseenter', handleActivate);
      col.addEventListener('touchstart', handleActivate, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDuoBanner);
  } else {
    setupDuoBanner();
  }
})();

// ── Footer Accordion Interaction for Mobile ──
(function initFooterAccordion() {
  const mobileMaxWidth = 1299;

  const syncFooterAccordionState = () => {
    const isMobile = window.innerWidth <= mobileMaxWidth;
    document.querySelectorAll('.footer__nav-group').forEach(group => {
      const title = group.querySelector('.footer__nav-title');
      if (!title) return;

      if (isMobile) {
        title.setAttribute('aria-expanded', group.classList.contains('is-open') ? 'true' : 'false');
      } else {
        group.classList.remove('is-open');
        title.removeAttribute('aria-expanded');
      }
    });
  };

  const handleAccordionClick = (e) => {
    if (window.innerWidth > mobileMaxWidth) return;
    const title = e.target.closest('.footer__nav-title');
    if (!title) return;
    const group = title.closest('.footer__nav-group');
    if (!group) return;

    const isOpen = group.classList.toggle('is-open');
    title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };

  document.addEventListener('click', handleAccordionClick);
  window.addEventListener('resize', syncFooterAccordionState, { passive: true });
  syncFooterAccordionState();
  window.setupFooterAccordion = syncFooterAccordionState;
})();

// ─────────────────────────────────────────────────────────────────────────────
// AllSaints-inspired Quick Buy Drawer Module
// ─────────────────────────────────────────────────────────────────────────────
function initQuickBuyDrawer() {
  let overlay = document.getElementById('quick-buy-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'quick-buy-overlay';
    overlay.className = 'quick-buy-overlay';
    overlay.addEventListener('touchmove', function (event) {
      event.preventDefault();
    }, { passive: false });
    document.body.appendChild(overlay);
  }

  let drawer = document.getElementById('quick-buy-drawer');
  if (!drawer) {
    drawer = document.createElement('aside');
    drawer.id = 'quick-buy-drawer';
    drawer.className = 'quick-buy-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'quick-buy-title');
    document.body.appendChild(drawer);
    
    // Close on overlay click
    overlay.addEventListener('click', closeQuickBuy);
  }
}

const QUICK_BUY_RESPONSIVE_WIDTHS = [480, 720, 960, 1200, 1440, 1800, 2200];

function buildQuickBuySrcset(source, intrinsicWidth) {
  const masterWidth = Math.floor(Number(intrinsicWidth));
  if (!source || !Number.isFinite(masterWidth) || masterWidth < 1) return '';

  try {
    const url = new URL(source, window.location.origin);
    const isShopifyCdn = url.hostname === 'cdn.shopify.com';
    const isShopifyStorefrontPath = url.pathname.startsWith('/cdn/shop/');
    if (!isShopifyCdn && !isShopifyStorefrontPath) return '';
    url.searchParams.delete('width');

    const widths = QUICK_BUY_RESPONSIVE_WIDTHS.filter(width => width < masterWidth);
    widths.push(masterWidth);

    return widths.map(width => {
      const sizedUrl = new URL(url.toString());
      sizedUrl.searchParams.set('width', width);
      return `${sizedUrl.toString()} ${width}w`;
    }).join(', ');
  } catch (error) {
    return '';
  }
}

function openQuickBuy(productId) {
  try {
    const isEn = getLang() === 'en';
    const useUsd = isUsdRegion();
    const p = PRODUCTS[productId];
    if (!p) return;

    initQuickBuyDrawer();
    const drawer = document.getElementById('quick-buy-drawer');
    const overlay = document.getElementById('quick-buy-overlay');
    if (drawer) drawer.dataset.productId = productId;

    const price = useUsd ? p.priceUsd : p.pricePen;
    const formattedPrice = useUsd ? `$${price.toFixed(2)}` : `S/ ${price.toFixed(2)}`;

    let imageSlides = '';
    const galleries = window.MA_QUICK_BUY_GALLERIES || {};
    const quickBuyGallery = galleries[productId];
    const responsiveGallery = quickBuyGallery
      ? (quickBuyGallery.mobile && quickBuyGallery.mobile.length > 0 ? quickBuyGallery.mobile : quickBuyGallery.desktop)
      : null;
    const pImages = Array.isArray(responsiveGallery) && responsiveGallery.length > 0
      ? responsiveGallery
      : (p.images && p.images.length > 0 ? p.images : [p.bannerImage || '']);

    pImages.forEach((imageData, idx) => {
      const imgSrc = typeof imageData === 'string' ? imageData : imageData.src;
      const imageAlt = typeof imageData === 'string' ? p.name : (imageData.alt || p.name);
      const imageWidth = typeof imageData === 'string' ? '' : (Number(imageData.width) || '');
      const imageHeight = typeof imageData === 'string' ? '' : (Number(imageData.height) || '');
      const escapedAlt = String(imageAlt)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      const resolvedSrc = getAssetUrl(imgSrc);
      const srcset = buildQuickBuySrcset(resolvedSrc, imageWidth);
      imageSlides += `
        <div class="quick-buy-drawer__slide" data-index="${idx}">
          <img
            class="quick-buy-drawer__image"
            src="${resolvedSrc}"
            ${srcset ? `srcset="${srcset}" sizes="(max-width: 989px) 100vw, 50vw"` : ''}
            ${imageWidth ? `width="${imageWidth}"` : ''}
            ${imageHeight ? `height="${imageHeight}"` : ''}
            alt="${escapedAlt}"
            loading="${idx === 0 ? 'eager' : 'lazy'}"
            decoding="async"
            ${idx === 0 ? 'fetchpriority="high"' : ''}
          >
        </div>
      `;
    });

    const dict = I18N[getLang()] || I18N.es;
    const colorKey = 'color.' + (p.color || '').toLowerCase();
    const colorLabel = (dict[colorKey] || p.color || '').toUpperCase();
    const sizes = p.sizes || [];
    const isOneSize = sizes.length === 1 && String(sizes[0]).trim().toUpperCase() === 'O/S';

    const { html: sizeOptionsHtml, hasProfile, recommendedSize } = buildPdpSizeOptionsHTML(p, '');

    const fitDesc = p.fitDescription ? (isEn ? p.fitDescription.en : p.fitDescription.es) : '';
    const cleanName = p.name.split(' - ')[0];

    drawer.innerHTML = `
      <header class="quick-buy-drawer__header">
        <div class="quick-buy-drawer__header-spacer"></div>
        <button class="quick-buy-drawer__close" aria-label="Close" style="background:none;border:none;font-family:var(--font-base);font-size:14px;font-weight:300;color:var(--color-black);cursor:pointer;padding:0;line-height:1;width:44px;height:44px;display:flex;align-items:center;justify-content:center;position:absolute;z-index:10;top:${window.innerWidth <= 768 ? '22px' : '40px'};right:${window.innerWidth <= 768 ? '16px' : '35px'}">✕</button>
      </header>
      <div class="quick-buy-drawer__body">
        <div class="quick-buy-drawer__slider-container">
          <div class="quick-buy-drawer__slider">
            ${imageSlides}
          </div>
        </div>
        <div class="quick-buy-drawer__info">
          <div class="quick-buy-drawer__meta">
            <h3 class="quick-buy-drawer__name" id="quick-buy-title">${cleanName}</h3>
            <div class="quick-buy-drawer__sub-meta">
              <span class="quick-buy-drawer__color">${colorLabel}</span>
              <span class="quick-buy-drawer__price">${formattedPrice}</span>
            </div>
          </div>
          
          ${fitDesc ? `<p class="quick-buy-drawer__fit-desc">${fitDesc}</p>` : ''}
          
          <div class="quick-buy-drawer__select-wrapper">
            <select class="quick-buy-drawer__select" id="quick-buy-size-select" aria-label="${isEn ? 'Select size' : 'Seleccionar talla'}">
              ${sizeOptionsHtml}
            </select>
          </div>
          
          <button class="quick-buy-drawer__btn" id="quick-buy-add-btn">${isEn ? 'ADD TO CART' : 'AÑADIR AL CARRITO'}</button>
          <a href="${getProductUrl(productId)}" class="quick-buy-drawer__more-link">${isEn ? 'More details' : 'Más detalles'}</a>
        </div>
      </div>
    `;

    const selectEl = drawer.querySelector('#quick-buy-size-select');
    
    const openFitDrawerForQuickBuy = () => {
      let drawerUI = window._fitDrawerGlobalInstance;
      if (!drawerUI && window.FitDrawerUI) {
        drawerUI = new window.FitDrawerUI();
        drawerUI.render(isEn ? 'en' : 'es');
        window._fitDrawerGlobalInstance = drawerUI;
      }
      
      if (drawerUI) {
        let appliedFromFitModal = false;
        const repo = window.FitProfileRepository ? new window.FitProfileRepository() : null;
        const engine = window.FitRecommendationEngine ? new window.FitRecommendationEngine() : null;
        const resolver = window.ShopifyVariantResolver ? new window.ShopifyVariantResolver(p) : null;
        const productType = window.getProductType ? window.getProductType(productId) : 't01';
        
        drawerUI.onSubmit(() => {
          const metrics = drawerUI.getMetricValues();
          drawerUI.hideError();
          if (!metrics) return;

          const { heightCm, weightKg } = metrics;
          if (engine) {
            const validation = engine.validate(heightCm, weightKg);
            if (!validation.valid) {
              if (validation.field === 'height') {
                if (drawerUI._heightUnit === 'in') {
                  drawerUI.showFieldError('height', isEn
                    ? 'Enter a valid height between 59 and 81 inches.'
                    : 'Ingresa una altura válida entre 59 y 81 pulgadas.');
                } else {
                  drawerUI.showFieldError('height', isEn
                    ? 'Enter a valid height between 150 and 205 cm.'
                    : 'Ingresa una altura válida entre 150 y 205 cm.');
                }
              } else {
                if (drawerUI._weightUnit === 'lbs') {
                  drawerUI.showFieldError('weight', isEn
                    ? 'Enter a valid weight between 99 and 265 lbs.'
                    : 'Ingresa un peso válido entre 99 y 265 lbs.');
                } else {
                  drawerUI.showFieldError('weight', isEn
                    ? 'Enter a valid weight between 45 and 120 kg.'
                    : 'Ingresa un peso válido entre 45 y 120 kg.');
                }
              }
              return;
            }
            
            const result = engine.recommend(heightCm, weightKg, productType);
            if (result && result.size) {
              window.MA_RECOMMENDED_SIZE = result.size;
            }

            if (repo) {
              repo.saveProfile(heightCm, weightKg);
            }
            
            const available = resolver ? resolver.isAvailable(result.size) : true;
            const productSizesNormalized = p.sizes 
              ? p.sizes.map(s => String(s).trim().toUpperCase()) 
              : [];
            const sizeExists = productSizesNormalized.includes(String(result.size).trim().toUpperCase());
            
            drawerUI.showResult(result.size, available, isEn ? 'en' : 'es', sizeExists);
          }
        });

        drawerUI.onApply(() => {
          appliedFromFitModal = true;
          const applyBtn = document.querySelector('[data-fit-apply]');
          const sizeToApply = applyBtn ? applyBtn.dataset.fitApplySize : null;
          if (!sizeToApply) return;
          
          const metrics = drawerUI.getMetricValues();
          if (metrics && repo) {
            repo.saveProfile(metrics.heightCm, metrics.weightKg);
          }


          const cartObj = typeof cart !== 'undefined' ? cart : (window.cart || null);
          let addSuccess = true;
          if (cartObj) {
            const priceUsd = Number(p.priceUsd);
            const pricePen = Number(p.pricePen);
            addSuccess = cartObj.add({
              id: productId,
              name: p.name,
              color: p.color,
              size: sizeToApply,
              priceUsd: priceUsd,
              pricePen: pricePen,
              qty: 1
            });
            const showToastFn = typeof showToast === 'function' ? showToast : (window.showToast || null);
            const tFn = typeof t === 'function' ? t : (window.t || null);
            if (addSuccess !== false && showToastFn && tFn) {
              showToastFn(tFn('toast.added'));
            }
          }

          if (addSuccess !== false) {
            if (applyBtn) {
              applyBtn.textContent = isEn ? '✓ SELECTED' : '✓ SELECCIONADO';
              applyBtn.classList.add('is-applied');
            }
            // Flow completed: Close fit drawer & keep Quick Buy drawer closed!
            closeQuickBuy();
            setTimeout(() => {
              drawerUI.close();
              if (applyBtn) {
                setTimeout(() => {
                  applyBtn.classList.remove('is-applied');
                }, 400);
              }
            }, 300);
          }
        });

        drawerUI.onClose(() => {
          if (drawer) {
            drawer.classList.remove('is-hidden-fit');
          }
          const qOverlay = document.getElementById('quick-buy-overlay');
          if (qOverlay) qOverlay.style.display = '';
        });

        // Make Quick Buy drawer and overlay hidden while Fit modal is open
        if (drawer) {
          drawer.classList.add('is-hidden-fit');
        }
        const qOverlay = document.getElementById('quick-buy-overlay');
        if (qOverlay) qOverlay.style.display = 'none';

        const profile = repo ? repo.getProfile() : null;
        drawerUI.open(profile, p, null);
      }
    };

    const handleQuickBuySizeChange = (selectedSize) => {
      const isOos = p.outOfStockSizes && p.outOfStockSizes.includes(selectedSize);
      const addBtn = drawer.querySelector('#quick-buy-add-btn');
      let restockContainer = drawer.querySelector('#quick-buy-restock-container');
      if (restockContainer) restockContainer.remove();

      if (addBtn) {
        if (isOos) {
          addBtn.style.display = 'block';
          addBtn.disabled = true;
          addBtn.textContent = isEn ? 'OUT OF STOCK' : 'AGOTADO';
          addBtn.style.opacity = '0.5';
          addBtn.style.cursor = 'not-allowed';
        } else {
          addBtn.style.display = 'block';
          addBtn.disabled = false;
          addBtn.textContent = isEn ? 'ADD TO BAG' : 'AÑADIR AL CARRITO';
          addBtn.style.opacity = '1';
          addBtn.style.cursor = 'pointer';
        }
      }
    };

    if (selectEl) {
      selectEl.addEventListener('change', () => {
        if (!isOneSize && (selectEl.value === 'find-size' || selectEl.value === '')) {
          selectEl.value = recommendedSize || '';
          if (document.activeElement === selectEl) selectEl.blur();
          openFitDrawerForQuickBuy();
          return;
        }
        handleQuickBuySizeChange(selectEl.value);
      });

      if (!hasProfile && !isOneSize) {
        const triggerFitForQuickBuy = (e) => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }
          }
          if (document.activeElement === selectEl) {
            selectEl.blur();
          }
          openFitDrawerForQuickBuy();
          return false;
        };

        const wrapperQb = selectEl.closest('.quick-buy-drawer__select-wrapper') || selectEl.parentElement;
        const qbEvents = ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'click', 'focus'];
        qbEvents.forEach(evtType => {
          selectEl.addEventListener(evtType, triggerFitForQuickBuy, { capture: true });
          if (wrapperQb) wrapperQb.addEventListener(evtType, triggerFitForQuickBuy, { capture: true });
        });
      }
    }

    if (!isOneSize && selectEl && recommendedSize && sizes.includes(recommendedSize)) {
      selectEl.value = recommendedSize;
    }

    handleQuickBuySizeChange(selectEl ? selectEl.value : (isOneSize ? 'O/S' : ''));

    const closeBtn = drawer.querySelector('.quick-buy-drawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeQuickBuy);
    }

    const addBtn = drawer.querySelector('#quick-buy-add-btn');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        let selectedSize = isOneSize ? 'O/S' : (selectEl ? selectEl.value : '');
        if (!selectedSize || selectedSize === 'find-size') {
          if (selectEl) {
            selectEl.focus();
            selectEl.style.borderColor = '#dc2626';
            setTimeout(() => selectEl.style.borderColor = '', 1500);
          }
          const showToastFn = typeof showToast === 'function' ? showToast : (window.showToast || null);
          if (showToastFn) {
            showToastFn(isEn ? 'Please select a size' : 'Por favor elige una talla');
          }
          return;
        }

        const cartObj = window.cart || (typeof cart !== 'undefined' ? cart : null);
        if (cartObj) {
          const priceUsd = Number(p.priceUsd);
          const pricePen = Number(p.pricePen);

          const addSuccess = cartObj.add({
            id: productId,
            name: p.name,
            color: p.color,
            size: selectedSize,
            priceUsd: priceUsd,
            pricePen: pricePen,
            qty: 1
          });

          if (addSuccess !== false) {
            const slider = drawer.querySelector('.quick-buy-drawer__slider');
            const currentSlideIdx = slider ? Math.round(slider.scrollLeft / slider.clientWidth) : 0;
            const activeImg = drawer.querySelector(`.quick-buy-drawer__slide[data-index="${currentSlideIdx}"] img`) || drawer.querySelector('.quick-buy-drawer__image');
            const animateFn = typeof animateAddToCart === 'function' ? animateAddToCart : (window.animateAddToCart || null);
            if (animateFn && activeImg) {
              animateFn(activeImg);
            }

            const showToastFn = typeof showToast === 'function' ? showToast : (window.showToast || null);
            const tFn = typeof t === 'function' ? t : (window.t || null);
            if (showToastFn && tFn) {
              showToastFn(tFn('toast.added'));
            }
            // Close Quick Buy module!
            closeQuickBuy();
          }
        }
      });
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.classList.add('quick-buy-open');

    document.removeEventListener('keydown', handleQuickBuyKeydown);
    document.addEventListener('keydown', handleQuickBuyKeydown);

    requestAnimationFrame(() => {
      if (closeBtn) {
        closeBtn.focus();
      } else {
        const first = drawer.querySelector('button, [href], select, input');
        if (first) first.focus();
      }
    });
  } catch (err) {
    console.error("Error in openQuickBuy:", err);
  }
}

let quickBuyOpenerEl = null;

function handleQuickBuyKeydown(e) {
  const drawer = document.getElementById('quick-buy-drawer');
  if (!drawer || !drawer.classList.contains('is-open')) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    closeQuickBuy();
    return;
  }

  if (e.key === 'Tab') {
    const focusables = drawer.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const firstEl = focusables[0];
    const lastEl = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstEl || !drawer.contains(document.activeElement)) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl || !drawer.contains(document.activeElement)) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  }
}

function closeQuickBuy() {
  const drawer = document.getElementById('quick-buy-drawer');
  const overlay = document.getElementById('quick-buy-overlay');
  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.classList.remove('is-hidden-fit');
    drawer.setAttribute('aria-hidden', 'true');
  }
  if (overlay) {
    overlay.classList.remove('is-visible');
  }
  document.body.classList.remove('quick-buy-open');

  document.removeEventListener('keydown', handleQuickBuyKeydown);

  if (quickBuyOpenerEl && typeof quickBuyOpenerEl.focus === 'function' && document.body.contains(quickBuyOpenerEl)) {
    try { quickBuyOpenerEl.focus(); } catch(e) {}
  }
}

function initGlobalQuickBuy() {
  const cards = document.querySelectorAll('.gallery-v2__card');
  cards.forEach(card => {
    if (card.dataset.quickBuyWired) return;
    card.dataset.quickBuyWired = 'true';

    const trigger = card.querySelector('.gallery-v2__quick-add-trigger');
    if (trigger) {
      addTapListener(trigger, (e) => {
        const productId = card.getAttribute('data-product-id');
        quickBuyOpenerEl = trigger;
        openQuickBuy(productId, trigger);
      });
    }
  });
}

// ── Global Quick Buy Drawer Hook ──
(function initGlobalQuickBuyHook() {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.gallery-v2__quick-add-trigger');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const card = trigger.closest('.gallery-v2__card, [data-product-id]');
    const productId = card ? card.getAttribute('data-product-id') : trigger.getAttribute('data-product-id');
    if (productId && typeof openQuickBuy === 'function') {
      quickBuyOpenerEl = trigger;
      openQuickBuy(productId, trigger);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalQuickBuy);
  } else {
    initGlobalQuickBuy();
  }
})();

// ── Global Reactive Fit Update Listener ──
window.addEventListener('ma:fit-updated', () => {
  if (typeof window._refreshPdpSizeSelector === 'function') {
    window._refreshPdpSizeSelector();
  }
  const quickBuyDrawer = document.getElementById('quick-buy-drawer');
  if (quickBuyDrawer && quickBuyDrawer.classList.contains('is-open')) {
    const activeProductId = quickBuyDrawer.dataset.productId;
    if (activeProductId && typeof openQuickBuy === 'function') {
      openQuickBuy(activeProductId);
    }
  }
});

// ── Expose critical functions globally for inline onclick attributes ──
window.openQuickBuy = openQuickBuy;
window.closeQuickBuy = closeQuickBuy;

// ── Mobile Edge Swipe to Close Module (+ or ENCUENTRA TU TALLA) ──
(function initMobileEdgeSwipeToClose() {
  let startX = 0;
  let startY = 0;
  let isTracking = false;

  window.addEventListener('touchstart', (e) => {
    if (!e.touches || e.touches.length !== 1) return;

    const hasOpenDrawer = 
      document.querySelector('#mobile-menu.is-open') ||
      document.querySelector('#cart-drawer.is-open') ||
      document.querySelector('[data-fit-drawer].is-open') ||
      document.querySelector('#drawer-care.is-open, #drawer-care.active') ||
      document.querySelector('#drawer-shipping.is-open, #drawer-shipping.active') ||
      document.querySelector('#drawer-service.is-open, #drawer-service.active') ||
      document.querySelector('.pdp-drawer.is-open, .pdp-drawer.active') ||
      document.querySelector('#quick-buy-drawer.is-open');

    if (!hasOpenDrawer) {
      isTracking = false;
      return;
    }

    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isTracking = true;
  }, { passive: true });

  window.addEventListener('touchend', (e) => {
    if (!isTracking || !e.changedTouches || e.changedTouches.length !== 1) return;

    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const deltaX = endX - startX;
    const deltaY = Math.abs(endY - startY);

    if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > deltaY * 1.1) {
      const mobileMenu = document.querySelector('#mobile-menu.is-open');
      const cartDrawer = document.querySelector('#cart-drawer.is-open');
      const fitDrawer = document.querySelector('[data-fit-drawer].is-open');
      const careDrawer = document.querySelector('#drawer-care.is-open, #drawer-care.active');
      const shippingDrawer = document.querySelector('#drawer-shipping.is-open, #drawer-shipping.active');
      const serviceDrawer = document.querySelector('#drawer-service.is-open, #drawer-service.active');
      const pdpDrawer = document.querySelector('.pdp-drawer.is-open, .pdp-drawer.active');
      const quickBuyDrawer = document.querySelector('#quick-buy-drawer.is-open');

      if (mobileMenu && (deltaX > 40 || deltaX < -40)) {
        const closeBtn = document.getElementById('mobile-menu-close');
        if (closeBtn) closeBtn.click();
        else mobileMenu.classList.remove('is-open');
      } else if (cartDrawer && deltaX > 40) {
        const closeBtn = document.getElementById('cart-close');
        if (closeBtn) closeBtn.click();
        else cartDrawer.classList.remove('is-open');
      } else if (fitDrawer && deltaX > 40) {
        let drawerUI = window._fitDrawerGlobalInstance;
        if (drawerUI && typeof drawerUI.close === 'function') {
          drawerUI.close();
        } else {
          fitDrawer.classList.remove('is-open');
          const fitOverlay = document.querySelector('[data-fit-overlay]');
          if (fitOverlay) fitOverlay.classList.remove('is-visible');
        }
      } else if (careDrawer && deltaX > 40) {
        const closeBtn = document.getElementById('drawer-care-close') || careDrawer.querySelector('.drawer__close, .pdp-drawer__close');
        if (closeBtn) closeBtn.click();
        else careDrawer.classList.remove('is-open', 'active');
      } else if (shippingDrawer && deltaX > 40) {
        const closeBtn = document.getElementById('drawer-shipping-close') || shippingDrawer.querySelector('.drawer__close, .pdp-drawer__close');
        if (closeBtn) closeBtn.click();
        else shippingDrawer.classList.remove('is-open', 'active');
      } else if (serviceDrawer && deltaX > 40) {
        const closeBtn = document.getElementById('drawer-service-close') || serviceDrawer.querySelector('.drawer__close, .pdp-drawer__close');
        if (closeBtn) closeBtn.click();
        else serviceDrawer.classList.remove('is-open', 'active');
      } else if (pdpDrawer && deltaX > 40) {
        const closeBtn = pdpDrawer.querySelector('.pdp-drawer__close, .drawer__close');
        if (closeBtn) closeBtn.click();
        else pdpDrawer.classList.remove('is-open', 'active');
      } else if (quickBuyDrawer && deltaX > 40) {
        if (typeof closeQuickBuy === 'function') {
          closeQuickBuy();
        }
      }
    }

    isTracking = false;
  }, { passive: true });
})();

// ─────────────────────────────────────────────────────────────────────────────
// EDITORIAL MODAL — First-Order 10% Discount Popup
// Triggers once per user, only on the homepage, after scrolling ~60% of page.
// Stored in localStorage so it only ever shows once per device/browser.
// ─────────────────────────────────────────────────────────────────────────────
(function initEditorialModal() {
  var STORAGE_KEY      = 'mk_popup_seen';
  var SCROLL_THRESHOLD = 0.60; // show after user scrolls 60% of total page height

  // Only run when the modal is present (homepage)
  var modal = document.getElementById('editorial-modal');
  if (!modal) return;

  var form = document.getElementById('editorial-modal-form');

  // ── Open ──────────────────────────────────────────────────────────────────
  function openModal() {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // ── Close ─────────────────────────────────────────────────────────────────
  function closeModal() {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
  }

  // ── Scroll trigger ────────────────────────────────────────────────────────
  function onScroll() {
    try { if (localStorage.getItem(STORAGE_KEY)) { window.removeEventListener('scroll', onScroll); return; } } catch(e) {}
    var scrolled = window.scrollY + window.innerHeight;
    var total    = document.documentElement.scrollHeight;
    if (total > 0 && scrolled / total >= SCROLL_THRESHOLD) {
      window.removeEventListener('scroll', onScroll);
      openModal();
    }
  }

  // ── Close via overlay / close button / ESC ────────────────────────────────
  modal.addEventListener('click', function(e) {
    if (e.target.closest('[data-modal-close]')) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-visible')) closeModal();
  });

  // ── Form submit → Pure Controlled AJAX via App Proxy ───────────────────────
  if (form) {
    var submitBtn  = form.querySelector('.editorial-modal__submit') || document.getElementById('editorial-modal-submit-btn');
    var emailInput = form.querySelector('.editorial-modal__input');
    var honeypotEl = form.querySelector('[name="b_company_fax"]');
    var isSubmitting = false;

    function showErrorMsg(msg) {
      var errorEl = form.querySelector('.editorial-modal__error');
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'editorial-modal__error';
        errorEl.setAttribute('role', 'alert');
        errorEl.setAttribute('aria-live', 'assertive');
        form.appendChild(errorEl);
      }
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }

    function clearErrorMsg() {
      var errorEl = form.querySelector('.editorial-modal__error');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.style.display = 'none';
      }
    }

    function handleButtonClick(e) {
      if (e && e.preventDefault) e.preventDefault();

      // Synchronous double-submit guard
      if (isSubmitting) return;

      var emailVal = emailInput ? emailInput.value.trim() : '';
      var isEn = (typeof getLang === 'function' ? getLang() : 'es') === 'en' || (window.location.pathname.indexOf('/en') === 0);

      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        showErrorMsg(isEn ? "PLEASE ENTER A VALID EMAIL ADDRESS." : "POR FAVOR INGRESA UN CORREO VÁLIDO.");
        if (emailInput) emailInput.focus();
        return;
      }

      // 1. Immediately disable button & lock submission synchronously
      isSubmitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      clearErrorMsg();

      var proxyUrl = '/apps/newsletter/subscribe';
      var payload = {
        email: emailVal,
        b_company_fax: honeypotEl ? honeypotEl.value.trim() : ''
      };

      fetch(proxyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok || !data || data.success !== true) {
            throw new Error(data && data.error ? data.error : ('HTTP ' + res.status));
          }
          return data;
        });
      })
      .then(function() {
        // CONFIRMED SUCCESS
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch(ex) {}

        var content     = modal.querySelector('.editorial-modal__content');
        var container   = modal.querySelector('.editorial-modal__container');
        var successView = modal.querySelector('.editorial-modal__success-view');

        if (content) content.classList.add('is-success-fade-out');

        setTimeout(function() {
          if (container)   container.classList.add('is-success');
          if (successView) {
            successView.style.opacity    = '1';
            successView.style.visibility = 'visible';
            successView.style.transform  = 'scale(1)';
          }
        }, 260);
      })
      .catch(function(err) {
        isSubmitting = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }

        var isEn = (typeof getLang === 'function' ? getLang() : 'es') === 'en' || (window.location.pathname.indexOf('/en') === 0);
        var errorText = isEn
          ? "WE COULDN'T COMPLETE YOUR SIGN-UP. TRY AGAIN."
          : "NO PUDIMOS COMPLETAR EL REGISTRO. INTÉNTALO DE NUEVO.";
        showErrorMsg(errorText);
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', handleButtonClick);
    }

    if (emailInput) {
      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleButtonClick(e);
        }
      });
    }

    // Defensive shield against any accidental form submit
    form.addEventListener('submit', function(e) {
      e.preventDefault();
    });
  }

  // ── Normal session scroll listening ───────────────────────────────────────
  try {
    if (!localStorage.getItem(STORAGE_KEY)) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  } catch(e) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();

// ─────────────────────────────────────────────────────────────────────────────
// iOS Safari Status Bar — WebKit top edge sentinel handled via HTML/CSS
// ─────────────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────────────
// Sitewide Anti-Copy & Anti-Save Protection for Images (PC & Mobile)
// Prevents right-click menu and dragging on images
// ─────────────────────────────────────────────────────────────────────────────
(function initImageProtection() {
  document.addEventListener('contextmenu', function(e) {
    var target = e.target;
    if (target && (target.tagName === 'IMG' || target.closest('img') || target.tagName === 'SVG' || target.closest('svg'))) {
      e.preventDefault();
      return false;
    }
  }, false);

  document.addEventListener('dragstart', function(e) {
    var target = e.target;
    if (target && (target.tagName === 'IMG' || target.closest('img'))) {
      e.preventDefault();
      return false;
    }
  }, false);
})();


// ─────────────────────────────────────────────────────────────────────────────
// Dedicated Cart Page Controller (`/cart`)
// ─────────────────────────────────────────────────────────────────────────────
function initCartPage() {
  const cartPage = document.getElementById('cart-page');
  if (!cartPage) return;

  cartPage.addEventListener('click', function(e) {
    const target = e.target.closest('button');
    if (!target) return;

    const action = target.dataset.action;
    const key = target.dataset.key;

    if (action === 'increase-qty' || action === 'decrease-qty') {
      const itemEl = target.closest('.cart-page__item');
      if (!itemEl) return;
      const input = itemEl.querySelector('.cart-page__qty-input');
      if (!input) return;

      let currentQty = parseInt(input.value, 10) || 1;
      if (action === 'increase-qty') {
        currentQty += 1;
      } else if (action === 'decrease-qty') {
        currentQty = Math.max(0, currentQty - 1);
      }
      input.value = currentQty;
      updateCartPageItem(key, currentQty);
    } else if (action === 'remove-item') {
      updateCartPageItem(key, 0);
    }
  });

  cartPage.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('cart-page__qty-input')) {
      const input = e.target;
      const key = input.dataset.key;
      let newQty = parseInt(input.value, 10);
      if (isNaN(newQty) || newQty < 0) newQty = 0;
      updateCartPageItem(key, newQty);
    }
  });

  document.addEventListener('cart:changed', function() {
    if (window.cart && window.cart.items) {
      syncCartPageWithState(window.cart);
    }
  });
}

function updateCartPageItem(key, quantity) {
  if (window.cart && typeof window.cart.updateItem === 'function') {
    window.cart.updateItem(key, quantity);
  } else {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(res => res.json())
    .then(data => {
      if (window.cart && typeof window.cart.load === 'function') {
        window.cart.load();
      } else {
        window.location.reload();
      }
    })
    .catch(err => {
      console.error('Error updating cart page item:', err);
    });
  }
}

function syncCartPageWithState(cartData) {
  const cartContent = document.getElementById('cart-page-content');
  const countBadge = document.getElementById('cart-page-count-badge');
  if (countBadge) {
    countBadge.textContent = '(' + (cartData.item_count || 0) + ')';
  }

  if (!cartContent) return;

  if (!cartData.items || cartData.items.length === 0) {
    const rootPath = window.MA_ROOT_PATH || '';
    const lang = (window.MA_LOCALE || 'es').toLowerCase();
    const emptyTitle = lang === 'en' ? 'Your cart is empty.' : 'Tu carrito está vacío.';
    const ctaText = lang === 'en' ? 'DISCOVER THE SYSTEM' : 'DESCUBRIR EL SISTEMA';

    cartContent.innerHTML = '<div class="cart-page__empty-state" id="cart-page-empty-state"><div class="cart-page__empty-content"><h2 class="cart-page__empty-title" data-i18n="cart.empty">' + emptyTitle + '</h2><p class="cart-page__empty-subtitle">Descubre el diseño contemporáneo y la calidad elevada de MARK ALTITUDE.</p><a href="' + rootPath + '/#collection" class="btn btn--dark cart-page__empty-cta" data-i18n="cta.discover_system">' + ctaText + '</a></div></div>';
    return;
  }

  const subtotalEl = document.getElementById('cart-page-subtotal');
  if (subtotalEl) {
    const formatMoney = (cents) => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(cents);
      return 'S/ ' + (cents / 100).toFixed(2);
    };
    subtotalEl.textContent = formatMoney(cartData.total_price);
    subtotalEl.setAttribute('data-price-pen', (cartData.total_price / 100).toFixed(2));
  }

  if (typeof updateCurrencyDisplays === 'function') {
    updateCurrencyDisplays();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartPage);
} else {
  initCartPage();
}

// ─────────────────────────────────────────────────────────────────────────────
// Cart Page Header Enforcement — keep header solid/dark on /cart template
// ─────────────────────────────────────────────────────────────────────────────
(function enforceCartPageHeader() {
  if (!document.body.classList.contains('template-cart')) return;

  const header = document.getElementById('site-header');
  if (!header) return;

  // Remove light/transparent classes that may have been applied
  function solidifyHeader() {
    header.classList.remove('site-header--light', 'is-header-hidden', 'is-header-peek');
    header.classList.add('is-header-editorial');
    // Force solid white background via inline style (overrides any JS-set transparency)
    header.style.setProperty('background', 'rgba(250, 249, 246, 0.97)', 'important');
    header.style.setProperty('background-color', 'rgba(250, 249, 246, 0.97)', 'important');
    header.style.setProperty('border-bottom', '1px solid rgba(0,0,0,0.08)', 'important');
    header.style.setProperty('box-shadow', '0 1px 12px rgba(0,0,0,0.06)', 'important');

    // Fix logo and icon colors
    const logosAndIcons = header.querySelectorAll('svg, .header-link, .header-icon');
    logosAndIcons.forEach(function(el) {
      el.style.setProperty('color', '#111111', 'important');
      el.style.setProperty('stroke', '#111111', 'important');
    });

    const headerBg = header.querySelector('.site-header__bg');
    if (headerBg) {
      headerBg.style.setProperty('opacity', '1', 'important');
      headerBg.style.setProperty('background', 'rgba(250, 249, 246, 0.97)', 'important');
    }

    const cartCount = header.querySelector('.header-cart-count');
    if (cartCount) {
      cartCount.style.setProperty('background', '#111111', 'important');
      cartCount.style.setProperty('color', '#ffffff', 'important');
    }
  }

  // Apply immediately and also after any DOM paint
  solidifyHeader();
  requestAnimationFrame(solidifyHeader);
  setTimeout(solidifyHeader, 100);
  setTimeout(solidifyHeader, 400);

  // Also override global html background
  document.documentElement.style.setProperty('background', '#FAF9F6', 'important');
  document.documentElement.style.setProperty('background-color', '#FAF9F6', 'important');
})();

// ─────────────────────────────────────────────────────────────────────────────
// Track Last Visited PDP & Auto-Open Cart Drawer on ?open_cart=true
// ─────────────────────────────────────────────────────────────────────────────
(function trackPdpAndOpenCart() {
  if (window.location.pathname.indexOf('/products/') !== -1) {
    try {
      localStorage.setItem('ma_last_pdp', window.location.pathname + window.location.search);
    } catch(e) {}
  }

  var searchStr = window.location.search;
  if (searchStr.indexOf('open_cart=true') !== -1 || window.location.hash === '#open-cart') {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('open_cart');
      var newSearch = urlParams.toString() ? '?' + urlParams.toString() : '';
      var cleanUrl = window.location.pathname + newSearch + (window.location.hash === '#open-cart' ? '' : window.location.hash);
      window.history.replaceState({}, '', cleanUrl);
    } catch(e) {}

    function triggerCartOpen() {
      if (typeof openCart === 'function') {
        openCart();
      } else {
        var cartEl = document.getElementById('cart-drawer');
        if (cartEl) {
          cartEl.classList.add('is-open');
          document.body.classList.add('cart-open');
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(triggerCartOpen, 150);
      });
    } else {
      setTimeout(triggerCartOpen, 150);
    }
  }
})();





